(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec76d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec76d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ciQby", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8f4fa560eb6ad76c$export$ffb0004e005737fa; }, function (v) { return $8f4fa560eb6ad76c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8f4fa560eb6ad76c$export$34b9dba7ce09269b; }, function (v) { return $8f4fa560eb6ad76c$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8f4fa560eb6ad76c$export$25062201e9e25d76; }, function (v) { return $8f4fa560eb6ad76c$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8f4fa560eb6ad76c$export$ffb0004e005737fa;
var $8f4fa560eb6ad76c$export$34b9dba7ce09269b;
var $8f4fa560eb6ad76c$export$25062201e9e25d76;
'use strict';

var $1G08a = parcelRequire("1G08a");
var $8f4fa560eb6ad76c$var$k = Symbol.for("react.element"), $8f4fa560eb6ad76c$var$l = Symbol.for("react.fragment"), $8f4fa560eb6ad76c$var$m = Object.prototype.hasOwnProperty, $8f4fa560eb6ad76c$var$n = $1G08a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $8f4fa560eb6ad76c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8f4fa560eb6ad76c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$8f4fa560eb6ad76c$var$m.call(a, b) && !$8f4fa560eb6ad76c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $8f4fa560eb6ad76c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $8f4fa560eb6ad76c$var$n.current
    };
}
$8f4fa560eb6ad76c$export$ffb0004e005737fa = $8f4fa560eb6ad76c$var$l;
$8f4fa560eb6ad76c$export$34b9dba7ce09269b = $8f4fa560eb6ad76c$var$q;
$8f4fa560eb6ad76c$export$25062201e9e25d76 = $8f4fa560eb6ad76c$var$q;

});
parcelRegister("1G08a", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1OuAU"));

});
parcelRegister("1OuAU", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $152231542539c2ae$export$dca3b0875bd9a954; }, function (v) { return $152231542539c2ae$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $152231542539c2ae$export$16fa2f45be04daa8; }, function (v) { return $152231542539c2ae$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $152231542539c2ae$export$ffb0004e005737fa; }, function (v) { return $152231542539c2ae$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $152231542539c2ae$export$e2c29f18771995cb; }, function (v) { return $152231542539c2ae$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $152231542539c2ae$export$221d75b3f55bb0bd; }, function (v) { return $152231542539c2ae$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $152231542539c2ae$export$5f8d39834fd61797; }, function (v) { return $152231542539c2ae$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $152231542539c2ae$export$74bf444e3cd11ea5; }, function (v) { return $152231542539c2ae$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $152231542539c2ae$export$ae55be85d98224ed; }, function (v) { return $152231542539c2ae$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $152231542539c2ae$export$3ba232387fd5d6dd; }, function (v) { return $152231542539c2ae$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $152231542539c2ae$export$e530037191fcd5d7; }, function (v) { return $152231542539c2ae$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $152231542539c2ae$export$fd42f52fd3ae1109; }, function (v) { return $152231542539c2ae$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $152231542539c2ae$export$c8a8987d4410bf2d; }, function (v) { return $152231542539c2ae$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $152231542539c2ae$export$d38cd72104c1f0e9; }, function (v) { return $152231542539c2ae$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $152231542539c2ae$export$7d1e3a5e95ceca43; }, function (v) { return $152231542539c2ae$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $152231542539c2ae$export$257a8862b851cb5b; }, function (v) { return $152231542539c2ae$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $152231542539c2ae$export$a8257692ac88316c; }, function (v) { return $152231542539c2ae$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $152231542539c2ae$export$488013bae63b21da; }, function (v) { return $152231542539c2ae$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $152231542539c2ae$export$7c73462e0d25e514; }, function (v) { return $152231542539c2ae$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $152231542539c2ae$export$7568632d0d33d16d; }, function (v) { return $152231542539c2ae$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $152231542539c2ae$export$88948ce120ea2619; }, function (v) { return $152231542539c2ae$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $152231542539c2ae$export$35808ee640e87ca7; }, function (v) { return $152231542539c2ae$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $152231542539c2ae$export$fae74005e78b1a27; }, function (v) { return $152231542539c2ae$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $152231542539c2ae$export$dc8fbce3eb94dc1e; }, function (v) { return $152231542539c2ae$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $152231542539c2ae$export$6a7bc4e911dc01cf; }, function (v) { return $152231542539c2ae$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $152231542539c2ae$export$6d9c69b0de29b591; }, function (v) { return $152231542539c2ae$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $152231542539c2ae$export$f680877a34711e37; }, function (v) { return $152231542539c2ae$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $152231542539c2ae$export$d5a552a76deda3c2; }, function (v) { return $152231542539c2ae$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $152231542539c2ae$export$aaabe4eda9ed9969; }, function (v) { return $152231542539c2ae$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $152231542539c2ae$export$e5c5a5f917a5871c; }, function (v) { return $152231542539c2ae$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $152231542539c2ae$export$1538c33de8887b59; }, function (v) { return $152231542539c2ae$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $152231542539c2ae$export$13e3392192263954; }, function (v) { return $152231542539c2ae$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $152231542539c2ae$export$b8f5890fc79d6aca; }, function (v) { return $152231542539c2ae$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $152231542539c2ae$export$60241385465d0a34; }, function (v) { return $152231542539c2ae$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $152231542539c2ae$export$306c0aa65ff9ec16; }, function (v) { return $152231542539c2ae$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $152231542539c2ae$export$7b286972b8d8ccbf; }, function (v) { return $152231542539c2ae$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $152231542539c2ae$export$83d89fbfd8236492; }, function (v) { return $152231542539c2ae$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $152231542539c2ae$export$dca3b0875bd9a954;
var $152231542539c2ae$export$16fa2f45be04daa8;
var $152231542539c2ae$export$ffb0004e005737fa;
var $152231542539c2ae$export$e2c29f18771995cb;
var $152231542539c2ae$export$221d75b3f55bb0bd;
var $152231542539c2ae$export$5f8d39834fd61797;
var $152231542539c2ae$export$74bf444e3cd11ea5;
var $152231542539c2ae$export$ae55be85d98224ed;
var $152231542539c2ae$export$3ba232387fd5d6dd;
var $152231542539c2ae$export$e530037191fcd5d7;
var $152231542539c2ae$export$fd42f52fd3ae1109;
var $152231542539c2ae$export$c8a8987d4410bf2d;
var $152231542539c2ae$export$d38cd72104c1f0e9;
var $152231542539c2ae$export$7d1e3a5e95ceca43;
var $152231542539c2ae$export$257a8862b851cb5b;
var $152231542539c2ae$export$a8257692ac88316c;
var $152231542539c2ae$export$488013bae63b21da;
var $152231542539c2ae$export$7c73462e0d25e514;
var $152231542539c2ae$export$7568632d0d33d16d;
var $152231542539c2ae$export$88948ce120ea2619;
var $152231542539c2ae$export$35808ee640e87ca7;
var $152231542539c2ae$export$fae74005e78b1a27;
var $152231542539c2ae$export$dc8fbce3eb94dc1e;
var $152231542539c2ae$export$6a7bc4e911dc01cf;
var $152231542539c2ae$export$6d9c69b0de29b591;
var $152231542539c2ae$export$f680877a34711e37;
var $152231542539c2ae$export$d5a552a76deda3c2;
var $152231542539c2ae$export$aaabe4eda9ed9969;
var $152231542539c2ae$export$e5c5a5f917a5871c;
var $152231542539c2ae$export$1538c33de8887b59;
var $152231542539c2ae$export$13e3392192263954;
var $152231542539c2ae$export$b8f5890fc79d6aca;
var $152231542539c2ae$export$60241385465d0a34;
var $152231542539c2ae$export$306c0aa65ff9ec16;
var $152231542539c2ae$export$7b286972b8d8ccbf;
var $152231542539c2ae$export$83d89fbfd8236492;
'use strict';
var $152231542539c2ae$var$l = Symbol.for("react.element"), $152231542539c2ae$var$n = Symbol.for("react.portal"), $152231542539c2ae$var$p = Symbol.for("react.fragment"), $152231542539c2ae$var$q = Symbol.for("react.strict_mode"), $152231542539c2ae$var$r = Symbol.for("react.profiler"), $152231542539c2ae$var$t = Symbol.for("react.provider"), $152231542539c2ae$var$u = Symbol.for("react.context"), $152231542539c2ae$var$v = Symbol.for("react.forward_ref"), $152231542539c2ae$var$w = Symbol.for("react.suspense"), $152231542539c2ae$var$x = Symbol.for("react.memo"), $152231542539c2ae$var$y = Symbol.for("react.lazy"), $152231542539c2ae$var$z = Symbol.iterator;
function $152231542539c2ae$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $152231542539c2ae$var$z && a[$152231542539c2ae$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $152231542539c2ae$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $152231542539c2ae$var$C = Object.assign, $152231542539c2ae$var$D = {};
function $152231542539c2ae$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $152231542539c2ae$var$D;
    this.updater = e || $152231542539c2ae$var$B;
}
$152231542539c2ae$var$E.prototype.isReactComponent = {};
$152231542539c2ae$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$152231542539c2ae$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $152231542539c2ae$var$F() {}
$152231542539c2ae$var$F.prototype = $152231542539c2ae$var$E.prototype;
function $152231542539c2ae$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $152231542539c2ae$var$D;
    this.updater = e || $152231542539c2ae$var$B;
}
var $152231542539c2ae$var$H = $152231542539c2ae$var$G.prototype = new $152231542539c2ae$var$F;
$152231542539c2ae$var$H.constructor = $152231542539c2ae$var$G;
$152231542539c2ae$var$C($152231542539c2ae$var$H, $152231542539c2ae$var$E.prototype);
$152231542539c2ae$var$H.isPureReactComponent = !0;
var $152231542539c2ae$var$I = Array.isArray, $152231542539c2ae$var$J = Object.prototype.hasOwnProperty, $152231542539c2ae$var$K = {
    current: null
}, $152231542539c2ae$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $152231542539c2ae$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$152231542539c2ae$var$J.call(b, d) && !$152231542539c2ae$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $152231542539c2ae$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $152231542539c2ae$var$K.current
    };
}
function $152231542539c2ae$var$N(a, b) {
    return {
        $$typeof: $152231542539c2ae$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $152231542539c2ae$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $152231542539c2ae$var$l;
}
function $152231542539c2ae$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $152231542539c2ae$var$P = /\/+/g;
function $152231542539c2ae$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $152231542539c2ae$var$escape("" + a.key) : b.toString(36);
}
function $152231542539c2ae$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $152231542539c2ae$var$l:
                case $152231542539c2ae$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $152231542539c2ae$var$Q(h, 0) : d, $152231542539c2ae$var$I(c) ? (e = "", null != a && (e = a.replace($152231542539c2ae$var$P, "$&/") + "/"), $152231542539c2ae$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($152231542539c2ae$var$O(c) && (c = $152231542539c2ae$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($152231542539c2ae$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($152231542539c2ae$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $152231542539c2ae$var$Q(k, g);
        h += $152231542539c2ae$var$R(k, b, e, f, c);
    }
    else if (f = $152231542539c2ae$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $152231542539c2ae$var$Q(k, g++), h += $152231542539c2ae$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $152231542539c2ae$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $152231542539c2ae$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $152231542539c2ae$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $152231542539c2ae$var$U = {
    current: null
}, $152231542539c2ae$var$V = {
    transition: null
}, $152231542539c2ae$var$W = {
    ReactCurrentDispatcher: $152231542539c2ae$var$U,
    ReactCurrentBatchConfig: $152231542539c2ae$var$V,
    ReactCurrentOwner: $152231542539c2ae$var$K
};
function $152231542539c2ae$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$152231542539c2ae$export$dca3b0875bd9a954 = {
    map: $152231542539c2ae$var$S,
    forEach: function(a, b, e) {
        $152231542539c2ae$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $152231542539c2ae$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $152231542539c2ae$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$152231542539c2ae$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$152231542539c2ae$export$16fa2f45be04daa8 = $152231542539c2ae$var$E;
$152231542539c2ae$export$ffb0004e005737fa = $152231542539c2ae$var$p;
$152231542539c2ae$export$e2c29f18771995cb = $152231542539c2ae$var$r;
$152231542539c2ae$export$221d75b3f55bb0bd = $152231542539c2ae$var$G;
$152231542539c2ae$export$5f8d39834fd61797 = $152231542539c2ae$var$q;
$152231542539c2ae$export$74bf444e3cd11ea5 = $152231542539c2ae$var$w;
$152231542539c2ae$export$ae55be85d98224ed = $152231542539c2ae$var$W;
$152231542539c2ae$export$3ba232387fd5d6dd = $152231542539c2ae$var$X;
$152231542539c2ae$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $152231542539c2ae$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $152231542539c2ae$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$152231542539c2ae$var$J.call(b, f) && !$152231542539c2ae$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $152231542539c2ae$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$152231542539c2ae$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $152231542539c2ae$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $152231542539c2ae$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$152231542539c2ae$export$c8a8987d4410bf2d = $152231542539c2ae$var$M;
$152231542539c2ae$export$d38cd72104c1f0e9 = function(a) {
    var b = $152231542539c2ae$var$M.bind(null, a);
    b.type = a;
    return b;
};
$152231542539c2ae$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$152231542539c2ae$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $152231542539c2ae$var$v,
        render: a
    };
};
$152231542539c2ae$export$a8257692ac88316c = $152231542539c2ae$var$O;
$152231542539c2ae$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $152231542539c2ae$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $152231542539c2ae$var$T
    };
};
$152231542539c2ae$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $152231542539c2ae$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$152231542539c2ae$export$7568632d0d33d16d = function(a) {
    var b = $152231542539c2ae$var$V.transition;
    $152231542539c2ae$var$V.transition = {};
    try {
        a();
    } finally{
        $152231542539c2ae$var$V.transition = b;
    }
};
$152231542539c2ae$export$88948ce120ea2619 = $152231542539c2ae$var$X;
$152231542539c2ae$export$35808ee640e87ca7 = function(a, b) {
    return $152231542539c2ae$var$U.current.useCallback(a, b);
};
$152231542539c2ae$export$fae74005e78b1a27 = function(a) {
    return $152231542539c2ae$var$U.current.useContext(a);
};
$152231542539c2ae$export$dc8fbce3eb94dc1e = function() {};
$152231542539c2ae$export$6a7bc4e911dc01cf = function(a) {
    return $152231542539c2ae$var$U.current.useDeferredValue(a);
};
$152231542539c2ae$export$6d9c69b0de29b591 = function(a, b) {
    return $152231542539c2ae$var$U.current.useEffect(a, b);
};
$152231542539c2ae$export$f680877a34711e37 = function() {
    return $152231542539c2ae$var$U.current.useId();
};
$152231542539c2ae$export$d5a552a76deda3c2 = function(a, b, e) {
    return $152231542539c2ae$var$U.current.useImperativeHandle(a, b, e);
};
$152231542539c2ae$export$aaabe4eda9ed9969 = function(a, b) {
    return $152231542539c2ae$var$U.current.useInsertionEffect(a, b);
};
$152231542539c2ae$export$e5c5a5f917a5871c = function(a, b) {
    return $152231542539c2ae$var$U.current.useLayoutEffect(a, b);
};
$152231542539c2ae$export$1538c33de8887b59 = function(a, b) {
    return $152231542539c2ae$var$U.current.useMemo(a, b);
};
$152231542539c2ae$export$13e3392192263954 = function(a, b, e) {
    return $152231542539c2ae$var$U.current.useReducer(a, b, e);
};
$152231542539c2ae$export$b8f5890fc79d6aca = function(a) {
    return $152231542539c2ae$var$U.current.useRef(a);
};
$152231542539c2ae$export$60241385465d0a34 = function(a) {
    return $152231542539c2ae$var$U.current.useState(a);
};
$152231542539c2ae$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $152231542539c2ae$var$U.current.useSyncExternalStore(a, b, e);
};
$152231542539c2ae$export$7b286972b8d8ccbf = function() {
    return $152231542539c2ae$var$U.current.useTransition();
};
$152231542539c2ae$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("96xzw", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $6a0eb74c8d3eb840$export$ae55be85d98224ed; }, function (v) { return $6a0eb74c8d3eb840$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $6a0eb74c8d3eb840$export$d39a5bbd09211389; }, function (v) { return $6a0eb74c8d3eb840$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $6a0eb74c8d3eb840$export$882461b6382ed46c; }, function (v) { return $6a0eb74c8d3eb840$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $6a0eb74c8d3eb840$export$466bfc07425424d5; }, function (v) { return $6a0eb74c8d3eb840$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $6a0eb74c8d3eb840$export$cd75ccfd720a3cd4; }, function (v) { return $6a0eb74c8d3eb840$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $6a0eb74c8d3eb840$export$fa8d919ba61d84db; }, function (v) { return $6a0eb74c8d3eb840$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $6a0eb74c8d3eb840$export$757ceba2d55c277e; }, function (v) { return $6a0eb74c8d3eb840$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $6a0eb74c8d3eb840$export$b3890eb0ae9dca99; }, function (v) { return $6a0eb74c8d3eb840$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $6a0eb74c8d3eb840$export$502457920280e6be; }, function (v) { return $6a0eb74c8d3eb840$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $6a0eb74c8d3eb840$export$c78a37762a8d58e1; }, function (v) { return $6a0eb74c8d3eb840$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $6a0eb74c8d3eb840$export$dc54d992c10e8a18; }, function (v) { return $6a0eb74c8d3eb840$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $6a0eb74c8d3eb840$export$83d89fbfd8236492; }, function (v) { return $6a0eb74c8d3eb840$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $6a0eb74c8d3eb840$export$ae55be85d98224ed;
var $6a0eb74c8d3eb840$export$d39a5bbd09211389;
var $6a0eb74c8d3eb840$export$882461b6382ed46c;
var $6a0eb74c8d3eb840$export$466bfc07425424d5;
var $6a0eb74c8d3eb840$export$cd75ccfd720a3cd4;
var $6a0eb74c8d3eb840$export$fa8d919ba61d84db;
var $6a0eb74c8d3eb840$export$757ceba2d55c277e;
var $6a0eb74c8d3eb840$export$b3890eb0ae9dca99;
var $6a0eb74c8d3eb840$export$502457920280e6be;
var $6a0eb74c8d3eb840$export$c78a37762a8d58e1;
var $6a0eb74c8d3eb840$export$dc54d992c10e8a18;
var $6a0eb74c8d3eb840$export$83d89fbfd8236492;
'use strict';

var $1G08a = parcelRequire("1G08a");

var $lyjZb = parcelRequire("lyjZb");
function $6a0eb74c8d3eb840$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $6a0eb74c8d3eb840$var$da = new Set, $6a0eb74c8d3eb840$var$ea = {};
function $6a0eb74c8d3eb840$var$fa(a, b) {
    $6a0eb74c8d3eb840$var$ha(a, b);
    $6a0eb74c8d3eb840$var$ha(a + "Capture", b);
}
function $6a0eb74c8d3eb840$var$ha(a, b) {
    $6a0eb74c8d3eb840$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$6a0eb74c8d3eb840$var$da.add(b[a]);
}
var $6a0eb74c8d3eb840$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $6a0eb74c8d3eb840$var$ja = Object.prototype.hasOwnProperty, $6a0eb74c8d3eb840$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $6a0eb74c8d3eb840$var$la = {}, $6a0eb74c8d3eb840$var$ma = {};
function $6a0eb74c8d3eb840$var$oa(a) {
    if ($6a0eb74c8d3eb840$var$ja.call($6a0eb74c8d3eb840$var$ma, a)) return !0;
    if ($6a0eb74c8d3eb840$var$ja.call($6a0eb74c8d3eb840$var$la, a)) return !1;
    if ($6a0eb74c8d3eb840$var$ka.test(a)) return $6a0eb74c8d3eb840$var$ma[a] = !0;
    $6a0eb74c8d3eb840$var$la[a] = !0;
    return !1;
}
function $6a0eb74c8d3eb840$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $6a0eb74c8d3eb840$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $6a0eb74c8d3eb840$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $6a0eb74c8d3eb840$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $6a0eb74c8d3eb840$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $6a0eb74c8d3eb840$var$z[b] = new $6a0eb74c8d3eb840$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $6a0eb74c8d3eb840$var$ra = /[\-:]([a-z])/g;
function $6a0eb74c8d3eb840$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($6a0eb74c8d3eb840$var$ra, $6a0eb74c8d3eb840$var$sa);
    $6a0eb74c8d3eb840$var$z[b] = new $6a0eb74c8d3eb840$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($6a0eb74c8d3eb840$var$ra, $6a0eb74c8d3eb840$var$sa);
    $6a0eb74c8d3eb840$var$z[b] = new $6a0eb74c8d3eb840$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($6a0eb74c8d3eb840$var$ra, $6a0eb74c8d3eb840$var$sa);
    $6a0eb74c8d3eb840$var$z[b] = new $6a0eb74c8d3eb840$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$6a0eb74c8d3eb840$var$z.xlinkHref = new $6a0eb74c8d3eb840$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $6a0eb74c8d3eb840$var$z[a] = new $6a0eb74c8d3eb840$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $6a0eb74c8d3eb840$var$ta(a, b, c, d) {
    var e = $6a0eb74c8d3eb840$var$z.hasOwnProperty(b) ? $6a0eb74c8d3eb840$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $6a0eb74c8d3eb840$var$qa(b, c, e, d) && (c = null), d || null === e ? $6a0eb74c8d3eb840$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $6a0eb74c8d3eb840$var$ua = $1G08a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $6a0eb74c8d3eb840$var$va = Symbol.for("react.element"), $6a0eb74c8d3eb840$var$wa = Symbol.for("react.portal"), $6a0eb74c8d3eb840$var$ya = Symbol.for("react.fragment"), $6a0eb74c8d3eb840$var$za = Symbol.for("react.strict_mode"), $6a0eb74c8d3eb840$var$Aa = Symbol.for("react.profiler"), $6a0eb74c8d3eb840$var$Ba = Symbol.for("react.provider"), $6a0eb74c8d3eb840$var$Ca = Symbol.for("react.context"), $6a0eb74c8d3eb840$var$Da = Symbol.for("react.forward_ref"), $6a0eb74c8d3eb840$var$Ea = Symbol.for("react.suspense"), $6a0eb74c8d3eb840$var$Fa = Symbol.for("react.suspense_list"), $6a0eb74c8d3eb840$var$Ga = Symbol.for("react.memo"), $6a0eb74c8d3eb840$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $6a0eb74c8d3eb840$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $6a0eb74c8d3eb840$var$Ja = Symbol.iterator;
function $6a0eb74c8d3eb840$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $6a0eb74c8d3eb840$var$Ja && a[$6a0eb74c8d3eb840$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $6a0eb74c8d3eb840$var$A = Object.assign, $6a0eb74c8d3eb840$var$La;
function $6a0eb74c8d3eb840$var$Ma(a) {
    if (void 0 === $6a0eb74c8d3eb840$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $6a0eb74c8d3eb840$var$La = b && b[1] || "";
    }
    return "\n" + $6a0eb74c8d3eb840$var$La + a;
}
var $6a0eb74c8d3eb840$var$Na = !1;
function $6a0eb74c8d3eb840$var$Oa(a, b) {
    if (!a || $6a0eb74c8d3eb840$var$Na) return "";
    $6a0eb74c8d3eb840$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $6a0eb74c8d3eb840$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $6a0eb74c8d3eb840$var$Ma(a) : "";
}
function $6a0eb74c8d3eb840$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $6a0eb74c8d3eb840$var$Ma(a.type);
        case 16:
            return $6a0eb74c8d3eb840$var$Ma("Lazy");
        case 13:
            return $6a0eb74c8d3eb840$var$Ma("Suspense");
        case 19:
            return $6a0eb74c8d3eb840$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $6a0eb74c8d3eb840$var$Oa(a.type, !1), a;
        case 11:
            return a = $6a0eb74c8d3eb840$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $6a0eb74c8d3eb840$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $6a0eb74c8d3eb840$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $6a0eb74c8d3eb840$var$ya:
            return "Fragment";
        case $6a0eb74c8d3eb840$var$wa:
            return "Portal";
        case $6a0eb74c8d3eb840$var$Aa:
            return "Profiler";
        case $6a0eb74c8d3eb840$var$za:
            return "StrictMode";
        case $6a0eb74c8d3eb840$var$Ea:
            return "Suspense";
        case $6a0eb74c8d3eb840$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $6a0eb74c8d3eb840$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $6a0eb74c8d3eb840$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $6a0eb74c8d3eb840$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $6a0eb74c8d3eb840$var$Ga:
            return b = a.displayName || null, null !== b ? b : $6a0eb74c8d3eb840$var$Qa(a.type) || "Memo";
        case $6a0eb74c8d3eb840$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $6a0eb74c8d3eb840$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $6a0eb74c8d3eb840$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $6a0eb74c8d3eb840$var$Qa(b);
        case 8:
            return b === $6a0eb74c8d3eb840$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $6a0eb74c8d3eb840$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $6a0eb74c8d3eb840$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $6a0eb74c8d3eb840$var$Ua(a) {
    var b = $6a0eb74c8d3eb840$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $6a0eb74c8d3eb840$var$Va(a) {
    a._valueTracker || (a._valueTracker = $6a0eb74c8d3eb840$var$Ua(a));
}
function $6a0eb74c8d3eb840$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $6a0eb74c8d3eb840$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $6a0eb74c8d3eb840$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $6a0eb74c8d3eb840$var$Ya(a, b) {
    var c = b.checked;
    return $6a0eb74c8d3eb840$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $6a0eb74c8d3eb840$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $6a0eb74c8d3eb840$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $6a0eb74c8d3eb840$var$ab(a, b) {
    b = b.checked;
    null != b && $6a0eb74c8d3eb840$var$ta(a, "checked", b, !1);
}
function $6a0eb74c8d3eb840$var$bb(a, b) {
    $6a0eb74c8d3eb840$var$ab(a, b);
    var c = $6a0eb74c8d3eb840$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $6a0eb74c8d3eb840$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $6a0eb74c8d3eb840$var$cb(a, b.type, $6a0eb74c8d3eb840$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $6a0eb74c8d3eb840$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $6a0eb74c8d3eb840$var$cb(a, b, c) {
    if ("number" !== b || $6a0eb74c8d3eb840$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $6a0eb74c8d3eb840$var$eb = Array.isArray;
function $6a0eb74c8d3eb840$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $6a0eb74c8d3eb840$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $6a0eb74c8d3eb840$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($6a0eb74c8d3eb840$var$p(91));
    return $6a0eb74c8d3eb840$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $6a0eb74c8d3eb840$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($6a0eb74c8d3eb840$var$p(92));
            if ($6a0eb74c8d3eb840$var$eb(c)) {
                if (1 < c.length) throw Error($6a0eb74c8d3eb840$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $6a0eb74c8d3eb840$var$Sa(c)
    };
}
function $6a0eb74c8d3eb840$var$ib(a, b) {
    var c = $6a0eb74c8d3eb840$var$Sa(b.value), d = $6a0eb74c8d3eb840$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $6a0eb74c8d3eb840$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $6a0eb74c8d3eb840$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $6a0eb74c8d3eb840$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $6a0eb74c8d3eb840$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $6a0eb74c8d3eb840$var$mb, $6a0eb74c8d3eb840$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $6a0eb74c8d3eb840$var$mb = $6a0eb74c8d3eb840$var$mb || document.createElement("div");
        $6a0eb74c8d3eb840$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $6a0eb74c8d3eb840$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $6a0eb74c8d3eb840$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $6a0eb74c8d3eb840$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $6a0eb74c8d3eb840$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($6a0eb74c8d3eb840$var$pb).forEach(function(a) {
    $6a0eb74c8d3eb840$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $6a0eb74c8d3eb840$var$pb[b] = $6a0eb74c8d3eb840$var$pb[a];
    });
});
function $6a0eb74c8d3eb840$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $6a0eb74c8d3eb840$var$pb.hasOwnProperty(a) && $6a0eb74c8d3eb840$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $6a0eb74c8d3eb840$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $6a0eb74c8d3eb840$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $6a0eb74c8d3eb840$var$tb = $6a0eb74c8d3eb840$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $6a0eb74c8d3eb840$var$ub(a, b) {
    if (b) {
        if ($6a0eb74c8d3eb840$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($6a0eb74c8d3eb840$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($6a0eb74c8d3eb840$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($6a0eb74c8d3eb840$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($6a0eb74c8d3eb840$var$p(62));
    }
}
function $6a0eb74c8d3eb840$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $6a0eb74c8d3eb840$var$wb = null;
function $6a0eb74c8d3eb840$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $6a0eb74c8d3eb840$var$yb = null, $6a0eb74c8d3eb840$var$zb = null, $6a0eb74c8d3eb840$var$Ab = null;
function $6a0eb74c8d3eb840$var$Bb(a) {
    if (a = $6a0eb74c8d3eb840$var$Cb(a)) {
        if ("function" !== typeof $6a0eb74c8d3eb840$var$yb) throw Error($6a0eb74c8d3eb840$var$p(280));
        var b = a.stateNode;
        b && (b = $6a0eb74c8d3eb840$var$Db(b), $6a0eb74c8d3eb840$var$yb(a.stateNode, a.type, b));
    }
}
function $6a0eb74c8d3eb840$var$Eb(a) {
    $6a0eb74c8d3eb840$var$zb ? $6a0eb74c8d3eb840$var$Ab ? $6a0eb74c8d3eb840$var$Ab.push(a) : $6a0eb74c8d3eb840$var$Ab = [
        a
    ] : $6a0eb74c8d3eb840$var$zb = a;
}
function $6a0eb74c8d3eb840$var$Fb() {
    if ($6a0eb74c8d3eb840$var$zb) {
        var a = $6a0eb74c8d3eb840$var$zb, b = $6a0eb74c8d3eb840$var$Ab;
        $6a0eb74c8d3eb840$var$Ab = $6a0eb74c8d3eb840$var$zb = null;
        $6a0eb74c8d3eb840$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$6a0eb74c8d3eb840$var$Bb(b[a]);
    }
}
function $6a0eb74c8d3eb840$var$Gb(a, b) {
    return a(b);
}
function $6a0eb74c8d3eb840$var$Hb() {}
var $6a0eb74c8d3eb840$var$Ib = !1;
function $6a0eb74c8d3eb840$var$Jb(a, b, c) {
    if ($6a0eb74c8d3eb840$var$Ib) return a(b, c);
    $6a0eb74c8d3eb840$var$Ib = !0;
    try {
        return $6a0eb74c8d3eb840$var$Gb(a, b, c);
    } finally{
        if ($6a0eb74c8d3eb840$var$Ib = !1, null !== $6a0eb74c8d3eb840$var$zb || null !== $6a0eb74c8d3eb840$var$Ab) $6a0eb74c8d3eb840$var$Hb(), $6a0eb74c8d3eb840$var$Fb();
    }
}
function $6a0eb74c8d3eb840$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $6a0eb74c8d3eb840$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($6a0eb74c8d3eb840$var$p(231, b, typeof c));
    return c;
}
var $6a0eb74c8d3eb840$var$Lb = !1;
if ($6a0eb74c8d3eb840$var$ia) try {
    var $6a0eb74c8d3eb840$var$Mb = {};
    Object.defineProperty($6a0eb74c8d3eb840$var$Mb, "passive", {
        get: function() {
            $6a0eb74c8d3eb840$var$Lb = !0;
        }
    });
    window.addEventListener("test", $6a0eb74c8d3eb840$var$Mb, $6a0eb74c8d3eb840$var$Mb);
    window.removeEventListener("test", $6a0eb74c8d3eb840$var$Mb, $6a0eb74c8d3eb840$var$Mb);
} catch (a) {
    $6a0eb74c8d3eb840$var$Lb = !1;
}
function $6a0eb74c8d3eb840$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $6a0eb74c8d3eb840$var$Ob = !1, $6a0eb74c8d3eb840$var$Pb = null, $6a0eb74c8d3eb840$var$Qb = !1, $6a0eb74c8d3eb840$var$Rb = null, $6a0eb74c8d3eb840$var$Sb = {
    onError: function(a) {
        $6a0eb74c8d3eb840$var$Ob = !0;
        $6a0eb74c8d3eb840$var$Pb = a;
    }
};
function $6a0eb74c8d3eb840$var$Tb(a, b, c, d, e, f, g, h, k) {
    $6a0eb74c8d3eb840$var$Ob = !1;
    $6a0eb74c8d3eb840$var$Pb = null;
    $6a0eb74c8d3eb840$var$Nb.apply($6a0eb74c8d3eb840$var$Sb, arguments);
}
function $6a0eb74c8d3eb840$var$Ub(a, b, c, d, e, f, g, h, k) {
    $6a0eb74c8d3eb840$var$Tb.apply(this, arguments);
    if ($6a0eb74c8d3eb840$var$Ob) {
        if ($6a0eb74c8d3eb840$var$Ob) {
            var l = $6a0eb74c8d3eb840$var$Pb;
            $6a0eb74c8d3eb840$var$Ob = !1;
            $6a0eb74c8d3eb840$var$Pb = null;
        } else throw Error($6a0eb74c8d3eb840$var$p(198));
        $6a0eb74c8d3eb840$var$Qb || ($6a0eb74c8d3eb840$var$Qb = !0, $6a0eb74c8d3eb840$var$Rb = l);
    }
}
function $6a0eb74c8d3eb840$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $6a0eb74c8d3eb840$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $6a0eb74c8d3eb840$var$Xb(a) {
    if ($6a0eb74c8d3eb840$var$Vb(a) !== a) throw Error($6a0eb74c8d3eb840$var$p(188));
}
function $6a0eb74c8d3eb840$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $6a0eb74c8d3eb840$var$Vb(a);
        if (null === b) throw Error($6a0eb74c8d3eb840$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $6a0eb74c8d3eb840$var$Xb(e), a;
                if (f === d) return $6a0eb74c8d3eb840$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($6a0eb74c8d3eb840$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($6a0eb74c8d3eb840$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($6a0eb74c8d3eb840$var$p(190));
    }
    if (3 !== c.tag) throw Error($6a0eb74c8d3eb840$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $6a0eb74c8d3eb840$var$Zb(a) {
    a = $6a0eb74c8d3eb840$var$Yb(a);
    return null !== a ? $6a0eb74c8d3eb840$var$$b(a) : null;
}
function $6a0eb74c8d3eb840$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $6a0eb74c8d3eb840$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $6a0eb74c8d3eb840$var$ac = $lyjZb.unstable_scheduleCallback, $6a0eb74c8d3eb840$var$bc = $lyjZb.unstable_cancelCallback, $6a0eb74c8d3eb840$var$cc = $lyjZb.unstable_shouldYield, $6a0eb74c8d3eb840$var$dc = $lyjZb.unstable_requestPaint, $6a0eb74c8d3eb840$var$B = $lyjZb.unstable_now, $6a0eb74c8d3eb840$var$ec = $lyjZb.unstable_getCurrentPriorityLevel, $6a0eb74c8d3eb840$var$fc = $lyjZb.unstable_ImmediatePriority, $6a0eb74c8d3eb840$var$gc = $lyjZb.unstable_UserBlockingPriority, $6a0eb74c8d3eb840$var$hc = $lyjZb.unstable_NormalPriority, $6a0eb74c8d3eb840$var$ic = $lyjZb.unstable_LowPriority, $6a0eb74c8d3eb840$var$jc = $lyjZb.unstable_IdlePriority, $6a0eb74c8d3eb840$var$kc = null, $6a0eb74c8d3eb840$var$lc = null;
function $6a0eb74c8d3eb840$var$mc(a) {
    if ($6a0eb74c8d3eb840$var$lc && "function" === typeof $6a0eb74c8d3eb840$var$lc.onCommitFiberRoot) try {
        $6a0eb74c8d3eb840$var$lc.onCommitFiberRoot($6a0eb74c8d3eb840$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $6a0eb74c8d3eb840$var$oc = Math.clz32 ? Math.clz32 : $6a0eb74c8d3eb840$var$nc, $6a0eb74c8d3eb840$var$pc = Math.log, $6a0eb74c8d3eb840$var$qc = Math.LN2;
function $6a0eb74c8d3eb840$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($6a0eb74c8d3eb840$var$pc(a) / $6a0eb74c8d3eb840$var$qc | 0) | 0;
}
var $6a0eb74c8d3eb840$var$rc = 64, $6a0eb74c8d3eb840$var$sc = 4194304;
function $6a0eb74c8d3eb840$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $6a0eb74c8d3eb840$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $6a0eb74c8d3eb840$var$tc(h) : (f &= g, 0 !== f && (d = $6a0eb74c8d3eb840$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $6a0eb74c8d3eb840$var$tc(g) : 0 !== f && (d = $6a0eb74c8d3eb840$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $6a0eb74c8d3eb840$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $6a0eb74c8d3eb840$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $6a0eb74c8d3eb840$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $6a0eb74c8d3eb840$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $6a0eb74c8d3eb840$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $6a0eb74c8d3eb840$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $6a0eb74c8d3eb840$var$yc() {
    var a = $6a0eb74c8d3eb840$var$rc;
    $6a0eb74c8d3eb840$var$rc <<= 1;
    0 === ($6a0eb74c8d3eb840$var$rc & 4194240) && ($6a0eb74c8d3eb840$var$rc = 64);
    return a;
}
function $6a0eb74c8d3eb840$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $6a0eb74c8d3eb840$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $6a0eb74c8d3eb840$var$oc(b);
    a[b] = c;
}
function $6a0eb74c8d3eb840$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $6a0eb74c8d3eb840$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $6a0eb74c8d3eb840$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $6a0eb74c8d3eb840$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $6a0eb74c8d3eb840$var$C = 0;
function $6a0eb74c8d3eb840$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $6a0eb74c8d3eb840$var$Ec, $6a0eb74c8d3eb840$var$Fc, $6a0eb74c8d3eb840$var$Gc, $6a0eb74c8d3eb840$var$Hc, $6a0eb74c8d3eb840$var$Ic, $6a0eb74c8d3eb840$var$Jc = !1, $6a0eb74c8d3eb840$var$Kc = [], $6a0eb74c8d3eb840$var$Lc = null, $6a0eb74c8d3eb840$var$Mc = null, $6a0eb74c8d3eb840$var$Nc = null, $6a0eb74c8d3eb840$var$Oc = new Map, $6a0eb74c8d3eb840$var$Pc = new Map, $6a0eb74c8d3eb840$var$Qc = [], $6a0eb74c8d3eb840$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $6a0eb74c8d3eb840$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $6a0eb74c8d3eb840$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $6a0eb74c8d3eb840$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $6a0eb74c8d3eb840$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $6a0eb74c8d3eb840$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $6a0eb74c8d3eb840$var$Pc.delete(b.pointerId);
    }
}
function $6a0eb74c8d3eb840$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $6a0eb74c8d3eb840$var$Cb(b), null !== b && $6a0eb74c8d3eb840$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $6a0eb74c8d3eb840$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $6a0eb74c8d3eb840$var$Lc = $6a0eb74c8d3eb840$var$Tc($6a0eb74c8d3eb840$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $6a0eb74c8d3eb840$var$Mc = $6a0eb74c8d3eb840$var$Tc($6a0eb74c8d3eb840$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $6a0eb74c8d3eb840$var$Nc = $6a0eb74c8d3eb840$var$Tc($6a0eb74c8d3eb840$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $6a0eb74c8d3eb840$var$Oc.set(f, $6a0eb74c8d3eb840$var$Tc($6a0eb74c8d3eb840$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $6a0eb74c8d3eb840$var$Pc.set(f, $6a0eb74c8d3eb840$var$Tc($6a0eb74c8d3eb840$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $6a0eb74c8d3eb840$var$Vc(a) {
    var b = $6a0eb74c8d3eb840$var$Wc(a.target);
    if (null !== b) {
        var c = $6a0eb74c8d3eb840$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $6a0eb74c8d3eb840$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $6a0eb74c8d3eb840$var$Ic(a.priority, function() {
                        $6a0eb74c8d3eb840$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $6a0eb74c8d3eb840$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $6a0eb74c8d3eb840$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $6a0eb74c8d3eb840$var$wb = d;
            c.target.dispatchEvent(d);
            $6a0eb74c8d3eb840$var$wb = null;
        } else return b = $6a0eb74c8d3eb840$var$Cb(c), null !== b && $6a0eb74c8d3eb840$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $6a0eb74c8d3eb840$var$Zc(a, b, c) {
    $6a0eb74c8d3eb840$var$Xc(a) && c.delete(b);
}
function $6a0eb74c8d3eb840$var$$c() {
    $6a0eb74c8d3eb840$var$Jc = !1;
    null !== $6a0eb74c8d3eb840$var$Lc && $6a0eb74c8d3eb840$var$Xc($6a0eb74c8d3eb840$var$Lc) && ($6a0eb74c8d3eb840$var$Lc = null);
    null !== $6a0eb74c8d3eb840$var$Mc && $6a0eb74c8d3eb840$var$Xc($6a0eb74c8d3eb840$var$Mc) && ($6a0eb74c8d3eb840$var$Mc = null);
    null !== $6a0eb74c8d3eb840$var$Nc && $6a0eb74c8d3eb840$var$Xc($6a0eb74c8d3eb840$var$Nc) && ($6a0eb74c8d3eb840$var$Nc = null);
    $6a0eb74c8d3eb840$var$Oc.forEach($6a0eb74c8d3eb840$var$Zc);
    $6a0eb74c8d3eb840$var$Pc.forEach($6a0eb74c8d3eb840$var$Zc);
}
function $6a0eb74c8d3eb840$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $6a0eb74c8d3eb840$var$Jc || ($6a0eb74c8d3eb840$var$Jc = !0, $lyjZb.unstable_scheduleCallback($lyjZb.unstable_NormalPriority, $6a0eb74c8d3eb840$var$$c)));
}
function $6a0eb74c8d3eb840$var$bd(a) {
    function b(b) {
        return $6a0eb74c8d3eb840$var$ad(b, a);
    }
    if (0 < $6a0eb74c8d3eb840$var$Kc.length) {
        $6a0eb74c8d3eb840$var$ad($6a0eb74c8d3eb840$var$Kc[0], a);
        for(var c = 1; c < $6a0eb74c8d3eb840$var$Kc.length; c++){
            var d = $6a0eb74c8d3eb840$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $6a0eb74c8d3eb840$var$Lc && $6a0eb74c8d3eb840$var$ad($6a0eb74c8d3eb840$var$Lc, a);
    null !== $6a0eb74c8d3eb840$var$Mc && $6a0eb74c8d3eb840$var$ad($6a0eb74c8d3eb840$var$Mc, a);
    null !== $6a0eb74c8d3eb840$var$Nc && $6a0eb74c8d3eb840$var$ad($6a0eb74c8d3eb840$var$Nc, a);
    $6a0eb74c8d3eb840$var$Oc.forEach(b);
    $6a0eb74c8d3eb840$var$Pc.forEach(b);
    for(c = 0; c < $6a0eb74c8d3eb840$var$Qc.length; c++)d = $6a0eb74c8d3eb840$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $6a0eb74c8d3eb840$var$Qc.length && (c = $6a0eb74c8d3eb840$var$Qc[0], null === c.blockedOn);)$6a0eb74c8d3eb840$var$Vc(c), null === c.blockedOn && $6a0eb74c8d3eb840$var$Qc.shift();
}
var $6a0eb74c8d3eb840$var$cd = $6a0eb74c8d3eb840$var$ua.ReactCurrentBatchConfig, $6a0eb74c8d3eb840$var$dd = !0;
function $6a0eb74c8d3eb840$var$ed(a, b, c, d) {
    var e = $6a0eb74c8d3eb840$var$C, f = $6a0eb74c8d3eb840$var$cd.transition;
    $6a0eb74c8d3eb840$var$cd.transition = null;
    try {
        $6a0eb74c8d3eb840$var$C = 1, $6a0eb74c8d3eb840$var$fd(a, b, c, d);
    } finally{
        $6a0eb74c8d3eb840$var$C = e, $6a0eb74c8d3eb840$var$cd.transition = f;
    }
}
function $6a0eb74c8d3eb840$var$gd(a, b, c, d) {
    var e = $6a0eb74c8d3eb840$var$C, f = $6a0eb74c8d3eb840$var$cd.transition;
    $6a0eb74c8d3eb840$var$cd.transition = null;
    try {
        $6a0eb74c8d3eb840$var$C = 4, $6a0eb74c8d3eb840$var$fd(a, b, c, d);
    } finally{
        $6a0eb74c8d3eb840$var$C = e, $6a0eb74c8d3eb840$var$cd.transition = f;
    }
}
function $6a0eb74c8d3eb840$var$fd(a, b, c, d) {
    if ($6a0eb74c8d3eb840$var$dd) {
        var e = $6a0eb74c8d3eb840$var$Yc(a, b, c, d);
        if (null === e) $6a0eb74c8d3eb840$var$hd(a, b, d, $6a0eb74c8d3eb840$var$id, c), $6a0eb74c8d3eb840$var$Sc(a, d);
        else if ($6a0eb74c8d3eb840$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($6a0eb74c8d3eb840$var$Sc(a, d), b & 4 && -1 < $6a0eb74c8d3eb840$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $6a0eb74c8d3eb840$var$Cb(e);
                null !== f && $6a0eb74c8d3eb840$var$Ec(f);
                f = $6a0eb74c8d3eb840$var$Yc(a, b, c, d);
                null === f && $6a0eb74c8d3eb840$var$hd(a, b, d, $6a0eb74c8d3eb840$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $6a0eb74c8d3eb840$var$hd(a, b, d, null, c);
    }
}
var $6a0eb74c8d3eb840$var$id = null;
function $6a0eb74c8d3eb840$var$Yc(a, b, c, d) {
    $6a0eb74c8d3eb840$var$id = null;
    a = $6a0eb74c8d3eb840$var$xb(d);
    a = $6a0eb74c8d3eb840$var$Wc(a);
    if (null !== a) {
        if (b = $6a0eb74c8d3eb840$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $6a0eb74c8d3eb840$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $6a0eb74c8d3eb840$var$id = a;
    return null;
}
function $6a0eb74c8d3eb840$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($6a0eb74c8d3eb840$var$ec()){
                case $6a0eb74c8d3eb840$var$fc:
                    return 1;
                case $6a0eb74c8d3eb840$var$gc:
                    return 4;
                case $6a0eb74c8d3eb840$var$hc:
                case $6a0eb74c8d3eb840$var$ic:
                    return 16;
                case $6a0eb74c8d3eb840$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $6a0eb74c8d3eb840$var$kd = null, $6a0eb74c8d3eb840$var$ld = null, $6a0eb74c8d3eb840$var$md = null;
function $6a0eb74c8d3eb840$var$nd() {
    if ($6a0eb74c8d3eb840$var$md) return $6a0eb74c8d3eb840$var$md;
    var a, b = $6a0eb74c8d3eb840$var$ld, c = b.length, d, e = "value" in $6a0eb74c8d3eb840$var$kd ? $6a0eb74c8d3eb840$var$kd.value : $6a0eb74c8d3eb840$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $6a0eb74c8d3eb840$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $6a0eb74c8d3eb840$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $6a0eb74c8d3eb840$var$pd() {
    return !0;
}
function $6a0eb74c8d3eb840$var$qd() {
    return !1;
}
function $6a0eb74c8d3eb840$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $6a0eb74c8d3eb840$var$pd : $6a0eb74c8d3eb840$var$qd;
        this.isPropagationStopped = $6a0eb74c8d3eb840$var$qd;
        return this;
    }
    $6a0eb74c8d3eb840$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $6a0eb74c8d3eb840$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $6a0eb74c8d3eb840$var$pd);
        },
        persist: function() {},
        isPersistent: $6a0eb74c8d3eb840$var$pd
    });
    return b;
}
var $6a0eb74c8d3eb840$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $6a0eb74c8d3eb840$var$td = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$sd), $6a0eb74c8d3eb840$var$ud = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$sd, {
    view: 0,
    detail: 0
}), $6a0eb74c8d3eb840$var$vd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$ud), $6a0eb74c8d3eb840$var$wd, $6a0eb74c8d3eb840$var$xd, $6a0eb74c8d3eb840$var$yd, $6a0eb74c8d3eb840$var$Ad = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $6a0eb74c8d3eb840$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $6a0eb74c8d3eb840$var$yd && ($6a0eb74c8d3eb840$var$yd && "mousemove" === a.type ? ($6a0eb74c8d3eb840$var$wd = a.screenX - $6a0eb74c8d3eb840$var$yd.screenX, $6a0eb74c8d3eb840$var$xd = a.screenY - $6a0eb74c8d3eb840$var$yd.screenY) : $6a0eb74c8d3eb840$var$xd = $6a0eb74c8d3eb840$var$wd = 0, $6a0eb74c8d3eb840$var$yd = a);
        return $6a0eb74c8d3eb840$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $6a0eb74c8d3eb840$var$xd;
    }
}), $6a0eb74c8d3eb840$var$Bd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Ad), $6a0eb74c8d3eb840$var$Cd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$Ad, {
    dataTransfer: 0
}), $6a0eb74c8d3eb840$var$Dd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Cd), $6a0eb74c8d3eb840$var$Ed = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$ud, {
    relatedTarget: 0
}), $6a0eb74c8d3eb840$var$Fd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Ed), $6a0eb74c8d3eb840$var$Gd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6a0eb74c8d3eb840$var$Hd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Gd), $6a0eb74c8d3eb840$var$Id = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $6a0eb74c8d3eb840$var$Jd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Id), $6a0eb74c8d3eb840$var$Kd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$sd, {
    data: 0
}), $6a0eb74c8d3eb840$var$Ld = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Kd), $6a0eb74c8d3eb840$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $6a0eb74c8d3eb840$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $6a0eb74c8d3eb840$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $6a0eb74c8d3eb840$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $6a0eb74c8d3eb840$var$Od[a]) ? !!b[a] : !1;
}
function $6a0eb74c8d3eb840$var$zd() {
    return $6a0eb74c8d3eb840$var$Pd;
}
var $6a0eb74c8d3eb840$var$Qd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $6a0eb74c8d3eb840$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $6a0eb74c8d3eb840$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $6a0eb74c8d3eb840$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $6a0eb74c8d3eb840$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $6a0eb74c8d3eb840$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $6a0eb74c8d3eb840$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $6a0eb74c8d3eb840$var$Rd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Qd), $6a0eb74c8d3eb840$var$Sd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $6a0eb74c8d3eb840$var$Td = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Sd), $6a0eb74c8d3eb840$var$Ud = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $6a0eb74c8d3eb840$var$zd
}), $6a0eb74c8d3eb840$var$Vd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Ud), $6a0eb74c8d3eb840$var$Wd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6a0eb74c8d3eb840$var$Xd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Wd), $6a0eb74c8d3eb840$var$Yd = $6a0eb74c8d3eb840$var$A({}, $6a0eb74c8d3eb840$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $6a0eb74c8d3eb840$var$Zd = $6a0eb74c8d3eb840$var$rd($6a0eb74c8d3eb840$var$Yd), $6a0eb74c8d3eb840$var$$d = [
    9,
    13,
    27,
    32
], $6a0eb74c8d3eb840$var$ae = $6a0eb74c8d3eb840$var$ia && "CompositionEvent" in window, $6a0eb74c8d3eb840$var$be = null;
$6a0eb74c8d3eb840$var$ia && "documentMode" in document && ($6a0eb74c8d3eb840$var$be = document.documentMode);
var $6a0eb74c8d3eb840$var$ce = $6a0eb74c8d3eb840$var$ia && "TextEvent" in window && !$6a0eb74c8d3eb840$var$be, $6a0eb74c8d3eb840$var$de = $6a0eb74c8d3eb840$var$ia && (!$6a0eb74c8d3eb840$var$ae || $6a0eb74c8d3eb840$var$be && 8 < $6a0eb74c8d3eb840$var$be && 11 >= $6a0eb74c8d3eb840$var$be), $6a0eb74c8d3eb840$var$ee = String.fromCharCode(32), $6a0eb74c8d3eb840$var$fe = !1;
function $6a0eb74c8d3eb840$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $6a0eb74c8d3eb840$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $6a0eb74c8d3eb840$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $6a0eb74c8d3eb840$var$ie = !1;
function $6a0eb74c8d3eb840$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $6a0eb74c8d3eb840$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $6a0eb74c8d3eb840$var$fe = !0;
            return $6a0eb74c8d3eb840$var$ee;
        case "textInput":
            return a = b.data, a === $6a0eb74c8d3eb840$var$ee && $6a0eb74c8d3eb840$var$fe ? null : a;
        default:
            return null;
    }
}
function $6a0eb74c8d3eb840$var$ke(a, b) {
    if ($6a0eb74c8d3eb840$var$ie) return "compositionend" === a || !$6a0eb74c8d3eb840$var$ae && $6a0eb74c8d3eb840$var$ge(a, b) ? (a = $6a0eb74c8d3eb840$var$nd(), $6a0eb74c8d3eb840$var$md = $6a0eb74c8d3eb840$var$ld = $6a0eb74c8d3eb840$var$kd = null, $6a0eb74c8d3eb840$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $6a0eb74c8d3eb840$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $6a0eb74c8d3eb840$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $6a0eb74c8d3eb840$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$6a0eb74c8d3eb840$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $6a0eb74c8d3eb840$var$ne(a, b, c, d) {
    $6a0eb74c8d3eb840$var$Eb(d);
    b = $6a0eb74c8d3eb840$var$oe(b, "onChange");
    0 < b.length && (c = new $6a0eb74c8d3eb840$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $6a0eb74c8d3eb840$var$pe = null, $6a0eb74c8d3eb840$var$qe = null;
function $6a0eb74c8d3eb840$var$re(a) {
    $6a0eb74c8d3eb840$var$se(a, 0);
}
function $6a0eb74c8d3eb840$var$te(a) {
    var b = $6a0eb74c8d3eb840$var$ue(a);
    if ($6a0eb74c8d3eb840$var$Wa(b)) return a;
}
function $6a0eb74c8d3eb840$var$ve(a, b) {
    if ("change" === a) return b;
}
var $6a0eb74c8d3eb840$var$we = !1;
if ($6a0eb74c8d3eb840$var$ia) {
    var $6a0eb74c8d3eb840$var$xe;
    if ($6a0eb74c8d3eb840$var$ia) {
        var $6a0eb74c8d3eb840$var$ye = "oninput" in document;
        if (!$6a0eb74c8d3eb840$var$ye) {
            var $6a0eb74c8d3eb840$var$ze = document.createElement("div");
            $6a0eb74c8d3eb840$var$ze.setAttribute("oninput", "return;");
            $6a0eb74c8d3eb840$var$ye = "function" === typeof $6a0eb74c8d3eb840$var$ze.oninput;
        }
        $6a0eb74c8d3eb840$var$xe = $6a0eb74c8d3eb840$var$ye;
    } else $6a0eb74c8d3eb840$var$xe = !1;
    $6a0eb74c8d3eb840$var$we = $6a0eb74c8d3eb840$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $6a0eb74c8d3eb840$var$Ae() {
    $6a0eb74c8d3eb840$var$pe && ($6a0eb74c8d3eb840$var$pe.detachEvent("onpropertychange", $6a0eb74c8d3eb840$var$Be), $6a0eb74c8d3eb840$var$qe = $6a0eb74c8d3eb840$var$pe = null);
}
function $6a0eb74c8d3eb840$var$Be(a) {
    if ("value" === a.propertyName && $6a0eb74c8d3eb840$var$te($6a0eb74c8d3eb840$var$qe)) {
        var b = [];
        $6a0eb74c8d3eb840$var$ne(b, $6a0eb74c8d3eb840$var$qe, a, $6a0eb74c8d3eb840$var$xb(a));
        $6a0eb74c8d3eb840$var$Jb($6a0eb74c8d3eb840$var$re, b);
    }
}
function $6a0eb74c8d3eb840$var$Ce(a, b, c) {
    "focusin" === a ? ($6a0eb74c8d3eb840$var$Ae(), $6a0eb74c8d3eb840$var$pe = b, $6a0eb74c8d3eb840$var$qe = c, $6a0eb74c8d3eb840$var$pe.attachEvent("onpropertychange", $6a0eb74c8d3eb840$var$Be)) : "focusout" === a && $6a0eb74c8d3eb840$var$Ae();
}
function $6a0eb74c8d3eb840$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $6a0eb74c8d3eb840$var$te($6a0eb74c8d3eb840$var$qe);
}
function $6a0eb74c8d3eb840$var$Ee(a, b) {
    if ("click" === a) return $6a0eb74c8d3eb840$var$te(b);
}
function $6a0eb74c8d3eb840$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $6a0eb74c8d3eb840$var$te(b);
}
function $6a0eb74c8d3eb840$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $6a0eb74c8d3eb840$var$He = "function" === typeof Object.is ? Object.is : $6a0eb74c8d3eb840$var$Ge;
function $6a0eb74c8d3eb840$var$Ie(a, b) {
    if ($6a0eb74c8d3eb840$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$6a0eb74c8d3eb840$var$ja.call(b, e) || !$6a0eb74c8d3eb840$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $6a0eb74c8d3eb840$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $6a0eb74c8d3eb840$var$Ke(a, b) {
    var c = $6a0eb74c8d3eb840$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $6a0eb74c8d3eb840$var$Je(c);
    }
}
function $6a0eb74c8d3eb840$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $6a0eb74c8d3eb840$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $6a0eb74c8d3eb840$var$Me() {
    for(var a = window, b = $6a0eb74c8d3eb840$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $6a0eb74c8d3eb840$var$Xa(a.document);
    }
    return b;
}
function $6a0eb74c8d3eb840$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $6a0eb74c8d3eb840$var$Oe(a) {
    var b = $6a0eb74c8d3eb840$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $6a0eb74c8d3eb840$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $6a0eb74c8d3eb840$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $6a0eb74c8d3eb840$var$Ke(c, f);
                var g = $6a0eb74c8d3eb840$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $6a0eb74c8d3eb840$var$Pe = $6a0eb74c8d3eb840$var$ia && "documentMode" in document && 11 >= document.documentMode, $6a0eb74c8d3eb840$var$Qe = null, $6a0eb74c8d3eb840$var$Re = null, $6a0eb74c8d3eb840$var$Se = null, $6a0eb74c8d3eb840$var$Te = !1;
function $6a0eb74c8d3eb840$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $6a0eb74c8d3eb840$var$Te || null == $6a0eb74c8d3eb840$var$Qe || $6a0eb74c8d3eb840$var$Qe !== $6a0eb74c8d3eb840$var$Xa(d) || (d = $6a0eb74c8d3eb840$var$Qe, "selectionStart" in d && $6a0eb74c8d3eb840$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $6a0eb74c8d3eb840$var$Se && $6a0eb74c8d3eb840$var$Ie($6a0eb74c8d3eb840$var$Se, d) || ($6a0eb74c8d3eb840$var$Se = d, d = $6a0eb74c8d3eb840$var$oe($6a0eb74c8d3eb840$var$Re, "onSelect"), 0 < d.length && (b = new $6a0eb74c8d3eb840$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $6a0eb74c8d3eb840$var$Qe)));
}
function $6a0eb74c8d3eb840$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $6a0eb74c8d3eb840$var$We = {
    animationend: $6a0eb74c8d3eb840$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $6a0eb74c8d3eb840$var$Ve("Animation", "AnimationIteration"),
    animationstart: $6a0eb74c8d3eb840$var$Ve("Animation", "AnimationStart"),
    transitionend: $6a0eb74c8d3eb840$var$Ve("Transition", "TransitionEnd")
}, $6a0eb74c8d3eb840$var$Xe = {}, $6a0eb74c8d3eb840$var$Ye = {};
$6a0eb74c8d3eb840$var$ia && ($6a0eb74c8d3eb840$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $6a0eb74c8d3eb840$var$We.animationend.animation, delete $6a0eb74c8d3eb840$var$We.animationiteration.animation, delete $6a0eb74c8d3eb840$var$We.animationstart.animation), "TransitionEvent" in window || delete $6a0eb74c8d3eb840$var$We.transitionend.transition);
function $6a0eb74c8d3eb840$var$Ze(a) {
    if ($6a0eb74c8d3eb840$var$Xe[a]) return $6a0eb74c8d3eb840$var$Xe[a];
    if (!$6a0eb74c8d3eb840$var$We[a]) return a;
    var b = $6a0eb74c8d3eb840$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $6a0eb74c8d3eb840$var$Ye) return $6a0eb74c8d3eb840$var$Xe[a] = b[c];
    return a;
}
var $6a0eb74c8d3eb840$var$$e = $6a0eb74c8d3eb840$var$Ze("animationend"), $6a0eb74c8d3eb840$var$af = $6a0eb74c8d3eb840$var$Ze("animationiteration"), $6a0eb74c8d3eb840$var$bf = $6a0eb74c8d3eb840$var$Ze("animationstart"), $6a0eb74c8d3eb840$var$cf = $6a0eb74c8d3eb840$var$Ze("transitionend"), $6a0eb74c8d3eb840$var$df = new Map, $6a0eb74c8d3eb840$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $6a0eb74c8d3eb840$var$ff(a, b) {
    $6a0eb74c8d3eb840$var$df.set(a, b);
    $6a0eb74c8d3eb840$var$fa(b, [
        a
    ]);
}
for(var $6a0eb74c8d3eb840$var$gf = 0; $6a0eb74c8d3eb840$var$gf < $6a0eb74c8d3eb840$var$ef.length; $6a0eb74c8d3eb840$var$gf++){
    var $6a0eb74c8d3eb840$var$hf = $6a0eb74c8d3eb840$var$ef[$6a0eb74c8d3eb840$var$gf], $6a0eb74c8d3eb840$var$jf = $6a0eb74c8d3eb840$var$hf.toLowerCase(), $6a0eb74c8d3eb840$var$kf = $6a0eb74c8d3eb840$var$hf[0].toUpperCase() + $6a0eb74c8d3eb840$var$hf.slice(1);
    $6a0eb74c8d3eb840$var$ff($6a0eb74c8d3eb840$var$jf, "on" + $6a0eb74c8d3eb840$var$kf);
}
$6a0eb74c8d3eb840$var$ff($6a0eb74c8d3eb840$var$$e, "onAnimationEnd");
$6a0eb74c8d3eb840$var$ff($6a0eb74c8d3eb840$var$af, "onAnimationIteration");
$6a0eb74c8d3eb840$var$ff($6a0eb74c8d3eb840$var$bf, "onAnimationStart");
$6a0eb74c8d3eb840$var$ff("dblclick", "onDoubleClick");
$6a0eb74c8d3eb840$var$ff("focusin", "onFocus");
$6a0eb74c8d3eb840$var$ff("focusout", "onBlur");
$6a0eb74c8d3eb840$var$ff($6a0eb74c8d3eb840$var$cf, "onTransitionEnd");
$6a0eb74c8d3eb840$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$6a0eb74c8d3eb840$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$6a0eb74c8d3eb840$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$6a0eb74c8d3eb840$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$6a0eb74c8d3eb840$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$6a0eb74c8d3eb840$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$6a0eb74c8d3eb840$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$6a0eb74c8d3eb840$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$6a0eb74c8d3eb840$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$6a0eb74c8d3eb840$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $6a0eb74c8d3eb840$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $6a0eb74c8d3eb840$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($6a0eb74c8d3eb840$var$lf));
function $6a0eb74c8d3eb840$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $6a0eb74c8d3eb840$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $6a0eb74c8d3eb840$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $6a0eb74c8d3eb840$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $6a0eb74c8d3eb840$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($6a0eb74c8d3eb840$var$Qb) throw a = $6a0eb74c8d3eb840$var$Rb, $6a0eb74c8d3eb840$var$Qb = !1, $6a0eb74c8d3eb840$var$Rb = null, a;
}
function $6a0eb74c8d3eb840$var$D(a, b) {
    var c = b[$6a0eb74c8d3eb840$var$of];
    void 0 === c && (c = b[$6a0eb74c8d3eb840$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($6a0eb74c8d3eb840$var$pf(b, a, 2, !1), c.add(d));
}
function $6a0eb74c8d3eb840$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $6a0eb74c8d3eb840$var$pf(c, a, d, b);
}
var $6a0eb74c8d3eb840$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $6a0eb74c8d3eb840$var$sf(a) {
    if (!a[$6a0eb74c8d3eb840$var$rf]) {
        a[$6a0eb74c8d3eb840$var$rf] = !0;
        $6a0eb74c8d3eb840$var$da.forEach(function(b) {
            "selectionchange" !== b && ($6a0eb74c8d3eb840$var$mf.has(b) || $6a0eb74c8d3eb840$var$qf(b, !1, a), $6a0eb74c8d3eb840$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$6a0eb74c8d3eb840$var$rf] || (b[$6a0eb74c8d3eb840$var$rf] = !0, $6a0eb74c8d3eb840$var$qf("selectionchange", !1, b));
    }
}
function $6a0eb74c8d3eb840$var$pf(a, b, c, d) {
    switch($6a0eb74c8d3eb840$var$jd(b)){
        case 1:
            var e = $6a0eb74c8d3eb840$var$ed;
            break;
        case 4:
            e = $6a0eb74c8d3eb840$var$gd;
            break;
        default:
            e = $6a0eb74c8d3eb840$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$6a0eb74c8d3eb840$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $6a0eb74c8d3eb840$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $6a0eb74c8d3eb840$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $6a0eb74c8d3eb840$var$Jb(function() {
        var d = f, e = $6a0eb74c8d3eb840$var$xb(c), g = [];
        a: {
            var h = $6a0eb74c8d3eb840$var$df.get(a);
            if (void 0 !== h) {
                var k = $6a0eb74c8d3eb840$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $6a0eb74c8d3eb840$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $6a0eb74c8d3eb840$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $6a0eb74c8d3eb840$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $6a0eb74c8d3eb840$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $6a0eb74c8d3eb840$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $6a0eb74c8d3eb840$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $6a0eb74c8d3eb840$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $6a0eb74c8d3eb840$var$Vd;
                        break;
                    case $6a0eb74c8d3eb840$var$$e:
                    case $6a0eb74c8d3eb840$var$af:
                    case $6a0eb74c8d3eb840$var$bf:
                        k = $6a0eb74c8d3eb840$var$Hd;
                        break;
                    case $6a0eb74c8d3eb840$var$cf:
                        k = $6a0eb74c8d3eb840$var$Xd;
                        break;
                    case "scroll":
                        k = $6a0eb74c8d3eb840$var$vd;
                        break;
                    case "wheel":
                        k = $6a0eb74c8d3eb840$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $6a0eb74c8d3eb840$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $6a0eb74c8d3eb840$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $6a0eb74c8d3eb840$var$Kb(w, x), null != F && t.push($6a0eb74c8d3eb840$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $6a0eb74c8d3eb840$var$wb && (n = c.relatedTarget || c.fromElement) && ($6a0eb74c8d3eb840$var$Wc(n) || n[$6a0eb74c8d3eb840$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $6a0eb74c8d3eb840$var$Wc(n) : null, null !== n && (J = $6a0eb74c8d3eb840$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $6a0eb74c8d3eb840$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $6a0eb74c8d3eb840$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $6a0eb74c8d3eb840$var$ue(k);
                        u = null == n ? h : $6a0eb74c8d3eb840$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $6a0eb74c8d3eb840$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $6a0eb74c8d3eb840$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $6a0eb74c8d3eb840$var$vf(F))u++;
                            for(; 0 < w - u;)t = $6a0eb74c8d3eb840$var$vf(t), w--;
                            for(; 0 < u - w;)x = $6a0eb74c8d3eb840$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $6a0eb74c8d3eb840$var$vf(t);
                                x = $6a0eb74c8d3eb840$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $6a0eb74c8d3eb840$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $6a0eb74c8d3eb840$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $6a0eb74c8d3eb840$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $6a0eb74c8d3eb840$var$ve;
                else if ($6a0eb74c8d3eb840$var$me(h)) {
                    if ($6a0eb74c8d3eb840$var$we) na = $6a0eb74c8d3eb840$var$Fe;
                    else {
                        na = $6a0eb74c8d3eb840$var$De;
                        var xa = $6a0eb74c8d3eb840$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $6a0eb74c8d3eb840$var$Ee);
                if (na && (na = na(a, d))) {
                    $6a0eb74c8d3eb840$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $6a0eb74c8d3eb840$var$cb(h, "number", h.value);
            }
            xa = d ? $6a0eb74c8d3eb840$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($6a0eb74c8d3eb840$var$me(xa) || "true" === xa.contentEditable) $6a0eb74c8d3eb840$var$Qe = xa, $6a0eb74c8d3eb840$var$Re = d, $6a0eb74c8d3eb840$var$Se = null;
                    break;
                case "focusout":
                    $6a0eb74c8d3eb840$var$Se = $6a0eb74c8d3eb840$var$Re = $6a0eb74c8d3eb840$var$Qe = null;
                    break;
                case "mousedown":
                    $6a0eb74c8d3eb840$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $6a0eb74c8d3eb840$var$Te = !1;
                    $6a0eb74c8d3eb840$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($6a0eb74c8d3eb840$var$Pe) break;
                case "keydown":
                case "keyup":
                    $6a0eb74c8d3eb840$var$Ue(g, c, e);
            }
            var $a;
            if ($6a0eb74c8d3eb840$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $6a0eb74c8d3eb840$var$ie ? $6a0eb74c8d3eb840$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($6a0eb74c8d3eb840$var$de && "ko" !== c.locale && ($6a0eb74c8d3eb840$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $6a0eb74c8d3eb840$var$ie && ($a = $6a0eb74c8d3eb840$var$nd()) : ($6a0eb74c8d3eb840$var$kd = e, $6a0eb74c8d3eb840$var$ld = "value" in $6a0eb74c8d3eb840$var$kd ? $6a0eb74c8d3eb840$var$kd.value : $6a0eb74c8d3eb840$var$kd.textContent, $6a0eb74c8d3eb840$var$ie = !0)), xa = $6a0eb74c8d3eb840$var$oe(d, ba), 0 < xa.length && (ba = new $6a0eb74c8d3eb840$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $6a0eb74c8d3eb840$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $6a0eb74c8d3eb840$var$ce ? $6a0eb74c8d3eb840$var$je(a, c) : $6a0eb74c8d3eb840$var$ke(a, c)) d = $6a0eb74c8d3eb840$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $6a0eb74c8d3eb840$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $6a0eb74c8d3eb840$var$se(g, b);
    });
}
function $6a0eb74c8d3eb840$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $6a0eb74c8d3eb840$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $6a0eb74c8d3eb840$var$Kb(a, c), null != f && d.unshift($6a0eb74c8d3eb840$var$tf(a, f, e)), f = $6a0eb74c8d3eb840$var$Kb(a, b), null != f && d.push($6a0eb74c8d3eb840$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $6a0eb74c8d3eb840$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $6a0eb74c8d3eb840$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $6a0eb74c8d3eb840$var$Kb(c, f), null != k && g.unshift($6a0eb74c8d3eb840$var$tf(c, k, h))) : e || (k = $6a0eb74c8d3eb840$var$Kb(c, f), null != k && g.push($6a0eb74c8d3eb840$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $6a0eb74c8d3eb840$var$xf = /\r\n?/g, $6a0eb74c8d3eb840$var$yf = /\u0000|\uFFFD/g;
function $6a0eb74c8d3eb840$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($6a0eb74c8d3eb840$var$xf, "\n").replace($6a0eb74c8d3eb840$var$yf, "");
}
function $6a0eb74c8d3eb840$var$Af(a, b, c) {
    b = $6a0eb74c8d3eb840$var$zf(b);
    if ($6a0eb74c8d3eb840$var$zf(a) !== b && c) throw Error($6a0eb74c8d3eb840$var$p(425));
}
function $6a0eb74c8d3eb840$var$Bf() {}
var $6a0eb74c8d3eb840$var$Cf = null, $6a0eb74c8d3eb840$var$Df = null;
function $6a0eb74c8d3eb840$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $6a0eb74c8d3eb840$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $6a0eb74c8d3eb840$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $6a0eb74c8d3eb840$var$Hf = "function" === typeof Promise ? Promise : void 0, $6a0eb74c8d3eb840$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $6a0eb74c8d3eb840$var$Hf ? function(a) {
    return $6a0eb74c8d3eb840$var$Hf.resolve(null).then(a).catch($6a0eb74c8d3eb840$var$If);
} : $6a0eb74c8d3eb840$var$Ff;
function $6a0eb74c8d3eb840$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $6a0eb74c8d3eb840$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $6a0eb74c8d3eb840$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $6a0eb74c8d3eb840$var$bd(b);
}
function $6a0eb74c8d3eb840$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $6a0eb74c8d3eb840$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $6a0eb74c8d3eb840$var$Nf = Math.random().toString(36).slice(2), $6a0eb74c8d3eb840$var$Of = "__reactFiber$" + $6a0eb74c8d3eb840$var$Nf, $6a0eb74c8d3eb840$var$Pf = "__reactProps$" + $6a0eb74c8d3eb840$var$Nf, $6a0eb74c8d3eb840$var$uf = "__reactContainer$" + $6a0eb74c8d3eb840$var$Nf, $6a0eb74c8d3eb840$var$of = "__reactEvents$" + $6a0eb74c8d3eb840$var$Nf, $6a0eb74c8d3eb840$var$Qf = "__reactListeners$" + $6a0eb74c8d3eb840$var$Nf, $6a0eb74c8d3eb840$var$Rf = "__reactHandles$" + $6a0eb74c8d3eb840$var$Nf;
function $6a0eb74c8d3eb840$var$Wc(a) {
    var b = a[$6a0eb74c8d3eb840$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$6a0eb74c8d3eb840$var$uf] || c[$6a0eb74c8d3eb840$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $6a0eb74c8d3eb840$var$Mf(a); null !== a;){
                if (c = a[$6a0eb74c8d3eb840$var$Of]) return c;
                a = $6a0eb74c8d3eb840$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $6a0eb74c8d3eb840$var$Cb(a) {
    a = a[$6a0eb74c8d3eb840$var$Of] || a[$6a0eb74c8d3eb840$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $6a0eb74c8d3eb840$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($6a0eb74c8d3eb840$var$p(33));
}
function $6a0eb74c8d3eb840$var$Db(a) {
    return a[$6a0eb74c8d3eb840$var$Pf] || null;
}
var $6a0eb74c8d3eb840$var$Sf = [], $6a0eb74c8d3eb840$var$Tf = -1;
function $6a0eb74c8d3eb840$var$Uf(a) {
    return {
        current: a
    };
}
function $6a0eb74c8d3eb840$var$E(a) {
    0 > $6a0eb74c8d3eb840$var$Tf || (a.current = $6a0eb74c8d3eb840$var$Sf[$6a0eb74c8d3eb840$var$Tf], $6a0eb74c8d3eb840$var$Sf[$6a0eb74c8d3eb840$var$Tf] = null, $6a0eb74c8d3eb840$var$Tf--);
}
function $6a0eb74c8d3eb840$var$G(a, b) {
    $6a0eb74c8d3eb840$var$Tf++;
    $6a0eb74c8d3eb840$var$Sf[$6a0eb74c8d3eb840$var$Tf] = a.current;
    a.current = b;
}
var $6a0eb74c8d3eb840$var$Vf = {}, $6a0eb74c8d3eb840$var$H = $6a0eb74c8d3eb840$var$Uf($6a0eb74c8d3eb840$var$Vf), $6a0eb74c8d3eb840$var$Wf = $6a0eb74c8d3eb840$var$Uf(!1), $6a0eb74c8d3eb840$var$Xf = $6a0eb74c8d3eb840$var$Vf;
function $6a0eb74c8d3eb840$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $6a0eb74c8d3eb840$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $6a0eb74c8d3eb840$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $6a0eb74c8d3eb840$var$$f() {
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wf);
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$H);
}
function $6a0eb74c8d3eb840$var$ag(a, b, c) {
    if ($6a0eb74c8d3eb840$var$H.current !== $6a0eb74c8d3eb840$var$Vf) throw Error($6a0eb74c8d3eb840$var$p(168));
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$H, b);
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$Wf, c);
}
function $6a0eb74c8d3eb840$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($6a0eb74c8d3eb840$var$p(108, $6a0eb74c8d3eb840$var$Ra(a) || "Unknown", e));
    return $6a0eb74c8d3eb840$var$A({}, c, d);
}
function $6a0eb74c8d3eb840$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $6a0eb74c8d3eb840$var$Vf;
    $6a0eb74c8d3eb840$var$Xf = $6a0eb74c8d3eb840$var$H.current;
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$H, a);
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$Wf, $6a0eb74c8d3eb840$var$Wf.current);
    return !0;
}
function $6a0eb74c8d3eb840$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($6a0eb74c8d3eb840$var$p(169));
    c ? (a = $6a0eb74c8d3eb840$var$bg(a, b, $6a0eb74c8d3eb840$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wf), $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$H), $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$H, a)) : $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wf);
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$Wf, c);
}
var $6a0eb74c8d3eb840$var$eg = null, $6a0eb74c8d3eb840$var$fg = !1, $6a0eb74c8d3eb840$var$gg = !1;
function $6a0eb74c8d3eb840$var$hg(a) {
    null === $6a0eb74c8d3eb840$var$eg ? $6a0eb74c8d3eb840$var$eg = [
        a
    ] : $6a0eb74c8d3eb840$var$eg.push(a);
}
function $6a0eb74c8d3eb840$var$ig(a) {
    $6a0eb74c8d3eb840$var$fg = !0;
    $6a0eb74c8d3eb840$var$hg(a);
}
function $6a0eb74c8d3eb840$var$jg() {
    if (!$6a0eb74c8d3eb840$var$gg && null !== $6a0eb74c8d3eb840$var$eg) {
        $6a0eb74c8d3eb840$var$gg = !0;
        var a = 0, b = $6a0eb74c8d3eb840$var$C;
        try {
            var c = $6a0eb74c8d3eb840$var$eg;
            for($6a0eb74c8d3eb840$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $6a0eb74c8d3eb840$var$eg = null;
            $6a0eb74c8d3eb840$var$fg = !1;
        } catch (e) {
            throw null !== $6a0eb74c8d3eb840$var$eg && ($6a0eb74c8d3eb840$var$eg = $6a0eb74c8d3eb840$var$eg.slice(a + 1)), $6a0eb74c8d3eb840$var$ac($6a0eb74c8d3eb840$var$fc, $6a0eb74c8d3eb840$var$jg), e;
        } finally{
            $6a0eb74c8d3eb840$var$C = b, $6a0eb74c8d3eb840$var$gg = !1;
        }
    }
    return null;
}
var $6a0eb74c8d3eb840$var$kg = [], $6a0eb74c8d3eb840$var$lg = 0, $6a0eb74c8d3eb840$var$mg = null, $6a0eb74c8d3eb840$var$ng = 0, $6a0eb74c8d3eb840$var$og = [], $6a0eb74c8d3eb840$var$pg = 0, $6a0eb74c8d3eb840$var$qg = null, $6a0eb74c8d3eb840$var$rg = 1, $6a0eb74c8d3eb840$var$sg = "";
function $6a0eb74c8d3eb840$var$tg(a, b) {
    $6a0eb74c8d3eb840$var$kg[$6a0eb74c8d3eb840$var$lg++] = $6a0eb74c8d3eb840$var$ng;
    $6a0eb74c8d3eb840$var$kg[$6a0eb74c8d3eb840$var$lg++] = $6a0eb74c8d3eb840$var$mg;
    $6a0eb74c8d3eb840$var$mg = a;
    $6a0eb74c8d3eb840$var$ng = b;
}
function $6a0eb74c8d3eb840$var$ug(a, b, c) {
    $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg++] = $6a0eb74c8d3eb840$var$rg;
    $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg++] = $6a0eb74c8d3eb840$var$sg;
    $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg++] = $6a0eb74c8d3eb840$var$qg;
    $6a0eb74c8d3eb840$var$qg = a;
    var d = $6a0eb74c8d3eb840$var$rg;
    a = $6a0eb74c8d3eb840$var$sg;
    var e = 32 - $6a0eb74c8d3eb840$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $6a0eb74c8d3eb840$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $6a0eb74c8d3eb840$var$rg = 1 << 32 - $6a0eb74c8d3eb840$var$oc(b) + e | c << e | d;
        $6a0eb74c8d3eb840$var$sg = f + a;
    } else $6a0eb74c8d3eb840$var$rg = 1 << f | c << e | d, $6a0eb74c8d3eb840$var$sg = a;
}
function $6a0eb74c8d3eb840$var$vg(a) {
    null !== a.return && ($6a0eb74c8d3eb840$var$tg(a, 1), $6a0eb74c8d3eb840$var$ug(a, 1, 0));
}
function $6a0eb74c8d3eb840$var$wg(a) {
    for(; a === $6a0eb74c8d3eb840$var$mg;)$6a0eb74c8d3eb840$var$mg = $6a0eb74c8d3eb840$var$kg[--$6a0eb74c8d3eb840$var$lg], $6a0eb74c8d3eb840$var$kg[$6a0eb74c8d3eb840$var$lg] = null, $6a0eb74c8d3eb840$var$ng = $6a0eb74c8d3eb840$var$kg[--$6a0eb74c8d3eb840$var$lg], $6a0eb74c8d3eb840$var$kg[$6a0eb74c8d3eb840$var$lg] = null;
    for(; a === $6a0eb74c8d3eb840$var$qg;)$6a0eb74c8d3eb840$var$qg = $6a0eb74c8d3eb840$var$og[--$6a0eb74c8d3eb840$var$pg], $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg] = null, $6a0eb74c8d3eb840$var$sg = $6a0eb74c8d3eb840$var$og[--$6a0eb74c8d3eb840$var$pg], $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg] = null, $6a0eb74c8d3eb840$var$rg = $6a0eb74c8d3eb840$var$og[--$6a0eb74c8d3eb840$var$pg], $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg] = null;
}
var $6a0eb74c8d3eb840$var$xg = null, $6a0eb74c8d3eb840$var$yg = null, $6a0eb74c8d3eb840$var$I = !1, $6a0eb74c8d3eb840$var$zg = null;
function $6a0eb74c8d3eb840$var$Ag(a, b) {
    var c = $6a0eb74c8d3eb840$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $6a0eb74c8d3eb840$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $6a0eb74c8d3eb840$var$xg = a, $6a0eb74c8d3eb840$var$yg = $6a0eb74c8d3eb840$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $6a0eb74c8d3eb840$var$xg = a, $6a0eb74c8d3eb840$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $6a0eb74c8d3eb840$var$qg ? {
                id: $6a0eb74c8d3eb840$var$rg,
                overflow: $6a0eb74c8d3eb840$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $6a0eb74c8d3eb840$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $6a0eb74c8d3eb840$var$xg = a, $6a0eb74c8d3eb840$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $6a0eb74c8d3eb840$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $6a0eb74c8d3eb840$var$Eg(a) {
    if ($6a0eb74c8d3eb840$var$I) {
        var b = $6a0eb74c8d3eb840$var$yg;
        if (b) {
            var c = b;
            if (!$6a0eb74c8d3eb840$var$Cg(a, b)) {
                if ($6a0eb74c8d3eb840$var$Dg(a)) throw Error($6a0eb74c8d3eb840$var$p(418));
                b = $6a0eb74c8d3eb840$var$Lf(c.nextSibling);
                var d = $6a0eb74c8d3eb840$var$xg;
                b && $6a0eb74c8d3eb840$var$Cg(a, b) ? $6a0eb74c8d3eb840$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $6a0eb74c8d3eb840$var$I = !1, $6a0eb74c8d3eb840$var$xg = a);
            }
        } else {
            if ($6a0eb74c8d3eb840$var$Dg(a)) throw Error($6a0eb74c8d3eb840$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $6a0eb74c8d3eb840$var$I = !1;
            $6a0eb74c8d3eb840$var$xg = a;
        }
    }
}
function $6a0eb74c8d3eb840$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $6a0eb74c8d3eb840$var$xg = a;
}
function $6a0eb74c8d3eb840$var$Gg(a) {
    if (a !== $6a0eb74c8d3eb840$var$xg) return !1;
    if (!$6a0eb74c8d3eb840$var$I) return $6a0eb74c8d3eb840$var$Fg(a), $6a0eb74c8d3eb840$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$6a0eb74c8d3eb840$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $6a0eb74c8d3eb840$var$yg)) {
        if ($6a0eb74c8d3eb840$var$Dg(a)) throw $6a0eb74c8d3eb840$var$Hg(), Error($6a0eb74c8d3eb840$var$p(418));
        for(; b;)$6a0eb74c8d3eb840$var$Ag(a, b), b = $6a0eb74c8d3eb840$var$Lf(b.nextSibling);
    }
    $6a0eb74c8d3eb840$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($6a0eb74c8d3eb840$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $6a0eb74c8d3eb840$var$yg = $6a0eb74c8d3eb840$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $6a0eb74c8d3eb840$var$yg = null;
        }
    } else $6a0eb74c8d3eb840$var$yg = $6a0eb74c8d3eb840$var$xg ? $6a0eb74c8d3eb840$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $6a0eb74c8d3eb840$var$Hg() {
    for(var a = $6a0eb74c8d3eb840$var$yg; a;)a = $6a0eb74c8d3eb840$var$Lf(a.nextSibling);
}
function $6a0eb74c8d3eb840$var$Ig() {
    $6a0eb74c8d3eb840$var$yg = $6a0eb74c8d3eb840$var$xg = null;
    $6a0eb74c8d3eb840$var$I = !1;
}
function $6a0eb74c8d3eb840$var$Jg(a) {
    null === $6a0eb74c8d3eb840$var$zg ? $6a0eb74c8d3eb840$var$zg = [
        a
    ] : $6a0eb74c8d3eb840$var$zg.push(a);
}
var $6a0eb74c8d3eb840$var$Kg = $6a0eb74c8d3eb840$var$ua.ReactCurrentBatchConfig;
function $6a0eb74c8d3eb840$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($6a0eb74c8d3eb840$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($6a0eb74c8d3eb840$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($6a0eb74c8d3eb840$var$p(284));
        if (!c._owner) throw Error($6a0eb74c8d3eb840$var$p(290, a));
    }
    return a;
}
function $6a0eb74c8d3eb840$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($6a0eb74c8d3eb840$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $6a0eb74c8d3eb840$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $6a0eb74c8d3eb840$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $6a0eb74c8d3eb840$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $6a0eb74c8d3eb840$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $6a0eb74c8d3eb840$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $6a0eb74c8d3eb840$var$Ha && $6a0eb74c8d3eb840$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $6a0eb74c8d3eb840$var$Lg(a, b, c), d.return = a, d;
        d = $6a0eb74c8d3eb840$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $6a0eb74c8d3eb840$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $6a0eb74c8d3eb840$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $6a0eb74c8d3eb840$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $6a0eb74c8d3eb840$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $6a0eb74c8d3eb840$var$va:
                    return c = $6a0eb74c8d3eb840$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $6a0eb74c8d3eb840$var$Lg(a, null, b), c.return = a, c;
                case $6a0eb74c8d3eb840$var$wa:
                    return b = $6a0eb74c8d3eb840$var$Sg(b, a.mode, c), b.return = a, b;
                case $6a0eb74c8d3eb840$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($6a0eb74c8d3eb840$var$eb(b) || $6a0eb74c8d3eb840$var$Ka(b)) return b = $6a0eb74c8d3eb840$var$Tg(b, a.mode, c, null), b.return = a, b;
            $6a0eb74c8d3eb840$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $6a0eb74c8d3eb840$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $6a0eb74c8d3eb840$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $6a0eb74c8d3eb840$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($6a0eb74c8d3eb840$var$eb(c) || $6a0eb74c8d3eb840$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $6a0eb74c8d3eb840$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $6a0eb74c8d3eb840$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $6a0eb74c8d3eb840$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $6a0eb74c8d3eb840$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($6a0eb74c8d3eb840$var$eb(d) || $6a0eb74c8d3eb840$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $6a0eb74c8d3eb840$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $6a0eb74c8d3eb840$var$I && $6a0eb74c8d3eb840$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $6a0eb74c8d3eb840$var$I && $6a0eb74c8d3eb840$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $6a0eb74c8d3eb840$var$I && $6a0eb74c8d3eb840$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $6a0eb74c8d3eb840$var$Ka(h);
        if ("function" !== typeof l) throw Error($6a0eb74c8d3eb840$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($6a0eb74c8d3eb840$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $6a0eb74c8d3eb840$var$I && $6a0eb74c8d3eb840$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $6a0eb74c8d3eb840$var$I && $6a0eb74c8d3eb840$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $6a0eb74c8d3eb840$var$I && $6a0eb74c8d3eb840$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $6a0eb74c8d3eb840$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $6a0eb74c8d3eb840$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $6a0eb74c8d3eb840$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $6a0eb74c8d3eb840$var$Ha && $6a0eb74c8d3eb840$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $6a0eb74c8d3eb840$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $6a0eb74c8d3eb840$var$ya ? (d = $6a0eb74c8d3eb840$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $6a0eb74c8d3eb840$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $6a0eb74c8d3eb840$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $6a0eb74c8d3eb840$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $6a0eb74c8d3eb840$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $6a0eb74c8d3eb840$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($6a0eb74c8d3eb840$var$eb(f)) return n(a, d, f, h);
            if ($6a0eb74c8d3eb840$var$Ka(f)) return t(a, d, f, h);
            $6a0eb74c8d3eb840$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $6a0eb74c8d3eb840$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $6a0eb74c8d3eb840$var$Ug = $6a0eb74c8d3eb840$var$Og(!0), $6a0eb74c8d3eb840$var$Vg = $6a0eb74c8d3eb840$var$Og(!1), $6a0eb74c8d3eb840$var$Wg = $6a0eb74c8d3eb840$var$Uf(null), $6a0eb74c8d3eb840$var$Xg = null, $6a0eb74c8d3eb840$var$Yg = null, $6a0eb74c8d3eb840$var$Zg = null;
function $6a0eb74c8d3eb840$var$$g() {
    $6a0eb74c8d3eb840$var$Zg = $6a0eb74c8d3eb840$var$Yg = $6a0eb74c8d3eb840$var$Xg = null;
}
function $6a0eb74c8d3eb840$var$ah(a) {
    var b = $6a0eb74c8d3eb840$var$Wg.current;
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wg);
    a._currentValue = b;
}
function $6a0eb74c8d3eb840$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $6a0eb74c8d3eb840$var$ch(a, b) {
    $6a0eb74c8d3eb840$var$Xg = a;
    $6a0eb74c8d3eb840$var$Zg = $6a0eb74c8d3eb840$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($6a0eb74c8d3eb840$var$dh = !0), a.firstContext = null);
}
function $6a0eb74c8d3eb840$var$eh(a) {
    var b = a._currentValue;
    if ($6a0eb74c8d3eb840$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $6a0eb74c8d3eb840$var$Yg) {
            if (null === $6a0eb74c8d3eb840$var$Xg) throw Error($6a0eb74c8d3eb840$var$p(308));
            $6a0eb74c8d3eb840$var$Yg = a;
            $6a0eb74c8d3eb840$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $6a0eb74c8d3eb840$var$Yg = $6a0eb74c8d3eb840$var$Yg.next = a;
    }
    return b;
}
var $6a0eb74c8d3eb840$var$fh = null;
function $6a0eb74c8d3eb840$var$gh(a) {
    null === $6a0eb74c8d3eb840$var$fh ? $6a0eb74c8d3eb840$var$fh = [
        a
    ] : $6a0eb74c8d3eb840$var$fh.push(a);
}
function $6a0eb74c8d3eb840$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $6a0eb74c8d3eb840$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $6a0eb74c8d3eb840$var$ih(a, d);
}
function $6a0eb74c8d3eb840$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $6a0eb74c8d3eb840$var$jh = !1;
function $6a0eb74c8d3eb840$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $6a0eb74c8d3eb840$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $6a0eb74c8d3eb840$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $6a0eb74c8d3eb840$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($6a0eb74c8d3eb840$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $6a0eb74c8d3eb840$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $6a0eb74c8d3eb840$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $6a0eb74c8d3eb840$var$ih(a, c);
}
function $6a0eb74c8d3eb840$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $6a0eb74c8d3eb840$var$Cc(a, c);
    }
}
function $6a0eb74c8d3eb840$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $6a0eb74c8d3eb840$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $6a0eb74c8d3eb840$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $6a0eb74c8d3eb840$var$A({}, q, r);
                            break a;
                        case 2:
                            $6a0eb74c8d3eb840$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $6a0eb74c8d3eb840$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $6a0eb74c8d3eb840$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($6a0eb74c8d3eb840$var$p(191, e));
            e.call(d);
        }
    }
}
var $6a0eb74c8d3eb840$var$th = {}, $6a0eb74c8d3eb840$var$uh = $6a0eb74c8d3eb840$var$Uf($6a0eb74c8d3eb840$var$th), $6a0eb74c8d3eb840$var$vh = $6a0eb74c8d3eb840$var$Uf($6a0eb74c8d3eb840$var$th), $6a0eb74c8d3eb840$var$wh = $6a0eb74c8d3eb840$var$Uf($6a0eb74c8d3eb840$var$th);
function $6a0eb74c8d3eb840$var$xh(a) {
    if (a === $6a0eb74c8d3eb840$var$th) throw Error($6a0eb74c8d3eb840$var$p(174));
    return a;
}
function $6a0eb74c8d3eb840$var$yh(a, b) {
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$wh, b);
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$vh, a);
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$uh, $6a0eb74c8d3eb840$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $6a0eb74c8d3eb840$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $6a0eb74c8d3eb840$var$lb(b, a);
    }
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$uh);
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$uh, b);
}
function $6a0eb74c8d3eb840$var$zh() {
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$uh);
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$vh);
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$wh);
}
function $6a0eb74c8d3eb840$var$Ah(a) {
    $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$wh.current);
    var b = $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$uh.current);
    var c = $6a0eb74c8d3eb840$var$lb(b, a.type);
    b !== c && ($6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$vh, a), $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$uh, c));
}
function $6a0eb74c8d3eb840$var$Bh(a) {
    $6a0eb74c8d3eb840$var$vh.current === a && ($6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$uh), $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$vh));
}
var $6a0eb74c8d3eb840$var$L = $6a0eb74c8d3eb840$var$Uf(0);
function $6a0eb74c8d3eb840$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $6a0eb74c8d3eb840$var$Dh = [];
function $6a0eb74c8d3eb840$var$Eh() {
    for(var a = 0; a < $6a0eb74c8d3eb840$var$Dh.length; a++)$6a0eb74c8d3eb840$var$Dh[a]._workInProgressVersionPrimary = null;
    $6a0eb74c8d3eb840$var$Dh.length = 0;
}
var $6a0eb74c8d3eb840$var$Fh = $6a0eb74c8d3eb840$var$ua.ReactCurrentDispatcher, $6a0eb74c8d3eb840$var$Gh = $6a0eb74c8d3eb840$var$ua.ReactCurrentBatchConfig, $6a0eb74c8d3eb840$var$Hh = 0, $6a0eb74c8d3eb840$var$M = null, $6a0eb74c8d3eb840$var$N = null, $6a0eb74c8d3eb840$var$O = null, $6a0eb74c8d3eb840$var$Ih = !1, $6a0eb74c8d3eb840$var$Jh = !1, $6a0eb74c8d3eb840$var$Kh = 0, $6a0eb74c8d3eb840$var$Lh = 0;
function $6a0eb74c8d3eb840$var$P() {
    throw Error($6a0eb74c8d3eb840$var$p(321));
}
function $6a0eb74c8d3eb840$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$6a0eb74c8d3eb840$var$He(a[c], b[c])) return !1;
    return !0;
}
function $6a0eb74c8d3eb840$var$Nh(a, b, c, d, e, f) {
    $6a0eb74c8d3eb840$var$Hh = f;
    $6a0eb74c8d3eb840$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $6a0eb74c8d3eb840$var$Fh.current = null === a || null === a.memoizedState ? $6a0eb74c8d3eb840$var$Oh : $6a0eb74c8d3eb840$var$Ph;
    a = c(d, e);
    if ($6a0eb74c8d3eb840$var$Jh) {
        f = 0;
        do {
            $6a0eb74c8d3eb840$var$Jh = !1;
            $6a0eb74c8d3eb840$var$Kh = 0;
            if (25 <= f) throw Error($6a0eb74c8d3eb840$var$p(301));
            f += 1;
            $6a0eb74c8d3eb840$var$O = $6a0eb74c8d3eb840$var$N = null;
            b.updateQueue = null;
            $6a0eb74c8d3eb840$var$Fh.current = $6a0eb74c8d3eb840$var$Qh;
            a = c(d, e);
        }while ($6a0eb74c8d3eb840$var$Jh);
    }
    $6a0eb74c8d3eb840$var$Fh.current = $6a0eb74c8d3eb840$var$Rh;
    b = null !== $6a0eb74c8d3eb840$var$N && null !== $6a0eb74c8d3eb840$var$N.next;
    $6a0eb74c8d3eb840$var$Hh = 0;
    $6a0eb74c8d3eb840$var$O = $6a0eb74c8d3eb840$var$N = $6a0eb74c8d3eb840$var$M = null;
    $6a0eb74c8d3eb840$var$Ih = !1;
    if (b) throw Error($6a0eb74c8d3eb840$var$p(300));
    return a;
}
function $6a0eb74c8d3eb840$var$Sh() {
    var a = 0 !== $6a0eb74c8d3eb840$var$Kh;
    $6a0eb74c8d3eb840$var$Kh = 0;
    return a;
}
function $6a0eb74c8d3eb840$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $6a0eb74c8d3eb840$var$O ? $6a0eb74c8d3eb840$var$M.memoizedState = $6a0eb74c8d3eb840$var$O = a : $6a0eb74c8d3eb840$var$O = $6a0eb74c8d3eb840$var$O.next = a;
    return $6a0eb74c8d3eb840$var$O;
}
function $6a0eb74c8d3eb840$var$Uh() {
    if (null === $6a0eb74c8d3eb840$var$N) {
        var a = $6a0eb74c8d3eb840$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $6a0eb74c8d3eb840$var$N.next;
    var b = null === $6a0eb74c8d3eb840$var$O ? $6a0eb74c8d3eb840$var$M.memoizedState : $6a0eb74c8d3eb840$var$O.next;
    if (null !== b) $6a0eb74c8d3eb840$var$O = b, $6a0eb74c8d3eb840$var$N = a;
    else {
        if (null === a) throw Error($6a0eb74c8d3eb840$var$p(310));
        $6a0eb74c8d3eb840$var$N = a;
        a = {
            memoizedState: $6a0eb74c8d3eb840$var$N.memoizedState,
            baseState: $6a0eb74c8d3eb840$var$N.baseState,
            baseQueue: $6a0eb74c8d3eb840$var$N.baseQueue,
            queue: $6a0eb74c8d3eb840$var$N.queue,
            next: null
        };
        null === $6a0eb74c8d3eb840$var$O ? $6a0eb74c8d3eb840$var$M.memoizedState = $6a0eb74c8d3eb840$var$O = a : $6a0eb74c8d3eb840$var$O = $6a0eb74c8d3eb840$var$O.next = a;
    }
    return $6a0eb74c8d3eb840$var$O;
}
function $6a0eb74c8d3eb840$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $6a0eb74c8d3eb840$var$Wh(a) {
    var b = $6a0eb74c8d3eb840$var$Uh(), c = b.queue;
    if (null === c) throw Error($6a0eb74c8d3eb840$var$p(311));
    c.lastRenderedReducer = a;
    var d = $6a0eb74c8d3eb840$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($6a0eb74c8d3eb840$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $6a0eb74c8d3eb840$var$M.lanes |= m;
                $6a0eb74c8d3eb840$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $6a0eb74c8d3eb840$var$He(d, b.memoizedState) || ($6a0eb74c8d3eb840$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $6a0eb74c8d3eb840$var$M.lanes |= f, $6a0eb74c8d3eb840$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $6a0eb74c8d3eb840$var$Xh(a) {
    var b = $6a0eb74c8d3eb840$var$Uh(), c = b.queue;
    if (null === c) throw Error($6a0eb74c8d3eb840$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $6a0eb74c8d3eb840$var$He(f, b.memoizedState) || ($6a0eb74c8d3eb840$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $6a0eb74c8d3eb840$var$Yh() {}
function $6a0eb74c8d3eb840$var$Zh(a, b) {
    var c = $6a0eb74c8d3eb840$var$M, d = $6a0eb74c8d3eb840$var$Uh(), e = b(), f = !$6a0eb74c8d3eb840$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $6a0eb74c8d3eb840$var$dh = !0);
    d = d.queue;
    $6a0eb74c8d3eb840$var$$h($6a0eb74c8d3eb840$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $6a0eb74c8d3eb840$var$O && $6a0eb74c8d3eb840$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $6a0eb74c8d3eb840$var$bi(9, $6a0eb74c8d3eb840$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $6a0eb74c8d3eb840$var$Q) throw Error($6a0eb74c8d3eb840$var$p(349));
        0 !== ($6a0eb74c8d3eb840$var$Hh & 30) || $6a0eb74c8d3eb840$var$di(c, b, e);
    }
    return e;
}
function $6a0eb74c8d3eb840$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $6a0eb74c8d3eb840$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $6a0eb74c8d3eb840$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $6a0eb74c8d3eb840$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $6a0eb74c8d3eb840$var$ei(b) && $6a0eb74c8d3eb840$var$fi(a);
}
function $6a0eb74c8d3eb840$var$ai(a, b, c) {
    return c(function() {
        $6a0eb74c8d3eb840$var$ei(b) && $6a0eb74c8d3eb840$var$fi(a);
    });
}
function $6a0eb74c8d3eb840$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$6a0eb74c8d3eb840$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $6a0eb74c8d3eb840$var$fi(a) {
    var b = $6a0eb74c8d3eb840$var$ih(a, 1);
    null !== b && $6a0eb74c8d3eb840$var$gi(b, a, 1, -1);
}
function $6a0eb74c8d3eb840$var$hi(a) {
    var b = $6a0eb74c8d3eb840$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $6a0eb74c8d3eb840$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $6a0eb74c8d3eb840$var$ii.bind(null, $6a0eb74c8d3eb840$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $6a0eb74c8d3eb840$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $6a0eb74c8d3eb840$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $6a0eb74c8d3eb840$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $6a0eb74c8d3eb840$var$ji() {
    return $6a0eb74c8d3eb840$var$Uh().memoizedState;
}
function $6a0eb74c8d3eb840$var$ki(a, b, c, d) {
    var e = $6a0eb74c8d3eb840$var$Th();
    $6a0eb74c8d3eb840$var$M.flags |= a;
    e.memoizedState = $6a0eb74c8d3eb840$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $6a0eb74c8d3eb840$var$li(a, b, c, d) {
    var e = $6a0eb74c8d3eb840$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $6a0eb74c8d3eb840$var$N) {
        var g = $6a0eb74c8d3eb840$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $6a0eb74c8d3eb840$var$Mh(d, g.deps)) {
            e.memoizedState = $6a0eb74c8d3eb840$var$bi(b, c, f, d);
            return;
        }
    }
    $6a0eb74c8d3eb840$var$M.flags |= a;
    e.memoizedState = $6a0eb74c8d3eb840$var$bi(1 | b, c, f, d);
}
function $6a0eb74c8d3eb840$var$mi(a, b) {
    return $6a0eb74c8d3eb840$var$ki(8390656, 8, a, b);
}
function $6a0eb74c8d3eb840$var$$h(a, b) {
    return $6a0eb74c8d3eb840$var$li(2048, 8, a, b);
}
function $6a0eb74c8d3eb840$var$ni(a, b) {
    return $6a0eb74c8d3eb840$var$li(4, 2, a, b);
}
function $6a0eb74c8d3eb840$var$oi(a, b) {
    return $6a0eb74c8d3eb840$var$li(4, 4, a, b);
}
function $6a0eb74c8d3eb840$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $6a0eb74c8d3eb840$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $6a0eb74c8d3eb840$var$li(4, 4, $6a0eb74c8d3eb840$var$pi.bind(null, b, a), c);
}
function $6a0eb74c8d3eb840$var$ri() {}
function $6a0eb74c8d3eb840$var$si(a, b) {
    var c = $6a0eb74c8d3eb840$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $6a0eb74c8d3eb840$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $6a0eb74c8d3eb840$var$ti(a, b) {
    var c = $6a0eb74c8d3eb840$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $6a0eb74c8d3eb840$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $6a0eb74c8d3eb840$var$ui(a, b, c) {
    if (0 === ($6a0eb74c8d3eb840$var$Hh & 21)) return a.baseState && (a.baseState = !1, $6a0eb74c8d3eb840$var$dh = !0), a.memoizedState = c;
    $6a0eb74c8d3eb840$var$He(c, b) || (c = $6a0eb74c8d3eb840$var$yc(), $6a0eb74c8d3eb840$var$M.lanes |= c, $6a0eb74c8d3eb840$var$rh |= c, a.baseState = !0);
    return b;
}
function $6a0eb74c8d3eb840$var$vi(a, b) {
    var c = $6a0eb74c8d3eb840$var$C;
    $6a0eb74c8d3eb840$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $6a0eb74c8d3eb840$var$Gh.transition;
    $6a0eb74c8d3eb840$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $6a0eb74c8d3eb840$var$C = c, $6a0eb74c8d3eb840$var$Gh.transition = d;
    }
}
function $6a0eb74c8d3eb840$var$wi() {
    return $6a0eb74c8d3eb840$var$Uh().memoizedState;
}
function $6a0eb74c8d3eb840$var$xi(a, b, c) {
    var d = $6a0eb74c8d3eb840$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6a0eb74c8d3eb840$var$zi(a)) $6a0eb74c8d3eb840$var$Ai(b, c);
    else if (c = $6a0eb74c8d3eb840$var$hh(a, b, c, d), null !== c) {
        var e = $6a0eb74c8d3eb840$var$R();
        $6a0eb74c8d3eb840$var$gi(c, a, d, e);
        $6a0eb74c8d3eb840$var$Bi(c, b, d);
    }
}
function $6a0eb74c8d3eb840$var$ii(a, b, c) {
    var d = $6a0eb74c8d3eb840$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6a0eb74c8d3eb840$var$zi(a)) $6a0eb74c8d3eb840$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($6a0eb74c8d3eb840$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $6a0eb74c8d3eb840$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $6a0eb74c8d3eb840$var$hh(a, b, e, d);
        null !== c && (e = $6a0eb74c8d3eb840$var$R(), $6a0eb74c8d3eb840$var$gi(c, a, d, e), $6a0eb74c8d3eb840$var$Bi(c, b, d));
    }
}
function $6a0eb74c8d3eb840$var$zi(a) {
    var b = a.alternate;
    return a === $6a0eb74c8d3eb840$var$M || null !== b && b === $6a0eb74c8d3eb840$var$M;
}
function $6a0eb74c8d3eb840$var$Ai(a, b) {
    $6a0eb74c8d3eb840$var$Jh = $6a0eb74c8d3eb840$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $6a0eb74c8d3eb840$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $6a0eb74c8d3eb840$var$Cc(a, c);
    }
}
var $6a0eb74c8d3eb840$var$Rh = {
    readContext: $6a0eb74c8d3eb840$var$eh,
    useCallback: $6a0eb74c8d3eb840$var$P,
    useContext: $6a0eb74c8d3eb840$var$P,
    useEffect: $6a0eb74c8d3eb840$var$P,
    useImperativeHandle: $6a0eb74c8d3eb840$var$P,
    useInsertionEffect: $6a0eb74c8d3eb840$var$P,
    useLayoutEffect: $6a0eb74c8d3eb840$var$P,
    useMemo: $6a0eb74c8d3eb840$var$P,
    useReducer: $6a0eb74c8d3eb840$var$P,
    useRef: $6a0eb74c8d3eb840$var$P,
    useState: $6a0eb74c8d3eb840$var$P,
    useDebugValue: $6a0eb74c8d3eb840$var$P,
    useDeferredValue: $6a0eb74c8d3eb840$var$P,
    useTransition: $6a0eb74c8d3eb840$var$P,
    useMutableSource: $6a0eb74c8d3eb840$var$P,
    useSyncExternalStore: $6a0eb74c8d3eb840$var$P,
    useId: $6a0eb74c8d3eb840$var$P,
    unstable_isNewReconciler: !1
}, $6a0eb74c8d3eb840$var$Oh = {
    readContext: $6a0eb74c8d3eb840$var$eh,
    useCallback: function(a, b) {
        $6a0eb74c8d3eb840$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $6a0eb74c8d3eb840$var$eh,
    useEffect: $6a0eb74c8d3eb840$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $6a0eb74c8d3eb840$var$ki(4194308, 4, $6a0eb74c8d3eb840$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $6a0eb74c8d3eb840$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $6a0eb74c8d3eb840$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $6a0eb74c8d3eb840$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $6a0eb74c8d3eb840$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $6a0eb74c8d3eb840$var$xi.bind(null, $6a0eb74c8d3eb840$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $6a0eb74c8d3eb840$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $6a0eb74c8d3eb840$var$hi,
    useDebugValue: $6a0eb74c8d3eb840$var$ri,
    useDeferredValue: function(a) {
        return $6a0eb74c8d3eb840$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $6a0eb74c8d3eb840$var$hi(!1), b = a[0];
        a = $6a0eb74c8d3eb840$var$vi.bind(null, a[1]);
        $6a0eb74c8d3eb840$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $6a0eb74c8d3eb840$var$M, e = $6a0eb74c8d3eb840$var$Th();
        if ($6a0eb74c8d3eb840$var$I) {
            if (void 0 === c) throw Error($6a0eb74c8d3eb840$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $6a0eb74c8d3eb840$var$Q) throw Error($6a0eb74c8d3eb840$var$p(349));
            0 !== ($6a0eb74c8d3eb840$var$Hh & 30) || $6a0eb74c8d3eb840$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $6a0eb74c8d3eb840$var$mi($6a0eb74c8d3eb840$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $6a0eb74c8d3eb840$var$bi(9, $6a0eb74c8d3eb840$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $6a0eb74c8d3eb840$var$Th(), b = $6a0eb74c8d3eb840$var$Q.identifierPrefix;
        if ($6a0eb74c8d3eb840$var$I) {
            var c = $6a0eb74c8d3eb840$var$sg;
            var d = $6a0eb74c8d3eb840$var$rg;
            c = (d & ~(1 << 32 - $6a0eb74c8d3eb840$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $6a0eb74c8d3eb840$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $6a0eb74c8d3eb840$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $6a0eb74c8d3eb840$var$Ph = {
    readContext: $6a0eb74c8d3eb840$var$eh,
    useCallback: $6a0eb74c8d3eb840$var$si,
    useContext: $6a0eb74c8d3eb840$var$eh,
    useEffect: $6a0eb74c8d3eb840$var$$h,
    useImperativeHandle: $6a0eb74c8d3eb840$var$qi,
    useInsertionEffect: $6a0eb74c8d3eb840$var$ni,
    useLayoutEffect: $6a0eb74c8d3eb840$var$oi,
    useMemo: $6a0eb74c8d3eb840$var$ti,
    useReducer: $6a0eb74c8d3eb840$var$Wh,
    useRef: $6a0eb74c8d3eb840$var$ji,
    useState: function() {
        return $6a0eb74c8d3eb840$var$Wh($6a0eb74c8d3eb840$var$Vh);
    },
    useDebugValue: $6a0eb74c8d3eb840$var$ri,
    useDeferredValue: function(a) {
        var b = $6a0eb74c8d3eb840$var$Uh();
        return $6a0eb74c8d3eb840$var$ui(b, $6a0eb74c8d3eb840$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $6a0eb74c8d3eb840$var$Wh($6a0eb74c8d3eb840$var$Vh)[0], b = $6a0eb74c8d3eb840$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $6a0eb74c8d3eb840$var$Yh,
    useSyncExternalStore: $6a0eb74c8d3eb840$var$Zh,
    useId: $6a0eb74c8d3eb840$var$wi,
    unstable_isNewReconciler: !1
}, $6a0eb74c8d3eb840$var$Qh = {
    readContext: $6a0eb74c8d3eb840$var$eh,
    useCallback: $6a0eb74c8d3eb840$var$si,
    useContext: $6a0eb74c8d3eb840$var$eh,
    useEffect: $6a0eb74c8d3eb840$var$$h,
    useImperativeHandle: $6a0eb74c8d3eb840$var$qi,
    useInsertionEffect: $6a0eb74c8d3eb840$var$ni,
    useLayoutEffect: $6a0eb74c8d3eb840$var$oi,
    useMemo: $6a0eb74c8d3eb840$var$ti,
    useReducer: $6a0eb74c8d3eb840$var$Xh,
    useRef: $6a0eb74c8d3eb840$var$ji,
    useState: function() {
        return $6a0eb74c8d3eb840$var$Xh($6a0eb74c8d3eb840$var$Vh);
    },
    useDebugValue: $6a0eb74c8d3eb840$var$ri,
    useDeferredValue: function(a) {
        var b = $6a0eb74c8d3eb840$var$Uh();
        return null === $6a0eb74c8d3eb840$var$N ? b.memoizedState = a : $6a0eb74c8d3eb840$var$ui(b, $6a0eb74c8d3eb840$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $6a0eb74c8d3eb840$var$Xh($6a0eb74c8d3eb840$var$Vh)[0], b = $6a0eb74c8d3eb840$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $6a0eb74c8d3eb840$var$Yh,
    useSyncExternalStore: $6a0eb74c8d3eb840$var$Zh,
    useId: $6a0eb74c8d3eb840$var$wi,
    unstable_isNewReconciler: !1
};
function $6a0eb74c8d3eb840$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $6a0eb74c8d3eb840$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $6a0eb74c8d3eb840$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $6a0eb74c8d3eb840$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $6a0eb74c8d3eb840$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $6a0eb74c8d3eb840$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $6a0eb74c8d3eb840$var$R(), e = $6a0eb74c8d3eb840$var$yi(a), f = $6a0eb74c8d3eb840$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $6a0eb74c8d3eb840$var$nh(a, f, e);
        null !== b && ($6a0eb74c8d3eb840$var$gi(b, a, e, d), $6a0eb74c8d3eb840$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $6a0eb74c8d3eb840$var$R(), e = $6a0eb74c8d3eb840$var$yi(a), f = $6a0eb74c8d3eb840$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $6a0eb74c8d3eb840$var$nh(a, f, e);
        null !== b && ($6a0eb74c8d3eb840$var$gi(b, a, e, d), $6a0eb74c8d3eb840$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $6a0eb74c8d3eb840$var$R(), d = $6a0eb74c8d3eb840$var$yi(a), e = $6a0eb74c8d3eb840$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $6a0eb74c8d3eb840$var$nh(a, e, d);
        null !== b && ($6a0eb74c8d3eb840$var$gi(b, a, d, c), $6a0eb74c8d3eb840$var$oh(b, a, d));
    }
};
function $6a0eb74c8d3eb840$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$6a0eb74c8d3eb840$var$Ie(c, d) || !$6a0eb74c8d3eb840$var$Ie(e, f) : !0;
}
function $6a0eb74c8d3eb840$var$Gi(a, b, c) {
    var d = !1, e = $6a0eb74c8d3eb840$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $6a0eb74c8d3eb840$var$eh(f) : (e = $6a0eb74c8d3eb840$var$Zf(b) ? $6a0eb74c8d3eb840$var$Xf : $6a0eb74c8d3eb840$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $6a0eb74c8d3eb840$var$Yf(a, e) : $6a0eb74c8d3eb840$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $6a0eb74c8d3eb840$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $6a0eb74c8d3eb840$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $6a0eb74c8d3eb840$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $6a0eb74c8d3eb840$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $6a0eb74c8d3eb840$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $6a0eb74c8d3eb840$var$eh(f) : (f = $6a0eb74c8d3eb840$var$Zf(b) ? $6a0eb74c8d3eb840$var$Xf : $6a0eb74c8d3eb840$var$H.current, e.context = $6a0eb74c8d3eb840$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($6a0eb74c8d3eb840$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $6a0eb74c8d3eb840$var$Ei.enqueueReplaceState(e, e.state, null), $6a0eb74c8d3eb840$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $6a0eb74c8d3eb840$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $6a0eb74c8d3eb840$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $6a0eb74c8d3eb840$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $6a0eb74c8d3eb840$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $6a0eb74c8d3eb840$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $6a0eb74c8d3eb840$var$Ni(a, b, c) {
    c = $6a0eb74c8d3eb840$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $6a0eb74c8d3eb840$var$Oi || ($6a0eb74c8d3eb840$var$Oi = !0, $6a0eb74c8d3eb840$var$Pi = d);
        $6a0eb74c8d3eb840$var$Li(a, b);
    };
    return c;
}
function $6a0eb74c8d3eb840$var$Qi(a, b, c) {
    c = $6a0eb74c8d3eb840$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $6a0eb74c8d3eb840$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $6a0eb74c8d3eb840$var$Li(a, b);
        "function" !== typeof d && (null === $6a0eb74c8d3eb840$var$Ri ? $6a0eb74c8d3eb840$var$Ri = new Set([
            this
        ]) : $6a0eb74c8d3eb840$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $6a0eb74c8d3eb840$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $6a0eb74c8d3eb840$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $6a0eb74c8d3eb840$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $6a0eb74c8d3eb840$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $6a0eb74c8d3eb840$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $6a0eb74c8d3eb840$var$mh(-1, 1), b.tag = 2, $6a0eb74c8d3eb840$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $6a0eb74c8d3eb840$var$Wi = $6a0eb74c8d3eb840$var$ua.ReactCurrentOwner, $6a0eb74c8d3eb840$var$dh = !1;
function $6a0eb74c8d3eb840$var$Xi(a, b, c, d) {
    b.child = null === a ? $6a0eb74c8d3eb840$var$Vg(b, null, c, d) : $6a0eb74c8d3eb840$var$Ug(b, a.child, c, d);
}
function $6a0eb74c8d3eb840$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $6a0eb74c8d3eb840$var$ch(b, e);
    d = $6a0eb74c8d3eb840$var$Nh(a, b, c, d, f, e);
    c = $6a0eb74c8d3eb840$var$Sh();
    if (null !== a && !$6a0eb74c8d3eb840$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $6a0eb74c8d3eb840$var$Zi(a, b, e);
    $6a0eb74c8d3eb840$var$I && c && $6a0eb74c8d3eb840$var$vg(b);
    b.flags |= 1;
    $6a0eb74c8d3eb840$var$Xi(a, b, d, e);
    return b.child;
}
function $6a0eb74c8d3eb840$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$6a0eb74c8d3eb840$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $6a0eb74c8d3eb840$var$bj(a, b, f, d, e);
        a = $6a0eb74c8d3eb840$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $6a0eb74c8d3eb840$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $6a0eb74c8d3eb840$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $6a0eb74c8d3eb840$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $6a0eb74c8d3eb840$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($6a0eb74c8d3eb840$var$Ie(f, d) && a.ref === b.ref) {
            if ($6a0eb74c8d3eb840$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($6a0eb74c8d3eb840$var$dh = !0);
            else return b.lanes = a.lanes, $6a0eb74c8d3eb840$var$Zi(a, b, e);
        }
    }
    return $6a0eb74c8d3eb840$var$cj(a, b, c, d, e);
}
function $6a0eb74c8d3eb840$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$ej, $6a0eb74c8d3eb840$var$fj), $6a0eb74c8d3eb840$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$ej, $6a0eb74c8d3eb840$var$fj), $6a0eb74c8d3eb840$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$ej, $6a0eb74c8d3eb840$var$fj);
            $6a0eb74c8d3eb840$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$ej, $6a0eb74c8d3eb840$var$fj), $6a0eb74c8d3eb840$var$fj |= d;
    $6a0eb74c8d3eb840$var$Xi(a, b, e, c);
    return b.child;
}
function $6a0eb74c8d3eb840$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $6a0eb74c8d3eb840$var$cj(a, b, c, d, e) {
    var f = $6a0eb74c8d3eb840$var$Zf(c) ? $6a0eb74c8d3eb840$var$Xf : $6a0eb74c8d3eb840$var$H.current;
    f = $6a0eb74c8d3eb840$var$Yf(b, f);
    $6a0eb74c8d3eb840$var$ch(b, e);
    c = $6a0eb74c8d3eb840$var$Nh(a, b, c, d, f, e);
    d = $6a0eb74c8d3eb840$var$Sh();
    if (null !== a && !$6a0eb74c8d3eb840$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $6a0eb74c8d3eb840$var$Zi(a, b, e);
    $6a0eb74c8d3eb840$var$I && d && $6a0eb74c8d3eb840$var$vg(b);
    b.flags |= 1;
    $6a0eb74c8d3eb840$var$Xi(a, b, c, e);
    return b.child;
}
function $6a0eb74c8d3eb840$var$hj(a, b, c, d, e) {
    if ($6a0eb74c8d3eb840$var$Zf(c)) {
        var f = !0;
        $6a0eb74c8d3eb840$var$cg(b);
    } else f = !1;
    $6a0eb74c8d3eb840$var$ch(b, e);
    if (null === b.stateNode) $6a0eb74c8d3eb840$var$ij(a, b), $6a0eb74c8d3eb840$var$Gi(b, c, d), $6a0eb74c8d3eb840$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $6a0eb74c8d3eb840$var$eh(l) : (l = $6a0eb74c8d3eb840$var$Zf(c) ? $6a0eb74c8d3eb840$var$Xf : $6a0eb74c8d3eb840$var$H.current, l = $6a0eb74c8d3eb840$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $6a0eb74c8d3eb840$var$Hi(b, g, d, l);
        $6a0eb74c8d3eb840$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $6a0eb74c8d3eb840$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $6a0eb74c8d3eb840$var$Wf.current || $6a0eb74c8d3eb840$var$jh ? ("function" === typeof m && ($6a0eb74c8d3eb840$var$Di(b, c, m, d), k = b.memoizedState), (h = $6a0eb74c8d3eb840$var$jh || $6a0eb74c8d3eb840$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $6a0eb74c8d3eb840$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $6a0eb74c8d3eb840$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $6a0eb74c8d3eb840$var$eh(k) : (k = $6a0eb74c8d3eb840$var$Zf(c) ? $6a0eb74c8d3eb840$var$Xf : $6a0eb74c8d3eb840$var$H.current, k = $6a0eb74c8d3eb840$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $6a0eb74c8d3eb840$var$Hi(b, g, d, k);
        $6a0eb74c8d3eb840$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $6a0eb74c8d3eb840$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $6a0eb74c8d3eb840$var$Wf.current || $6a0eb74c8d3eb840$var$jh ? ("function" === typeof y && ($6a0eb74c8d3eb840$var$Di(b, c, y, d), n = b.memoizedState), (l = $6a0eb74c8d3eb840$var$jh || $6a0eb74c8d3eb840$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $6a0eb74c8d3eb840$var$jj(a, b, c, d, f, e);
}
function $6a0eb74c8d3eb840$var$jj(a, b, c, d, e, f) {
    $6a0eb74c8d3eb840$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $6a0eb74c8d3eb840$var$dg(b, c, !1), $6a0eb74c8d3eb840$var$Zi(a, b, f);
    d = b.stateNode;
    $6a0eb74c8d3eb840$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $6a0eb74c8d3eb840$var$Ug(b, a.child, null, f), b.child = $6a0eb74c8d3eb840$var$Ug(b, null, h, f)) : $6a0eb74c8d3eb840$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $6a0eb74c8d3eb840$var$dg(b, c, !0);
    return b.child;
}
function $6a0eb74c8d3eb840$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $6a0eb74c8d3eb840$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $6a0eb74c8d3eb840$var$ag(a, b.context, !1);
    $6a0eb74c8d3eb840$var$yh(a, b.containerInfo);
}
function $6a0eb74c8d3eb840$var$lj(a, b, c, d, e) {
    $6a0eb74c8d3eb840$var$Ig();
    $6a0eb74c8d3eb840$var$Jg(e);
    b.flags |= 256;
    $6a0eb74c8d3eb840$var$Xi(a, b, c, d);
    return b.child;
}
var $6a0eb74c8d3eb840$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $6a0eb74c8d3eb840$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $6a0eb74c8d3eb840$var$oj(a, b, c) {
    var d = b.pendingProps, e = $6a0eb74c8d3eb840$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, e & 1);
    if (null === a) {
        $6a0eb74c8d3eb840$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $6a0eb74c8d3eb840$var$pj(g, d, 0, null), a = $6a0eb74c8d3eb840$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $6a0eb74c8d3eb840$var$nj(c), b.memoizedState = $6a0eb74c8d3eb840$var$mj, a) : $6a0eb74c8d3eb840$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $6a0eb74c8d3eb840$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $6a0eb74c8d3eb840$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $6a0eb74c8d3eb840$var$Pg(h, f) : (f = $6a0eb74c8d3eb840$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $6a0eb74c8d3eb840$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $6a0eb74c8d3eb840$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $6a0eb74c8d3eb840$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $6a0eb74c8d3eb840$var$qj(a, b) {
    b = $6a0eb74c8d3eb840$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $6a0eb74c8d3eb840$var$sj(a, b, c, d) {
    null !== d && $6a0eb74c8d3eb840$var$Jg(d);
    $6a0eb74c8d3eb840$var$Ug(b, a.child, null, c);
    a = $6a0eb74c8d3eb840$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $6a0eb74c8d3eb840$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $6a0eb74c8d3eb840$var$Ki(Error($6a0eb74c8d3eb840$var$p(422))), $6a0eb74c8d3eb840$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $6a0eb74c8d3eb840$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $6a0eb74c8d3eb840$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $6a0eb74c8d3eb840$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $6a0eb74c8d3eb840$var$nj(g);
        b.memoizedState = $6a0eb74c8d3eb840$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $6a0eb74c8d3eb840$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($6a0eb74c8d3eb840$var$p(419));
        d = $6a0eb74c8d3eb840$var$Ki(f, d, void 0);
        return $6a0eb74c8d3eb840$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($6a0eb74c8d3eb840$var$dh || h) {
        d = $6a0eb74c8d3eb840$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $6a0eb74c8d3eb840$var$ih(a, e), $6a0eb74c8d3eb840$var$gi(d, a, e, -1));
        }
        $6a0eb74c8d3eb840$var$tj();
        d = $6a0eb74c8d3eb840$var$Ki(Error($6a0eb74c8d3eb840$var$p(421)));
        return $6a0eb74c8d3eb840$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $6a0eb74c8d3eb840$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $6a0eb74c8d3eb840$var$yg = $6a0eb74c8d3eb840$var$Lf(e.nextSibling);
    $6a0eb74c8d3eb840$var$xg = b;
    $6a0eb74c8d3eb840$var$I = !0;
    $6a0eb74c8d3eb840$var$zg = null;
    null !== a && ($6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg++] = $6a0eb74c8d3eb840$var$rg, $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg++] = $6a0eb74c8d3eb840$var$sg, $6a0eb74c8d3eb840$var$og[$6a0eb74c8d3eb840$var$pg++] = $6a0eb74c8d3eb840$var$qg, $6a0eb74c8d3eb840$var$rg = a.id, $6a0eb74c8d3eb840$var$sg = a.overflow, $6a0eb74c8d3eb840$var$qg = b);
    b = $6a0eb74c8d3eb840$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $6a0eb74c8d3eb840$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $6a0eb74c8d3eb840$var$bh(a.return, b, c);
}
function $6a0eb74c8d3eb840$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $6a0eb74c8d3eb840$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $6a0eb74c8d3eb840$var$Xi(a, b, d.children, c);
    d = $6a0eb74c8d3eb840$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $6a0eb74c8d3eb840$var$vj(a, c, b);
            else if (19 === a.tag) $6a0eb74c8d3eb840$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $6a0eb74c8d3eb840$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $6a0eb74c8d3eb840$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $6a0eb74c8d3eb840$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $6a0eb74c8d3eb840$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $6a0eb74c8d3eb840$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $6a0eb74c8d3eb840$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $6a0eb74c8d3eb840$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $6a0eb74c8d3eb840$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($6a0eb74c8d3eb840$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $6a0eb74c8d3eb840$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $6a0eb74c8d3eb840$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $6a0eb74c8d3eb840$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $6a0eb74c8d3eb840$var$kj(b);
            $6a0eb74c8d3eb840$var$Ig();
            break;
        case 5:
            $6a0eb74c8d3eb840$var$Ah(b);
            break;
        case 1:
            $6a0eb74c8d3eb840$var$Zf(b.type) && $6a0eb74c8d3eb840$var$cg(b);
            break;
        case 4:
            $6a0eb74c8d3eb840$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, $6a0eb74c8d3eb840$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $6a0eb74c8d3eb840$var$oj(a, b, c);
                $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, $6a0eb74c8d3eb840$var$L.current & 1);
                a = $6a0eb74c8d3eb840$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, $6a0eb74c8d3eb840$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $6a0eb74c8d3eb840$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, $6a0eb74c8d3eb840$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $6a0eb74c8d3eb840$var$dj(a, b, c);
    }
    return $6a0eb74c8d3eb840$var$Zi(a, b, c);
}
var $6a0eb74c8d3eb840$var$zj, $6a0eb74c8d3eb840$var$Aj, $6a0eb74c8d3eb840$var$Bj, $6a0eb74c8d3eb840$var$Cj;
$6a0eb74c8d3eb840$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$6a0eb74c8d3eb840$var$Aj = function() {};
$6a0eb74c8d3eb840$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $6a0eb74c8d3eb840$var$Ya(a, e);
                d = $6a0eb74c8d3eb840$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $6a0eb74c8d3eb840$var$A({}, e, {
                    value: void 0
                });
                d = $6a0eb74c8d3eb840$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $6a0eb74c8d3eb840$var$gb(a, e);
                d = $6a0eb74c8d3eb840$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $6a0eb74c8d3eb840$var$Bf);
        }
        $6a0eb74c8d3eb840$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($6a0eb74c8d3eb840$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($6a0eb74c8d3eb840$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $6a0eb74c8d3eb840$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$6a0eb74c8d3eb840$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $6a0eb74c8d3eb840$var$Dj(a, b) {
    if (!$6a0eb74c8d3eb840$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $6a0eb74c8d3eb840$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $6a0eb74c8d3eb840$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $6a0eb74c8d3eb840$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $6a0eb74c8d3eb840$var$S(b), null;
        case 1:
            return $6a0eb74c8d3eb840$var$Zf(b.type) && $6a0eb74c8d3eb840$var$$f(), $6a0eb74c8d3eb840$var$S(b), null;
        case 3:
            d = b.stateNode;
            $6a0eb74c8d3eb840$var$zh();
            $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wf);
            $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$H);
            $6a0eb74c8d3eb840$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $6a0eb74c8d3eb840$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $6a0eb74c8d3eb840$var$zg && ($6a0eb74c8d3eb840$var$Fj($6a0eb74c8d3eb840$var$zg), $6a0eb74c8d3eb840$var$zg = null));
            $6a0eb74c8d3eb840$var$Aj(a, b);
            $6a0eb74c8d3eb840$var$S(b);
            return null;
        case 5:
            $6a0eb74c8d3eb840$var$Bh(b);
            var e = $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $6a0eb74c8d3eb840$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($6a0eb74c8d3eb840$var$p(166));
                    $6a0eb74c8d3eb840$var$S(b);
                    return null;
                }
                a = $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$uh.current);
                if ($6a0eb74c8d3eb840$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$6a0eb74c8d3eb840$var$Of] = b;
                    d[$6a0eb74c8d3eb840$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $6a0eb74c8d3eb840$var$D("cancel", d);
                            $6a0eb74c8d3eb840$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $6a0eb74c8d3eb840$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $6a0eb74c8d3eb840$var$lf.length; e++)$6a0eb74c8d3eb840$var$D($6a0eb74c8d3eb840$var$lf[e], d);
                            break;
                        case "source":
                            $6a0eb74c8d3eb840$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $6a0eb74c8d3eb840$var$D("error", d);
                            $6a0eb74c8d3eb840$var$D("load", d);
                            break;
                        case "details":
                            $6a0eb74c8d3eb840$var$D("toggle", d);
                            break;
                        case "input":
                            $6a0eb74c8d3eb840$var$Za(d, f);
                            $6a0eb74c8d3eb840$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $6a0eb74c8d3eb840$var$D("invalid", d);
                            break;
                        case "textarea":
                            $6a0eb74c8d3eb840$var$hb(d, f), $6a0eb74c8d3eb840$var$D("invalid", d);
                    }
                    $6a0eb74c8d3eb840$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $6a0eb74c8d3eb840$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $6a0eb74c8d3eb840$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $6a0eb74c8d3eb840$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $6a0eb74c8d3eb840$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $6a0eb74c8d3eb840$var$Va(d);
                            $6a0eb74c8d3eb840$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $6a0eb74c8d3eb840$var$Va(d);
                            $6a0eb74c8d3eb840$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $6a0eb74c8d3eb840$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $6a0eb74c8d3eb840$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$6a0eb74c8d3eb840$var$Of] = b;
                    a[$6a0eb74c8d3eb840$var$Pf] = d;
                    $6a0eb74c8d3eb840$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $6a0eb74c8d3eb840$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $6a0eb74c8d3eb840$var$D("cancel", a);
                                $6a0eb74c8d3eb840$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $6a0eb74c8d3eb840$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $6a0eb74c8d3eb840$var$lf.length; e++)$6a0eb74c8d3eb840$var$D($6a0eb74c8d3eb840$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $6a0eb74c8d3eb840$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $6a0eb74c8d3eb840$var$D("error", a);
                                $6a0eb74c8d3eb840$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $6a0eb74c8d3eb840$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $6a0eb74c8d3eb840$var$Za(a, d);
                                e = $6a0eb74c8d3eb840$var$Ya(a, d);
                                $6a0eb74c8d3eb840$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $6a0eb74c8d3eb840$var$A({}, d, {
                                    value: void 0
                                });
                                $6a0eb74c8d3eb840$var$D("invalid", a);
                                break;
                            case "textarea":
                                $6a0eb74c8d3eb840$var$hb(a, d);
                                e = $6a0eb74c8d3eb840$var$gb(a, d);
                                $6a0eb74c8d3eb840$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $6a0eb74c8d3eb840$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $6a0eb74c8d3eb840$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $6a0eb74c8d3eb840$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $6a0eb74c8d3eb840$var$ob(a, k) : "number" === typeof k && $6a0eb74c8d3eb840$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($6a0eb74c8d3eb840$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $6a0eb74c8d3eb840$var$D("scroll", a) : null != k && $6a0eb74c8d3eb840$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $6a0eb74c8d3eb840$var$Va(a);
                                $6a0eb74c8d3eb840$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $6a0eb74c8d3eb840$var$Va(a);
                                $6a0eb74c8d3eb840$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $6a0eb74c8d3eb840$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $6a0eb74c8d3eb840$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $6a0eb74c8d3eb840$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $6a0eb74c8d3eb840$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $6a0eb74c8d3eb840$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $6a0eb74c8d3eb840$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($6a0eb74c8d3eb840$var$p(166));
                c = $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$wh.current);
                $6a0eb74c8d3eb840$var$xh($6a0eb74c8d3eb840$var$uh.current);
                if ($6a0eb74c8d3eb840$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$6a0eb74c8d3eb840$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $6a0eb74c8d3eb840$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $6a0eb74c8d3eb840$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $6a0eb74c8d3eb840$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$6a0eb74c8d3eb840$var$Of] = b, b.stateNode = d;
            }
            $6a0eb74c8d3eb840$var$S(b);
            return null;
        case 13:
            $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($6a0eb74c8d3eb840$var$I && null !== $6a0eb74c8d3eb840$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $6a0eb74c8d3eb840$var$Hg(), $6a0eb74c8d3eb840$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $6a0eb74c8d3eb840$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($6a0eb74c8d3eb840$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($6a0eb74c8d3eb840$var$p(317));
                        f[$6a0eb74c8d3eb840$var$Of] = b;
                    } else $6a0eb74c8d3eb840$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $6a0eb74c8d3eb840$var$S(b);
                    f = !1;
                } else null !== $6a0eb74c8d3eb840$var$zg && ($6a0eb74c8d3eb840$var$Fj($6a0eb74c8d3eb840$var$zg), $6a0eb74c8d3eb840$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($6a0eb74c8d3eb840$var$L.current & 1) ? 0 === $6a0eb74c8d3eb840$var$T && ($6a0eb74c8d3eb840$var$T = 3) : $6a0eb74c8d3eb840$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $6a0eb74c8d3eb840$var$S(b);
            return null;
        case 4:
            return $6a0eb74c8d3eb840$var$zh(), $6a0eb74c8d3eb840$var$Aj(a, b), null === a && $6a0eb74c8d3eb840$var$sf(b.stateNode.containerInfo), $6a0eb74c8d3eb840$var$S(b), null;
        case 10:
            return $6a0eb74c8d3eb840$var$ah(b.type._context), $6a0eb74c8d3eb840$var$S(b), null;
        case 17:
            return $6a0eb74c8d3eb840$var$Zf(b.type) && $6a0eb74c8d3eb840$var$$f(), $6a0eb74c8d3eb840$var$S(b), null;
        case 19:
            $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$L);
            f = b.memoizedState;
            if (null === f) return $6a0eb74c8d3eb840$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $6a0eb74c8d3eb840$var$Dj(f, !1);
                else {
                    if (0 !== $6a0eb74c8d3eb840$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $6a0eb74c8d3eb840$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $6a0eb74c8d3eb840$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, $6a0eb74c8d3eb840$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $6a0eb74c8d3eb840$var$B() > $6a0eb74c8d3eb840$var$Gj && (b.flags |= 128, d = !0, $6a0eb74c8d3eb840$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $6a0eb74c8d3eb840$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $6a0eb74c8d3eb840$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$6a0eb74c8d3eb840$var$I) return $6a0eb74c8d3eb840$var$S(b), null;
                    } else 2 * $6a0eb74c8d3eb840$var$B() - f.renderingStartTime > $6a0eb74c8d3eb840$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $6a0eb74c8d3eb840$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $6a0eb74c8d3eb840$var$B(), b.sibling = null, c = $6a0eb74c8d3eb840$var$L.current, $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$L, d ? c & 1 | 2 : c & 1), b;
            $6a0eb74c8d3eb840$var$S(b);
            return null;
        case 22:
        case 23:
            return $6a0eb74c8d3eb840$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($6a0eb74c8d3eb840$var$fj & 1073741824) && ($6a0eb74c8d3eb840$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $6a0eb74c8d3eb840$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($6a0eb74c8d3eb840$var$p(156, b.tag));
}
function $6a0eb74c8d3eb840$var$Ij(a, b) {
    $6a0eb74c8d3eb840$var$wg(b);
    switch(b.tag){
        case 1:
            return $6a0eb74c8d3eb840$var$Zf(b.type) && $6a0eb74c8d3eb840$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $6a0eb74c8d3eb840$var$zh(), $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wf), $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$H), $6a0eb74c8d3eb840$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $6a0eb74c8d3eb840$var$Bh(b), null;
        case 13:
            $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($6a0eb74c8d3eb840$var$p(340));
                $6a0eb74c8d3eb840$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$L), null;
        case 4:
            return $6a0eb74c8d3eb840$var$zh(), null;
        case 10:
            return $6a0eb74c8d3eb840$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $6a0eb74c8d3eb840$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $6a0eb74c8d3eb840$var$Jj = !1, $6a0eb74c8d3eb840$var$U = !1, $6a0eb74c8d3eb840$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $6a0eb74c8d3eb840$var$V = null;
function $6a0eb74c8d3eb840$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $6a0eb74c8d3eb840$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $6a0eb74c8d3eb840$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $6a0eb74c8d3eb840$var$W(a, b, d);
    }
}
var $6a0eb74c8d3eb840$var$Nj = !1;
function $6a0eb74c8d3eb840$var$Oj(a, b) {
    $6a0eb74c8d3eb840$var$Cf = $6a0eb74c8d3eb840$var$dd;
    a = $6a0eb74c8d3eb840$var$Me();
    if ($6a0eb74c8d3eb840$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $6a0eb74c8d3eb840$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $6a0eb74c8d3eb840$var$dd = !1;
    for($6a0eb74c8d3eb840$var$V = b; null !== $6a0eb74c8d3eb840$var$V;)if (b = $6a0eb74c8d3eb840$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $6a0eb74c8d3eb840$var$V = a;
    else for(; null !== $6a0eb74c8d3eb840$var$V;){
        b = $6a0eb74c8d3eb840$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $6a0eb74c8d3eb840$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($6a0eb74c8d3eb840$var$p(163));
            }
        } catch (F) {
            $6a0eb74c8d3eb840$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $6a0eb74c8d3eb840$var$V = a;
            break;
        }
        $6a0eb74c8d3eb840$var$V = b.return;
    }
    n = $6a0eb74c8d3eb840$var$Nj;
    $6a0eb74c8d3eb840$var$Nj = !1;
    return n;
}
function $6a0eb74c8d3eb840$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $6a0eb74c8d3eb840$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $6a0eb74c8d3eb840$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $6a0eb74c8d3eb840$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $6a0eb74c8d3eb840$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $6a0eb74c8d3eb840$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$6a0eb74c8d3eb840$var$Of], delete b[$6a0eb74c8d3eb840$var$Pf], delete b[$6a0eb74c8d3eb840$var$of], delete b[$6a0eb74c8d3eb840$var$Qf], delete b[$6a0eb74c8d3eb840$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $6a0eb74c8d3eb840$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $6a0eb74c8d3eb840$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $6a0eb74c8d3eb840$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $6a0eb74c8d3eb840$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $6a0eb74c8d3eb840$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($6a0eb74c8d3eb840$var$Vj(a, b, c), a = a.sibling; null !== a;)$6a0eb74c8d3eb840$var$Vj(a, b, c), a = a.sibling;
}
function $6a0eb74c8d3eb840$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($6a0eb74c8d3eb840$var$Wj(a, b, c), a = a.sibling; null !== a;)$6a0eb74c8d3eb840$var$Wj(a, b, c), a = a.sibling;
}
var $6a0eb74c8d3eb840$var$X = null, $6a0eb74c8d3eb840$var$Xj = !1;
function $6a0eb74c8d3eb840$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$6a0eb74c8d3eb840$var$Zj(a, b, c), c = c.sibling;
}
function $6a0eb74c8d3eb840$var$Zj(a, b, c) {
    if ($6a0eb74c8d3eb840$var$lc && "function" === typeof $6a0eb74c8d3eb840$var$lc.onCommitFiberUnmount) try {
        $6a0eb74c8d3eb840$var$lc.onCommitFiberUnmount($6a0eb74c8d3eb840$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $6a0eb74c8d3eb840$var$U || $6a0eb74c8d3eb840$var$Lj(c, b);
        case 6:
            var d = $6a0eb74c8d3eb840$var$X, e = $6a0eb74c8d3eb840$var$Xj;
            $6a0eb74c8d3eb840$var$X = null;
            $6a0eb74c8d3eb840$var$Yj(a, b, c);
            $6a0eb74c8d3eb840$var$X = d;
            $6a0eb74c8d3eb840$var$Xj = e;
            null !== $6a0eb74c8d3eb840$var$X && ($6a0eb74c8d3eb840$var$Xj ? (a = $6a0eb74c8d3eb840$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $6a0eb74c8d3eb840$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $6a0eb74c8d3eb840$var$X && ($6a0eb74c8d3eb840$var$Xj ? (a = $6a0eb74c8d3eb840$var$X, c = c.stateNode, 8 === a.nodeType ? $6a0eb74c8d3eb840$var$Kf(a.parentNode, c) : 1 === a.nodeType && $6a0eb74c8d3eb840$var$Kf(a, c), $6a0eb74c8d3eb840$var$bd(a)) : $6a0eb74c8d3eb840$var$Kf($6a0eb74c8d3eb840$var$X, c.stateNode));
            break;
        case 4:
            d = $6a0eb74c8d3eb840$var$X;
            e = $6a0eb74c8d3eb840$var$Xj;
            $6a0eb74c8d3eb840$var$X = c.stateNode.containerInfo;
            $6a0eb74c8d3eb840$var$Xj = !0;
            $6a0eb74c8d3eb840$var$Yj(a, b, c);
            $6a0eb74c8d3eb840$var$X = d;
            $6a0eb74c8d3eb840$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$6a0eb74c8d3eb840$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $6a0eb74c8d3eb840$var$Mj(c, b, g) : 0 !== (f & 4) && $6a0eb74c8d3eb840$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $6a0eb74c8d3eb840$var$Yj(a, b, c);
            break;
        case 1:
            if (!$6a0eb74c8d3eb840$var$U && ($6a0eb74c8d3eb840$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $6a0eb74c8d3eb840$var$W(c, b, h);
            }
            $6a0eb74c8d3eb840$var$Yj(a, b, c);
            break;
        case 21:
            $6a0eb74c8d3eb840$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($6a0eb74c8d3eb840$var$U = (d = $6a0eb74c8d3eb840$var$U) || null !== c.memoizedState, $6a0eb74c8d3eb840$var$Yj(a, b, c), $6a0eb74c8d3eb840$var$U = d) : $6a0eb74c8d3eb840$var$Yj(a, b, c);
            break;
        default:
            $6a0eb74c8d3eb840$var$Yj(a, b, c);
    }
}
function $6a0eb74c8d3eb840$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $6a0eb74c8d3eb840$var$Kj);
        b.forEach(function(b) {
            var d = $6a0eb74c8d3eb840$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $6a0eb74c8d3eb840$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $6a0eb74c8d3eb840$var$X = h.stateNode;
                        $6a0eb74c8d3eb840$var$Xj = !1;
                        break a;
                    case 3:
                        $6a0eb74c8d3eb840$var$X = h.stateNode.containerInfo;
                        $6a0eb74c8d3eb840$var$Xj = !0;
                        break a;
                    case 4:
                        $6a0eb74c8d3eb840$var$X = h.stateNode.containerInfo;
                        $6a0eb74c8d3eb840$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $6a0eb74c8d3eb840$var$X) throw Error($6a0eb74c8d3eb840$var$p(160));
            $6a0eb74c8d3eb840$var$Zj(f, g, e);
            $6a0eb74c8d3eb840$var$X = null;
            $6a0eb74c8d3eb840$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $6a0eb74c8d3eb840$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$6a0eb74c8d3eb840$var$dk(b, a), b = b.sibling;
}
function $6a0eb74c8d3eb840$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            if (d & 4) {
                try {
                    $6a0eb74c8d3eb840$var$Pj(3, a, a.return), $6a0eb74c8d3eb840$var$Qj(3, a);
                } catch (t) {
                    $6a0eb74c8d3eb840$var$W(a, a.return, t);
                }
                try {
                    $6a0eb74c8d3eb840$var$Pj(5, a, a.return);
                } catch (t) {
                    $6a0eb74c8d3eb840$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            d & 512 && null !== c && $6a0eb74c8d3eb840$var$Lj(c, c.return);
            break;
        case 5:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            d & 512 && null !== c && $6a0eb74c8d3eb840$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $6a0eb74c8d3eb840$var$ob(e, "");
                } catch (t) {
                    $6a0eb74c8d3eb840$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $6a0eb74c8d3eb840$var$ab(e, f);
                    $6a0eb74c8d3eb840$var$vb(h, g);
                    var l = $6a0eb74c8d3eb840$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $6a0eb74c8d3eb840$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $6a0eb74c8d3eb840$var$nb(e, q) : "children" === m ? $6a0eb74c8d3eb840$var$ob(e, q) : $6a0eb74c8d3eb840$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $6a0eb74c8d3eb840$var$bb(e, f);
                            break;
                        case "textarea":
                            $6a0eb74c8d3eb840$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $6a0eb74c8d3eb840$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $6a0eb74c8d3eb840$var$fb(e, !!f.multiple, f.defaultValue, !0) : $6a0eb74c8d3eb840$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$6a0eb74c8d3eb840$var$Pf] = f;
                } catch (t) {
                    $6a0eb74c8d3eb840$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($6a0eb74c8d3eb840$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $6a0eb74c8d3eb840$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $6a0eb74c8d3eb840$var$bd(b.containerInfo);
            } catch (t) {
                $6a0eb74c8d3eb840$var$W(a, a.return, t);
            }
            break;
        case 4:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            break;
        case 13:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($6a0eb74c8d3eb840$var$fk = $6a0eb74c8d3eb840$var$B()));
            d & 4 && $6a0eb74c8d3eb840$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($6a0eb74c8d3eb840$var$U = (l = $6a0eb74c8d3eb840$var$U) || m, $6a0eb74c8d3eb840$var$ck(b, a), $6a0eb74c8d3eb840$var$U = l) : $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($6a0eb74c8d3eb840$var$V = a, m = a.child; null !== m;){
                    for(q = $6a0eb74c8d3eb840$var$V = m; null !== $6a0eb74c8d3eb840$var$V;){
                        r = $6a0eb74c8d3eb840$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $6a0eb74c8d3eb840$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $6a0eb74c8d3eb840$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $6a0eb74c8d3eb840$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $6a0eb74c8d3eb840$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $6a0eb74c8d3eb840$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $6a0eb74c8d3eb840$var$V = y) : $6a0eb74c8d3eb840$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $6a0eb74c8d3eb840$var$rb("display", g));
                            } catch (t) {
                                $6a0eb74c8d3eb840$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $6a0eb74c8d3eb840$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $6a0eb74c8d3eb840$var$ck(b, a);
            $6a0eb74c8d3eb840$var$ek(a);
            d & 4 && $6a0eb74c8d3eb840$var$ak(a);
            break;
        case 21:
            break;
        default:
            $6a0eb74c8d3eb840$var$ck(b, a), $6a0eb74c8d3eb840$var$ek(a);
    }
}
function $6a0eb74c8d3eb840$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($6a0eb74c8d3eb840$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($6a0eb74c8d3eb840$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($6a0eb74c8d3eb840$var$ob(e, ""), d.flags &= -33);
                    var f = $6a0eb74c8d3eb840$var$Uj(a);
                    $6a0eb74c8d3eb840$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $6a0eb74c8d3eb840$var$Uj(a);
                    $6a0eb74c8d3eb840$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($6a0eb74c8d3eb840$var$p(161));
            }
        } catch (k) {
            $6a0eb74c8d3eb840$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $6a0eb74c8d3eb840$var$hk(a, b, c) {
    $6a0eb74c8d3eb840$var$V = a;
    $6a0eb74c8d3eb840$var$ik(a, b, c);
}
function $6a0eb74c8d3eb840$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $6a0eb74c8d3eb840$var$V;){
        var e = $6a0eb74c8d3eb840$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $6a0eb74c8d3eb840$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $6a0eb74c8d3eb840$var$U;
                h = $6a0eb74c8d3eb840$var$Jj;
                var l = $6a0eb74c8d3eb840$var$U;
                $6a0eb74c8d3eb840$var$Jj = g;
                if (($6a0eb74c8d3eb840$var$U = k) && !l) for($6a0eb74c8d3eb840$var$V = e; null !== $6a0eb74c8d3eb840$var$V;)g = $6a0eb74c8d3eb840$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $6a0eb74c8d3eb840$var$jk(e) : null !== k ? (k.return = g, $6a0eb74c8d3eb840$var$V = k) : $6a0eb74c8d3eb840$var$jk(e);
                for(; null !== f;)$6a0eb74c8d3eb840$var$V = f, $6a0eb74c8d3eb840$var$ik(f, b, c), f = f.sibling;
                $6a0eb74c8d3eb840$var$V = e;
                $6a0eb74c8d3eb840$var$Jj = h;
                $6a0eb74c8d3eb840$var$U = l;
            }
            $6a0eb74c8d3eb840$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $6a0eb74c8d3eb840$var$V = f) : $6a0eb74c8d3eb840$var$kk(a, b, c);
    }
}
function $6a0eb74c8d3eb840$var$kk(a) {
    for(; null !== $6a0eb74c8d3eb840$var$V;){
        var b = $6a0eb74c8d3eb840$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $6a0eb74c8d3eb840$var$U || $6a0eb74c8d3eb840$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$6a0eb74c8d3eb840$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $6a0eb74c8d3eb840$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $6a0eb74c8d3eb840$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $6a0eb74c8d3eb840$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $6a0eb74c8d3eb840$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($6a0eb74c8d3eb840$var$p(163));
                }
                $6a0eb74c8d3eb840$var$U || b.flags & 512 && $6a0eb74c8d3eb840$var$Rj(b);
            } catch (r) {
                $6a0eb74c8d3eb840$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $6a0eb74c8d3eb840$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $6a0eb74c8d3eb840$var$V = c;
            break;
        }
        $6a0eb74c8d3eb840$var$V = b.return;
    }
}
function $6a0eb74c8d3eb840$var$gk(a) {
    for(; null !== $6a0eb74c8d3eb840$var$V;){
        var b = $6a0eb74c8d3eb840$var$V;
        if (b === a) {
            $6a0eb74c8d3eb840$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $6a0eb74c8d3eb840$var$V = c;
            break;
        }
        $6a0eb74c8d3eb840$var$V = b.return;
    }
}
function $6a0eb74c8d3eb840$var$jk(a) {
    for(; null !== $6a0eb74c8d3eb840$var$V;){
        var b = $6a0eb74c8d3eb840$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $6a0eb74c8d3eb840$var$Qj(4, b);
                    } catch (k) {
                        $6a0eb74c8d3eb840$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $6a0eb74c8d3eb840$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $6a0eb74c8d3eb840$var$Rj(b);
                    } catch (k) {
                        $6a0eb74c8d3eb840$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $6a0eb74c8d3eb840$var$Rj(b);
                    } catch (k) {
                        $6a0eb74c8d3eb840$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $6a0eb74c8d3eb840$var$W(b, b.return, k);
        }
        if (b === a) {
            $6a0eb74c8d3eb840$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $6a0eb74c8d3eb840$var$V = h;
            break;
        }
        $6a0eb74c8d3eb840$var$V = b.return;
    }
}
var $6a0eb74c8d3eb840$var$lk = Math.ceil, $6a0eb74c8d3eb840$var$mk = $6a0eb74c8d3eb840$var$ua.ReactCurrentDispatcher, $6a0eb74c8d3eb840$var$nk = $6a0eb74c8d3eb840$var$ua.ReactCurrentOwner, $6a0eb74c8d3eb840$var$ok = $6a0eb74c8d3eb840$var$ua.ReactCurrentBatchConfig, $6a0eb74c8d3eb840$var$K = 0, $6a0eb74c8d3eb840$var$Q = null, $6a0eb74c8d3eb840$var$Y = null, $6a0eb74c8d3eb840$var$Z = 0, $6a0eb74c8d3eb840$var$fj = 0, $6a0eb74c8d3eb840$var$ej = $6a0eb74c8d3eb840$var$Uf(0), $6a0eb74c8d3eb840$var$T = 0, $6a0eb74c8d3eb840$var$pk = null, $6a0eb74c8d3eb840$var$rh = 0, $6a0eb74c8d3eb840$var$qk = 0, $6a0eb74c8d3eb840$var$rk = 0, $6a0eb74c8d3eb840$var$sk = null, $6a0eb74c8d3eb840$var$tk = null, $6a0eb74c8d3eb840$var$fk = 0, $6a0eb74c8d3eb840$var$Gj = Infinity, $6a0eb74c8d3eb840$var$uk = null, $6a0eb74c8d3eb840$var$Oi = !1, $6a0eb74c8d3eb840$var$Pi = null, $6a0eb74c8d3eb840$var$Ri = null, $6a0eb74c8d3eb840$var$vk = !1, $6a0eb74c8d3eb840$var$wk = null, $6a0eb74c8d3eb840$var$xk = 0, $6a0eb74c8d3eb840$var$yk = 0, $6a0eb74c8d3eb840$var$zk = null, $6a0eb74c8d3eb840$var$Ak = -1, $6a0eb74c8d3eb840$var$Bk = 0;
function $6a0eb74c8d3eb840$var$R() {
    return 0 !== ($6a0eb74c8d3eb840$var$K & 6) ? $6a0eb74c8d3eb840$var$B() : -1 !== $6a0eb74c8d3eb840$var$Ak ? $6a0eb74c8d3eb840$var$Ak : $6a0eb74c8d3eb840$var$Ak = $6a0eb74c8d3eb840$var$B();
}
function $6a0eb74c8d3eb840$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($6a0eb74c8d3eb840$var$K & 2) && 0 !== $6a0eb74c8d3eb840$var$Z) return $6a0eb74c8d3eb840$var$Z & -$6a0eb74c8d3eb840$var$Z;
    if (null !== $6a0eb74c8d3eb840$var$Kg.transition) return 0 === $6a0eb74c8d3eb840$var$Bk && ($6a0eb74c8d3eb840$var$Bk = $6a0eb74c8d3eb840$var$yc()), $6a0eb74c8d3eb840$var$Bk;
    a = $6a0eb74c8d3eb840$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $6a0eb74c8d3eb840$var$jd(a.type);
    return a;
}
function $6a0eb74c8d3eb840$var$gi(a, b, c, d) {
    if (50 < $6a0eb74c8d3eb840$var$yk) throw $6a0eb74c8d3eb840$var$yk = 0, $6a0eb74c8d3eb840$var$zk = null, Error($6a0eb74c8d3eb840$var$p(185));
    $6a0eb74c8d3eb840$var$Ac(a, c, d);
    if (0 === ($6a0eb74c8d3eb840$var$K & 2) || a !== $6a0eb74c8d3eb840$var$Q) a === $6a0eb74c8d3eb840$var$Q && (0 === ($6a0eb74c8d3eb840$var$K & 2) && ($6a0eb74c8d3eb840$var$qk |= c), 4 === $6a0eb74c8d3eb840$var$T && $6a0eb74c8d3eb840$var$Ck(a, $6a0eb74c8d3eb840$var$Z)), $6a0eb74c8d3eb840$var$Dk(a, d), 1 === c && 0 === $6a0eb74c8d3eb840$var$K && 0 === (b.mode & 1) && ($6a0eb74c8d3eb840$var$Gj = $6a0eb74c8d3eb840$var$B() + 500, $6a0eb74c8d3eb840$var$fg && $6a0eb74c8d3eb840$var$jg());
}
function $6a0eb74c8d3eb840$var$Dk(a, b) {
    var c = a.callbackNode;
    $6a0eb74c8d3eb840$var$wc(a, b);
    var d = $6a0eb74c8d3eb840$var$uc(a, a === $6a0eb74c8d3eb840$var$Q ? $6a0eb74c8d3eb840$var$Z : 0);
    if (0 === d) null !== c && $6a0eb74c8d3eb840$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $6a0eb74c8d3eb840$var$bc(c);
        if (1 === b) 0 === a.tag ? $6a0eb74c8d3eb840$var$ig($6a0eb74c8d3eb840$var$Ek.bind(null, a)) : $6a0eb74c8d3eb840$var$hg($6a0eb74c8d3eb840$var$Ek.bind(null, a)), $6a0eb74c8d3eb840$var$Jf(function() {
            0 === ($6a0eb74c8d3eb840$var$K & 6) && $6a0eb74c8d3eb840$var$jg();
        }), c = null;
        else {
            switch($6a0eb74c8d3eb840$var$Dc(d)){
                case 1:
                    c = $6a0eb74c8d3eb840$var$fc;
                    break;
                case 4:
                    c = $6a0eb74c8d3eb840$var$gc;
                    break;
                case 16:
                    c = $6a0eb74c8d3eb840$var$hc;
                    break;
                case 536870912:
                    c = $6a0eb74c8d3eb840$var$jc;
                    break;
                default:
                    c = $6a0eb74c8d3eb840$var$hc;
            }
            c = $6a0eb74c8d3eb840$var$Fk(c, $6a0eb74c8d3eb840$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $6a0eb74c8d3eb840$var$Gk(a, b) {
    $6a0eb74c8d3eb840$var$Ak = -1;
    $6a0eb74c8d3eb840$var$Bk = 0;
    if (0 !== ($6a0eb74c8d3eb840$var$K & 6)) throw Error($6a0eb74c8d3eb840$var$p(327));
    var c = a.callbackNode;
    if ($6a0eb74c8d3eb840$var$Hk() && a.callbackNode !== c) return null;
    var d = $6a0eb74c8d3eb840$var$uc(a, a === $6a0eb74c8d3eb840$var$Q ? $6a0eb74c8d3eb840$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $6a0eb74c8d3eb840$var$Ik(a, d);
    else {
        b = d;
        var e = $6a0eb74c8d3eb840$var$K;
        $6a0eb74c8d3eb840$var$K |= 2;
        var f = $6a0eb74c8d3eb840$var$Jk();
        if ($6a0eb74c8d3eb840$var$Q !== a || $6a0eb74c8d3eb840$var$Z !== b) $6a0eb74c8d3eb840$var$uk = null, $6a0eb74c8d3eb840$var$Gj = $6a0eb74c8d3eb840$var$B() + 500, $6a0eb74c8d3eb840$var$Kk(a, b);
        for(;;)try {
            $6a0eb74c8d3eb840$var$Lk();
            break;
        } catch (h) {
            $6a0eb74c8d3eb840$var$Mk(a, h);
        }
        $6a0eb74c8d3eb840$var$$g();
        $6a0eb74c8d3eb840$var$mk.current = f;
        $6a0eb74c8d3eb840$var$K = e;
        null !== $6a0eb74c8d3eb840$var$Y ? b = 0 : ($6a0eb74c8d3eb840$var$Q = null, $6a0eb74c8d3eb840$var$Z = 0, b = $6a0eb74c8d3eb840$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $6a0eb74c8d3eb840$var$xc(a), 0 !== e && (d = e, b = $6a0eb74c8d3eb840$var$Nk(a, e)));
        if (1 === b) throw c = $6a0eb74c8d3eb840$var$pk, $6a0eb74c8d3eb840$var$Kk(a, 0), $6a0eb74c8d3eb840$var$Ck(a, d), $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B()), c;
        if (6 === b) $6a0eb74c8d3eb840$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$6a0eb74c8d3eb840$var$Ok(e) && (b = $6a0eb74c8d3eb840$var$Ik(a, d), 2 === b && (f = $6a0eb74c8d3eb840$var$xc(a), 0 !== f && (d = f, b = $6a0eb74c8d3eb840$var$Nk(a, f))), 1 === b)) throw c = $6a0eb74c8d3eb840$var$pk, $6a0eb74c8d3eb840$var$Kk(a, 0), $6a0eb74c8d3eb840$var$Ck(a, d), $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($6a0eb74c8d3eb840$var$p(345));
                case 2:
                    $6a0eb74c8d3eb840$var$Pk(a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk);
                    break;
                case 3:
                    $6a0eb74c8d3eb840$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $6a0eb74c8d3eb840$var$fk + 500 - $6a0eb74c8d3eb840$var$B(), 10 < b)) {
                        if (0 !== $6a0eb74c8d3eb840$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $6a0eb74c8d3eb840$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $6a0eb74c8d3eb840$var$Ff($6a0eb74c8d3eb840$var$Pk.bind(null, a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk), b);
                        break;
                    }
                    $6a0eb74c8d3eb840$var$Pk(a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk);
                    break;
                case 4:
                    $6a0eb74c8d3eb840$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $6a0eb74c8d3eb840$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $6a0eb74c8d3eb840$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $6a0eb74c8d3eb840$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $6a0eb74c8d3eb840$var$Ff($6a0eb74c8d3eb840$var$Pk.bind(null, a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk), d);
                        break;
                    }
                    $6a0eb74c8d3eb840$var$Pk(a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk);
                    break;
                case 5:
                    $6a0eb74c8d3eb840$var$Pk(a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk);
                    break;
                default:
                    throw Error($6a0eb74c8d3eb840$var$p(329));
            }
        }
    }
    $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B());
    return a.callbackNode === c ? $6a0eb74c8d3eb840$var$Gk.bind(null, a) : null;
}
function $6a0eb74c8d3eb840$var$Nk(a, b) {
    var c = $6a0eb74c8d3eb840$var$sk;
    a.current.memoizedState.isDehydrated && ($6a0eb74c8d3eb840$var$Kk(a, b).flags |= 256);
    a = $6a0eb74c8d3eb840$var$Ik(a, b);
    2 !== a && (b = $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$tk = c, null !== b && $6a0eb74c8d3eb840$var$Fj(b));
    return a;
}
function $6a0eb74c8d3eb840$var$Fj(a) {
    null === $6a0eb74c8d3eb840$var$tk ? $6a0eb74c8d3eb840$var$tk = a : $6a0eb74c8d3eb840$var$tk.push.apply($6a0eb74c8d3eb840$var$tk, a);
}
function $6a0eb74c8d3eb840$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$6a0eb74c8d3eb840$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $6a0eb74c8d3eb840$var$Ck(a, b) {
    b &= ~$6a0eb74c8d3eb840$var$rk;
    b &= ~$6a0eb74c8d3eb840$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $6a0eb74c8d3eb840$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $6a0eb74c8d3eb840$var$Ek(a) {
    if (0 !== ($6a0eb74c8d3eb840$var$K & 6)) throw Error($6a0eb74c8d3eb840$var$p(327));
    $6a0eb74c8d3eb840$var$Hk();
    var b = $6a0eb74c8d3eb840$var$uc(a, 0);
    if (0 === (b & 1)) return $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B()), null;
    var c = $6a0eb74c8d3eb840$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $6a0eb74c8d3eb840$var$xc(a);
        0 !== d && (b = d, c = $6a0eb74c8d3eb840$var$Nk(a, d));
    }
    if (1 === c) throw c = $6a0eb74c8d3eb840$var$pk, $6a0eb74c8d3eb840$var$Kk(a, 0), $6a0eb74c8d3eb840$var$Ck(a, b), $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B()), c;
    if (6 === c) throw Error($6a0eb74c8d3eb840$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $6a0eb74c8d3eb840$var$Pk(a, $6a0eb74c8d3eb840$var$tk, $6a0eb74c8d3eb840$var$uk);
    $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B());
    return null;
}
function $6a0eb74c8d3eb840$var$Qk(a, b) {
    var c = $6a0eb74c8d3eb840$var$K;
    $6a0eb74c8d3eb840$var$K |= 1;
    try {
        return a(b);
    } finally{
        $6a0eb74c8d3eb840$var$K = c, 0 === $6a0eb74c8d3eb840$var$K && ($6a0eb74c8d3eb840$var$Gj = $6a0eb74c8d3eb840$var$B() + 500, $6a0eb74c8d3eb840$var$fg && $6a0eb74c8d3eb840$var$jg());
    }
}
function $6a0eb74c8d3eb840$var$Rk(a) {
    null !== $6a0eb74c8d3eb840$var$wk && 0 === $6a0eb74c8d3eb840$var$wk.tag && 0 === ($6a0eb74c8d3eb840$var$K & 6) && $6a0eb74c8d3eb840$var$Hk();
    var b = $6a0eb74c8d3eb840$var$K;
    $6a0eb74c8d3eb840$var$K |= 1;
    var c = $6a0eb74c8d3eb840$var$ok.transition, d = $6a0eb74c8d3eb840$var$C;
    try {
        if ($6a0eb74c8d3eb840$var$ok.transition = null, $6a0eb74c8d3eb840$var$C = 1, a) return a();
    } finally{
        $6a0eb74c8d3eb840$var$C = d, $6a0eb74c8d3eb840$var$ok.transition = c, $6a0eb74c8d3eb840$var$K = b, 0 === ($6a0eb74c8d3eb840$var$K & 6) && $6a0eb74c8d3eb840$var$jg();
    }
}
function $6a0eb74c8d3eb840$var$Hj() {
    $6a0eb74c8d3eb840$var$fj = $6a0eb74c8d3eb840$var$ej.current;
    $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$ej);
}
function $6a0eb74c8d3eb840$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $6a0eb74c8d3eb840$var$Gf(c));
    if (null !== $6a0eb74c8d3eb840$var$Y) for(c = $6a0eb74c8d3eb840$var$Y.return; null !== c;){
        var d = c;
        $6a0eb74c8d3eb840$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $6a0eb74c8d3eb840$var$$f();
                break;
            case 3:
                $6a0eb74c8d3eb840$var$zh();
                $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$Wf);
                $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$H);
                $6a0eb74c8d3eb840$var$Eh();
                break;
            case 5:
                $6a0eb74c8d3eb840$var$Bh(d);
                break;
            case 4:
                $6a0eb74c8d3eb840$var$zh();
                break;
            case 13:
                $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$L);
                break;
            case 19:
                $6a0eb74c8d3eb840$var$E($6a0eb74c8d3eb840$var$L);
                break;
            case 10:
                $6a0eb74c8d3eb840$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $6a0eb74c8d3eb840$var$Hj();
        }
        c = c.return;
    }
    $6a0eb74c8d3eb840$var$Q = a;
    $6a0eb74c8d3eb840$var$Y = a = $6a0eb74c8d3eb840$var$Pg(a.current, null);
    $6a0eb74c8d3eb840$var$Z = $6a0eb74c8d3eb840$var$fj = b;
    $6a0eb74c8d3eb840$var$T = 0;
    $6a0eb74c8d3eb840$var$pk = null;
    $6a0eb74c8d3eb840$var$rk = $6a0eb74c8d3eb840$var$qk = $6a0eb74c8d3eb840$var$rh = 0;
    $6a0eb74c8d3eb840$var$tk = $6a0eb74c8d3eb840$var$sk = null;
    if (null !== $6a0eb74c8d3eb840$var$fh) {
        for(b = 0; b < $6a0eb74c8d3eb840$var$fh.length; b++)if (c = $6a0eb74c8d3eb840$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $6a0eb74c8d3eb840$var$fh = null;
    }
    return a;
}
function $6a0eb74c8d3eb840$var$Mk(a, b) {
    do {
        var c = $6a0eb74c8d3eb840$var$Y;
        try {
            $6a0eb74c8d3eb840$var$$g();
            $6a0eb74c8d3eb840$var$Fh.current = $6a0eb74c8d3eb840$var$Rh;
            if ($6a0eb74c8d3eb840$var$Ih) {
                for(var d = $6a0eb74c8d3eb840$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $6a0eb74c8d3eb840$var$Ih = !1;
            }
            $6a0eb74c8d3eb840$var$Hh = 0;
            $6a0eb74c8d3eb840$var$O = $6a0eb74c8d3eb840$var$N = $6a0eb74c8d3eb840$var$M = null;
            $6a0eb74c8d3eb840$var$Jh = !1;
            $6a0eb74c8d3eb840$var$Kh = 0;
            $6a0eb74c8d3eb840$var$nk.current = null;
            if (null === c || null === c.return) {
                $6a0eb74c8d3eb840$var$T = 1;
                $6a0eb74c8d3eb840$var$pk = b;
                $6a0eb74c8d3eb840$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $6a0eb74c8d3eb840$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $6a0eb74c8d3eb840$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $6a0eb74c8d3eb840$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $6a0eb74c8d3eb840$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $6a0eb74c8d3eb840$var$Si(f, l, b);
                            $6a0eb74c8d3eb840$var$tj();
                            break a;
                        }
                        k = Error($6a0eb74c8d3eb840$var$p(426));
                    }
                } else if ($6a0eb74c8d3eb840$var$I && h.mode & 1) {
                    var J = $6a0eb74c8d3eb840$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $6a0eb74c8d3eb840$var$Vi(J, g, h, f, b);
                        $6a0eb74c8d3eb840$var$Jg($6a0eb74c8d3eb840$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $6a0eb74c8d3eb840$var$Ji(k, h);
                4 !== $6a0eb74c8d3eb840$var$T && ($6a0eb74c8d3eb840$var$T = 2);
                null === $6a0eb74c8d3eb840$var$sk ? $6a0eb74c8d3eb840$var$sk = [
                    f
                ] : $6a0eb74c8d3eb840$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $6a0eb74c8d3eb840$var$Ni(f, k, b);
                            $6a0eb74c8d3eb840$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $6a0eb74c8d3eb840$var$Ri || !$6a0eb74c8d3eb840$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $6a0eb74c8d3eb840$var$Qi(f, h, b);
                                $6a0eb74c8d3eb840$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $6a0eb74c8d3eb840$var$Sk(c);
        } catch (na) {
            b = na;
            $6a0eb74c8d3eb840$var$Y === c && null !== c && ($6a0eb74c8d3eb840$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $6a0eb74c8d3eb840$var$Jk() {
    var a = $6a0eb74c8d3eb840$var$mk.current;
    $6a0eb74c8d3eb840$var$mk.current = $6a0eb74c8d3eb840$var$Rh;
    return null === a ? $6a0eb74c8d3eb840$var$Rh : a;
}
function $6a0eb74c8d3eb840$var$tj() {
    if (0 === $6a0eb74c8d3eb840$var$T || 3 === $6a0eb74c8d3eb840$var$T || 2 === $6a0eb74c8d3eb840$var$T) $6a0eb74c8d3eb840$var$T = 4;
    null === $6a0eb74c8d3eb840$var$Q || 0 === ($6a0eb74c8d3eb840$var$rh & 268435455) && 0 === ($6a0eb74c8d3eb840$var$qk & 268435455) || $6a0eb74c8d3eb840$var$Ck($6a0eb74c8d3eb840$var$Q, $6a0eb74c8d3eb840$var$Z);
}
function $6a0eb74c8d3eb840$var$Ik(a, b) {
    var c = $6a0eb74c8d3eb840$var$K;
    $6a0eb74c8d3eb840$var$K |= 2;
    var d = $6a0eb74c8d3eb840$var$Jk();
    if ($6a0eb74c8d3eb840$var$Q !== a || $6a0eb74c8d3eb840$var$Z !== b) $6a0eb74c8d3eb840$var$uk = null, $6a0eb74c8d3eb840$var$Kk(a, b);
    for(;;)try {
        $6a0eb74c8d3eb840$var$Tk();
        break;
    } catch (e) {
        $6a0eb74c8d3eb840$var$Mk(a, e);
    }
    $6a0eb74c8d3eb840$var$$g();
    $6a0eb74c8d3eb840$var$K = c;
    $6a0eb74c8d3eb840$var$mk.current = d;
    if (null !== $6a0eb74c8d3eb840$var$Y) throw Error($6a0eb74c8d3eb840$var$p(261));
    $6a0eb74c8d3eb840$var$Q = null;
    $6a0eb74c8d3eb840$var$Z = 0;
    return $6a0eb74c8d3eb840$var$T;
}
function $6a0eb74c8d3eb840$var$Tk() {
    for(; null !== $6a0eb74c8d3eb840$var$Y;)$6a0eb74c8d3eb840$var$Uk($6a0eb74c8d3eb840$var$Y);
}
function $6a0eb74c8d3eb840$var$Lk() {
    for(; null !== $6a0eb74c8d3eb840$var$Y && !$6a0eb74c8d3eb840$var$cc();)$6a0eb74c8d3eb840$var$Uk($6a0eb74c8d3eb840$var$Y);
}
function $6a0eb74c8d3eb840$var$Uk(a) {
    var b = $6a0eb74c8d3eb840$var$Vk(a.alternate, a, $6a0eb74c8d3eb840$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $6a0eb74c8d3eb840$var$Sk(a) : $6a0eb74c8d3eb840$var$Y = b;
    $6a0eb74c8d3eb840$var$nk.current = null;
}
function $6a0eb74c8d3eb840$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $6a0eb74c8d3eb840$var$Ej(c, b, $6a0eb74c8d3eb840$var$fj), null !== c) {
                $6a0eb74c8d3eb840$var$Y = c;
                return;
            }
        } else {
            c = $6a0eb74c8d3eb840$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $6a0eb74c8d3eb840$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $6a0eb74c8d3eb840$var$T = 6;
                $6a0eb74c8d3eb840$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $6a0eb74c8d3eb840$var$Y = b;
            return;
        }
        $6a0eb74c8d3eb840$var$Y = b = a;
    }while (null !== b);
    0 === $6a0eb74c8d3eb840$var$T && ($6a0eb74c8d3eb840$var$T = 5);
}
function $6a0eb74c8d3eb840$var$Pk(a, b, c) {
    var d = $6a0eb74c8d3eb840$var$C, e = $6a0eb74c8d3eb840$var$ok.transition;
    try {
        $6a0eb74c8d3eb840$var$ok.transition = null, $6a0eb74c8d3eb840$var$C = 1, $6a0eb74c8d3eb840$var$Wk(a, b, c, d);
    } finally{
        $6a0eb74c8d3eb840$var$ok.transition = e, $6a0eb74c8d3eb840$var$C = d;
    }
    return null;
}
function $6a0eb74c8d3eb840$var$Wk(a, b, c, d) {
    do $6a0eb74c8d3eb840$var$Hk();
    while (null !== $6a0eb74c8d3eb840$var$wk);
    if (0 !== ($6a0eb74c8d3eb840$var$K & 6)) throw Error($6a0eb74c8d3eb840$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($6a0eb74c8d3eb840$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $6a0eb74c8d3eb840$var$Bc(a, f);
    a === $6a0eb74c8d3eb840$var$Q && ($6a0eb74c8d3eb840$var$Y = $6a0eb74c8d3eb840$var$Q = null, $6a0eb74c8d3eb840$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $6a0eb74c8d3eb840$var$vk || ($6a0eb74c8d3eb840$var$vk = !0, $6a0eb74c8d3eb840$var$Fk($6a0eb74c8d3eb840$var$hc, function() {
        $6a0eb74c8d3eb840$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $6a0eb74c8d3eb840$var$ok.transition;
        $6a0eb74c8d3eb840$var$ok.transition = null;
        var g = $6a0eb74c8d3eb840$var$C;
        $6a0eb74c8d3eb840$var$C = 1;
        var h = $6a0eb74c8d3eb840$var$K;
        $6a0eb74c8d3eb840$var$K |= 4;
        $6a0eb74c8d3eb840$var$nk.current = null;
        $6a0eb74c8d3eb840$var$Oj(a, c);
        $6a0eb74c8d3eb840$var$dk(c, a);
        $6a0eb74c8d3eb840$var$Oe($6a0eb74c8d3eb840$var$Df);
        $6a0eb74c8d3eb840$var$dd = !!$6a0eb74c8d3eb840$var$Cf;
        $6a0eb74c8d3eb840$var$Df = $6a0eb74c8d3eb840$var$Cf = null;
        a.current = c;
        $6a0eb74c8d3eb840$var$hk(c, a, e);
        $6a0eb74c8d3eb840$var$dc();
        $6a0eb74c8d3eb840$var$K = h;
        $6a0eb74c8d3eb840$var$C = g;
        $6a0eb74c8d3eb840$var$ok.transition = f;
    } else a.current = c;
    $6a0eb74c8d3eb840$var$vk && ($6a0eb74c8d3eb840$var$vk = !1, $6a0eb74c8d3eb840$var$wk = a, $6a0eb74c8d3eb840$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($6a0eb74c8d3eb840$var$Ri = null);
    $6a0eb74c8d3eb840$var$mc(c.stateNode, d);
    $6a0eb74c8d3eb840$var$Dk(a, $6a0eb74c8d3eb840$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($6a0eb74c8d3eb840$var$Oi) throw $6a0eb74c8d3eb840$var$Oi = !1, a = $6a0eb74c8d3eb840$var$Pi, $6a0eb74c8d3eb840$var$Pi = null, a;
    0 !== ($6a0eb74c8d3eb840$var$xk & 1) && 0 !== a.tag && $6a0eb74c8d3eb840$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $6a0eb74c8d3eb840$var$zk ? $6a0eb74c8d3eb840$var$yk++ : ($6a0eb74c8d3eb840$var$yk = 0, $6a0eb74c8d3eb840$var$zk = a) : $6a0eb74c8d3eb840$var$yk = 0;
    $6a0eb74c8d3eb840$var$jg();
    return null;
}
function $6a0eb74c8d3eb840$var$Hk() {
    if (null !== $6a0eb74c8d3eb840$var$wk) {
        var a = $6a0eb74c8d3eb840$var$Dc($6a0eb74c8d3eb840$var$xk), b = $6a0eb74c8d3eb840$var$ok.transition, c = $6a0eb74c8d3eb840$var$C;
        try {
            $6a0eb74c8d3eb840$var$ok.transition = null;
            $6a0eb74c8d3eb840$var$C = 16 > a ? 16 : a;
            if (null === $6a0eb74c8d3eb840$var$wk) var d = !1;
            else {
                a = $6a0eb74c8d3eb840$var$wk;
                $6a0eb74c8d3eb840$var$wk = null;
                $6a0eb74c8d3eb840$var$xk = 0;
                if (0 !== ($6a0eb74c8d3eb840$var$K & 6)) throw Error($6a0eb74c8d3eb840$var$p(331));
                var e = $6a0eb74c8d3eb840$var$K;
                $6a0eb74c8d3eb840$var$K |= 4;
                for($6a0eb74c8d3eb840$var$V = a.current; null !== $6a0eb74c8d3eb840$var$V;){
                    var f = $6a0eb74c8d3eb840$var$V, g = f.child;
                    if (0 !== ($6a0eb74c8d3eb840$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($6a0eb74c8d3eb840$var$V = l; null !== $6a0eb74c8d3eb840$var$V;){
                                    var m = $6a0eb74c8d3eb840$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $6a0eb74c8d3eb840$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $6a0eb74c8d3eb840$var$V = q;
                                    else for(; null !== $6a0eb74c8d3eb840$var$V;){
                                        m = $6a0eb74c8d3eb840$var$V;
                                        var r = m.sibling, y = m.return;
                                        $6a0eb74c8d3eb840$var$Sj(m);
                                        if (m === l) {
                                            $6a0eb74c8d3eb840$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $6a0eb74c8d3eb840$var$V = r;
                                            break;
                                        }
                                        $6a0eb74c8d3eb840$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $6a0eb74c8d3eb840$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $6a0eb74c8d3eb840$var$V = g;
                    else b: for(; null !== $6a0eb74c8d3eb840$var$V;){
                        f = $6a0eb74c8d3eb840$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $6a0eb74c8d3eb840$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $6a0eb74c8d3eb840$var$V = x;
                            break b;
                        }
                        $6a0eb74c8d3eb840$var$V = f.return;
                    }
                }
                var w = a.current;
                for($6a0eb74c8d3eb840$var$V = w; null !== $6a0eb74c8d3eb840$var$V;){
                    g = $6a0eb74c8d3eb840$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $6a0eb74c8d3eb840$var$V = u;
                    else b: for(g = w; null !== $6a0eb74c8d3eb840$var$V;){
                        h = $6a0eb74c8d3eb840$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $6a0eb74c8d3eb840$var$Qj(9, h);
                            }
                        } catch (na) {
                            $6a0eb74c8d3eb840$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $6a0eb74c8d3eb840$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $6a0eb74c8d3eb840$var$V = F;
                            break b;
                        }
                        $6a0eb74c8d3eb840$var$V = h.return;
                    }
                }
                $6a0eb74c8d3eb840$var$K = e;
                $6a0eb74c8d3eb840$var$jg();
                if ($6a0eb74c8d3eb840$var$lc && "function" === typeof $6a0eb74c8d3eb840$var$lc.onPostCommitFiberRoot) try {
                    $6a0eb74c8d3eb840$var$lc.onPostCommitFiberRoot($6a0eb74c8d3eb840$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $6a0eb74c8d3eb840$var$C = c, $6a0eb74c8d3eb840$var$ok.transition = b;
        }
    }
    return !1;
}
function $6a0eb74c8d3eb840$var$Xk(a, b, c) {
    b = $6a0eb74c8d3eb840$var$Ji(c, b);
    b = $6a0eb74c8d3eb840$var$Ni(a, b, 1);
    a = $6a0eb74c8d3eb840$var$nh(a, b, 1);
    b = $6a0eb74c8d3eb840$var$R();
    null !== a && ($6a0eb74c8d3eb840$var$Ac(a, 1, b), $6a0eb74c8d3eb840$var$Dk(a, b));
}
function $6a0eb74c8d3eb840$var$W(a, b, c) {
    if (3 === a.tag) $6a0eb74c8d3eb840$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $6a0eb74c8d3eb840$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $6a0eb74c8d3eb840$var$Ri || !$6a0eb74c8d3eb840$var$Ri.has(d))) {
                a = $6a0eb74c8d3eb840$var$Ji(c, a);
                a = $6a0eb74c8d3eb840$var$Qi(b, a, 1);
                b = $6a0eb74c8d3eb840$var$nh(b, a, 1);
                a = $6a0eb74c8d3eb840$var$R();
                null !== b && ($6a0eb74c8d3eb840$var$Ac(b, 1, a), $6a0eb74c8d3eb840$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $6a0eb74c8d3eb840$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $6a0eb74c8d3eb840$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $6a0eb74c8d3eb840$var$Q === a && ($6a0eb74c8d3eb840$var$Z & c) === c && (4 === $6a0eb74c8d3eb840$var$T || 3 === $6a0eb74c8d3eb840$var$T && ($6a0eb74c8d3eb840$var$Z & 130023424) === $6a0eb74c8d3eb840$var$Z && 500 > $6a0eb74c8d3eb840$var$B() - $6a0eb74c8d3eb840$var$fk ? $6a0eb74c8d3eb840$var$Kk(a, 0) : $6a0eb74c8d3eb840$var$rk |= c);
    $6a0eb74c8d3eb840$var$Dk(a, b);
}
function $6a0eb74c8d3eb840$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $6a0eb74c8d3eb840$var$sc, $6a0eb74c8d3eb840$var$sc <<= 1, 0 === ($6a0eb74c8d3eb840$var$sc & 130023424) && ($6a0eb74c8d3eb840$var$sc = 4194304)));
    var c = $6a0eb74c8d3eb840$var$R();
    a = $6a0eb74c8d3eb840$var$ih(a, b);
    null !== a && ($6a0eb74c8d3eb840$var$Ac(a, b, c), $6a0eb74c8d3eb840$var$Dk(a, c));
}
function $6a0eb74c8d3eb840$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $6a0eb74c8d3eb840$var$Yk(a, c);
}
function $6a0eb74c8d3eb840$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($6a0eb74c8d3eb840$var$p(314));
    }
    null !== d && d.delete(b);
    $6a0eb74c8d3eb840$var$Yk(a, c);
}
var $6a0eb74c8d3eb840$var$Vk;
$6a0eb74c8d3eb840$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $6a0eb74c8d3eb840$var$Wf.current) $6a0eb74c8d3eb840$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $6a0eb74c8d3eb840$var$dh = !1, $6a0eb74c8d3eb840$var$yj(a, b, c);
            $6a0eb74c8d3eb840$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $6a0eb74c8d3eb840$var$dh = !1, $6a0eb74c8d3eb840$var$I && 0 !== (b.flags & 1048576) && $6a0eb74c8d3eb840$var$ug(b, $6a0eb74c8d3eb840$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $6a0eb74c8d3eb840$var$ij(a, b);
            a = b.pendingProps;
            var e = $6a0eb74c8d3eb840$var$Yf(b, $6a0eb74c8d3eb840$var$H.current);
            $6a0eb74c8d3eb840$var$ch(b, c);
            e = $6a0eb74c8d3eb840$var$Nh(null, b, d, a, e, c);
            var f = $6a0eb74c8d3eb840$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $6a0eb74c8d3eb840$var$Zf(d) ? (f = !0, $6a0eb74c8d3eb840$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $6a0eb74c8d3eb840$var$kh(b), e.updater = $6a0eb74c8d3eb840$var$Ei, b.stateNode = e, e._reactInternals = b, $6a0eb74c8d3eb840$var$Ii(b, d, a, c), b = $6a0eb74c8d3eb840$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $6a0eb74c8d3eb840$var$I && f && $6a0eb74c8d3eb840$var$vg(b), $6a0eb74c8d3eb840$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $6a0eb74c8d3eb840$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $6a0eb74c8d3eb840$var$Zk(d);
                a = $6a0eb74c8d3eb840$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $6a0eb74c8d3eb840$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $6a0eb74c8d3eb840$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $6a0eb74c8d3eb840$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $6a0eb74c8d3eb840$var$$i(null, b, d, $6a0eb74c8d3eb840$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($6a0eb74c8d3eb840$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6a0eb74c8d3eb840$var$Ci(d, e), $6a0eb74c8d3eb840$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6a0eb74c8d3eb840$var$Ci(d, e), $6a0eb74c8d3eb840$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $6a0eb74c8d3eb840$var$kj(b);
                if (null === a) throw Error($6a0eb74c8d3eb840$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $6a0eb74c8d3eb840$var$lh(a, b);
                $6a0eb74c8d3eb840$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $6a0eb74c8d3eb840$var$Ji(Error($6a0eb74c8d3eb840$var$p(423)), b);
                        b = $6a0eb74c8d3eb840$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $6a0eb74c8d3eb840$var$Ji(Error($6a0eb74c8d3eb840$var$p(424)), b);
                        b = $6a0eb74c8d3eb840$var$lj(a, b, d, c, e);
                        break a;
                    } else for($6a0eb74c8d3eb840$var$yg = $6a0eb74c8d3eb840$var$Lf(b.stateNode.containerInfo.firstChild), $6a0eb74c8d3eb840$var$xg = b, $6a0eb74c8d3eb840$var$I = !0, $6a0eb74c8d3eb840$var$zg = null, c = $6a0eb74c8d3eb840$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $6a0eb74c8d3eb840$var$Ig();
                    if (d === e) {
                        b = $6a0eb74c8d3eb840$var$Zi(a, b, c);
                        break a;
                    }
                    $6a0eb74c8d3eb840$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $6a0eb74c8d3eb840$var$Ah(b), null === a && $6a0eb74c8d3eb840$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $6a0eb74c8d3eb840$var$Ef(d, e) ? g = null : null !== f && $6a0eb74c8d3eb840$var$Ef(d, f) && (b.flags |= 32), $6a0eb74c8d3eb840$var$gj(a, b), $6a0eb74c8d3eb840$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $6a0eb74c8d3eb840$var$Eg(b), null;
        case 13:
            return $6a0eb74c8d3eb840$var$oj(a, b, c);
        case 4:
            return $6a0eb74c8d3eb840$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $6a0eb74c8d3eb840$var$Ug(b, null, d, c) : $6a0eb74c8d3eb840$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6a0eb74c8d3eb840$var$Ci(d, e), $6a0eb74c8d3eb840$var$Yi(a, b, d, e, c);
        case 7:
            return $6a0eb74c8d3eb840$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $6a0eb74c8d3eb840$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $6a0eb74c8d3eb840$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $6a0eb74c8d3eb840$var$G($6a0eb74c8d3eb840$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($6a0eb74c8d3eb840$var$He(f.value, g)) {
                        if (f.children === e.children && !$6a0eb74c8d3eb840$var$Wf.current) {
                            b = $6a0eb74c8d3eb840$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $6a0eb74c8d3eb840$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $6a0eb74c8d3eb840$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($6a0eb74c8d3eb840$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $6a0eb74c8d3eb840$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $6a0eb74c8d3eb840$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $6a0eb74c8d3eb840$var$ch(b, c), e = $6a0eb74c8d3eb840$var$eh(e), d = d(e), b.flags |= 1, $6a0eb74c8d3eb840$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $6a0eb74c8d3eb840$var$Ci(d, b.pendingProps), e = $6a0eb74c8d3eb840$var$Ci(d.type, e), $6a0eb74c8d3eb840$var$$i(a, b, d, e, c);
        case 15:
            return $6a0eb74c8d3eb840$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6a0eb74c8d3eb840$var$Ci(d, e), $6a0eb74c8d3eb840$var$ij(a, b), b.tag = 1, $6a0eb74c8d3eb840$var$Zf(d) ? (a = !0, $6a0eb74c8d3eb840$var$cg(b)) : a = !1, $6a0eb74c8d3eb840$var$ch(b, c), $6a0eb74c8d3eb840$var$Gi(b, d, e), $6a0eb74c8d3eb840$var$Ii(b, d, e, c), $6a0eb74c8d3eb840$var$jj(null, b, d, !0, a, c);
        case 19:
            return $6a0eb74c8d3eb840$var$xj(a, b, c);
        case 22:
            return $6a0eb74c8d3eb840$var$dj(a, b, c);
    }
    throw Error($6a0eb74c8d3eb840$var$p(156, b.tag));
};
function $6a0eb74c8d3eb840$var$Fk(a, b) {
    return $6a0eb74c8d3eb840$var$ac(a, b);
}
function $6a0eb74c8d3eb840$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $6a0eb74c8d3eb840$var$Bg(a, b, c, d) {
    return new $6a0eb74c8d3eb840$var$$k(a, b, c, d);
}
function $6a0eb74c8d3eb840$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $6a0eb74c8d3eb840$var$Zk(a) {
    if ("function" === typeof a) return $6a0eb74c8d3eb840$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $6a0eb74c8d3eb840$var$Da) return 11;
        if (a === $6a0eb74c8d3eb840$var$Ga) return 14;
    }
    return 2;
}
function $6a0eb74c8d3eb840$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $6a0eb74c8d3eb840$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $6a0eb74c8d3eb840$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $6a0eb74c8d3eb840$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $6a0eb74c8d3eb840$var$ya:
            return $6a0eb74c8d3eb840$var$Tg(c.children, e, f, b);
        case $6a0eb74c8d3eb840$var$za:
            g = 8;
            e |= 8;
            break;
        case $6a0eb74c8d3eb840$var$Aa:
            return a = $6a0eb74c8d3eb840$var$Bg(12, c, b, e | 2), a.elementType = $6a0eb74c8d3eb840$var$Aa, a.lanes = f, a;
        case $6a0eb74c8d3eb840$var$Ea:
            return a = $6a0eb74c8d3eb840$var$Bg(13, c, b, e), a.elementType = $6a0eb74c8d3eb840$var$Ea, a.lanes = f, a;
        case $6a0eb74c8d3eb840$var$Fa:
            return a = $6a0eb74c8d3eb840$var$Bg(19, c, b, e), a.elementType = $6a0eb74c8d3eb840$var$Fa, a.lanes = f, a;
        case $6a0eb74c8d3eb840$var$Ia:
            return $6a0eb74c8d3eb840$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $6a0eb74c8d3eb840$var$Ba:
                    g = 10;
                    break a;
                case $6a0eb74c8d3eb840$var$Ca:
                    g = 9;
                    break a;
                case $6a0eb74c8d3eb840$var$Da:
                    g = 11;
                    break a;
                case $6a0eb74c8d3eb840$var$Ga:
                    g = 14;
                    break a;
                case $6a0eb74c8d3eb840$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($6a0eb74c8d3eb840$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $6a0eb74c8d3eb840$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $6a0eb74c8d3eb840$var$Tg(a, b, c, d) {
    a = $6a0eb74c8d3eb840$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $6a0eb74c8d3eb840$var$pj(a, b, c, d) {
    a = $6a0eb74c8d3eb840$var$Bg(22, a, d, b);
    a.elementType = $6a0eb74c8d3eb840$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $6a0eb74c8d3eb840$var$Qg(a, b, c) {
    a = $6a0eb74c8d3eb840$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $6a0eb74c8d3eb840$var$Sg(a, b, c) {
    b = $6a0eb74c8d3eb840$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $6a0eb74c8d3eb840$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $6a0eb74c8d3eb840$var$zc(0);
    this.expirationTimes = $6a0eb74c8d3eb840$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $6a0eb74c8d3eb840$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $6a0eb74c8d3eb840$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $6a0eb74c8d3eb840$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $6a0eb74c8d3eb840$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $6a0eb74c8d3eb840$var$kh(f);
    return a;
}
function $6a0eb74c8d3eb840$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $6a0eb74c8d3eb840$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $6a0eb74c8d3eb840$var$dl(a) {
    if (!a) return $6a0eb74c8d3eb840$var$Vf;
    a = a._reactInternals;
    a: {
        if ($6a0eb74c8d3eb840$var$Vb(a) !== a || 1 !== a.tag) throw Error($6a0eb74c8d3eb840$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($6a0eb74c8d3eb840$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($6a0eb74c8d3eb840$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($6a0eb74c8d3eb840$var$Zf(c)) return $6a0eb74c8d3eb840$var$bg(a, c, b);
    }
    return b;
}
function $6a0eb74c8d3eb840$var$el(a, b, c, d, e, f, g, h, k) {
    a = $6a0eb74c8d3eb840$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $6a0eb74c8d3eb840$var$dl(null);
    c = a.current;
    d = $6a0eb74c8d3eb840$var$R();
    e = $6a0eb74c8d3eb840$var$yi(c);
    f = $6a0eb74c8d3eb840$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $6a0eb74c8d3eb840$var$nh(c, f, e);
    a.current.lanes = e;
    $6a0eb74c8d3eb840$var$Ac(a, e, d);
    $6a0eb74c8d3eb840$var$Dk(a, d);
    return a;
}
function $6a0eb74c8d3eb840$var$fl(a, b, c, d) {
    var e = b.current, f = $6a0eb74c8d3eb840$var$R(), g = $6a0eb74c8d3eb840$var$yi(e);
    c = $6a0eb74c8d3eb840$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $6a0eb74c8d3eb840$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $6a0eb74c8d3eb840$var$nh(e, b, g);
    null !== a && ($6a0eb74c8d3eb840$var$gi(a, e, g, f), $6a0eb74c8d3eb840$var$oh(a, e, g));
    return g;
}
function $6a0eb74c8d3eb840$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $6a0eb74c8d3eb840$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $6a0eb74c8d3eb840$var$il(a, b) {
    $6a0eb74c8d3eb840$var$hl(a, b);
    (a = a.alternate) && $6a0eb74c8d3eb840$var$hl(a, b);
}
function $6a0eb74c8d3eb840$var$jl() {
    return null;
}
var $6a0eb74c8d3eb840$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $6a0eb74c8d3eb840$var$ll(a) {
    this._internalRoot = a;
}
$6a0eb74c8d3eb840$var$ml.prototype.render = $6a0eb74c8d3eb840$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($6a0eb74c8d3eb840$var$p(409));
    $6a0eb74c8d3eb840$var$fl(a, b, null, null);
};
$6a0eb74c8d3eb840$var$ml.prototype.unmount = $6a0eb74c8d3eb840$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $6a0eb74c8d3eb840$var$Rk(function() {
            $6a0eb74c8d3eb840$var$fl(null, a, null, null);
        });
        b[$6a0eb74c8d3eb840$var$uf] = null;
    }
};
function $6a0eb74c8d3eb840$var$ml(a) {
    this._internalRoot = a;
}
$6a0eb74c8d3eb840$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $6a0eb74c8d3eb840$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $6a0eb74c8d3eb840$var$Qc.length && 0 !== b && b < $6a0eb74c8d3eb840$var$Qc[c].priority; c++);
        $6a0eb74c8d3eb840$var$Qc.splice(c, 0, a);
        0 === c && $6a0eb74c8d3eb840$var$Vc(a);
    }
};
function $6a0eb74c8d3eb840$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $6a0eb74c8d3eb840$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $6a0eb74c8d3eb840$var$pl() {}
function $6a0eb74c8d3eb840$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $6a0eb74c8d3eb840$var$gl(g);
                f.call(a);
            };
        }
        var g = $6a0eb74c8d3eb840$var$el(b, d, a, 0, null, !1, !1, "", $6a0eb74c8d3eb840$var$pl);
        a._reactRootContainer = g;
        a[$6a0eb74c8d3eb840$var$uf] = g.current;
        $6a0eb74c8d3eb840$var$sf(8 === a.nodeType ? a.parentNode : a);
        $6a0eb74c8d3eb840$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $6a0eb74c8d3eb840$var$gl(k);
            h.call(a);
        };
    }
    var k = $6a0eb74c8d3eb840$var$bl(a, 0, !1, null, null, !1, !1, "", $6a0eb74c8d3eb840$var$pl);
    a._reactRootContainer = k;
    a[$6a0eb74c8d3eb840$var$uf] = k.current;
    $6a0eb74c8d3eb840$var$sf(8 === a.nodeType ? a.parentNode : a);
    $6a0eb74c8d3eb840$var$Rk(function() {
        $6a0eb74c8d3eb840$var$fl(b, k, c, d);
    });
    return k;
}
function $6a0eb74c8d3eb840$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $6a0eb74c8d3eb840$var$gl(g);
                h.call(a);
            };
        }
        $6a0eb74c8d3eb840$var$fl(b, g, a, e);
    } else g = $6a0eb74c8d3eb840$var$ql(c, b, a, e, d);
    return $6a0eb74c8d3eb840$var$gl(g);
}
$6a0eb74c8d3eb840$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $6a0eb74c8d3eb840$var$tc(b.pendingLanes);
                0 !== c && ($6a0eb74c8d3eb840$var$Cc(b, c | 1), $6a0eb74c8d3eb840$var$Dk(b, $6a0eb74c8d3eb840$var$B()), 0 === ($6a0eb74c8d3eb840$var$K & 6) && ($6a0eb74c8d3eb840$var$Gj = $6a0eb74c8d3eb840$var$B() + 500, $6a0eb74c8d3eb840$var$jg()));
            }
            break;
        case 13:
            $6a0eb74c8d3eb840$var$Rk(function() {
                var b = $6a0eb74c8d3eb840$var$ih(a, 1);
                if (null !== b) {
                    var c = $6a0eb74c8d3eb840$var$R();
                    $6a0eb74c8d3eb840$var$gi(b, a, 1, c);
                }
            }), $6a0eb74c8d3eb840$var$il(a, 1);
    }
};
$6a0eb74c8d3eb840$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $6a0eb74c8d3eb840$var$ih(a, 134217728);
        if (null !== b) {
            var c = $6a0eb74c8d3eb840$var$R();
            $6a0eb74c8d3eb840$var$gi(b, a, 134217728, c);
        }
        $6a0eb74c8d3eb840$var$il(a, 134217728);
    }
};
$6a0eb74c8d3eb840$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $6a0eb74c8d3eb840$var$yi(a), c = $6a0eb74c8d3eb840$var$ih(a, b);
        if (null !== c) {
            var d = $6a0eb74c8d3eb840$var$R();
            $6a0eb74c8d3eb840$var$gi(c, a, b, d);
        }
        $6a0eb74c8d3eb840$var$il(a, b);
    }
};
$6a0eb74c8d3eb840$var$Hc = function() {
    return $6a0eb74c8d3eb840$var$C;
};
$6a0eb74c8d3eb840$var$Ic = function(a, b) {
    var c = $6a0eb74c8d3eb840$var$C;
    try {
        return $6a0eb74c8d3eb840$var$C = a, b();
    } finally{
        $6a0eb74c8d3eb840$var$C = c;
    }
};
$6a0eb74c8d3eb840$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $6a0eb74c8d3eb840$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $6a0eb74c8d3eb840$var$Db(d);
                        if (!e) throw Error($6a0eb74c8d3eb840$var$p(90));
                        $6a0eb74c8d3eb840$var$Wa(d);
                        $6a0eb74c8d3eb840$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $6a0eb74c8d3eb840$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $6a0eb74c8d3eb840$var$fb(a, !!c.multiple, b, !1);
    }
};
$6a0eb74c8d3eb840$var$Gb = $6a0eb74c8d3eb840$var$Qk;
$6a0eb74c8d3eb840$var$Hb = $6a0eb74c8d3eb840$var$Rk;
var $6a0eb74c8d3eb840$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $6a0eb74c8d3eb840$var$Cb,
        $6a0eb74c8d3eb840$var$ue,
        $6a0eb74c8d3eb840$var$Db,
        $6a0eb74c8d3eb840$var$Eb,
        $6a0eb74c8d3eb840$var$Fb,
        $6a0eb74c8d3eb840$var$Qk
    ]
}, $6a0eb74c8d3eb840$var$tl = {
    findFiberByHostInstance: $6a0eb74c8d3eb840$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $6a0eb74c8d3eb840$var$ul = {
    bundleType: $6a0eb74c8d3eb840$var$tl.bundleType,
    version: $6a0eb74c8d3eb840$var$tl.version,
    rendererPackageName: $6a0eb74c8d3eb840$var$tl.rendererPackageName,
    rendererConfig: $6a0eb74c8d3eb840$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $6a0eb74c8d3eb840$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $6a0eb74c8d3eb840$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $6a0eb74c8d3eb840$var$tl.findFiberByHostInstance || $6a0eb74c8d3eb840$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $6a0eb74c8d3eb840$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$6a0eb74c8d3eb840$var$vl.isDisabled && $6a0eb74c8d3eb840$var$vl.supportsFiber) try {
        $6a0eb74c8d3eb840$var$kc = $6a0eb74c8d3eb840$var$vl.inject($6a0eb74c8d3eb840$var$ul), $6a0eb74c8d3eb840$var$lc = $6a0eb74c8d3eb840$var$vl;
    } catch (a) {}
}
$6a0eb74c8d3eb840$export$ae55be85d98224ed = $6a0eb74c8d3eb840$var$sl;
$6a0eb74c8d3eb840$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$6a0eb74c8d3eb840$var$nl(b)) throw Error($6a0eb74c8d3eb840$var$p(200));
    return $6a0eb74c8d3eb840$var$cl(a, b, null, c);
};
$6a0eb74c8d3eb840$export$882461b6382ed46c = function(a, b) {
    if (!$6a0eb74c8d3eb840$var$nl(a)) throw Error($6a0eb74c8d3eb840$var$p(299));
    var c = !1, d = "", e = $6a0eb74c8d3eb840$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $6a0eb74c8d3eb840$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$6a0eb74c8d3eb840$var$uf] = b.current;
    $6a0eb74c8d3eb840$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $6a0eb74c8d3eb840$var$ll(b);
};
$6a0eb74c8d3eb840$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($6a0eb74c8d3eb840$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($6a0eb74c8d3eb840$var$p(268, a));
    }
    a = $6a0eb74c8d3eb840$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$6a0eb74c8d3eb840$export$cd75ccfd720a3cd4 = function(a) {
    return $6a0eb74c8d3eb840$var$Rk(a);
};
$6a0eb74c8d3eb840$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$6a0eb74c8d3eb840$var$ol(b)) throw Error($6a0eb74c8d3eb840$var$p(200));
    return $6a0eb74c8d3eb840$var$rl(null, a, b, !0, c);
};
$6a0eb74c8d3eb840$export$757ceba2d55c277e = function(a, b, c) {
    if (!$6a0eb74c8d3eb840$var$nl(a)) throw Error($6a0eb74c8d3eb840$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $6a0eb74c8d3eb840$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $6a0eb74c8d3eb840$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$6a0eb74c8d3eb840$var$uf] = b.current;
    $6a0eb74c8d3eb840$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $6a0eb74c8d3eb840$var$ml(b);
};
$6a0eb74c8d3eb840$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$6a0eb74c8d3eb840$var$ol(b)) throw Error($6a0eb74c8d3eb840$var$p(200));
    return $6a0eb74c8d3eb840$var$rl(null, a, b, !1, c);
};
$6a0eb74c8d3eb840$export$502457920280e6be = function(a) {
    if (!$6a0eb74c8d3eb840$var$ol(a)) throw Error($6a0eb74c8d3eb840$var$p(40));
    return a._reactRootContainer ? ($6a0eb74c8d3eb840$var$Rk(function() {
        $6a0eb74c8d3eb840$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$6a0eb74c8d3eb840$var$uf] = null;
        });
    }), !0) : !1;
};
$6a0eb74c8d3eb840$export$c78a37762a8d58e1 = $6a0eb74c8d3eb840$var$Qk;
$6a0eb74c8d3eb840$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$6a0eb74c8d3eb840$var$ol(c)) throw Error($6a0eb74c8d3eb840$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($6a0eb74c8d3eb840$var$p(38));
    return $6a0eb74c8d3eb840$var$rl(a, b, c, !1, d);
};
$6a0eb74c8d3eb840$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lyjZb", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eCmDB"));

});
parcelRegister("eCmDB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $aa462caee27c6fa1$export$c4744153514ff05d; }, function (v) { return $aa462caee27c6fa1$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $aa462caee27c6fa1$export$3e506c1ccc9cc1a7; }, function (v) { return $aa462caee27c6fa1$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $aa462caee27c6fa1$export$e26fe2ed2fa76875; }, function (v) { return $aa462caee27c6fa1$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $aa462caee27c6fa1$export$502329bbf4b505b1; }, function (v) { return $aa462caee27c6fa1$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $aa462caee27c6fa1$export$6e3807111c4874c4; }, function (v) { return $aa462caee27c6fa1$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $aa462caee27c6fa1$export$c27134553091fb3a; }, function (v) { return $aa462caee27c6fa1$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $aa462caee27c6fa1$export$33ee1acdc04fd2a2; }, function (v) { return $aa462caee27c6fa1$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $aa462caee27c6fa1$export$b00a404bbd5edef2; }, function (v) { return $aa462caee27c6fa1$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $aa462caee27c6fa1$export$8352ce38b91d0c62; }, function (v) { return $aa462caee27c6fa1$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $aa462caee27c6fa1$export$d66a1c1c77bd778b; }, function (v) { return $aa462caee27c6fa1$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $aa462caee27c6fa1$export$d3dfb8e4810cb555; }, function (v) { return $aa462caee27c6fa1$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $aa462caee27c6fa1$export$839f9183b0465a69; }, function (v) { return $aa462caee27c6fa1$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $aa462caee27c6fa1$export$72fdf0e06517287b; }, function (v) { return $aa462caee27c6fa1$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $aa462caee27c6fa1$export$4b844e58a3e414b4; }, function (v) { return $aa462caee27c6fa1$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $aa462caee27c6fa1$export$816d2913ae6b83b1; }, function (v) { return $aa462caee27c6fa1$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $aa462caee27c6fa1$export$61bcfe829111a1d0; }, function (v) { return $aa462caee27c6fa1$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $aa462caee27c6fa1$export$7ee8c9beb337bc3f; }, function (v) { return $aa462caee27c6fa1$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $aa462caee27c6fa1$export$b5836b71941fa3ed; }, function (v) { return $aa462caee27c6fa1$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $aa462caee27c6fa1$export$cf845f2c119da08a; }, function (v) { return $aa462caee27c6fa1$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa462caee27c6fa1$export$c4744153514ff05d;
var $aa462caee27c6fa1$export$3e506c1ccc9cc1a7;
var $aa462caee27c6fa1$export$e26fe2ed2fa76875;
var $aa462caee27c6fa1$export$502329bbf4b505b1;
var $aa462caee27c6fa1$export$6e3807111c4874c4;
var $aa462caee27c6fa1$export$c27134553091fb3a;
var $aa462caee27c6fa1$export$33ee1acdc04fd2a2;
var $aa462caee27c6fa1$export$b00a404bbd5edef2;
var $aa462caee27c6fa1$export$8352ce38b91d0c62;
var $aa462caee27c6fa1$export$d66a1c1c77bd778b;
var $aa462caee27c6fa1$export$d3dfb8e4810cb555;
var $aa462caee27c6fa1$export$839f9183b0465a69;
var $aa462caee27c6fa1$export$72fdf0e06517287b;
var $aa462caee27c6fa1$export$4b844e58a3e414b4;
var $aa462caee27c6fa1$export$816d2913ae6b83b1;
var $aa462caee27c6fa1$export$61bcfe829111a1d0;
var $aa462caee27c6fa1$export$7ee8c9beb337bc3f;
var $aa462caee27c6fa1$export$b5836b71941fa3ed;
var $aa462caee27c6fa1$export$cf845f2c119da08a;
'use strict';
function $aa462caee27c6fa1$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $aa462caee27c6fa1$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $aa462caee27c6fa1$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $aa462caee27c6fa1$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $aa462caee27c6fa1$var$g(C, c)) n < e && 0 > $aa462caee27c6fa1$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $aa462caee27c6fa1$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $aa462caee27c6fa1$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $aa462caee27c6fa1$var$l = performance;
    $aa462caee27c6fa1$export$c4744153514ff05d = function() {
        return $aa462caee27c6fa1$var$l.now();
    };
} else {
    var $aa462caee27c6fa1$var$p = Date, $aa462caee27c6fa1$var$q = $aa462caee27c6fa1$var$p.now();
    $aa462caee27c6fa1$export$c4744153514ff05d = function() {
        return $aa462caee27c6fa1$var$p.now() - $aa462caee27c6fa1$var$q;
    };
}
var $aa462caee27c6fa1$var$r = [], $aa462caee27c6fa1$var$t = [], $aa462caee27c6fa1$var$u = 1, $aa462caee27c6fa1$var$v = null, $aa462caee27c6fa1$var$y = 3, $aa462caee27c6fa1$var$z = !1, $aa462caee27c6fa1$var$A = !1, $aa462caee27c6fa1$var$B = !1, $aa462caee27c6fa1$var$D = "function" === typeof setTimeout ? setTimeout : null, $aa462caee27c6fa1$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $aa462caee27c6fa1$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $aa462caee27c6fa1$var$G(a) {
    for(var b = $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$t); null !== b;){
        if (null === b.callback) $aa462caee27c6fa1$var$k($aa462caee27c6fa1$var$t);
        else if (b.startTime <= a) $aa462caee27c6fa1$var$k($aa462caee27c6fa1$var$t), b.sortIndex = b.expirationTime, $aa462caee27c6fa1$var$f($aa462caee27c6fa1$var$r, b);
        else break;
        b = $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$t);
    }
}
function $aa462caee27c6fa1$var$H(a) {
    $aa462caee27c6fa1$var$B = !1;
    $aa462caee27c6fa1$var$G(a);
    if (!$aa462caee27c6fa1$var$A) {
        if (null !== $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$r)) $aa462caee27c6fa1$var$A = !0, $aa462caee27c6fa1$var$I($aa462caee27c6fa1$var$J);
        else {
            var b = $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$t);
            null !== b && $aa462caee27c6fa1$var$K($aa462caee27c6fa1$var$H, b.startTime - a);
        }
    }
}
function $aa462caee27c6fa1$var$J(a, b) {
    $aa462caee27c6fa1$var$A = !1;
    $aa462caee27c6fa1$var$B && ($aa462caee27c6fa1$var$B = !1, $aa462caee27c6fa1$var$E($aa462caee27c6fa1$var$L), $aa462caee27c6fa1$var$L = -1);
    $aa462caee27c6fa1$var$z = !0;
    var c = $aa462caee27c6fa1$var$y;
    try {
        $aa462caee27c6fa1$var$G(b);
        for($aa462caee27c6fa1$var$v = $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$r); null !== $aa462caee27c6fa1$var$v && (!($aa462caee27c6fa1$var$v.expirationTime > b) || a && !$aa462caee27c6fa1$var$M());){
            var d = $aa462caee27c6fa1$var$v.callback;
            if ("function" === typeof d) {
                $aa462caee27c6fa1$var$v.callback = null;
                $aa462caee27c6fa1$var$y = $aa462caee27c6fa1$var$v.priorityLevel;
                var e = d($aa462caee27c6fa1$var$v.expirationTime <= b);
                b = $aa462caee27c6fa1$export$c4744153514ff05d();
                "function" === typeof e ? $aa462caee27c6fa1$var$v.callback = e : $aa462caee27c6fa1$var$v === $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$r) && $aa462caee27c6fa1$var$k($aa462caee27c6fa1$var$r);
                $aa462caee27c6fa1$var$G(b);
            } else $aa462caee27c6fa1$var$k($aa462caee27c6fa1$var$r);
            $aa462caee27c6fa1$var$v = $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$r);
        }
        if (null !== $aa462caee27c6fa1$var$v) var w = !0;
        else {
            var m = $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$t);
            null !== m && $aa462caee27c6fa1$var$K($aa462caee27c6fa1$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $aa462caee27c6fa1$var$v = null, $aa462caee27c6fa1$var$y = c, $aa462caee27c6fa1$var$z = !1;
    }
}
var $aa462caee27c6fa1$var$N = !1, $aa462caee27c6fa1$var$O = null, $aa462caee27c6fa1$var$L = -1, $aa462caee27c6fa1$var$P = 5, $aa462caee27c6fa1$var$Q = -1;
function $aa462caee27c6fa1$var$M() {
    return $aa462caee27c6fa1$export$c4744153514ff05d() - $aa462caee27c6fa1$var$Q < $aa462caee27c6fa1$var$P ? !1 : !0;
}
function $aa462caee27c6fa1$var$R() {
    if (null !== $aa462caee27c6fa1$var$O) {
        var a = $aa462caee27c6fa1$export$c4744153514ff05d();
        $aa462caee27c6fa1$var$Q = a;
        var b = !0;
        try {
            b = $aa462caee27c6fa1$var$O(!0, a);
        } finally{
            b ? $aa462caee27c6fa1$var$S() : ($aa462caee27c6fa1$var$N = !1, $aa462caee27c6fa1$var$O = null);
        }
    } else $aa462caee27c6fa1$var$N = !1;
}
var $aa462caee27c6fa1$var$S;
if ("function" === typeof $aa462caee27c6fa1$var$F) $aa462caee27c6fa1$var$S = function() {
    $aa462caee27c6fa1$var$F($aa462caee27c6fa1$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $aa462caee27c6fa1$var$T = new MessageChannel, $aa462caee27c6fa1$var$U = $aa462caee27c6fa1$var$T.port2;
    $aa462caee27c6fa1$var$T.port1.onmessage = $aa462caee27c6fa1$var$R;
    $aa462caee27c6fa1$var$S = function() {
        $aa462caee27c6fa1$var$U.postMessage(null);
    };
} else $aa462caee27c6fa1$var$S = function() {
    $aa462caee27c6fa1$var$D($aa462caee27c6fa1$var$R, 0);
};
function $aa462caee27c6fa1$var$I(a) {
    $aa462caee27c6fa1$var$O = a;
    $aa462caee27c6fa1$var$N || ($aa462caee27c6fa1$var$N = !0, $aa462caee27c6fa1$var$S());
}
function $aa462caee27c6fa1$var$K(a, b) {
    $aa462caee27c6fa1$var$L = $aa462caee27c6fa1$var$D(function() {
        a($aa462caee27c6fa1$export$c4744153514ff05d());
    }, b);
}
$aa462caee27c6fa1$export$3e506c1ccc9cc1a7 = 5;
$aa462caee27c6fa1$export$e26fe2ed2fa76875 = 1;
$aa462caee27c6fa1$export$502329bbf4b505b1 = 4;
$aa462caee27c6fa1$export$6e3807111c4874c4 = 3;
$aa462caee27c6fa1$export$c27134553091fb3a = null;
$aa462caee27c6fa1$export$33ee1acdc04fd2a2 = 2;
$aa462caee27c6fa1$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$aa462caee27c6fa1$export$8352ce38b91d0c62 = function() {
    $aa462caee27c6fa1$var$A || $aa462caee27c6fa1$var$z || ($aa462caee27c6fa1$var$A = !0, $aa462caee27c6fa1$var$I($aa462caee27c6fa1$var$J));
};
$aa462caee27c6fa1$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $aa462caee27c6fa1$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$aa462caee27c6fa1$export$d3dfb8e4810cb555 = function() {
    return $aa462caee27c6fa1$var$y;
};
$aa462caee27c6fa1$export$839f9183b0465a69 = function() {
    return $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$r);
};
$aa462caee27c6fa1$export$72fdf0e06517287b = function(a) {
    switch($aa462caee27c6fa1$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $aa462caee27c6fa1$var$y;
    }
    var c = $aa462caee27c6fa1$var$y;
    $aa462caee27c6fa1$var$y = b;
    try {
        return a();
    } finally{
        $aa462caee27c6fa1$var$y = c;
    }
};
$aa462caee27c6fa1$export$4b844e58a3e414b4 = function() {};
$aa462caee27c6fa1$export$816d2913ae6b83b1 = function() {};
$aa462caee27c6fa1$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $aa462caee27c6fa1$var$y;
    $aa462caee27c6fa1$var$y = a;
    try {
        return b();
    } finally{
        $aa462caee27c6fa1$var$y = c;
    }
};
$aa462caee27c6fa1$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $aa462caee27c6fa1$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $aa462caee27c6fa1$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $aa462caee27c6fa1$var$f($aa462caee27c6fa1$var$t, a), null === $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$r) && a === $aa462caee27c6fa1$var$h($aa462caee27c6fa1$var$t) && ($aa462caee27c6fa1$var$B ? ($aa462caee27c6fa1$var$E($aa462caee27c6fa1$var$L), $aa462caee27c6fa1$var$L = -1) : $aa462caee27c6fa1$var$B = !0, $aa462caee27c6fa1$var$K($aa462caee27c6fa1$var$H, c - d))) : (a.sortIndex = e, $aa462caee27c6fa1$var$f($aa462caee27c6fa1$var$r, a), $aa462caee27c6fa1$var$A || $aa462caee27c6fa1$var$z || ($aa462caee27c6fa1$var$A = !0, $aa462caee27c6fa1$var$I($aa462caee27c6fa1$var$J)));
    return a;
};
$aa462caee27c6fa1$export$b5836b71941fa3ed = $aa462caee27c6fa1$var$M;
$aa462caee27c6fa1$export$cf845f2c119da08a = function(a) {
    var b = $aa462caee27c6fa1$var$y;
    return function() {
        var c = $aa462caee27c6fa1$var$y;
        $aa462caee27c6fa1$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $aa462caee27c6fa1$var$y = c;
        }
    };
};

});



var $ee14841e48c228d7$exports = {};
'use strict';

$ee14841e48c228d7$exports = (parcelRequire("ciQby"));



var $1G08a = parcelRequire("1G08a");
var $96335ac8adae3409$export$882461b6382ed46c;
var $96335ac8adae3409$export$757ceba2d55c277e;
'use strict';
var $b29855012ea0f66f$exports = {};
'use strict';
function $b29855012ea0f66f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b29855012ea0f66f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b29855012ea0f66f$var$checkDCE();

$b29855012ea0f66f$exports = (parcelRequire("96xzw"));


var $96335ac8adae3409$var$i;
$96335ac8adae3409$export$882461b6382ed46c = $b29855012ea0f66f$exports.createRoot;
$96335ac8adae3409$export$757ceba2d55c277e = $b29855012ea0f66f$exports.hydrateRoot;





var $1G08a = parcelRequire("1G08a");
const $babb1c77600fd982$export$d43f2f435f160490 = window.wwoofBooking?.apiUrl || '/wp-json/booking-system/v1/';
const $babb1c77600fd982$export$4a3a00e07ffce8bd = {
    BOOKINGS_CREATE: 'bookings/create',
    BOOKINGS_WWOOFER_CREATE: 'bookings/wwoofer-create',
    BOOKINGS_USER: (userId)=>`bookings/user/${userId}`,
    BOOKING_ACCEPT: (id)=>`bookings/${id}/accept`,
    BOOKING_CANCEL: (id)=>`bookings/${id}/cancel`,
    BOOKING_EDIT_DATES: (id)=>`bookings/${id}/edit-dates`,
    // Review endpoints
    REVIEWS_FORM: 'reviews/form',
    REVIEWS_SUBMIT: 'reviews/submit',
    REVIEWS_LIST: 'reviews/list',
    REVIEWS_RESPOND: 'reviews/respond',
    REVIEWS_STATS: 'reviews/stats',
    REVIEW_DETAIL: (id)=>`reviews/${id}`
};


class $9683d1ac1e2167a9$var$ApiService {
    constructor(){
        this.baseUrl = (0, $babb1c77600fd982$export$d43f2f435f160490);
        this.nonce = window.wwoofBooking?.nonce || '';
    }
    async request(endpoint, options = {}) {
        const url = `${this.baseUrl}${endpoint}`;
        const config = {
            headers: {
                'X-WP-Nonce': this.nonce,
                'Content-Type': 'application/json',
                ...options.headers
            },
            ...options
        };
        try {
            const response = await fetch(url, config);
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    }
    async get(endpoint) {
        return this.request(endpoint);
    }
    async post(endpoint, data = {}) {
        return this.request(endpoint, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    }
    async put(endpoint, data = {}) {
        return this.request(endpoint, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }
    async delete(endpoint) {
        return this.request(endpoint, {
            method: 'DELETE'
        });
    }
}
var $9683d1ac1e2167a9$export$2e2bcd8739ae039 = new $9683d1ac1e2167a9$var$ApiService();



const $b698a90aba0778fb$export$3969910379087fbd = {
    async createBooking (data) {
        return (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post((0, $babb1c77600fd982$export$4a3a00e07ffce8bd).BOOKINGS_CREATE, data);
    },
    async createWwooferBooking (data) {
        return (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post((0, $babb1c77600fd982$export$4a3a00e07ffce8bd).BOOKINGS_WWOOFER_CREATE, data);
    },
    async getUserBookings (userId) {
        return (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get((0, $babb1c77600fd982$export$4a3a00e07ffce8bd).BOOKINGS_USER(userId));
    },
    async acceptBooking (bookingId) {
        return (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post((0, $babb1c77600fd982$export$4a3a00e07ffce8bd).BOOKING_ACCEPT(bookingId));
    },
    async cancelBooking (bookingId) {
        return (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post((0, $babb1c77600fd982$export$4a3a00e07ffce8bd).BOOKING_CANCEL(bookingId));
    },
    async editBookingDates (bookingId, dates) {
        return (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).put((0, $babb1c77600fd982$export$4a3a00e07ffce8bd).BOOKING_EDIT_DATES(bookingId), dates);
    }
};


// Format dates for display (DD-MM-YYYY)
const $a3a32424dd0a2710$export$bea76c49158eff2b = (dateStr)=>{
    if (!dateStr) return '';
    const date = new Date(dateStr + 'T00:00:00Z');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};
const $a3a32424dd0a2710$export$d156a7a13ef27ff9 = (ddmmyyyy)=>{
    if (!ddmmyyyy) return '';
    const parts = ddmmyyyy.split('-');
    if (parts.length !== 3) return ddmmyyyy; // Return as-is if not in expected format
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const $a3a32424dd0a2710$export$2fbf685d4c7ca6e6 = (yyyymmdd)=>{
    if (!yyyymmdd) return '';
    const parts = yyyymmdd.split('-');
    if (parts.length !== 3) return yyyymmdd; // Return as-is if not in expected format
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
};
const $a3a32424dd0a2710$export$2e9241a0bdf6c8b8 = (start, end)=>{
    if (start === end) return $a3a32424dd0a2710$export$2fbf685d4c7ca6e6(start);
    const opts = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    };
    const s = new Date(start + 'T00:00:00Z');
    const e = new Date(end + 'T00:00:00Z');
    return `${s.toLocaleDateString(undefined, opts)} - ${e.toLocaleDateString(undefined, opts)}`;
};
const $a3a32424dd0a2710$export$c16e5eea4d80b673 = (dateStr)=>{
    const d = new Date(dateStr + 'T00:00:00Z');
    d.setDate(d.getDate() + 1);
    return d.toISOString().split('T')[0];
};
const $a3a32424dd0a2710$export$a26bb6a012e2ca6f = (daysFromNow = 7)=>{
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + daysFromNow);
    return minDate.toISOString().split('T')[0];
};
const $a3a32424dd0a2710$export$1118e4272ea1e258 = ()=>{
    return new Date().toISOString().split('T')[0];
};



parcelRequire("1G08a");
const $766f882fc71a230f$var$Button = ({ children: children, onClick: onClick, disabled: disabled = false, variant: variant = 'default', type: type = 'button', className: className = '', ...props })=>{
    const baseClass = 'action-button';
    const variantClass = variant !== 'default' ? `${variant}-button` : '';
    const classes = [
        baseClass,
        variantClass,
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
        type: type,
        className: classes,
        onClick: onClick,
        disabled: disabled,
        ...props,
        children: children
    });
};
var $766f882fc71a230f$export$2e2bcd8739ae039 = $766f882fc71a230f$var$Button;




var $1G08a = parcelRequire("1G08a");
const $29e8c66b7747c055$var$PopupNotification = ({ message: message, isVisible: isVisible, onClose: onClose, requireAgreement: requireAgreement = false, agreementText: agreementText = '', onAccept: onAccept })=>{
    const [isAgreed, setIsAgreed] = (0, $1G08a.useState)(false);
    (0, $1G08a.useEffect)(()=>{
        if (isVisible) {
            // Prevent body scroll when popup is open
            document.body.style.overflow = 'hidden';
            // Reset agreement state when popup opens
            setIsAgreed(false);
            return ()=>{
                document.body.style.overflow = 'unset';
            };
        }
    }, [
        isVisible
    ]);
    if (!isVisible) return null;
    const handleOkClick = ()=>{
        if (requireAgreement && onAccept) onAccept();
        else onClose();
    };
    const handleOverlayClick = requireAgreement ? undefined : onClose;
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "wwoof-popup-overlay",
        onClick: handleOverlayClick,
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
            className: "wwoof-popup",
            onClick: (e)=>e.stopPropagation(),
            children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "wwoof-popup-content",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "wwoof-popup-message",
                        dangerouslySetInnerHTML: {
                            __html: message
                        }
                    }),
                    requireAgreement && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "wwoof-popup-agreement",
                        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                            className: "wwoof-popup-agreement-label",
                            children: [
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: isAgreed,
                                    onChange: (e)=>setIsAgreed(e.target.checked),
                                    className: "wwoof-popup-agreement-checkbox"
                                }),
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                    className: "wwoof-popup-agreement-text",
                                    children: agreementText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "wwoof-popup-buttons",
                        children: [
                            requireAgreement && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: "wwoof-popup-cancel",
                                onClick: onClose,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: "wwoof-popup-close",
                                onClick: handleOkClick,
                                disabled: requireAgreement && !isAgreed,
                                children: "OK"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $29e8c66b7747c055$export$2e2bcd8739ae039 = $29e8c66b7747c055$var$PopupNotification;


const $d14f23ecf9d8993e$var$VisitRequestForm = ({ wwooferId: wwooferId, hostId: hostId, threadId: threadId })=>{
    const [startDate, setStartDate] = (0, $1G08a.useState)('');
    const [endDate, setEndDate] = (0, $1G08a.useState)('');
    const [message, setMessage] = (0, $1G08a.useState)('');
    const [loading, setLoading] = (0, $1G08a.useState)(false);
    const [errors, setErrors] = (0, $1G08a.useState)({});
    const [showPopup, setShowPopup] = (0, $1G08a.useState)(false);
    const [popupMessage, setPopupMessage] = (0, $1G08a.useState)('');
    const [agreedToDeclaration, setAgreedToDeclaration] = (0, $1G08a.useState)(false);
    const [showDeclarationPopup, setShowDeclarationPopup] = (0, $1G08a.useState)(false);
    const todayString = (0, $a3a32424dd0a2710$export$1118e4272ea1e258)();
    const validateForm = ()=>{
        const newErrors = {};
        if (!startDate) newErrors.startDate = 'Start date is required';
        else if ((0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate) < todayString) newErrors.startDate = 'Start date cannot be in the past';
        if (!endDate) newErrors.endDate = 'End date is required';
        else if ((0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(endDate) <= (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate)) newErrors.endDate = 'End date must be after start date';
        if (!agreedToDeclaration) newErrors.agreedToDeclaration = 'You must agree to the Host Declaration';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // Convert date input (YYYY-MM-DD) to DD-MM-YYYY for display
    const handleDateInputChange = (value, setterFunction)=>{
        if (value) {
            const parts = value.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts;
                setterFunction(`${day}-${month}-${year}`);
            }
        } else setterFunction('');
    };
    // Convert DD-MM-YYYY to YYYY-MM-DD for input value
    const getInputValue = (ddmmyyyy)=>{
        if (!ddmmyyyy) return '';
        const parts = ddmmyyyy.split('-');
        if (parts.length === 3) {
            const [day, month, year] = parts;
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        return '';
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        try {
            // Convert dates from DD-MM-YYYY to YYYY-MM-DD for backend
            const data = await (0, $b698a90aba0778fb$export$3969910379087fbd).createBooking({
                wwoofer_id: wwooferId,
                start_date: (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate),
                end_date: (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(endDate),
                message: message
            });
            if (data.success) {
                // Show popup notification instead of alert
                setPopupMessage(window.wwoofBooking?.popupTexts?.hostRequestSent || 'Your visit request has been sent!');
                setShowPopup(true);
                setStartDate('');
                setEndDate('');
                setMessage('');
                setAgreedToDeclaration(false);
                setErrors({});
            } else {
                setPopupMessage(data.message || 'Unknown error occurred');
                setShowPopup(true);
            }
        } catch (error) {
            console.error('Error creating booking:', error);
            setPopupMessage(error.message || 'Error creating booking request. Please try again.');
            setShowPopup(true);
        } finally{
            setLoading(false);
        }
    };
    const handlePopupClose = ()=>{
        setShowPopup(false);
        setPopupMessage('');
        // Only reload page if it was a success message (form was cleared)
        if (!startDate && !endDate && !message && !agreedToDeclaration) window.location.reload();
    };
    const handleShowDeclaration = (e)=>{
        e.preventDefault();
        setShowDeclarationPopup(true);
    };
    const handleDeclarationPopupClose = ()=>{
        setShowDeclarationPopup(false);
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "wwoof-visit-request-form",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("label", {
                                htmlFor: "start-date",
                                children: "Start Date"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                type: "date",
                                id: "start-date",
                                value: getInputValue(startDate),
                                min: todayString,
                                onChange: (e)=>handleDateInputChange(e.target.value, setStartDate),
                                className: errors.startDate ? 'error' : ''
                            }),
                            errors.startDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "error-message",
                                children: errors.startDate
                            }),
                            startDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "date-preview",
                                children: [
                                    "Display: ",
                                    startDate
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("label", {
                                htmlFor: "end-date",
                                children: "End Date"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                type: "date",
                                id: "end-date",
                                value: getInputValue(endDate),
                                min: getInputValue(startDate) || todayString,
                                onChange: (e)=>handleDateInputChange(e.target.value, setEndDate),
                                className: errors.endDate ? 'error' : ''
                            }),
                            errors.endDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "error-message",
                                children: errors.endDate
                            }),
                            endDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "date-preview",
                                children: [
                                    "Display: ",
                                    endDate
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("label", {
                                htmlFor: "message",
                                children: "Message"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("textarea", {
                                id: "message",
                                value: message,
                                onChange: (e)=>setMessage(e.target.value),
                                placeholder: "Add a personal message to your visit request...",
                                rows: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "checkbox-group",
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "agreed-to-declaration",
                                        checked: agreedToDeclaration,
                                        onChange: (e)=>setAgreedToDeclaration(e.target.checked),
                                        className: errors.agreedToDeclaration ? 'error' : ''
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                        htmlFor: "agreed-to-declaration",
                                        children: [
                                            "I agree to the",
                                            ' ',
                                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                                type: "button",
                                                className: "declaration-link",
                                                onClick: handleShowDeclaration,
                                                children: "Host Declaration"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            errors.agreedToDeclaration && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "error-message",
                                children: errors.agreedToDeclaration
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        type: "submit",
                        disabled: loading,
                        className: "wwoof-submit-button",
                        children: loading ? 'Sending...' : 'Request Visit'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: popupMessage,
                isVisible: showPopup,
                onClose: handlePopupClose
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: window.wwoofBooking?.popupTexts?.hostDeclaration || '<h3>Host Declaration</h3><p>Please configure the Host Declaration text in the admin backend.</p>',
                isVisible: showDeclarationPopup,
                onClose: handleDeclarationPopupClose
            })
        ]
    });
};
var $d14f23ecf9d8993e$export$2e2bcd8739ae039 = $d14f23ecf9d8993e$var$VisitRequestForm;




var $1G08a = parcelRequire("1G08a");




const $15903fdd71bea06b$var$WWOOFerVisitRequestForm = ({ hostId: hostId, wwooferId: wwooferId, threadId: threadId })=>{
    const [startDate, setStartDate] = (0, $1G08a.useState)('');
    const [endDate, setEndDate] = (0, $1G08a.useState)('');
    const [message, setMessage] = (0, $1G08a.useState)('');
    const [loading, setLoading] = (0, $1G08a.useState)(false);
    const [errors, setErrors] = (0, $1G08a.useState)({});
    const [showPopup, setShowPopup] = (0, $1G08a.useState)(false);
    const [popupMessage, setPopupMessage] = (0, $1G08a.useState)('');
    const [agreedToDeclaration, setAgreedToDeclaration] = (0, $1G08a.useState)(false);
    const [showDeclarationPopup, setShowDeclarationPopup] = (0, $1G08a.useState)(false);
    const todayString = (0, $a3a32424dd0a2710$export$1118e4272ea1e258)();
    const validateForm = ()=>{
        const newErrors = {};
        if (!startDate) newErrors.startDate = 'Start date is required';
        else if ((0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate) < todayString) newErrors.startDate = 'Start date cannot be in the past';
        if (!endDate) newErrors.endDate = 'End date is required';
        else if ((0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(endDate) <= (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate)) newErrors.endDate = 'End date must be after start date';
        if (!agreedToDeclaration) newErrors.agreedToDeclaration = 'You must agree to the WWOOFer Declaration';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // Convert date input (YYYY-MM-DD) to DD-MM-YYYY for display
    const handleDateInputChange = (value, setterFunction)=>{
        if (value) {
            const parts = value.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts;
                setterFunction(`${day}-${month}-${year}`);
            }
        } else setterFunction('');
    };
    // Convert DD-MM-YYYY to YYYY-MM-DD for input value
    const getInputValue = (ddmmyyyy)=>{
        if (!ddmmyyyy) return '';
        const parts = ddmmyyyy.split('-');
        if (parts.length === 3) {
            const [day, month, year] = parts;
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        return '';
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        try {
            // Convert dates from DD-MM-YYYY to YYYY-MM-DD for backend
            const data = await (0, $b698a90aba0778fb$export$3969910379087fbd).createWwooferBooking({
                host_id: hostId,
                start_date: (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate),
                end_date: (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(endDate),
                message: message
            });
            if (data.success) {
                // Show popup notification instead of alert
                setPopupMessage(window.wwoofBooking?.popupTexts?.wwooferRequestSent || 'Your visit request has been sent! The Host will be notified and can accept or decline your request.');
                setShowPopup(true);
                setStartDate('');
                setEndDate('');
                setMessage('');
                setAgreedToDeclaration(false);
                setErrors({});
            } else {
                setPopupMessage(data.message || 'Unknown error occurred');
                setShowPopup(true);
            }
        } catch (error) {
            console.error('Error creating booking:', error);
            setPopupMessage(error.message || 'Error creating booking request. Please try again.');
            setShowPopup(true);
        } finally{
            setLoading(false);
        }
    };
    const handlePopupClose = ()=>{
        setShowPopup(false);
        setPopupMessage('');
        // Only reload page if it was a success message (form was cleared)
        if (!startDate && !endDate && !message && !agreedToDeclaration) window.location.reload();
    };
    const handleShowDeclaration = (e)=>{
        e.preventDefault();
        setShowDeclarationPopup(true);
    };
    const handleDeclarationPopupClose = ()=>{
        setShowDeclarationPopup(false);
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "wwoof-visit-request-form",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("label", {
                                htmlFor: "wwoofer-start-date",
                                children: "Start Date"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                type: "date",
                                id: "wwoofer-start-date",
                                value: getInputValue(startDate),
                                min: todayString,
                                onChange: (e)=>handleDateInputChange(e.target.value, setStartDate),
                                className: errors.startDate ? 'error' : ''
                            }),
                            errors.startDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "error-message",
                                children: errors.startDate
                            }),
                            startDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "date-preview",
                                children: [
                                    "Display: ",
                                    startDate
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("label", {
                                htmlFor: "wwoofer-end-date",
                                children: "End Date"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                type: "date",
                                id: "wwoofer-end-date",
                                value: getInputValue(endDate),
                                min: getInputValue(startDate) || todayString,
                                onChange: (e)=>handleDateInputChange(e.target.value, setEndDate),
                                className: errors.endDate ? 'error' : ''
                            }),
                            errors.endDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "error-message",
                                children: errors.endDate
                            }),
                            endDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "date-preview",
                                children: [
                                    "Display: ",
                                    endDate
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("label", {
                                htmlFor: "wwoofer-message",
                                children: "Message"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("textarea", {
                                id: "wwoofer-message",
                                value: message,
                                onChange: (e)=>setMessage(e.target.value),
                                placeholder: "Introduce yourself and explain why you would like to visit this Host...",
                                rows: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "checkbox-group",
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "wwoofer-agreed-to-declaration",
                                        checked: agreedToDeclaration,
                                        onChange: (e)=>setAgreedToDeclaration(e.target.checked),
                                        className: errors.agreedToDeclaration ? 'error' : ''
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                        htmlFor: "wwoofer-agreed-to-declaration",
                                        children: [
                                            "I agree to the",
                                            ' ',
                                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                                type: "button",
                                                className: "declaration-link",
                                                onClick: handleShowDeclaration,
                                                children: "WWOOFer Declaration"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            errors.agreedToDeclaration && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "error-message",
                                children: errors.agreedToDeclaration
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        type: "submit",
                        disabled: loading,
                        className: "wwoof-submit-button",
                        children: loading ? 'Sending...' : 'Request Visit'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: popupMessage,
                isVisible: showPopup,
                onClose: handlePopupClose
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: window.wwoofBooking?.popupTexts?.wwooferDeclaration || '<h3>WWOOFer Declaration</h3><p>Please configure the WWOOFer Declaration text in the admin backend.</p>',
                isVisible: showDeclarationPopup,
                onClose: handleDeclarationPopupClose
            })
        ]
    });
};
var $15903fdd71bea06b$export$2e2bcd8739ae039 = $15903fdd71bea06b$var$WWOOFerVisitRequestForm;




var $1G08a = parcelRequire("1G08a");

var $1G08a = parcelRequire("1G08a");

const $1d7540ca182d067a$export$b40d734c8db78b02 = (userId)=>{
    const [bookings, setBookings] = (0, $1G08a.useState)([]);
    const [currentUserId, setCurrentUserId] = (0, $1G08a.useState)(userId || null);
    const [loading, setLoading] = (0, $1G08a.useState)(true);
    const [refreshing, setRefreshing] = (0, $1G08a.useState)(false);
    const [error, setError] = (0, $1G08a.useState)(null);
    const fetchBookings = async (isRefresh = false)=>{
        if (!userId && !currentUserId) return;
        if (isRefresh) setRefreshing(true);
        else setLoading(true);
        setError(null);
        try {
            const targetUserId = userId || currentUserId;
            const data = await (0, $b698a90aba0778fb$export$3969910379087fbd).getUserBookings(targetUserId);
            // Handle both array and object response
            if (Array.isArray(data)) setBookings(data);
            else {
                setBookings(data.bookings || []);
                setCurrentUserId(data.current_user_id || targetUserId || null);
            }
        } catch (err) {
            setError(err.message);
        } finally{
            if (isRefresh) setRefreshing(false);
            else setLoading(false);
        }
    };
    (0, $1G08a.useEffect)(()=>{
        fetchBookings();
    }, [
        userId,
        currentUserId
    ]);
    const refreshBookings = ()=>{
        fetchBookings(true);
    };
    return {
        bookings: bookings,
        currentUserId: currentUserId,
        loading: loading,
        refreshing: refreshing,
        error: error,
        refreshBookings: refreshBookings
    };
};



var $1G08a = parcelRequire("1G08a");

const $2dcc4f06e0257310$export$b05f746f92c8d0a9 = (onSuccess)=>{
    const [actionLoading, setActionLoading] = (0, $1G08a.useState)(false);
    const [error, setError] = (0, $1G08a.useState)(null);
    const [showAcceptPopup, setShowAcceptPopup] = (0, $1G08a.useState)(false);
    const [showAgreementPopup, setShowAgreementPopup] = (0, $1G08a.useState)(false);
    const [pendingBooking, setPendingBooking] = (0, $1G08a.useState)(null);
    const [showDatePicker, setShowDatePicker] = (0, $1G08a.useState)(false);
    const [bookingToEdit, setBookingToEdit] = (0, $1G08a.useState)(null);
    const [showErrorPopup, setShowErrorPopup] = (0, $1G08a.useState)(false);
    const [errorPopupMessage, setErrorPopupMessage] = (0, $1G08a.useState)('');
    const executeAction = async (action)=>{
        setActionLoading(true);
        setError(null);
        setShowErrorPopup(false);
        setErrorPopupMessage('');
        try {
            await action();
            if (onSuccess) onSuccess();
            return true; // Success
        } catch (err) {
            setError(err.message);
            // Show popup for any error
            if (err.message) {
                setErrorPopupMessage(err.message);
                setShowErrorPopup(true);
            }
            return false; // Failure
        } finally{
            setActionLoading(false);
        }
    };
    const acceptBooking = async (booking)=>{
        // Show agreement popup first
        setPendingBooking(booking);
        setShowAgreementPopup(true);
    };
    const handleAcceptAgreement = async ()=>{
        if (!pendingBooking) return;
        setShowAgreementPopup(false);
        await executeAction(async ()=>{
            await (0, $b698a90aba0778fb$export$3969910379087fbd).acceptBooking(pendingBooking.id);
        //setShowAcceptPopup(true);
        });
        setPendingBooking(null);
    };
    const handleAgreementClose = ()=>{
        setShowAgreementPopup(false);
        setPendingBooking(null);
    };
    const cancelBooking = async (bookingId)=>{
        if (!window.confirm('Are you sure you want to cancel this booking?')) return;
        await executeAction(()=>(0, $b698a90aba0778fb$export$3969910379087fbd).cancelBooking(bookingId));
    };
    const editBookingDates = async (booking)=>{
        setBookingToEdit(booking);
        setShowDatePicker(true);
    };
    const handleDatePickerSave = async (dates)=>{
        if (!bookingToEdit) return;
        const success = await executeAction(async ()=>{
            await (0, $b698a90aba0778fb$export$3969910379087fbd).editBookingDates(bookingToEdit.id, dates);
        });
        // Only close the modal if the operation was successful
        if (success) {
            setShowDatePicker(false);
            setBookingToEdit(null);
        }
    };
    const handleDatePickerClose = ()=>{
        setShowDatePicker(false);
        setBookingToEdit(null);
        setError(null); // Clear any errors when closing
    };
    return {
        actionLoading: actionLoading,
        error: error,
        acceptBooking: acceptBooking,
        cancelBooking: cancelBooking,
        editBookingDates: editBookingDates,
        setError: setError,
        showAcceptPopup: showAcceptPopup,
        setShowAcceptPopup: setShowAcceptPopup,
        showAgreementPopup: showAgreementPopup,
        setShowAgreementPopup: setShowAgreementPopup,
        handleAcceptAgreement: handleAcceptAgreement,
        handleAgreementClose: handleAgreementClose,
        pendingBooking: pendingBooking,
        showDatePicker: showDatePicker,
        bookingToEdit: bookingToEdit,
        handleDatePickerSave: handleDatePickerSave,
        handleDatePickerClose: handleDatePickerClose,
        showErrorPopup: showErrorPopup,
        setShowErrorPopup: setShowErrorPopup,
        errorPopupMessage: errorPopupMessage,
        setErrorPopupMessage: setErrorPopupMessage
    };
};



var $1G08a = parcelRequire("1G08a");

const $c0dbc813b76ae576$export$39a407f50f857acd = (userId)=>{
    const [changes, setChanges] = (0, $1G08a.useState)(null);
    const [loading, setLoading] = (0, $1G08a.useState)(true);
    const [showNotification, setShowNotification] = (0, $1G08a.useState)(false);
    const intervalRef = (0, $1G08a.useRef)(null);
    const hasInitialLoadRef = (0, $1G08a.useRef)(false);
    const fetchChanges = async ()=>{
        if (!userId) return;
        try {
            setLoading(true);
            // Get changes since last visit (only on initial load)
            const changesData = await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get('dashboard/changes');
            setChanges(changesData);
            // Show notification if there are changes and it's not first visit
            if (!changesData.is_first_visit && hasSignificantChanges(changesData.changes)) setShowNotification(true);
            // Mark dashboard as visited (don't wait for this)
            (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post('dashboard/mark-visited').catch(console.warn);
        } catch (error) {
            console.error('Failed to fetch dashboard changes:', error);
        } finally{
            setLoading(false);
            hasInitialLoadRef.current = true;
        }
    };
    const updateLastVisited = async ()=>{
        if (!userId) return;
        try {
            // Only update the last visited timestamp, don't fetch changes
            await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post('dashboard/mark-visited');
        } catch (error) {
            console.warn('Failed to update last visited timestamp:', error);
        }
    };
    const hasSignificantChanges = (changes)=>{
        if (!changes || typeof changes !== 'object') return false;
        return Object.keys(changes).some((key)=>Array.isArray(changes[key]) && changes[key].length > 0);
    };
    const dismissNotification = ()=>{
        setShowNotification(false);
    };
    // Initial load - fetch changes and show popup if needed
    (0, $1G08a.useEffect)(()=>{
        fetchChanges();
    }, [
        userId
    ]);
    // Set up periodic timestamp updates (every minute) - no popup
    (0, $1G08a.useEffect)(()=>{
        if (!hasInitialLoadRef.current) return;
        intervalRef.current = setInterval(()=>{
            updateLastVisited(); // Only update timestamp, don't check for changes
        }, 60000); // Update every minute
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        userId,
        hasInitialLoadRef.current
    ]);
    // Cleanup on unmount
    (0, $1G08a.useEffect)(()=>{
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []);
    return {
        changes: changes,
        loading: loading,
        showNotification: showNotification,
        dismissNotification: dismissNotification,
        refreshChanges: fetchChanges
    };
};


const $51a1d58e4b12a103$export$d971c9d602083500 = {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    IN_PROGRESS: 'inprogress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
};
const $51a1d58e4b12a103$export$764fad7f3e305206 = {
    [$51a1d58e4b12a103$export$d971c9d602083500.PENDING]: '#F59E0B',
    [$51a1d58e4b12a103$export$d971c9d602083500.ACCEPTED]: '#10B981',
    [$51a1d58e4b12a103$export$d971c9d602083500.IN_PROGRESS]: '#3B82F6',
    [$51a1d58e4b12a103$export$d971c9d602083500.COMPLETED]: '#6B7280',
    [$51a1d58e4b12a103$export$d971c9d602083500.CANCELLED]: '#EF4444'
};
const $51a1d58e4b12a103$export$8dac938d775a885c = {
    HOST_INITIATED: '#F59E0B',
    WWOOFER_INITIATED: '#8B5CF6'
};
const $51a1d58e4b12a103$export$7c6317deeec7a6c1 = {
    HOST: 'host',
    WWOOFER: 'wwoofer'
};
const $51a1d58e4b12a103$export$f4c4d822ceaa9764 = {
    LIST: 'list',
    CALENDAR: 'calendar'
};
const $51a1d58e4b12a103$export$9be60a615e817341 = {
    MONTH: 'dayGridMonth',
    YEAR: 'multiMonthYear',
    MULTI_MONTH_STACK: 'multiMonthStack'
};
const $51a1d58e4b12a103$export$4429537025aeeb07 = {
    [$51a1d58e4b12a103$export$d971c9d602083500.PENDING]: 'Pending',
    [$51a1d58e4b12a103$export$d971c9d602083500.ACCEPTED]: 'Accepted',
    [$51a1d58e4b12a103$export$d971c9d602083500.IN_PROGRESS]: 'In Progress',
    [$51a1d58e4b12a103$export$d971c9d602083500.COMPLETED]: 'Completed',
    [$51a1d58e4b12a103$export$d971c9d602083500.CANCELLED]: 'Cancelled'
};
const $51a1d58e4b12a103$export$a10e4eda63f1399b = {
    DATE_ASC: 'date_asc',
    DATE_DESC: 'date_desc',
    CREATED_ASC: 'created_asc',
    CREATED_DESC: 'created_desc'
};
const $51a1d58e4b12a103$export$370bfe54726d4782 = {
    [$51a1d58e4b12a103$export$a10e4eda63f1399b.DATE_ASC]: 'Start Date (Oldest First)',
    [$51a1d58e4b12a103$export$a10e4eda63f1399b.DATE_DESC]: 'Start Date (Newest First)',
    [$51a1d58e4b12a103$export$a10e4eda63f1399b.CREATED_ASC]: 'Created (Oldest First)',
    [$51a1d58e4b12a103$export$a10e4eda63f1399b.CREATED_DESC]: 'Created (Newest First)'
};



parcelRequire("1G08a");



var $1G08a = parcelRequire("1G08a");

const $62cfe7fbadc3d882$var$StatusFilter = ({ selectedStatuses: selectedStatuses, onStatusChange: onStatusChange })=>{
    const [isOpen, setIsOpen] = (0, $1G08a.useState)(false);
    const dropdownRef = (0, $1G08a.useRef)(null);
    // Close dropdown when clicking outside
    (0, $1G08a.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const handleStatusToggle = (status)=>{
        const newStatuses = selectedStatuses.includes(status) ? selectedStatuses.filter((s)=>s !== status) : [
            ...selectedStatuses,
            status
        ];
        onStatusChange(newStatuses);
    };
    const handleSelectAll = ()=>{
        const allStatuses = Object.values((0, $51a1d58e4b12a103$export$d971c9d602083500));
        onStatusChange(selectedStatuses.length === allStatuses.length ? [] : allStatuses);
    };
    const getDisplayText = ()=>{
        if (selectedStatuses.length === 0) return 'No statuses selected';
        if (selectedStatuses.length === Object.values((0, $51a1d58e4b12a103$export$d971c9d602083500)).length) return 'All statuses';
        if (selectedStatuses.length === 1) return (0, $51a1d58e4b12a103$export$4429537025aeeb07)[selectedStatuses[0]];
        return `${selectedStatuses.length} statuses selected`;
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "status-filter",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("button", {
                className: "status-filter-button",
                onClick: ()=>setIsOpen(!isOpen),
                type: "button",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                        className: "filter-icon",
                        children: "\uD83C\uDFF7\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                        className: "filter-text",
                        children: getDisplayText()
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                        className: "dropdown-arrow",
                        children: isOpen ? "\u25B2" : "\u25BC"
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "status-filter-dropdown",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "status-filter-header",
                        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            className: "select-all-button",
                            onClick: handleSelectAll,
                            type: "button",
                            children: selectedStatuses.length === Object.values((0, $51a1d58e4b12a103$export$d971c9d602083500)).length ? 'Deselect All' : 'Select All'
                        })
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "status-filter-options",
                        children: Object.entries((0, $51a1d58e4b12a103$export$d971c9d602083500)).map(([key, status])=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                className: "status-option",
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: selectedStatuses.includes(status),
                                        onChange: ()=>handleStatusToggle(status)
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                        className: "status-option-text",
                                        children: (0, $51a1d58e4b12a103$export$4429537025aeeb07)[status]
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                        className: "status-indicator",
                                        style: {
                                            backgroundColor: (0, $51a1d58e4b12a103$export$764fad7f3e305206)[status]
                                        }
                                    })
                                ]
                            }, status))
                    })
                ]
            })
        ]
    });
};
var $62cfe7fbadc3d882$export$2e2bcd8739ae039 = $62cfe7fbadc3d882$var$StatusFilter;



parcelRequire("1G08a");

const $dc1b2d09a3d2ff76$var$SortDropdown = ({ sortBy: sortBy, onSortChange: onSortChange })=>{
    const handleChange = (e)=>{
        onSortChange(e.target.value);
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "sort-dropdown",
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
            htmlFor: "booking-sort",
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                    className: "sort-label",
                    children: "Sort by:"
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("select", {
                    id: "booking-sort",
                    value: sortBy,
                    onChange: handleChange,
                    className: "sort-select",
                    children: Object.entries((0, $51a1d58e4b12a103$export$a10e4eda63f1399b)).map(([key, value])=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("option", {
                            value: value,
                            children: (0, $51a1d58e4b12a103$export$370bfe54726d4782)[value]
                        }, value))
                })
            ]
        })
    });
};
var $dc1b2d09a3d2ff76$export$2e2bcd8739ae039 = $dc1b2d09a3d2ff76$var$SortDropdown;


const $80b78a6727727a2b$var$FilterTabs = ({ view: view, setView: setView, calendarView: calendarView, setCalendarView: setCalendarView, selectedStatuses: selectedStatuses, onStatusChange: onStatusChange, sortBy: sortBy, onSortChange: onSortChange })=>{
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "dashboard-header",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "filter-controls",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "status-filter-container",
                        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $62cfe7fbadc3d882$export$2e2bcd8739ae039), {
                            selectedStatuses: selectedStatuses,
                            onStatusChange: onStatusChange
                        })
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "sort-filter-container",
                        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $dc1b2d09a3d2ff76$export$2e2bcd8739ae039), {
                            sortBy: sortBy,
                            onSortChange: onSortChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "view-controls",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "view-buttons",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: view === (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).LIST ? 'active' : '',
                                onClick: ()=>setView((0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).LIST),
                                children: "\uD83D\uDCCB List"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: view === (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).CALENDAR ? 'active' : '',
                                onClick: ()=>setView((0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).CALENDAR),
                                children: "\uD83D\uDCC5 Calendar"
                            })
                        ]
                    }),
                    view === (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).CALENDAR && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "calendar-view-buttons",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).MONTH ? 'active' : '',
                                onClick: ()=>setCalendarView((0, $51a1d58e4b12a103$export$9be60a615e817341).MONTH),
                                children: "Month"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).MULTI_MONTH_STACK ? 'active' : '',
                                onClick: ()=>setCalendarView((0, $51a1d58e4b12a103$export$9be60a615e817341).MULTI_MONTH_STACK),
                                children: "Stack"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                className: calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).YEAR ? 'active' : '',
                                onClick: ()=>setCalendarView((0, $51a1d58e4b12a103$export$9be60a615e817341).YEAR),
                                children: "Year"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $80b78a6727727a2b$export$2e2bcd8739ae039 = $80b78a6727727a2b$var$FilterTabs;



parcelRequire("1G08a");

parcelRequire("1G08a");


var $1G08a = parcelRequire("1G08a");



parcelRequire("1G08a");

const $66cd24bfd5600f4a$var$StatusBadge = ({ status: status, initiatedBy: initiatedBy = 'host' })=>{
    // Use different pending colors based on who initiated
    let backgroundColor = (0, $51a1d58e4b12a103$export$764fad7f3e305206)[status] || '#888';
    if (status === (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING) backgroundColor = initiatedBy === 'wwoofer' ? (0, $51a1d58e4b12a103$export$8dac938d775a885c).WWOOFER_INITIATED : (0, $51a1d58e4b12a103$export$8dac938d775a885c).HOST_INITIATED;
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
        className: "status-badge",
        style: {
            background: backgroundColor
        },
        children: status
    });
};
var $66cd24bfd5600f4a$export$2e2bcd8739ae039 = $66cd24bfd5600f4a$var$StatusBadge;





var $1G08a = parcelRequire("1G08a");
const $0baab276da19616b$var$MessageModal = ({ isOpen: isOpen, onClose: onClose, conversationId: conversationId, onSendMessage: onSendMessage, currentUserId: currentUserId, nonce: nonce })=>{
    const [messages, setMessages] = (0, $1G08a.useState)([]);
    const [newMessage, setNewMessage] = (0, $1G08a.useState)('');
    const [isLoading, setIsLoading] = (0, $1G08a.useState)(true);
    (0, $1G08a.useEffect)(()=>{
        if (isOpen && conversationId) fetchMessages();
    }, [
        isOpen,
        conversationId,
        nonce
    ]);
    const fetchMessages = async ()=>{
        try {
            setIsLoading(true);
            const response = await fetch(`/wp-json/better-messages/v1/thread/${conversationId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce
                }
            });
            if (!response.ok) throw new Error('Failed to fetch messages');
            const data = await response.json();
            const transformedMessages = (data.messages || []).map((msg)=>({
                    ...msg,
                    sender: data.users.find((user)=>user.id === msg.sender_id.toString()),
                    date: new Date(Math.floor(msg.created_at / 10000) * 1000).toLocaleString()
                })).sort((a, b)=>a.created_at - b.created_at);
            setMessages(transformedMessages);
            setTimeout(()=>{
                const messageList = document.querySelector('.message-list');
                if (messageList) messageList.scrollTop = messageList.scrollHeight;
            }, 100);
        } catch (error) {
            console.error('Error fetching messages:', error);
        } finally{
            setIsLoading(false);
        }
    };
    (0, $1G08a.useEffect)(()=>{
        const messageList = document.querySelector('.message-list');
        if (messageList) messageList.scrollTop = messageList.scrollHeight;
    }, [
        messages
    ]);
    const handleSendMessage = async (e)=>{
        e.preventDefault();
        if (!newMessage.trim()) return;
        try {
            const response = await fetch(`/wp-json/better-messages/v1/thread/${conversationId}/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce
                },
                body: JSON.stringify({
                    message: newMessage,
                    temp_id: Date.now().toString(),
                    temp_time: Date.now()
                })
            });
            if (!response.ok) throw new Error('Failed to send message');
            setNewMessage('');
            fetchMessages();
            if (onSendMessage) onSendMessage();
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "message-modal-overlay",
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "message-modal",
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "message-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h3", {
                            children: "Messages"
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            className: "close-button",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "message-list",
                    children: isLoading ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "loading",
                        children: "Loading messages..."
                    }) : messages.map((msg)=>{
                        const isBookingSystem = msg.sender?.name === 'Booking System';
                        const messageClass = `message ${isBookingSystem ? 'booking-system' : msg.sender_id === currentUserId ? 'sent' : 'received'}`;
                        return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                            className: messageClass,
                            children: [
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                    className: "message-sender",
                                    children: msg.sender?.name || 'Unknown'
                                }),
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                    className: "message-content",
                                    dangerouslySetInnerHTML: {
                                        __html: msg.message
                                    }
                                }),
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                    className: "message-meta",
                                    children: msg.date
                                })
                            ]
                        }, msg.message_id);
                    })
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("form", {
                    className: "message-form",
                    onSubmit: handleSendMessage,
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("textarea", {
                            value: newMessage,
                            onChange: (e)=>setNewMessage(e.target.value),
                            placeholder: "Type your message...",
                            rows: "3"
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            type: "submit",
                            className: "send-button",
                            children: "Send"
                        })
                    ]
                })
            ]
        })
    });
};
var $0baab276da19616b$export$2e2bcd8739ae039 = $0baab276da19616b$var$MessageModal;




var $1G08a = parcelRequire("1G08a");



parcelRequire("1G08a");


var $1G08a = parcelRequire("1G08a");

class $34e55c63a83a7460$var$ReviewsApiService {
    async getForm(reviewType, recipientId) {
        try {
            let url = `reviews/form?review_type=${reviewType}`;
            if (recipientId) url += `&recipient_id=${recipientId}`;
            return await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get(url);
        } catch (error) {
            console.error('Failed to get review form:', error);
            throw new Error('Unable to load review form');
        }
    }
    async submit({ booking_id: booking_id, member_id: member_id, fields: fields, badge_keys: badge_keys }) {
        try {
            const data = {
                booking_id: booking_id,
                member_id: member_id,
                fields: fields
            };
            if (Array.isArray(badge_keys) && badge_keys.length > 0) data.badge_keys = badge_keys;
            return await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post('reviews/submit', data);
        } catch (error) {
            console.error('Failed to submit review:', error);
            throw error;
        }
    }
    async list({ member_id: member_id, page: page = 1, per_page: per_page = 10, status: status }) {
        try {
            const params = new URLSearchParams({
                member_id: member_id.toString(),
                page: page.toString(),
                per_page: per_page.toString()
            });
            if (status) params.set('status', status);
            return await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get(`reviews/list?${params}`);
        } catch (error) {
            console.error('Failed to get reviews list:', error);
            throw error;
        }
    }
    async respond({ review_id: review_id, content: content }) {
        try {
            return await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post('reviews/respond', {
                review_id: review_id,
                content: content
            });
        } catch (error) {
            console.error('Failed to submit review response:', error);
            throw error;
        }
    }
    async stats({ member_id: member_id }) {
        try {
            return await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get(`reviews/stats?member_id=${member_id}`);
        } catch (error) {
            console.error('Failed to get review stats:', error);
            throw error;
        }
    }
    async getReview(reviewId) {
        try {
            return await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get(`reviews/${reviewId}`);
        } catch (error) {
            console.error('Failed to get review:', error);
            throw error;
        }
    }
}
var $34e55c63a83a7460$export$2e2bcd8739ae039 = new $34e55c63a83a7460$var$ReviewsApiService();


const $d2a1c945ab906502$var$ReviewForm = ({ bookingId: bookingId, memberId: memberId, reviewType: reviewType, onSubmitSuccess: onSubmitSuccess, onCancel: onCancel })=>{
    const [schema, setSchema] = (0, $1G08a.useState)(null);
    const [values, setValues] = (0, $1G08a.useState)({});
    const [selectedBadges, setSelectedBadges] = (0, $1G08a.useState)([]);
    const [loading, setLoading] = (0, $1G08a.useState)(true);
    const [error, setError] = (0, $1G08a.useState)('');
    const [status, setStatus] = (0, $1G08a.useState)('');
    const [submitting, setSubmitting] = (0, $1G08a.useState)(false);
    (0, $1G08a.useEffect)(()=>{
        let cancelled = false;
        setLoading(true);
        setError('');
        (0, $34e55c63a83a7460$export$2e2bcd8739ae039).getForm(reviewType, memberId).then((data)=>{
            if (cancelled) return;
            setSchema(data);
            const init = {};
            (data.fields || []).forEach((f)=>{
                init[f.key] = '';
            });
            setValues(init);
            setSelectedBadges([]);
        }).catch((err)=>{
            if (cancelled) return;
            setError(err.message || 'Unable to load review form.');
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        reviewType
    ]);
    const onChange = (key)=>(e)=>{
            setValues((v)=>({
                    ...v,
                    [key]: e.target.value
                }));
        };
    const badgesConfig = schema?.badges_config;
    const maxBadges = badgesConfig?.max_badges ?? 0;
    const onBadgeToggle = (badgeKey)=>{
        setSelectedBadges((prev)=>{
            if (prev.includes(badgeKey)) return prev.filter((k)=>k !== badgeKey);
            if (maxBadges > 0 && prev.length >= maxBadges) return prev;
            return [
                ...prev,
                badgeKey
            ];
        });
    };
    const onSubmit = async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        setStatus("Submitting\u2026");
        try {
            const result = await (0, $34e55c63a83a7460$export$2e2bcd8739ae039).submit({
                booking_id: bookingId,
                member_id: memberId,
                fields: values,
                badge_keys: selectedBadges
            });
            setStatus(result?.is_published || result?.publication_policy === 'immediate' ? 'Submitted successfully.' : 'Your review has been submitted and is awaiting publication.');
            // Clear form
            const cleared = {};
            Object.keys(values).forEach((k)=>cleared[k] = '');
            setValues(cleared);
            setSelectedBadges([]);
            // Call success callback
            if (onSubmitSuccess) setTimeout(()=>onSubmitSuccess(), 1000);
        } catch (err) {
            const msg = err && err.message ? err.message : 'Submission failed.';
            setStatus(msg);
        } finally{
            setSubmitting(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "review-form-loading",
        children: "Loading\u2026"
    });
    if (error) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "review-form-error",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                children: error
            }),
            onCancel && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                onClick: onCancel,
                className: "button",
                children: "Close"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "review-form-container",
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("form", {
            className: "review-form",
            onSubmit: onSubmit,
            children: [
                (schema?.fields || []).map((f)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "review-field",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                htmlFor: `review-field-${f.key}`,
                                children: [
                                    f.label || f.key,
                                    f.required && ' *'
                                ]
                            }),
                            f.type === 'rating' ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("select", {
                                id: `review-field-${f.key}`,
                                name: f.key,
                                value: values[f.key] || '',
                                onChange: onChange(f.key),
                                required: f.required,
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("option", {
                                        value: "",
                                        children: "Select rating"
                                    }),
                                    Array.from({
                                        length: (f.max ?? 5) - (f.min ?? 1) + 1
                                    }, (_, i)=>i + (f.min ?? 1)).map((n)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("option", {
                                            value: String(n),
                                            children: [
                                                n,
                                                " ",
                                                n === 1 ? 'Star' : 'Stars'
                                            ]
                                        }, n))
                                ]
                            }) : /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)((0, $ee14841e48c228d7$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("textarea", {
                                        id: `review-field-${f.key}`,
                                        name: f.key,
                                        rows: "4",
                                        value: values[f.key] || '',
                                        onChange: onChange(f.key),
                                        placeholder: f.placeholder || `Enter ${f.label || f.key}`,
                                        required: f.required
                                    }),
                                    f.type === 'text' && f.min_words > 0 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                        className: "review-field-help",
                                        children: [
                                            "Minimum ",
                                            f.min_words,
                                            " words"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, f.key)),
                badgesConfig?.enabled && Array.isArray(badgesConfig.badges) && badgesConfig.badges.length > 0 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "review-badges-section",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("h4", {
                            className: "review-badges-heading",
                            children: [
                                "Award Badges",
                                maxBadges > 0 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                    className: "review-badges-limit",
                                    children: [
                                        ' ',
                                        "(",
                                        selectedBadges.length,
                                        "/",
                                        maxBadges,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                            className: "review-badges-description",
                            children: maxBadges > 0 ? `You may select up to ${maxBadges} badge(s) to award.` : 'Select any badges you would like to award.'
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                            className: "review-badges-list",
                            children: badgesConfig.badges.map((badge)=>{
                                const isSelected = selectedBadges.includes(badge.key);
                                const isDisabled = badge.already_awarded || !isSelected && maxBadges > 0 && selectedBadges.length >= maxBadges;
                                return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                    className: `review-badge-item${isSelected ? ' is-selected' : ''}${isDisabled ? ' is-disabled' : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                            type: "checkbox",
                                            value: badge.key,
                                            checked: isSelected,
                                            disabled: isDisabled,
                                            onChange: ()=>!isDisabled && onBadgeToggle(badge.key),
                                            "aria-describedby": `review-badge-desc-${badge.key}`
                                        }),
                                        badge.icon_url && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("img", {
                                            src: badge.icon_url,
                                            alt: "",
                                            className: "review-badge-icon",
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                            className: "review-badge-label",
                                            children: badge.label
                                        }),
                                        badge.already_awarded && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                            className: "review-badge-awarded-note",
                                            children: "Already awarded"
                                        }),
                                        badge.description && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                            id: `review-badge-desc-${badge.key}`,
                                            className: "review-badge-description",
                                            children: badge.description
                                        })
                                    ]
                                }, badge.key);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "review-form-help",
                    children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                        children: "Please provide honest, respectful feedback. Required fields are marked with *."
                    })
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "review-form-actions",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            type: "submit",
                            className: "button button-primary",
                            disabled: submitting,
                            children: submitting ? "Submitting\u2026" : 'Submit Review'
                        }),
                        onCancel && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            type: "button",
                            onClick: onCancel,
                            className: "button",
                            disabled: submitting,
                            children: "Cancel"
                        })
                    ]
                }),
                status && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "review-form-status",
                    role: "status",
                    "aria-live": "polite",
                    children: status
                })
            ]
        })
    });
};
var $d2a1c945ab906502$export$2e2bcd8739ae039 = $d2a1c945ab906502$var$ReviewForm;




var $1G08a = parcelRequire("1G08a");

const $9d8d71ff00e9450c$var$ReviewDisplay = ({ reviewId: reviewId, onClose: onClose })=>{
    const [review, setReview] = (0, $1G08a.useState)(null);
    const [loading, setLoading] = (0, $1G08a.useState)(true);
    const [error, setError] = (0, $1G08a.useState)('');
    (0, $1G08a.useEffect)(()=>{
        let cancelled = false;
        setLoading(true);
        setError('');
        (0, $34e55c63a83a7460$export$2e2bcd8739ae039).getReview(reviewId).then((data)=>{
            if (cancelled) return;
            setReview(data);
        }).catch((err)=>{
            if (cancelled) return;
            setError(err.message || 'Unable to load review.');
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        reviewId
    ]);
    if (loading) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "review-display-loading",
        children: "Loading review\u2026"
    });
    if (error) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "review-display-error",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                children: error
            }),
            onClose && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                onClick: onClose,
                className: "button",
                children: "Close"
            })
        ]
    });
    if (!review) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "review-display-empty",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                children: "Review not found."
            }),
            onClose && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                onClick: onClose,
                className: "button",
                children: "Close"
            })
        ]
    });
    const formatDate = (dateString)=>{
        return new Date(dateString).toLocaleDateString();
    };
    const renderRatingStars = (rating, maxRating = 5)=>{
        const stars = [];
        for(let i = 1; i <= maxRating; i++)stars.push(/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
            className: `star ${i <= rating ? 'filled' : 'empty'}`,
            children: "\u2605"
        }, i));
        return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
            className: "rating-stars",
            children: stars
        });
    };
    const humanizeBadgeKey = (key)=>{
        return String(key).replace(/_/g, ' ').replace(/(^|\s)\S/g, (t)=>t.toUpperCase());
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "review-display",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "review-header",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h3", {
                        children: "Review"
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "review-meta",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                className: "review-author",
                                children: [
                                    "By: ",
                                    review.author_name
                                ]
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                className: "review-date",
                                children: [
                                    "Date: ",
                                    formatDate(review.created_at)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                className: "review-content",
                children: review.fields && !Array.isArray(review.fields) && typeof review.fields === 'object' ? Object.entries(review.fields).map(([key, value])=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "review-field",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                children: [
                                    key.replace(/_/g, ' ').replace(/(^|\s)\S/g, (t)=>t.toUpperCase()),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                className: "review-field-value",
                                children: typeof value === 'number' ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                    className: "rating-display",
                                    children: [
                                        renderRatingStars(parseInt(value)),
                                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                            className: "rating-text",
                                            children: [
                                                value,
                                                " / 5"
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                    className: "text-content",
                                    children: value || 'No comment provided'
                                })
                            })
                        ]
                    }, key)) : // If fields is already an array, keep existing behavior
                Array.isArray(review.fields) && review.fields.map((field)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "review-field",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                                children: [
                                    field.label,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                className: "review-field-value",
                                children: field.type === 'rating' ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                    className: "rating-display",
                                    children: [
                                        renderRatingStars(parseInt(field.value)),
                                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                            className: "rating-text",
                                            children: [
                                                field.value,
                                                " / ",
                                                field.max || 5
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                    className: "text-content",
                                    children: field.value || 'No comment provided'
                                })
                            })
                        ]
                    }, field.key))
            }),
            Array.isArray(review.badge_keys) && review.badge_keys.length > 0 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "review-badges-display",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                        className: "review-badges-display-label",
                        children: "Badges awarded:"
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "review-badges-display-list",
                        children: review.badge_keys.map((key)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "review-badge-chip",
                                children: humanizeBadgeKey(key)
                            }, key))
                    })
                ]
            }),
            Array.isArray(review.responses) && review.responses.length > 0 && (()=>{
                const resp = review.responses[0];
                return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "review-response",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h4", {
                            children: "Response"
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                            className: "response-content",
                            children: [
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                                    children: resp.content
                                }),
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                    className: "response-meta",
                                    children: [
                                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                            children: [
                                                "By: ",
                                                resp.author_name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                            children: [
                                                "Date: ",
                                                formatDate(resp.created_at)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            })(),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                className: "review-actions",
                children: onClose && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                    onClick: onClose,
                    className: "button",
                    children: "Close"
                })
            })
        ]
    });
};
var $9d8d71ff00e9450c$export$2e2bcd8739ae039 = $9d8d71ff00e9450c$var$ReviewDisplay;


const $96b6f6c8a13e63ac$var$ReviewModal = ({ isOpen: isOpen, onClose: onClose, mode: mode, booking: booking, currentUserId: currentUserId, reviewId: reviewId, onReviewSubmitted: onReviewSubmitted // optional callback(reviewId) invoked after successful submit
 })=>{
    if (!isOpen) return null;
    const getReviewType = ()=>{
        if (!booking || !currentUserId) return null;
        if (parseInt(booking.host_id) === parseInt(currentUserId)) return 'host_review';
        else if (parseInt(booking.wwoofer_id) === parseInt(currentUserId)) return 'wwoofer_review';
        return null;
    };
    const getMemberId = ()=>{
        if (!booking || !currentUserId) return null;
        if (parseInt(booking.host_id) === parseInt(currentUserId)) return parseInt(booking.wwoofer_id);
        else if (parseInt(booking.wwoofer_id) === parseInt(currentUserId)) return parseInt(booking.host_id);
        return null;
    };
    const handleSubmitSuccess = (newReviewId = null)=>{
        // Notify parent that a review was created/updated so it can update its UI
        if (typeof onReviewSubmitted === 'function') try {
            onReviewSubmitted(newReviewId);
        } catch (e) {
            // swallow - callback should not break modal flow
            // eslint-disable-next-line no-console
            console.error('onReviewSubmitted callback error', e);
        }
        // Close modal after a short delay to allow any animations or toast messages
        setTimeout(()=>{
            onClose();
        // Could trigger a refresh of booking data here if desired
        }, 450);
    };
    const reviewType = getReviewType();
    const memberId = getMemberId();
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "modal-content",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h2", {
                            children: mode === 'create' ? 'Leave a Review' : 'View Review'
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            className: "modal-close",
                            onClick: onClose,
                            "aria-label": "Close modal",
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "modal-body",
                    children: mode === 'create' ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $d2a1c945ab906502$export$2e2bcd8739ae039), {
                        bookingId: booking?.id,
                        memberId: memberId,
                        reviewType: reviewType,
                        onSubmitSuccess: handleSubmitSuccess,
                        onCancel: onClose
                    }) : /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $9d8d71ff00e9450c$export$2e2bcd8739ae039), {
                        reviewId: reviewId,
                        onClose: onClose
                    })
                })
            ]
        })
    });
};
var $96b6f6c8a13e63ac$export$2e2bcd8739ae039 = $96b6f6c8a13e63ac$var$ReviewModal;


const $8e22c1f9000dec18$var$ReviewButton = ({ booking: booking, currentUserId: currentUserId })=>{
    const [showReviewModal, setShowReviewModal] = (0, $1G08a.useState)(false);
    const [modalMode, setModalMode] = (0, $1G08a.useState)('create'); // 'create' or 'view'
    const [reviewIdToView, setReviewIdToView] = (0, $1G08a.useState)(null);
    // Check if reviews plugin is enabled from localized data
    const reviewsEnabled = window.wwoofBooking?.plugins?.reviewsEnabled || false;
    // If reviews plugin is not enabled, don't render anything
    if (!reviewsEnabled) return null;
    const isHost = parseInt(booking.host_id) === parseInt(currentUserId);
    const isWwoofer = parseInt(booking.wwoofer_id) === parseInt(currentUserId);
    // Local, mutable review id state so UI can update without page reload
    const [currentUserReviewId, setCurrentUserReviewId] = (0, $1G08a.useState)(isHost ? booking.host_review_id : booking.wwoofer_review_id);
    const [otherUserReviewId, setOtherUserReviewId] = (0, $1G08a.useState)(isHost ? booking.wwoofer_review_id : booking.host_review_id);
    // Keep local state in sync if booking prop changes
    (0, $1G08a.useEffect)(()=>{
        setCurrentUserReviewId(isHost ? booking.host_review_id : booking.wwoofer_review_id);
        setOtherUserReviewId(isHost ? booking.wwoofer_review_id : booking.host_review_id);
    }, [
        booking,
        isHost
    ]);
    // Only show review options for completed bookings
    if (booking.status !== (0, $51a1d58e4b12a103$export$d971c9d602083500).COMPLETED) return null;
    // User must be either host or wwoofer
    if (!isHost && !isWwoofer) return null;
    // Determine review states
    // Use the local state values for rendering
    const hasLeftReview = currentUserReviewId && currentUserReviewId !== '0';
    const otherUserHasLeftReview = otherUserReviewId && otherUserReviewId !== '0';
    const handleLeaveReview = ()=>{
        setModalMode('create');
        setShowReviewModal(true);
    };
    const handleViewMyReview = ()=>{
        setModalMode('view');
        setReviewIdToView(currentUserReviewId);
        setShowReviewModal(true);
    };
    const handleViewOtherReview = ()=>{
        setModalMode('view');
        setReviewIdToView(otherUserReviewId);
        setShowReviewModal(true);
    };
    const otherUserName = isHost ? booking.wwoofer_name : booking.host_name;
    // Callback passed to modal to update state immediately after a successful submit
    const handleReviewSubmitted = (newReviewId)=>{
        // If newReviewId is provided, store it; otherwise mark as a non-zero placeholder
        const idToSet = newReviewId ?? '1';
        setCurrentUserReviewId(idToSet);
    // Optionally also update booking object fields if parent relies on it elsewhere
    // (we don't mutate props directly here)
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "review-buttons",
        children: [
            !hasLeftReview && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                onClick: handleLeaveReview,
                className: "review-button leave-review",
                children: "\u2B50 Leave Review"
            }),
            hasLeftReview && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                onClick: handleViewMyReview,
                className: "review-button view-my-review",
                variant: "secondary",
                children: "\uD83D\uDCDD View My Review"
            }),
            otherUserHasLeftReview && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                onClick: handleViewOtherReview,
                className: "review-button view-other-review",
                variant: "secondary",
                children: [
                    "\uD83D\uDC41\uFE0F View ",
                    otherUserName,
                    "'s Review"
                ]
            }),
            showReviewModal && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $96b6f6c8a13e63ac$export$2e2bcd8739ae039), {
                isOpen: showReviewModal,
                onClose: ()=>setShowReviewModal(false),
                mode: modalMode,
                booking: booking,
                currentUserId: currentUserId,
                reviewId: reviewIdToView,
                onReviewSubmitted: handleReviewSubmitted
            })
        ]
    });
};
var $8e22c1f9000dec18$export$2e2bcd8739ae039 = $8e22c1f9000dec18$var$ReviewButton;


const $1bb93376bab2327d$var$BookingDetails = ({ booking: booking, actionLoading: actionLoading, onEditDates: onEditDates, onCancel: onCancel, onAccept: onAccept, currentUserId: currentUserId, showCloseButton: showCloseButton = false, onClose: onClose })=>{
    const [showMessageModal, setShowMessageModal] = (0, $1G08a.useState)(false);
    const canEditDates = (booking)=>{
        if (booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).HOST) {
            const allowedStatuses = [
                (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING,
                (0, $51a1d58e4b12a103$export$d971c9d602083500).ACCEPTED
            ];
            // Check if host editing of in-progress bookings is enabled
            const allowHostEditInprogress = window.wwoofBooking?.settings?.allowHostEditInprogress || false;
            if (allowHostEditInprogress) allowedStatuses.push((0, $51a1d58e4b12a103$export$d971c9d602083500).IN_PROGRESS);
            return allowedStatuses.includes(booking.status);
        }
        return false;
    };
    const canCancel = (booking)=>{
        const initiatedBy = booking.initiated_by || 'host';
        if (booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).HOST) // Hosts can cancel pending or accepted bookings they initiated
        // For WWOOFer-initiated requests, they can also decline (cancel) when pending
        return [
            (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING,
            (0, $51a1d58e4b12a103$export$d971c9d602083500).ACCEPTED
        ].includes(booking.status);
        else if (booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).WWOOFER) // WWOOFers can cancel pending bookings they initiated
        // For Host-initiated requests, they can decline (cancel) when pending
        return booking.status === (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING;
        return false;
    };
    const canAccept = (booking)=>{
        if (booking.status !== (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING) return false;
        const initiatedBy = booking.initiated_by || 'host';
        // WWOOFer-initiated: Host accepts
        if (initiatedBy === 'wwoofer') return booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).HOST;
        // Host-initiated: WWOOFer accepts
        return booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).WWOOFER;
    };
    const getCancelButtonLabel = (booking)=>{
        const isPending = booking.status === (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING;
        const initiatedBy = booking.initiated_by || 'host';
        if (isPending && initiatedBy === 'wwoofer') {
            if (booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).HOST) return 'Decline Request';
            else return 'Cancel Request';
        }
        if (isPending && initiatedBy === 'host') {
            if (booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).WWOOFER) return 'Decline Request';
            else return 'Cancel Request';
        }
        return 'Cancel Booking';
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "booking-card",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "booking-header",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        children: [
                            "\uD83D\uDCC5 ",
                            (0, $a3a32424dd0a2710$export$2e9241a0bdf6c8b8)(booking.start_date, booking.end_date)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $66cd24bfd5600f4a$export$2e2bcd8739ae039), {
                        status: booking.status,
                        initiatedBy: booking.initiated_by
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                className: "booking-dates",
                children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("p", {
                    children: [
                        "With: ",
                        booking.current_user_role === (0, $51a1d58e4b12a103$export$7c6317deeec7a6c1).HOST ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("a", {
                            href: booking.wwoofer_profile_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "profile-link",
                            children: booking.wwoofer_name
                        }) : /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("a", {
                            href: booking.host_profile_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "profile-link",
                            children: booking.host_name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "booking-actions",
                children: [
                    canEditDates(booking) && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        variant: "edit",
                        disabled: actionLoading,
                        onClick: ()=>onEditDates(booking),
                        children: actionLoading ? '...' : 'Edit Dates'
                    }),
                    canCancel(booking) && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        variant: "cancel",
                        disabled: actionLoading,
                        onClick: ()=>onCancel(booking.id),
                        children: actionLoading ? '...' : getCancelButtonLabel(booking)
                    }),
                    canAccept(booking) && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        variant: "accept",
                        disabled: actionLoading,
                        onClick: ()=>onAccept(booking),
                        children: actionLoading ? '...' : 'Accept'
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        onClick: ()=>setShowMessageModal(true),
                        className: "action-button",
                        children: "\uD83D\uDCAC View Messages"
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $8e22c1f9000dec18$export$2e2bcd8739ae039), {
                        booking: booking,
                        currentUserId: currentUserId
                    }),
                    showCloseButton && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        children: "Close"
                    })
                ]
            }),
            showMessageModal && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $0baab276da19616b$export$2e2bcd8739ae039), {
                isOpen: showMessageModal,
                onClose: ()=>setShowMessageModal(false),
                conversationId: booking.pm_thread_id,
                currentUserId: currentUserId,
                nonce: window.wwoofBooking?.nonce || window.wwoofBooking?.nonce || '',
                onSendMessage: ()=>{
                    // Optional callback for when a message is sent
                    console.log('Message sent');
                }
            })
        ]
    });
};
var $1bb93376bab2327d$export$2e2bcd8739ae039 = $1bb93376bab2327d$var$BookingDetails;


const $62b5f4e2048cb0a2$var$BookingCard = ({ booking: booking, actionLoading: actionLoading, onEditDates: onEditDates, onCancel: onCancel, onAccept: onAccept, currentUserId: currentUserId })=>{
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $1bb93376bab2327d$export$2e2bcd8739ae039), {
        booking: booking,
        actionLoading: actionLoading,
        onEditDates: onEditDates,
        onCancel: onCancel,
        onAccept: onAccept,
        currentUserId: currentUserId,
        showCloseButton: false
    });
};
var $62b5f4e2048cb0a2$export$2e2bcd8739ae039 = $62b5f4e2048cb0a2$var$BookingCard;



parcelRequire("1G08a");

const $4968431f639f2516$var$CalendarLegend = ({ unavailableDatesEnabled: unavailableDatesEnabled = false, wwooferInitiatedEnabled: wwooferInitiatedEnabled = false })=>{
    // Custom legend items that show both pending colors
    const legendItems = [
        {
            color: (0, $51a1d58e4b12a103$export$8dac938d775a885c).HOST_INITIATED,
            label: 'Pending (Host Request)'
        },
        ...wwooferInitiatedEnabled ? [
            {
                color: (0, $51a1d58e4b12a103$export$8dac938d775a885c).WWOOFER_INITIATED,
                label: 'Pending (WWOOFer Request)'
            }
        ] : [],
        {
            color: (0, $51a1d58e4b12a103$export$764fad7f3e305206)[(0, $51a1d58e4b12a103$export$d971c9d602083500).ACCEPTED],
            label: (0, $51a1d58e4b12a103$export$4429537025aeeb07)[(0, $51a1d58e4b12a103$export$d971c9d602083500).ACCEPTED]
        },
        {
            color: (0, $51a1d58e4b12a103$export$764fad7f3e305206)[(0, $51a1d58e4b12a103$export$d971c9d602083500).IN_PROGRESS],
            label: (0, $51a1d58e4b12a103$export$4429537025aeeb07)[(0, $51a1d58e4b12a103$export$d971c9d602083500).IN_PROGRESS]
        },
        {
            color: (0, $51a1d58e4b12a103$export$764fad7f3e305206)[(0, $51a1d58e4b12a103$export$d971c9d602083500).COMPLETED],
            label: (0, $51a1d58e4b12a103$export$4429537025aeeb07)[(0, $51a1d58e4b12a103$export$d971c9d602083500).COMPLETED]
        },
        {
            color: (0, $51a1d58e4b12a103$export$764fad7f3e305206)[(0, $51a1d58e4b12a103$export$d971c9d602083500).CANCELLED],
            label: (0, $51a1d58e4b12a103$export$4429537025aeeb07)[(0, $51a1d58e4b12a103$export$d971c9d602083500).CANCELLED]
        }
    ];
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "calendar-legend",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "legend-items",
                children: [
                    legendItems.map((item, index)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                            className: "legend-item",
                            children: [
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                    className: "legend-color",
                                    style: {
                                        backgroundColor: item.color
                                    }
                                }),
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                    className: "legend-label",
                                    children: item.label
                                })
                            ]
                        }, index)),
                    unavailableDatesEnabled && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "legend-item",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                                className: "legend-color legend-color--unavailable",
                                style: {
                                    backgroundColor: '#ff000033',
                                    border: '1px solid #ff000066'
                                }
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                                className: "legend-label",
                                children: "Unavailable"
                            })
                        ]
                    })
                ]
            }),
            unavailableDatesEnabled && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                className: "calendar-legend__unavailability-hint",
                children: "To mark dates as unavailable, click and drag across the days you want to block. Click an existing unavailable period to remove it."
            })
        ]
    });
};
var $4968431f639f2516$export$2e2bcd8739ae039 = $4968431f639f2516$var$CalendarLegend;



parcelRequire("1G08a");
const $21eb0e5ed4d9941c$var$LoadingSpinner = ({ message: message = 'Loading...' })=>{
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "loading",
        children: message
    });
};
var $21eb0e5ed4d9941c$export$2e2bcd8739ae039 = $21eb0e5ed4d9941c$var$LoadingSpinner;


const $e8272dd4e4d207a7$var$wwooferInitiatedEnabled = window.wwoofBooking?.settings?.wwooferInitiatedEnabled || false;
const $e8272dd4e4d207a7$var$BookingList = ({ bookings: bookings, loading: loading, actionLoading: actionLoading, onEditDates: onEditDates, onCancel: onCancel, onAccept: onAccept, currentUserId: currentUserId })=>{
    if (loading) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $21eb0e5ed4d9941c$export$2e2bcd8739ae039), {
        message: "Loading bookings..."
    });
    if (bookings.length === 0) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $21eb0e5ed4d9941c$export$2e2bcd8739ae039), {
        message: "No bookings found."
    });
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)((0, $ee14841e48c228d7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $4968431f639f2516$export$2e2bcd8739ae039), {
                wwooferInitiatedEnabled: $e8272dd4e4d207a7$var$wwooferInitiatedEnabled
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                className: "bookings-list",
                children: bookings.map((booking)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $62b5f4e2048cb0a2$export$2e2bcd8739ae039), {
                        booking: booking,
                        actionLoading: actionLoading,
                        onEditDates: onEditDates,
                        onCancel: onCancel,
                        onAccept: onAccept,
                        currentUserId: currentUserId
                    }, booking.id))
            })
        ]
    });
};
var $e8272dd4e4d207a7$export$2e2bcd8739ae039 = $e8272dd4e4d207a7$var$BookingList;




var $1G08a = parcelRequire("1G08a");

var $1G08a = parcelRequire("1G08a");
var $c329b3b3780c47a8$var$n, $c329b3b3780c47a8$export$41c562ebe57d11e2, $c329b3b3780c47a8$var$u, $c329b3b3780c47a8$export$a8257692ac88316c, $c329b3b3780c47a8$var$t, $c329b3b3780c47a8$var$r, $c329b3b3780c47a8$var$o, $c329b3b3780c47a8$var$f, $c329b3b3780c47a8$var$e, $c329b3b3780c47a8$var$c = {}, $c329b3b3780c47a8$var$s = [], $c329b3b3780c47a8$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $c329b3b3780c47a8$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $c329b3b3780c47a8$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $c329b3b3780c47a8$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $c329b3b3780c47a8$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $c329b3b3780c47a8$var$p(l, f, t, r, null);
}
function $c329b3b3780c47a8$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$c329b3b3780c47a8$var$u : o
    };
    return null == o && null != $c329b3b3780c47a8$export$41c562ebe57d11e2.vnode && $c329b3b3780c47a8$export$41c562ebe57d11e2.vnode(f), f;
}
function $c329b3b3780c47a8$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $c329b3b3780c47a8$export$ffb0004e005737fa(n) {
    return n.children;
}
function $c329b3b3780c47a8$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $c329b3b3780c47a8$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $c329b3b3780c47a8$var$g(n, r, l[r], u[r], i);
}
function $c329b3b3780c47a8$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $c329b3b3780c47a8$var$a.test(l) ? u : u + "px";
}
function $c329b3b3780c47a8$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $c329b3b3780c47a8$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $c329b3b3780c47a8$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $c329b3b3780c47a8$var$w : $c329b3b3780c47a8$var$m, r) : n.removeEventListener(l, r ? $c329b3b3780c47a8$var$w : $c329b3b3780c47a8$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $c329b3b3780c47a8$var$m(n) {
    $c329b3b3780c47a8$var$t = !0;
    try {
        return this.l[n.type + !1]($c329b3b3780c47a8$export$41c562ebe57d11e2.event ? $c329b3b3780c47a8$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $c329b3b3780c47a8$var$t = !1;
    }
}
function $c329b3b3780c47a8$var$w(n) {
    $c329b3b3780c47a8$var$t = !0;
    try {
        return this.l[n.type + !0]($c329b3b3780c47a8$export$41c562ebe57d11e2.event ? $c329b3b3780c47a8$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $c329b3b3780c47a8$var$t = !1;
    }
}
function $c329b3b3780c47a8$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $c329b3b3780c47a8$var$A(n, l) {
    if (null == l) return n.__ ? $c329b3b3780c47a8$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $c329b3b3780c47a8$var$A(n) : null;
}
function $c329b3b3780c47a8$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $c329b3b3780c47a8$var$P(n);
    }
}
function $c329b3b3780c47a8$var$C(n) {
    $c329b3b3780c47a8$var$t ? setTimeout(n) : $c329b3b3780c47a8$var$f(n);
}
function $c329b3b3780c47a8$var$T(n) {
    (!n.__d && (n.__d = !0) && $c329b3b3780c47a8$var$r.push(n) && !$c329b3b3780c47a8$var$$.__r++ || $c329b3b3780c47a8$var$o !== $c329b3b3780c47a8$export$41c562ebe57d11e2.debounceRendering) && (($c329b3b3780c47a8$var$o = $c329b3b3780c47a8$export$41c562ebe57d11e2.debounceRendering) || $c329b3b3780c47a8$var$C)($c329b3b3780c47a8$var$$);
}
function $c329b3b3780c47a8$var$$() {
    var n, l, u, i, t, o, f, e;
    for($c329b3b3780c47a8$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $c329b3b3780c47a8$var$r.shift();)n.__d && (l = $c329b3b3780c47a8$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $c329b3b3780c47a8$var$h({}, o)).__v = o.__v + 1, $c329b3b3780c47a8$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $c329b3b3780c47a8$var$A(o) : f, o.__h), $c329b3b3780c47a8$var$N(i, o), o.__e != f && $c329b3b3780c47a8$var$P(o)), $c329b3b3780c47a8$var$r.length > l && $c329b3b3780c47a8$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $c329b3b3780c47a8$var$$.__r = 0;
}
function $c329b3b3780c47a8$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $c329b3b3780c47a8$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $c329b3b3780c47a8$var$p(null, d, null, null, d) : Array.isArray(d) ? $c329b3b3780c47a8$var$p($c329b3b3780c47a8$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $c329b3b3780c47a8$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $c329b3b3780c47a8$var$M(n, d, y = y || $c329b3b3780c47a8$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $c329b3b3780c47a8$var$I(d, e, n) : e = $c329b3b3780c47a8$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $c329b3b3780c47a8$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $c329b3b3780c47a8$var$L(i).nextSibling), $c329b3b3780c47a8$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$c329b3b3780c47a8$var$S(g[h], g[++h], g[++h]);
}
function $c329b3b3780c47a8$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $c329b3b3780c47a8$var$I(i, l, u) : $c329b3b3780c47a8$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $c329b3b3780c47a8$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $c329b3b3780c47a8$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $c329b3b3780c47a8$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $c329b3b3780c47a8$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $c329b3b3780c47a8$var$L(u))) return i;
    }
    return null;
}
function $c329b3b3780c47a8$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $c329b3b3780c47a8$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $c329b3b3780c47a8$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $c329b3b3780c47a8$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $c329b3b3780c47a8$var$h({}, a.__s)), $c329b3b3780c47a8$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $c329b3b3780c47a8$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $c329b3b3780c47a8$var$h($c329b3b3780c47a8$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $c329b3b3780c47a8$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $c329b3b3780c47a8$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $c329b3b3780c47a8$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $c329b3b3780c47a8$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $c329b3b3780c47a8$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $c329b3b3780c47a8$var$N(n, u) {
    $c329b3b3780c47a8$export$41c562ebe57d11e2.__c && $c329b3b3780c47a8$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $c329b3b3780c47a8$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $c329b3b3780c47a8$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $c329b3b3780c47a8$var$n.call(l.childNodes), a = (y = i.props || $c329b3b3780c47a8$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($c329b3b3780c47a8$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, $c329b3b3780c47a8$var$H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $c329b3b3780c47a8$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $c329b3b3780c47a8$var$v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $c329b3b3780c47a8$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $c329b3b3780c47a8$var$g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $c329b3b3780c47a8$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $c329b3b3780c47a8$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $c329b3b3780c47a8$var$q(n, u, i) {
    var t, r;
    if ($c329b3b3780c47a8$export$41c562ebe57d11e2.unmount && $c329b3b3780c47a8$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $c329b3b3780c47a8$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $c329b3b3780c47a8$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $c329b3b3780c47a8$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $c329b3b3780c47a8$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $c329b3b3780c47a8$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $c329b3b3780c47a8$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $c329b3b3780c47a8$export$41c562ebe57d11e2.__ && $c329b3b3780c47a8$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $c329b3b3780c47a8$var$M(i, u = (!r && t || i).__k = $c329b3b3780c47a8$export$c8a8987d4410bf2d($c329b3b3780c47a8$export$ffb0004e005737fa, null, [
        u
    ]), o || $c329b3b3780c47a8$var$c, $c329b3b3780c47a8$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $c329b3b3780c47a8$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $c329b3b3780c47a8$var$N(f, u);
}
function $c329b3b3780c47a8$export$fa8d919ba61d84db(n, l) {
    $c329b3b3780c47a8$export$b3890eb0ae9dca99(n, l, $c329b3b3780c47a8$export$fa8d919ba61d84db);
}
function $c329b3b3780c47a8$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $c329b3b3780c47a8$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $c329b3b3780c47a8$var$n.call(arguments, 2) : i), $c329b3b3780c47a8$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $c329b3b3780c47a8$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $c329b3b3780c47a8$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $c329b3b3780c47a8$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$c329b3b3780c47a8$var$n = $c329b3b3780c47a8$var$s.slice, $c329b3b3780c47a8$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $c329b3b3780c47a8$var$u = 0, $c329b3b3780c47a8$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $c329b3b3780c47a8$var$t = !1, $c329b3b3780c47a8$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $c329b3b3780c47a8$var$h({}, this.state), "function" == typeof n && (n = n($c329b3b3780c47a8$var$h({}, u), this.props)), n && $c329b3b3780c47a8$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $c329b3b3780c47a8$var$T(this));
}, $c329b3b3780c47a8$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $c329b3b3780c47a8$var$T(this));
}, $c329b3b3780c47a8$export$16fa2f45be04daa8.prototype.render = $c329b3b3780c47a8$export$ffb0004e005737fa, $c329b3b3780c47a8$var$r = [], $c329b3b3780c47a8$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $c329b3b3780c47a8$var$$.__r = 0, $c329b3b3780c47a8$var$e = 0;




var $cb4751afea0363b4$var$t, $cb4751afea0363b4$var$r, $cb4751afea0363b4$var$u, $cb4751afea0363b4$var$i, $cb4751afea0363b4$var$o = 0, $cb4751afea0363b4$var$f = [], $cb4751afea0363b4$var$c = [], $cb4751afea0363b4$var$e = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__b, $cb4751afea0363b4$var$a = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__r, $cb4751afea0363b4$var$v = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).diffed, $cb4751afea0363b4$var$l = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__c, $cb4751afea0363b4$var$m = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).unmount;
function $cb4751afea0363b4$var$d(t, u) {
    (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__h && (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__h($cb4751afea0363b4$var$r, t, $cb4751afea0363b4$var$o || u), $cb4751afea0363b4$var$o = 0;
    var i = $cb4751afea0363b4$var$r.__H || ($cb4751afea0363b4$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $cb4751afea0363b4$var$c
    }), i.__[t];
}
function $cb4751afea0363b4$export$60241385465d0a34(n) {
    return $cb4751afea0363b4$var$o = 1, $cb4751afea0363b4$export$13e3392192263954($cb4751afea0363b4$var$B, n);
}
function $cb4751afea0363b4$export$13e3392192263954(n, u, i) {
    var o = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $cb4751afea0363b4$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $cb4751afea0363b4$var$r, !$cb4751afea0363b4$var$r.u)) {
        $cb4751afea0363b4$var$r.u = !0;
        var f = $cb4751afea0363b4$var$r.shouldComponentUpdate;
        $cb4751afea0363b4$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $cb4751afea0363b4$export$6d9c69b0de29b591(u, i) {
    var o = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 3);
    !(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__s && $cb4751afea0363b4$var$z(o.__H, i) && (o.__ = u, o.i = i, $cb4751afea0363b4$var$r.__H.__h.push(o));
}
function $cb4751afea0363b4$export$e5c5a5f917a5871c(u, i) {
    var o = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 4);
    !(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__s && $cb4751afea0363b4$var$z(o.__H, i) && (o.__ = u, o.i = i, $cb4751afea0363b4$var$r.__h.push(o));
}
function $cb4751afea0363b4$export$b8f5890fc79d6aca(n) {
    return $cb4751afea0363b4$var$o = 5, $cb4751afea0363b4$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $cb4751afea0363b4$export$d5a552a76deda3c2(n, t, r) {
    $cb4751afea0363b4$var$o = 6, $cb4751afea0363b4$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $cb4751afea0363b4$export$1538c33de8887b59(n, r) {
    var u = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 7);
    return $cb4751afea0363b4$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $cb4751afea0363b4$export$35808ee640e87ca7(n, t) {
    return $cb4751afea0363b4$var$o = 8, $cb4751afea0363b4$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $cb4751afea0363b4$export$fae74005e78b1a27(n) {
    var u = $cb4751afea0363b4$var$r.context[n.__c], i = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($cb4751afea0363b4$var$r)), u.props.value) : n.__;
}
function $cb4751afea0363b4$export$dc8fbce3eb94dc1e(t, r) {
    (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).useDebugValue && (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $cb4751afea0363b4$export$c052f6604b7d51fe(n) {
    var u = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 10), i = $cb4751afea0363b4$export$60241385465d0a34();
    return u.__ = n, $cb4751afea0363b4$var$r.componentDidCatch || ($cb4751afea0363b4$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $cb4751afea0363b4$export$f680877a34711e37() {
    var n = $cb4751afea0363b4$var$d($cb4751afea0363b4$var$t++, 11);
    if (!n.__) {
        for(var u = $cb4751afea0363b4$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $cb4751afea0363b4$var$b() {
    for(var t; t = $cb4751afea0363b4$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($cb4751afea0363b4$var$k), t.__H.__h.forEach($cb4751afea0363b4$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__b = function(n) {
    $cb4751afea0363b4$var$r = null, $cb4751afea0363b4$var$e && $cb4751afea0363b4$var$e(n);
}, (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__r = function(n) {
    $cb4751afea0363b4$var$a && $cb4751afea0363b4$var$a(n), $cb4751afea0363b4$var$t = 0;
    var i = ($cb4751afea0363b4$var$r = n.__c).__H;
    i && ($cb4751afea0363b4$var$u === $cb4751afea0363b4$var$r ? (i.__h = [], $cb4751afea0363b4$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $cb4751afea0363b4$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($cb4751afea0363b4$var$k), i.__h.forEach($cb4751afea0363b4$var$w), i.__h = [])), $cb4751afea0363b4$var$u = $cb4751afea0363b4$var$r;
}, (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).diffed = function(t) {
    $cb4751afea0363b4$var$v && $cb4751afea0363b4$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $cb4751afea0363b4$var$f.push(o) && $cb4751afea0363b4$var$i === (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).requestAnimationFrame || (($cb4751afea0363b4$var$i = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).requestAnimationFrame) || $cb4751afea0363b4$var$j)($cb4751afea0363b4$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $cb4751afea0363b4$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $cb4751afea0363b4$var$c;
    })), $cb4751afea0363b4$var$u = $cb4751afea0363b4$var$r = null;
}, (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($cb4751afea0363b4$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $cb4751afea0363b4$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $cb4751afea0363b4$var$l && $cb4751afea0363b4$var$l(t, r);
}, (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).unmount = function(t) {
    $cb4751afea0363b4$var$m && $cb4751afea0363b4$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $cb4751afea0363b4$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $cb4751afea0363b4$var$g = "function" == typeof requestAnimationFrame;
function $cb4751afea0363b4$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $cb4751afea0363b4$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $cb4751afea0363b4$var$g && (t = requestAnimationFrame(r));
}
function $cb4751afea0363b4$var$k(n) {
    var t = $cb4751afea0363b4$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $cb4751afea0363b4$var$r = t;
}
function $cb4751afea0363b4$var$w(n) {
    var t = $cb4751afea0363b4$var$r;
    n.__c = n.__(), $cb4751afea0363b4$var$r = t;
}
function $cb4751afea0363b4$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $cb4751afea0363b4$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $aac9273d3c8f822f$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $aac9273d3c8f822f$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $aac9273d3c8f822f$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $aac9273d3c8f822f$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $aac9273d3c8f822f$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $aac9273d3c8f822f$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($aac9273d3c8f822f$export$221d75b3f55bb0bd.prototype = new (0, $c329b3b3780c47a8$export$16fa2f45be04daa8)).isPureReactComponent = !0, $aac9273d3c8f822f$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $aac9273d3c8f822f$var$C(this.props, n) || $aac9273d3c8f822f$var$C(this.state, t);
};
var $aac9273d3c8f822f$var$x = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__b;
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $aac9273d3c8f822f$var$x && $aac9273d3c8f822f$var$x(n);
};
var $aac9273d3c8f822f$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $aac9273d3c8f822f$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $aac9273d3c8f822f$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $aac9273d3c8f822f$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $aac9273d3c8f822f$var$A = function(n, t) {
    return null == n ? null : (0, $c329b3b3780c47a8$export$47e4c5b300681277)((0, $c329b3b3780c47a8$export$47e4c5b300681277)(n).map(t));
}, $aac9273d3c8f822f$export$dca3b0875bd9a954 = {
    map: $aac9273d3c8f822f$var$A,
    forEach: $aac9273d3c8f822f$var$A,
    count: function(n) {
        return n ? (0, $c329b3b3780c47a8$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $c329b3b3780c47a8$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $c329b3b3780c47a8$export$47e4c5b300681277)
}, $aac9273d3c8f822f$var$T = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__e;
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $aac9273d3c8f822f$var$T(n, t, e, r);
};
var $aac9273d3c8f822f$var$I = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).unmount;
function $aac9273d3c8f822f$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $aac9273d3c8f822f$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $aac9273d3c8f822f$var$L(n, t, e);
    })), n;
}
function $aac9273d3c8f822f$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $aac9273d3c8f822f$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $aac9273d3c8f822f$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $aac9273d3c8f822f$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $aac9273d3c8f822f$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $aac9273d3c8f822f$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $aac9273d3c8f822f$var$I && $aac9273d3c8f822f$var$I(n);
}, ($aac9273d3c8f822f$export$74bf444e3cd11ea5.prototype = new (0, $c329b3b3780c47a8$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $aac9273d3c8f822f$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $aac9273d3c8f822f$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $aac9273d3c8f822f$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $aac9273d3c8f822f$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $aac9273d3c8f822f$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__h = null), [
        (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $aac9273d3c8f822f$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $aac9273d3c8f822f$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $aac9273d3c8f822f$var$$(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $c329b3b3780c47a8$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $c329b3b3780c47a8$export$b3890eb0ae9dca99)((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($aac9273d3c8f822f$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $aac9273d3c8f822f$export$d39a5bbd09211389(n, e) {
    var r = (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($aac9273d3c8f822f$var$$, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($aac9273d3c8f822f$export$998bcd577473dd93.prototype = new (0, $c329b3b3780c47a8$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $aac9273d3c8f822f$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $aac9273d3c8f822f$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $aac9273d3c8f822f$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $c329b3b3780c47a8$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $aac9273d3c8f822f$export$998bcd577473dd93.prototype.componentDidUpdate = $aac9273d3c8f822f$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $aac9273d3c8f822f$var$W(n, e, t);
    });
};
var $aac9273d3c8f822f$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $aac9273d3c8f822f$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $aac9273d3c8f822f$var$H = "undefined" != typeof document, $aac9273d3c8f822f$var$Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $aac9273d3c8f822f$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $c329b3b3780c47a8$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $aac9273d3c8f822f$export$fa8d919ba61d84db(n, t, e) {
    return (0, $c329b3b3780c47a8$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $c329b3b3780c47a8$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $c329b3b3780c47a8$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $aac9273d3c8f822f$var$G = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).event;
function $aac9273d3c8f822f$var$J() {}
function $aac9273d3c8f822f$var$K() {
    return this.cancelBubble;
}
function $aac9273d3c8f822f$var$Q() {
    return this.defaultPrevented;
}
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).event = function(n) {
    return $aac9273d3c8f822f$var$G && (n = $aac9273d3c8f822f$var$G(n)), n.persist = $aac9273d3c8f822f$var$J, n.isPropagationStopped = $aac9273d3c8f822f$var$K, n.isDefaultPrevented = $aac9273d3c8f822f$var$Q, n.nativeEvent = n;
};
var $aac9273d3c8f822f$var$X, $aac9273d3c8f822f$var$nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $aac9273d3c8f822f$var$tn = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).vnode;
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            $aac9273d3c8f822f$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$aac9273d3c8f822f$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $aac9273d3c8f822f$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $c329b3b3780c47a8$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, $c329b3b3780c47a8$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && ($aac9273d3c8f822f$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $aac9273d3c8f822f$var$nn));
    }
    n.$$typeof = $aac9273d3c8f822f$var$z, $aac9273d3c8f822f$var$tn && $aac9273d3c8f822f$var$tn(n);
};
var $aac9273d3c8f822f$var$en = (0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__r;
(0, $c329b3b3780c47a8$export$41c562ebe57d11e2).__r = function(n) {
    $aac9273d3c8f822f$var$en && $aac9273d3c8f822f$var$en(n), $aac9273d3c8f822f$var$X = n.__c;
};
var $aac9273d3c8f822f$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $aac9273d3c8f822f$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $aac9273d3c8f822f$export$83d89fbfd8236492 = "17.0.2";
function $aac9273d3c8f822f$export$d38cd72104c1f0e9(n) {
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d).bind(null, n);
}
function $aac9273d3c8f822f$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $aac9273d3c8f822f$var$z;
}
function $aac9273d3c8f822f$export$e530037191fcd5d7(n) {
    return $aac9273d3c8f822f$export$a8257692ac88316c(n) ? (0, $c329b3b3780c47a8$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $aac9273d3c8f822f$export$502457920280e6be(n) {
    return !!n.__k && ((0, $c329b3b3780c47a8$export$b3890eb0ae9dca99)(null, n), !0);
}
function $aac9273d3c8f822f$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $aac9273d3c8f822f$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $aac9273d3c8f822f$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $aac9273d3c8f822f$export$5f8d39834fd61797 = (0, $c329b3b3780c47a8$export$ffb0004e005737fa);
function $aac9273d3c8f822f$export$7568632d0d33d16d(n) {
    n();
}
function $aac9273d3c8f822f$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $aac9273d3c8f822f$export$7b286972b8d8ccbf() {
    return [
        !1,
        $aac9273d3c8f822f$export$7568632d0d33d16d
    ];
}
var $aac9273d3c8f822f$export$aaabe4eda9ed9969 = (0, $cb4751afea0363b4$export$e5c5a5f917a5871c);
function $aac9273d3c8f822f$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $cb4751afea0363b4$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $cb4751afea0363b4$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $aac9273d3c8f822f$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $cb4751afea0363b4$export$6d9c69b0de29b591)(function() {
        return $aac9273d3c8f822f$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $aac9273d3c8f822f$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $aac9273d3c8f822f$export$2e2bcd8739ae039 = {
    useState: (0, $cb4751afea0363b4$export$60241385465d0a34),
    useId: (0, $cb4751afea0363b4$export$f680877a34711e37),
    useReducer: (0, $cb4751afea0363b4$export$13e3392192263954),
    useEffect: (0, $cb4751afea0363b4$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $cb4751afea0363b4$export$e5c5a5f917a5871c),
    useInsertionEffect: $aac9273d3c8f822f$export$aaabe4eda9ed9969,
    useTransition: $aac9273d3c8f822f$export$7b286972b8d8ccbf,
    useDeferredValue: $aac9273d3c8f822f$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $aac9273d3c8f822f$export$306c0aa65ff9ec16,
    startTransition: $aac9273d3c8f822f$export$7568632d0d33d16d,
    useRef: (0, $cb4751afea0363b4$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $cb4751afea0363b4$export$d5a552a76deda3c2),
    useMemo: (0, $cb4751afea0363b4$export$1538c33de8887b59),
    useCallback: (0, $cb4751afea0363b4$export$35808ee640e87ca7),
    useContext: (0, $cb4751afea0363b4$export$fae74005e78b1a27),
    useDebugValue: (0, $cb4751afea0363b4$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $aac9273d3c8f822f$export$dca3b0875bd9a954,
    render: $aac9273d3c8f822f$export$b3890eb0ae9dca99,
    hydrate: $aac9273d3c8f822f$export$fa8d919ba61d84db,
    unmountComponentAtNode: $aac9273d3c8f822f$export$502457920280e6be,
    createPortal: $aac9273d3c8f822f$export$d39a5bbd09211389,
    createElement: (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d),
    createContext: (0, $c329b3b3780c47a8$export$fd42f52fd3ae1109),
    createFactory: $aac9273d3c8f822f$export$d38cd72104c1f0e9,
    cloneElement: $aac9273d3c8f822f$export$e530037191fcd5d7,
    createRef: (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43),
    Fragment: (0, $c329b3b3780c47a8$export$ffb0004e005737fa),
    isValidElement: $aac9273d3c8f822f$export$a8257692ac88316c,
    findDOMNode: $aac9273d3c8f822f$export$466bfc07425424d5,
    Component: (0, $c329b3b3780c47a8$export$16fa2f45be04daa8),
    PureComponent: $aac9273d3c8f822f$export$221d75b3f55bb0bd,
    memo: $aac9273d3c8f822f$export$7c73462e0d25e514,
    forwardRef: $aac9273d3c8f822f$export$257a8862b851cb5b,
    flushSync: $aac9273d3c8f822f$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $aac9273d3c8f822f$export$c78a37762a8d58e1,
    StrictMode: $aac9273d3c8f822f$export$5f8d39834fd61797,
    Suspense: $aac9273d3c8f822f$export$74bf444e3cd11ea5,
    SuspenseList: $aac9273d3c8f822f$export$998bcd577473dd93,
    lazy: $aac9273d3c8f822f$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $aac9273d3c8f822f$export$ae55be85d98224ed
};


const $806c23c1e016259b$var$styleTexts = [];
const $806c23c1e016259b$var$styleEls = new Map();
function $806c23c1e016259b$export$e9316ff9106cdb75(styleText) {
    $806c23c1e016259b$var$styleTexts.push(styleText);
    $806c23c1e016259b$var$styleEls.forEach((styleEl)=>{
        $806c23c1e016259b$var$appendStylesTo(styleEl, styleText);
    });
}
function $806c23c1e016259b$export$555508cbc6add439(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $806c23c1e016259b$var$registerStylesRoot(el.getRootNode());
}
function $806c23c1e016259b$var$registerStylesRoot(rootNode) {
    let styleEl = $806c23c1e016259b$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector('style[data-fullcalendar]');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.setAttribute('data-fullcalendar', '');
            const nonce = $806c23c1e016259b$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $806c23c1e016259b$var$styleEls.set(rootNode, styleEl);
        $806c23c1e016259b$var$hydrateStylesRoot(styleEl);
    }
}
function $806c23c1e016259b$var$hydrateStylesRoot(styleEl) {
    for (const styleText of $806c23c1e016259b$var$styleTexts)$806c23c1e016259b$var$appendStylesTo(styleEl, styleText);
}
function $806c23c1e016259b$var$appendStylesTo(styleEl, styleText) {
    const { sheet: sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split('}').forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + '}', ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let $806c23c1e016259b$var$queriedNonceValue;
function $806c23c1e016259b$var$getNonceValue() {
    if ($806c23c1e016259b$var$queriedNonceValue === undefined) $806c23c1e016259b$var$queriedNonceValue = $806c23c1e016259b$var$queryNonceValue();
    return $806c23c1e016259b$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $806c23c1e016259b$var$queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
    const elWithNonce = document.querySelector('script[nonce]');
    if (elWithNonce) return elWithNonce.nonce || '';
    return '';
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== 'undefined') $806c23c1e016259b$var$registerStylesRoot(document);
var $806c23c1e016259b$var$css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
$806c23c1e016259b$export$e9316ff9106cdb75($806c23c1e016259b$var$css_248z);
class $806c23c1e016259b$export$96f57966bedc81b4 {
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = '') {
        let { pauseDepths: pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = '', force) {
        let { pauseDepths: pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
}
function $806c23c1e016259b$export$9f4f30ee63539e24(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$export$dc98b0b04f4c7758(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($806c23c1e016259b$export$c03999cb2f36933f(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $806c23c1e016259b$export$c03999cb2f36933f(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $806c23c1e016259b$export$23ebac1979863676(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $806c23c1e016259b$export$91477dc880baac21(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || $806c23c1e016259b$export$c03999cb2f36933f(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const $806c23c1e016259b$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $806c23c1e016259b$export$faec65b429be379(el, props) {
    for(let propName in props)$806c23c1e016259b$export$2219238a014317b0(el, propName, props[propName]);
}
function $806c23c1e016259b$export$2219238a014317b0(el, name, val) {
    if (val == null) el.style[name] = '';
    else if (typeof val === 'number' && $806c23c1e016259b$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $806c23c1e016259b$export$2ed0fc6709e59212(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let $806c23c1e016259b$var$guid$1 = 0;
function $806c23c1e016259b$export$6559d589eb85fbb6() {
    $806c23c1e016259b$var$guid$1 += 1;
    return 'fc-dom-' + $806c23c1e016259b$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $806c23c1e016259b$export$fef3dfd9bad05307(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$var$buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = $806c23c1e016259b$export$dc98b0b04f4c7758(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $806c23c1e016259b$export$3d8c2f653ac9d0b9(container, eventType, selector, handler) {
    let attachedHandler = $806c23c1e016259b$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $806c23c1e016259b$export$34aec0b863436764(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return $806c23c1e016259b$export$3d8c2f653ac9d0b9(container, 'mouseover', selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const $806c23c1e016259b$var$transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function $806c23c1e016259b$export$8c78c7c36408ea29(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        $806c23c1e016259b$var$transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    $806c23c1e016259b$var$transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $806c23c1e016259b$var$createAriaKeyboardAttrs(handler));
}
function $806c23c1e016259b$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let $806c23c1e016259b$var$guidNumber = 0;
function $806c23c1e016259b$export$39b482c5e57630a8() {
    $806c23c1e016259b$var$guidNumber += 1;
    return String($806c23c1e016259b$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $806c23c1e016259b$export$d66dc83d8cfc8dd() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function $806c23c1e016259b$export$1fbe638ecf81657e() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $806c23c1e016259b$export$2f6ca3d3b1f80bf5(el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.addEventListener('selectstart', $806c23c1e016259b$export$fef3dfd9bad05307);
}
function $806c23c1e016259b$export$8a5498727ef6be21(el) {
    el.style.userSelect = '';
    el.style.webkitUserSelect = '';
    el.removeEventListener('selectstart', $806c23c1e016259b$export$fef3dfd9bad05307);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $806c23c1e016259b$export$d24c54395ce0c509(el) {
    el.addEventListener('contextmenu', $806c23c1e016259b$export$fef3dfd9bad05307);
}
function $806c23c1e016259b$export$6554612db691658e(el) {
    el.removeEventListener('contextmenu', $806c23c1e016259b$export$fef3dfd9bad05307);
}
function $806c23c1e016259b$export$1a82df3d29112e01(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
    else if (typeof input === 'function') tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === 'function') specs.push({
            func: token
        });
    }
    return specs;
}
function $806c23c1e016259b$export$306ddfe3a8403e2(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $806c23c1e016259b$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $806c23c1e016259b$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $806c23c1e016259b$export$7a38258bbe170828(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $806c23c1e016259b$export$7a38258bbe170828(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $806c23c1e016259b$export$21579262ef46735b(val, len) {
    let s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function $806c23c1e016259b$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === 'function') return formatter(...args);
    if (typeof formatter === 'string') return args.reduce((str, arg, index)=>str.replace('$' + index, arg || ''), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $806c23c1e016259b$export$493d36ec626b6698(a, b) {
    return a - b;
}
function $806c23c1e016259b$export$ab83b03e4111b1d0(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $806c23c1e016259b$var$computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    let contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const $806c23c1e016259b$var$INTERNAL_UNITS = [
    'years',
    'months',
    'days',
    'milliseconds'
];
const $806c23c1e016259b$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $806c23c1e016259b$export$4368d992c4eafac0(input, unit) {
    if (typeof input === 'string') return $806c23c1e016259b$var$parseString(input);
    if (typeof input === 'object' && input) return $806c23c1e016259b$var$parseObject(input);
    if (typeof input === 'number') return $806c23c1e016259b$var$parseObject({
        [unit || 'milliseconds']: input
    });
    return null;
}
function $806c23c1e016259b$var$parseString(s) {
    let m = $806c23c1e016259b$var$PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $806c23c1e016259b$var$parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $806c23c1e016259b$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $806c23c1e016259b$export$a36fb7d24305ed9d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $806c23c1e016259b$export$acf3ba20e47771d(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $806c23c1e016259b$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $806c23c1e016259b$export$55ff3cc1821e8445(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $806c23c1e016259b$var$asRoughYears(dur) {
    return $806c23c1e016259b$var$asRoughDays(dur) / 365;
}
function $806c23c1e016259b$var$asRoughMonths(dur) {
    return $806c23c1e016259b$var$asRoughDays(dur) / 30;
}
function $806c23c1e016259b$var$asRoughDays(dur) {
    return $806c23c1e016259b$export$4b170465d7badfa1(dur) / 864e5;
}
function $806c23c1e016259b$export$847533e5bf524f5f(dur) {
    return $806c23c1e016259b$export$4b170465d7badfa1(dur) / 60000;
}
function $806c23c1e016259b$export$b169257caa88022a(dur) {
    return $806c23c1e016259b$export$4b170465d7badfa1(dur) / 1000;
}
function $806c23c1e016259b$export$4b170465d7badfa1(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $806c23c1e016259b$export$479ac0420f53ed26(numerator, denominator) {
    let res = null;
    for(let i = 0; i < $806c23c1e016259b$var$INTERNAL_UNITS.length; i += 1){
        let unit = $806c23c1e016259b$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!$806c23c1e016259b$export$ab83b03e4111b1d0(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $806c23c1e016259b$export$db3b6bfb95261072(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: 'millisecond',
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: 'second',
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: 'minute',
            value: ms / 60000
        };
        if (ms) return {
            unit: 'hour',
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: 'week',
            value: dur.days / 7
        };
        return {
            unit: 'day',
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: 'month',
        value: dur.months
    };
    if (dur.years) return {
        unit: 'year',
        value: dur.years
    };
    return {
        unit: 'millisecond',
        value: 0
    };
}
// TODO: new util arrayify?
function $806c23c1e016259b$export$3d12bd131bb975d1(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $806c23c1e016259b$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const $806c23c1e016259b$var$DAY_IDS = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat'
];
// Adding
function $806c23c1e016259b$export$151db275011178c4(m, n) {
    let a = $806c23c1e016259b$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $806c23c1e016259b$var$arrayToUtcDate(a);
}
function $806c23c1e016259b$export$625550452a3fa3ec(m, n) {
    let a = $806c23c1e016259b$var$dateToUtcArray(m);
    a[2] += n;
    return $806c23c1e016259b$var$arrayToUtcDate(a);
}
function $806c23c1e016259b$export$51b138e5a065c2bb(m, n) {
    let a = $806c23c1e016259b$var$dateToUtcArray(m);
    a[6] += n;
    return $806c23c1e016259b$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $806c23c1e016259b$export$136fd86de524d3c2(m0, m1) {
    return $806c23c1e016259b$export$b4d5ecaefe2b27f3(m0, m1) / 7;
}
function $806c23c1e016259b$export$b4d5ecaefe2b27f3(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $806c23c1e016259b$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $806c23c1e016259b$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $806c23c1e016259b$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $806c23c1e016259b$export$62d08d6fa708df47(m0, m1) {
    let m0day = $806c23c1e016259b$export$9e5f44173e64f162(m0);
    let m1day = $806c23c1e016259b$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($806c23c1e016259b$export$b4d5ecaefe2b27f3(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $806c23c1e016259b$export$31e67cf12fc9668(m0, m1) {
    let d = $806c23c1e016259b$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $806c23c1e016259b$export$4a5767248b18ef41(m0, m1) {
    if ($806c23c1e016259b$var$timeAsMs(m0) === $806c23c1e016259b$var$timeAsMs(m1)) return Math.round($806c23c1e016259b$export$b4d5ecaefe2b27f3(m0, m1));
    return null;
}
// Start-Of
function $806c23c1e016259b$export$9e5f44173e64f162(m) {
    return $806c23c1e016259b$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $806c23c1e016259b$var$startOfHour(m) {
    return $806c23c1e016259b$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $806c23c1e016259b$var$startOfMinute(m) {
    return $806c23c1e016259b$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $806c23c1e016259b$var$startOfSecond(m) {
    return $806c23c1e016259b$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $806c23c1e016259b$var$weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = $806c23c1e016259b$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $806c23c1e016259b$var$weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = $806c23c1e016259b$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $806c23c1e016259b$var$weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = $806c23c1e016259b$var$arrayToUtcDate([
        year,
        0,
        1 + $806c23c1e016259b$var$firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = $806c23c1e016259b$export$9e5f44173e64f162(marker);
    let days = Math.round($806c23c1e016259b$export$b4d5ecaefe2b27f3(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $806c23c1e016259b$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + $806c23c1e016259b$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $806c23c1e016259b$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $806c23c1e016259b$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $806c23c1e016259b$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $806c23c1e016259b$var$arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function $806c23c1e016259b$export$5521614468b862fb(m) {
    return !isNaN(m.valueOf());
}
function $806c23c1e016259b$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $806c23c1e016259b$export$f438b12253c2b499(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) s = s.replace('T00:00:00Z', '');
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace('Z', '');
        else if (timeZoneOffset !== 0) s = s.replace('Z', $806c23c1e016259b$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $806c23c1e016259b$export$56350196709588fc(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
function $806c23c1e016259b$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $806c23c1e016259b$export$4e222d082f82ee97(marker) {
    return $806c23c1e016259b$export$21579262ef46735b(marker.getUTCHours(), 2) + ':' + $806c23c1e016259b$export$21579262ef46735b(marker.getUTCMinutes(), 2) + ':' + $806c23c1e016259b$export$21579262ef46735b(marker.getUTCSeconds(), 2);
}
function $806c23c1e016259b$var$formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? '-' : '+';
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + $806c23c1e016259b$export$21579262ef46735b(hours, 2)}:${$806c23c1e016259b$export$21579262ef46735b(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${$806c23c1e016259b$export$21579262ef46735b(mins, 2)}` : ''}`;
}
function $806c23c1e016259b$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$806c23c1e016259b$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $806c23c1e016259b$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!$806c23c1e016259b$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $806c23c1e016259b$export$91c6e00c14e7e6fd(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$806c23c1e016259b$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $806c23c1e016259b$export$9d398bebfec1c039(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!$806c23c1e016259b$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const $806c23c1e016259b$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
const $806c23c1e016259b$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const $806c23c1e016259b$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const $806c23c1e016259b$var$COMMA_RE = /,/g; // we need re for globalness
const $806c23c1e016259b$var$MULTI_SPACE_RE = /\s+/g;
const $806c23c1e016259b$var$LTR_RE = /\u200e/g; // control character
const $806c23c1e016259b$var$UTC_RE = /UTC|GMT/;
class $806c23c1e016259b$var$NativeFormatter {
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(let name in formatSettings)if (name in $806c23c1e016259b$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            const severity = $806c23c1e016259b$var$EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min($806c23c1e016259b$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $806c23c1e016259b$var$STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min($806c23c1e016259b$var$STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = $806c23c1e016259b$export$df995fae86a55f06($806c23c1e016259b$var$buildFormattingFunc);
    }
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
        let diffSeverity = $806c23c1e016259b$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = $806c23c1e016259b$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = $806c23c1e016259b$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = $806c23c1e016259b$var$findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getSmallestUnit() {
        switch(this.smallestUnitNum){
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    }
}
function $806c23c1e016259b$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return (date)=>$806c23c1e016259b$var$formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$806c23c1e016259b$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return $806c23c1e016259b$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $806c23c1e016259b$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $806c23c1e016259b$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker: marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return $806c23c1e016259b$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $806c23c1e016259b$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
        if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $806c23c1e016259b$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($806c23c1e016259b$var$LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') s = $806c23c1e016259b$var$injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : $806c23c1e016259b$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($806c23c1e016259b$var$COMMA_RE, '').trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($806c23c1e016259b$var$MERIDIEM_RE, '').trim();
    else if (extendedSettings.meridiem === 'narrow') s = s.replace($806c23c1e016259b$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === 'short') s = s.replace($806c23c1e016259b$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === 'lowercase') s = s.replace($806c23c1e016259b$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace($806c23c1e016259b$var$MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function $806c23c1e016259b$var$injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace($806c23c1e016259b$var$UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function $806c23c1e016259b$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === 'long') parts.push(weekTextLong);
    else if (display === 'short' || display === 'narrow') parts.push(weekText);
    if (display === 'long' || display === 'short') parts.push(' ');
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') parts.reverse();
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $806c23c1e016259b$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($806c23c1e016259b$var$timeAsMs(d0) !== $806c23c1e016259b$var$timeAsMs(d1)) return 1;
    return 0;
}
function $806c23c1e016259b$var$computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in $806c23c1e016259b$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $806c23c1e016259b$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $806c23c1e016259b$var$findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $806c23c1e016259b$var$expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $806c23c1e016259b$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = $806c23c1e016259b$var$expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? $806c23c1e016259b$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class $806c23c1e016259b$var$CmdFormatter {
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $806c23c1e016259b$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $806c23c1e016259b$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
class $806c23c1e016259b$var$FuncFormatter {
    constructor(func){
        this.func = func;
    }
    format(date, context, betterDefaultSeparator) {
        return this.func($806c23c1e016259b$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func($806c23c1e016259b$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
function $806c23c1e016259b$export$d141bba7fdc215a3(input) {
    if (typeof input === 'object' && input) return new $806c23c1e016259b$var$NativeFormatter(input);
    if (typeof input === 'string') return new $806c23c1e016259b$var$CmdFormatter(input);
    if (typeof input === 'function') return new $806c23c1e016259b$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
const $806c23c1e016259b$export$61196ced6d74a310 = {
    navLinkDayClick: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    duration: $806c23c1e016259b$export$4368d992c4eafac0,
    bootstrapFontAwesome: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    buttonIcons: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    customButtons: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $806c23c1e016259b$export$4368d992c4eafac0,
    defaultTimedEventDuration: $806c23c1e016259b$export$4368d992c4eafac0,
    nextDayThreshold: $806c23c1e016259b$export$4368d992c4eafac0,
    scrollTime: $806c23c1e016259b$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $806c23c1e016259b$export$4368d992c4eafac0,
    slotMaxTime: $806c23c1e016259b$export$4368d992c4eafac0,
    dayPopoverFormat: $806c23c1e016259b$export$d141bba7fdc215a3,
    slotDuration: $806c23c1e016259b$export$4368d992c4eafac0,
    snapDuration: $806c23c1e016259b$export$4368d992c4eafac0,
    headerToolbar: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    footerToolbar: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $806c23c1e016259b$export$d141bba7fdc215a3,
    dayHeaderClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayCellContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    viewDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    locale: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventOrder: $806c23c1e016259b$export$1a82df3d29112e01,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    contentHeight: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $806c23c1e016259b$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    initialDate: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    now: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    viewHeight: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventConstraint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventAllow: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    selectConstraint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    selectOverlap: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    selectAllow: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $806c23c1e016259b$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    allDayContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $806c23c1e016259b$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $806c23c1e016259b$export$4368d992c4eafac0,
    hiddenDays: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    visibleRange: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    titleFormat: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    navLinkHint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $806c23c1e016259b$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const $806c23c1e016259b$export$f1e1789686576879 = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: 'long',
        day: 'numeric'
    }
};
// calendar listeners
// ------------------
const $806c23c1e016259b$export$3a1a48c8f6ef640e = {
    datesSet: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventsSet: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventAdd: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventChange: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventRemove: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    windowResize: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventClick: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    select: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    unselect: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    loading: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    _beforeprint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    _afterprint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    _noEventResize: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    _resize: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $806c23c1e016259b$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
const $806c23c1e016259b$export$a07804094c3ecf2d = {
    buttonText: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    buttonHints: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    views: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    plugins: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    initialEvents: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    events: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventSources: $806c23c1e016259b$export$7ccc53e8f1e7dfc5
};
const $806c23c1e016259b$export$c4ce752e73470fba = {
    headerToolbar: $806c23c1e016259b$var$isMaybeObjectsEqual,
    footerToolbar: $806c23c1e016259b$var$isMaybeObjectsEqual,
    buttonText: $806c23c1e016259b$var$isMaybeObjectsEqual,
    buttonHints: $806c23c1e016259b$var$isMaybeObjectsEqual,
    buttonIcons: $806c23c1e016259b$var$isMaybeObjectsEqual,
    dateIncrement: $806c23c1e016259b$var$isMaybeObjectsEqual,
    plugins: $806c23c1e016259b$var$isMaybeArraysEqual,
    events: $806c23c1e016259b$var$isMaybeArraysEqual,
    eventSources: $806c23c1e016259b$var$isMaybeArraysEqual,
    ['resources']: $806c23c1e016259b$var$isMaybeArraysEqual
};
function $806c23c1e016259b$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) return $806c23c1e016259b$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $806c23c1e016259b$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $806c23c1e016259b$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const $806c23c1e016259b$export$56c0d5a1e737357d = {
    type: String,
    component: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    content: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    didMount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    willUnmount: $806c23c1e016259b$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $806c23c1e016259b$export$3466f893ebf79586(optionSets) {
    return $806c23c1e016259b$export$953cecd6e717a553(optionSets, $806c23c1e016259b$export$c4ce752e73470fba);
}
function $806c23c1e016259b$export$ee7c8ad385a60b7b(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function $806c23c1e016259b$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
const { hasOwnProperty: $806c23c1e016259b$var$hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $806c23c1e016259b$export$953cecd6e717a553(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === $806c23c1e016259b$var$isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === 'object' && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $806c23c1e016259b$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function $806c23c1e016259b$export$dda1d9f60106f0e9(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $806c23c1e016259b$export$407448d2b89b1813(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $806c23c1e016259b$export$2d1720544b23b823(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $806c23c1e016259b$export$90a7f3efeed30595(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function $806c23c1e016259b$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if ($806c23c1e016259b$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if ($806c23c1e016259b$var$hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const $806c23c1e016259b$var$HANDLER_RE = /^on[A-Z]/;
function $806c23c1e016259b$var$isNonHandlerPropsEqual(obj0, obj1) {
    const keys = $806c23c1e016259b$var$getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!$806c23c1e016259b$var$HANDLER_RE.test(key)) return false;
    }
    return true;
}
function $806c23c1e016259b$var$getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if ($806c23c1e016259b$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if ($806c23c1e016259b$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function $806c23c1e016259b$export$b9a6b53f9be3734(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    for(let key in newProps){
        if (key in oldProps && $806c23c1e016259b$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $806c23c1e016259b$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $806c23c1e016259b$export$a05254e7c3aeba6e(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
let $806c23c1e016259b$var$calendarSystemClassMap = {};
function $806c23c1e016259b$var$registerCalendarSystem(name, theClass) {
    $806c23c1e016259b$var$calendarSystemClassMap[name] = theClass;
}
function $806c23c1e016259b$var$createCalendarSystem(name) {
    return new $806c23c1e016259b$var$calendarSystemClassMap[name]();
}
class $806c23c1e016259b$var$GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return $806c23c1e016259b$var$arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return $806c23c1e016259b$var$dateToUtcArray(marker);
    }
}
$806c23c1e016259b$var$registerCalendarSystem('gregory', $806c23c1e016259b$var$GregorianCalendarSystem);
const $806c23c1e016259b$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $806c23c1e016259b$export$26a0a7676ca7aa04(str) {
    let m = $806c23c1e016259b$var$ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if ($806c23c1e016259b$export$5521614468b862fb(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
class $806c23c1e016259b$export$3722cfe417b6ed86 {
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $806c23c1e016259b$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return $806c23c1e016259b$var$arrayToUtcDate($806c23c1e016259b$var$dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === 'string') return this.parse(input);
        let marker = null;
        if (typeof input === 'number') marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = $806c23c1e016259b$var$arrayToUtcDate(input);
        if (marker === null || !$806c23c1e016259b$export$5521614468b862fb(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = $806c23c1e016259b$export$26a0a7676ca7aa04(s);
        if (parts === null) return null;
        let { marker: marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($806c23c1e016259b$var$timeAsMs(m0) === $806c23c1e016259b$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($806c23c1e016259b$var$timeAsMs(m0) === $806c23c1e016259b$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: 'year',
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: 'month',
            value: n
        };
        n = $806c23c1e016259b$export$31e67cf12fc9668(m0, m1);
        if (n !== null) return {
            unit: 'week',
            value: n
        };
        n = $806c23c1e016259b$export$4a5767248b18ef41(m0, m1);
        if (n !== null) return {
            unit: 'day',
            value: n
        };
        n = $806c23c1e016259b$var$diffHours(m0, m1);
        if ($806c23c1e016259b$export$ab83b03e4111b1d0(n)) return {
            unit: 'hour',
            value: n
        };
        n = $806c23c1e016259b$var$diffMinutes(m0, m1);
        if ($806c23c1e016259b$export$ab83b03e4111b1d0(n)) return {
            unit: 'minute',
            value: n
        };
        n = $806c23c1e016259b$var$diffSeconds(m0, m1);
        if ($806c23c1e016259b$export$ab83b03e4111b1d0(n)) return {
            unit: 'second',
            value: n
        };
        return {
            unit: 'millisecond',
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / $806c23c1e016259b$var$asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / $806c23c1e016259b$var$asRoughMonths(d);
        }
        if (d.days) {
            diff = $806c23c1e016259b$export$4a5767248b18ef41(m0, m1);
            if (diff !== null) return diff / $806c23c1e016259b$var$asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / $806c23c1e016259b$export$4b170465d7badfa1(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === 'year') return this.startOfYear(m);
        if (unit === 'month') return this.startOfMonth(m);
        if (unit === 'week') return this.startOfWeek(m);
        if (unit === 'day') return $806c23c1e016259b$export$9e5f44173e64f162(m);
        if (unit === 'hour') return $806c23c1e016259b$var$startOfHour(m);
        if (unit === 'minute') return $806c23c1e016259b$var$startOfMinute(m);
        if (unit === 'second') return $806c23c1e016259b$var$startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return $806c23c1e016259b$var$weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = $806c23c1e016259b$export$51b138e5a065c2bb(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return $806c23c1e016259b$export$f438b12253c2b499(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === 'local') return $806c23c1e016259b$var$arrayToUtcDate($806c23c1e016259b$var$dateToLocalArray(new Date(ms)));
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
        return $806c23c1e016259b$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === 'local') return -$806c23c1e016259b$var$arrayToLocalDate($806c23c1e016259b$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === 'UTC') return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($806c23c1e016259b$var$dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === 'local') return $806c23c1e016259b$var$arrayToLocalDate($806c23c1e016259b$var$dateToUtcArray(m));
        if (this.timeZone === 'UTC') return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($806c23c1e016259b$var$dateToUtcArray(m)) * 60000);
    }
}
class $806c23c1e016259b$export$971d5caa766a69d7 {
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || '';
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return '';
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return '';
    }
}
$806c23c1e016259b$export$971d5caa766a69d7.prototype.classes = {};
$806c23c1e016259b$export$971d5caa766a69d7.prototype.iconClasses = {};
$806c23c1e016259b$export$971d5caa766a69d7.prototype.baseIconClass = '';
$806c23c1e016259b$export$971d5caa766a69d7.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $806c23c1e016259b$export$c3950d9923825c02(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = $c329b3b3780c47a8$export$41c562ebe57d11e2.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $c329b3b3780c47a8$export$41c562ebe57d11e2.debounceRendering = execCallbackSync;
    $c329b3b3780c47a8$export$b3890eb0ae9dca99($c329b3b3780c47a8$export$c8a8987d4410bf2d($806c23c1e016259b$var$FakeComponent, {}), document.createElement('div'));
    while(callbackQ.length)callbackQ.shift()();
    $c329b3b3780c47a8$export$41c562ebe57d11e2.debounceRendering = oldDebounceRendering;
}
class $806c23c1e016259b$var$FakeComponent extends $c329b3b3780c47a8$export$16fa2f45be04daa8 {
    render() {
        return $c329b3b3780c47a8$export$c8a8987d4410bf2d('div', {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function $806c23c1e016259b$export$c9170ad7d4cd7e57(defaultValue) {
    let ContextType = $c329b3b3780c47a8$export$fd42f52fd3ae1109(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class $806c23c1e016259b$export$49e6ee724f7f1ace {
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    detach() {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
}
const $806c23c1e016259b$export$e7c866399fa523f5 = $806c23c1e016259b$export$c9170ad7d4cd7e57({}); // for Components
function $806c23c1e016259b$export$ce26c07117d59d6a(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        nowManager: nowManager,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder (execFunc) {
            return new $806c23c1e016259b$export$49e6ee724f7f1ace(execFunc, emitter, $806c23c1e016259b$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class $806c23c1e016259b$export$3c2fa207a37baaea extends (0, $c329b3b3780c47a8$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps, nextState) {
        if (this.debug) // eslint-disable-next-line no-console
        console.log($806c23c1e016259b$var$getUnequalProps(nextProps, this.props), $806c23c1e016259b$var$getUnequalProps(nextState, this.state));
        return !$806c23c1e016259b$export$b9a6b53f9be3734(this.props, nextProps, this.propEquality) || !$806c23c1e016259b$export$b9a6b53f9be3734(this.state, nextState, this.stateEquality);
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!$806c23c1e016259b$export$b9a6b53f9be3734(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
$806c23c1e016259b$export$3c2fa207a37baaea.addPropsEquality = $806c23c1e016259b$var$addPropsEquality;
$806c23c1e016259b$export$3c2fa207a37baaea.addStateEquality = $806c23c1e016259b$var$addStateEquality;
$806c23c1e016259b$export$3c2fa207a37baaea.contextType = $806c23c1e016259b$export$e7c866399fa523f5;
$806c23c1e016259b$export$3c2fa207a37baaea.prototype.propEquality = {};
$806c23c1e016259b$export$3c2fa207a37baaea.prototype.stateEquality = {};
class $806c23c1e016259b$export$ef35774e6d314e91 extends $806c23c1e016259b$export$3c2fa207a37baaea {
}
$806c23c1e016259b$export$ef35774e6d314e91.contextType = $806c23c1e016259b$export$e7c866399fa523f5;
function $806c23c1e016259b$var$addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $806c23c1e016259b$var$addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $806c23c1e016259b$export$71cec2538cb2c617(ref, current) {
    if (typeof ref === 'function') ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
class $806c23c1e016259b$var$ContentInjector extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.id = $806c23c1e016259b$export$39b482c5e57630a8();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            const { options: options } = this.context;
            const { generatorName: generatorName } = this.props;
            if (!options.customRenderingReplaces || !$806c23c1e016259b$var$hasCustomRenderingHandler(generatorName, options)) this.updateElRef(el);
        };
        this.updateElRef = (el)=>{
            if (this.props.elRef) $806c23c1e016259b$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
        const attrs = $806c23c1e016259b$export$9ddbdd0bfc5623a(props, [], this.handleEl);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === 'object'; // non-null
                if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (isObject ? (0, $c329b3b3780c47a8$export$a8257692ac88316c)(customGeneratorRes) // vdom node
                 : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
                ) // use in vdom
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !$806c23c1e016259b$var$hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props: props, context: context } = this;
        const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive: isActive,
                containerEl: this.base,
                reportNewContainerEl: this.updateElRef,
                generatorMeta: generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter($806c23c1e016259b$var$isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
        const el = this.base;
        if (!$806c23c1e016259b$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach($806c23c1e016259b$export$9f4f30ee63539e24);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
}
$806c23c1e016259b$var$ContentInjector.addPropsEquality({
    elClasses: $806c23c1e016259b$export$23f2a1d2818174ef,
    elStyle: $806c23c1e016259b$export$a9c23c6ac3fc3eca,
    elAttrs: $806c23c1e016259b$var$isNonHandlerPropsEqual,
    renderProps: $806c23c1e016259b$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $806c23c1e016259b$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $806c23c1e016259b$export$9ddbdd0bfc5623a(props, extraClassNames, elRef) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $806c23c1e016259b$var$isTruthy(val) {
    return Boolean(val);
}
const $806c23c1e016259b$export$7910e0436ed8d1de = $806c23c1e016259b$export$c9170ad7d4cd7e57(0);
class $806c23c1e016259b$export$e7094788287c5e9b extends (0, $c329b3b3780c47a8$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.InnerContent = $806c23c1e016259b$var$InnerContentInjector.bind(undefined, this);
        this.handleEl = (el)=>{
            this.el = el;
            if (this.props.elRef) {
                $806c23c1e016259b$export$71cec2538cb2c617(this.props.elRef, el);
                if (el && this.didMountMisfire) this.componentDidMount();
            }
        };
    }
    render() {
        const { props: props } = this;
        const generatedClassNames = $806c23c1e016259b$var$generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = $806c23c1e016259b$export$9ddbdd0bfc5623a(props, generatedClassNames, this.handleEl);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$var$ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleEl,
            elTag: props.elTag || 'div',
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
        else this.didMountMisfire = true;
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
    }
}
$806c23c1e016259b$export$e7094788287c5e9b.contextType = $806c23c1e016259b$export$7910e0436ed8d1de;
function $806c23c1e016259b$var$InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $806c23c1e016259b$var$generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === 'string' ? [
        classNames
    ] : classNames;
}
class $806c23c1e016259b$export$a3c9165b94390bcd extends $806c23c1e016259b$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, Object.assign({}, props, {
            elTag: props.elTag || 'div',
            elClasses: [
                ...$806c23c1e016259b$export$8b22cf2602fb60ce(props.viewSpec),
                ...props.elClasses || []
            ],
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }), ()=>props.children);
    }
}
function $806c23c1e016259b$export$8b22cf2602fb60ce(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        'fc-view'
    ];
}
function $806c23c1e016259b$var$parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $806c23c1e016259b$var$invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start: start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($806c23c1e016259b$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $806c23c1e016259b$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $806c23c1e016259b$export$ae1af26003f05816(range0, range1) {
    let { start: start, end: end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $806c23c1e016259b$export$7a0bdf7d4a91ea88(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $806c23c1e016259b$export$c18d01048907ea92(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $806c23c1e016259b$export$f074adc9fbd50943(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $806c23c1e016259b$export$2329c99376c9d0a4(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $806c23c1e016259b$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $806c23c1e016259b$var$computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor($806c23c1e016259b$export$b4d5ecaefe2b27f3(timedRange.start, timedRange.end)) || 1;
    let start = $806c23c1e016259b$export$9e5f44173e64f162(timedRange.start);
    let end = $806c23c1e016259b$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $806c23c1e016259b$export$92108d983e8ee699(timedRange, nextDayThreshold = $806c23c1e016259b$export$4368d992c4eafac0(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = $806c23c1e016259b$export$9e5f44173e64f162(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $806c23c1e016259b$export$4b170465d7badfa1(nextDayThreshold)) endDay = $806c23c1e016259b$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $806c23c1e016259b$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $806c23c1e016259b$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $806c23c1e016259b$export$9fa96a7d116ea3ce(range) {
    let visibleRange = $806c23c1e016259b$export$92108d983e8ee699(range);
    return $806c23c1e016259b$export$b4d5ecaefe2b27f3(visibleRange.start, visibleRange.end) > 1;
}
function $806c23c1e016259b$export$28f7fcd39efa255(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') return $806c23c1e016259b$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), 'year');
    if (largeUnit === 'month') return $806c23c1e016259b$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), 'month');
    return $806c23c1e016259b$export$62d08d6fa708df47(date0, date1); // returns a duration
}
class $806c23c1e016259b$export$db202ddc8be9136 {
    constructor(props){
        this.props = props;
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props: props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = $806c23c1e016259b$var$constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = $806c23c1e016259b$export$ae1af26003f05816(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = $806c23c1e016259b$export$ae1af26003f05816(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = $806c23c1e016259b$export$c18d01048907ea92(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!$806c23c1e016259b$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate: currentDate,
            validRange: // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            activeRange: // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            renderRange: // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props: props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = $806c23c1e016259b$export$db3b6bfb95261072(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    }
    getFallbackDuration() {
        return $806c23c1e016259b$export$4368d992c4eafac0({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
        let { start: start, end: end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if ($806c23c1e016259b$var$asRoughDays(slotMinTime) < 0) {
                start = $806c23c1e016259b$export$9e5f44173e64f162(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if ($806c23c1e016259b$var$asRoughDays(slotMaxTime) > 1) {
                end = $806c23c1e016259b$export$9e5f44173e64f162(end); // necessary?
                end = $806c23c1e016259b$export$625550452a3fa3ec(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement: dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if ($806c23c1e016259b$export$4b170465d7badfa1(dateIncrement) < $806c23c1e016259b$export$4b170465d7badfa1(duration)) dateAlignment = $806c23c1e016259b$export$db3b6bfb95261072(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if ($806c23c1e016259b$var$asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = $806c23c1e016259b$export$9e5f44173e64f162(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = $806c23c1e016259b$export$9e5f44173e64f162(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = $806c23c1e016259b$export$625550452a3fa3ec(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props: props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement: dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return $806c23c1e016259b$export$4368d992c4eafac0(1, customAlignment);
        if (fallback) return fallback;
        return $806c23c1e016259b$export$4368d992c4eafac0({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = $806c23c1e016259b$var$parseRange(rangeInput, this.props.dateEnv);
            if (range) range = $806c23c1e016259b$export$92108d983e8ee699(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start: start, end: end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $806c23c1e016259b$export$625550452a3fa3ec(date, inc);
        return date;
    }
}
function $806c23c1e016259b$export$995eb9fca571757(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $806c23c1e016259b$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $806c23c1e016259b$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay: allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $806c23c1e016259b$var$expandRecurring(eventStore, framingRange, context) {
    let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
    let { defs: defs, instances: instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $806c23c1e016259b$export$dda1d9f60106f0e9(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration: duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = $806c23c1e016259b$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = $806c23c1e016259b$export$995eb9fca571757(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $806c23c1e016259b$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($806c23c1e016259b$export$9e5f44173e64f162);
    return markers;
}
const $806c23c1e016259b$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const $806c23c1e016259b$var$EVENT_DATE_REFINERS = {
    start: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    end: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    date: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
const $806c23c1e016259b$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $806c23c1e016259b$var$EVENT_NON_DATE_REFINERS), $806c23c1e016259b$var$EVENT_DATE_REFINERS), {
    extendedProps: $806c23c1e016259b$export$7ccc53e8f1e7dfc5
});
function $806c23c1e016259b$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $806c23c1e016259b$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined: refined, extra: extra } = $806c23c1e016259b$export$3b513254972cfc9c(raw, context, refiners);
    let defaultAllDay = $806c23c1e016259b$var$computeIsDefaultAllDay(eventSource, context);
    let recurringRes = $806c23c1e016259b$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = $806c23c1e016259b$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    let singleRes = $806c23c1e016259b$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = $806c23c1e016259b$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = $806c23c1e016259b$export$995eb9fca571757(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function $806c23c1e016259b$export$3b513254972cfc9c(raw, context, refiners = $806c23c1e016259b$var$buildEventRefiners(context)) {
    return $806c23c1e016259b$export$ee7c8ad385a60b7b(raw, refiners);
}
function $806c23c1e016259b$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $806c23c1e016259b$var$EVENT_UI_REFINERS), $806c23c1e016259b$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $806c23c1e016259b$export$f38c853ae54ed474(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || $806c23c1e016259b$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $806c23c1e016259b$export$25ce5a424b770e84(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $806c23c1e016259b$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay: allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $806c23c1e016259b$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $806c23c1e016259b$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $806c23c1e016259b$var$computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $806c23c1e016259b$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = $806c23c1e016259b$export$7f8ddf7c7c20b3cd();
    let eventRefiners = $806c23c1e016259b$var$buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = $806c23c1e016259b$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) $806c23c1e016259b$export$317a3d46287192d8(tuple, eventStore);
    }
    return eventStore;
}
function $806c23c1e016259b$export$317a3d46287192d8(tuple, eventStore = $806c23c1e016259b$export$7f8ddf7c7c20b3cd()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $806c23c1e016259b$export$667d3bf0c5f83305(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = $806c23c1e016259b$var$filterEventStoreDefs(eventStore, (lookDef)=>$806c23c1e016259b$var$isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $806c23c1e016259b$export$7f8ddf7c7c20b3cd();
}
function $806c23c1e016259b$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $806c23c1e016259b$export$7f8ddf7c7c20b3cd() {
    return {
        defs: {},
        instances: {}
    };
}
function $806c23c1e016259b$export$d377dcb2b61d6c4e(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $806c23c1e016259b$var$filterEventStoreDefs(eventStore, filterFunc) {
    let defs = $806c23c1e016259b$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    let instances = $806c23c1e016259b$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs: defs,
        instances: instances
    };
}
function $806c23c1e016259b$var$excludeSubEventStore(master, sub) {
    let { defs: defs, instances: instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $806c23c1e016259b$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $806c23c1e016259b$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === 'object' && input) return $806c23c1e016259b$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $806c23c1e016259b$export$f96d196f7728bb5(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const $806c23c1e016259b$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    overlap: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    allow: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    className: $806c23c1e016259b$export$f96d196f7728bb5,
    classNames: $806c23c1e016259b$export$f96d196f7728bb5,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const $806c23c1e016259b$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: []
};
function $806c23c1e016259b$export$25ce5a424b770e84(refined, context) {
    let constraint = $806c23c1e016259b$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $806c23c1e016259b$export$1ee57be6f6687d2c(uis) {
    return uis.reduce($806c23c1e016259b$var$combineTwoEventUis, $806c23c1e016259b$var$EMPTY_EVENT_UI);
}
function $806c23c1e016259b$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const $806c23c1e016259b$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    failure: $806c23c1e016259b$export$7ccc53e8f1e7dfc5
};
function $806c23c1e016259b$export$ffb5f4729a158638(raw, context, refiners = $806c23c1e016259b$export$35e795649ee09318(context)) {
    let rawObj;
    if (typeof raw === 'string') rawObj = {
        url: raw
    };
    else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === 'object' && raw) rawObj = raw;
    if (rawObj) {
        let { refined: refined, extra: extra } = $806c23c1e016259b$export$ee7c8ad385a60b7b(rawObj, refiners);
        let metaRes = $806c23c1e016259b$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: '',
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || '',
            sourceId: $806c23c1e016259b$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $806c23c1e016259b$export$25ce5a424b770e84(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $806c23c1e016259b$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $806c23c1e016259b$var$EVENT_UI_REFINERS), $806c23c1e016259b$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $806c23c1e016259b$var$buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $806c23c1e016259b$export$9bb611d729802a56(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case 'RECEIVE_EVENTS':
            return $806c23c1e016259b$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'RESET_RAW_EVENTS':
            return $806c23c1e016259b$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case 'ADD_EVENTS':
            return $806c23c1e016259b$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS':
            return $806c23c1e016259b$export$d377dcb2b61d6c4e(eventStore, action.eventStore);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $806c23c1e016259b$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case 'REMOVE_EVENTS':
            return $806c23c1e016259b$var$excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return $806c23c1e016259b$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return $806c23c1e016259b$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case 'REMOVE_ALL_EVENTS':
            return $806c23c1e016259b$export$7f8ddf7c7c20b3cd();
        default:
            return eventStore;
    }
}
function $806c23c1e016259b$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = $806c23c1e016259b$var$parseEvents($806c23c1e016259b$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $806c23c1e016259b$var$expandRecurring(subset, fetchRange, context);
        return $806c23c1e016259b$export$d377dcb2b61d6c4e($806c23c1e016259b$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $806c23c1e016259b$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $806c23c1e016259b$var$buildPublicIdMaps(existingEventStore);
    let newEventStore = $806c23c1e016259b$var$parseEvents($806c23c1e016259b$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $806c23c1e016259b$var$expandRecurring(newEventStore, activeRange, context);
}
function $806c23c1e016259b$var$transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $806c23c1e016259b$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $806c23c1e016259b$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $806c23c1e016259b$var$transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function $806c23c1e016259b$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $806c23c1e016259b$var$expandRecurring(subset, expandRange, context);
    return $806c23c1e016259b$export$d377dcb2b61d6c4e(eventStore, subset);
}
function $806c23c1e016259b$export$b4171a6734a65d42(eventStore, oldDateEnv, newDateEnv) {
    let { defs: defs } = eventStore;
    let instances = $806c23c1e016259b$export$407448d2b89b1813(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $806c23c1e016259b$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $806c23c1e016259b$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $806c23c1e016259b$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $806c23c1e016259b$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function $806c23c1e016259b$var$buildPublicIdMaps(eventStore) {
    const { defs: defs, instances: instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId: publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId: publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
class $806c23c1e016259b$export$d66501df72047452 {
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        $806c23c1e016259b$var$addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        $806c23c1e016259b$var$removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
}
function $806c23c1e016259b$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $806c23c1e016259b$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
const $806c23c1e016259b$var$DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours'
};
/*
TODO: pass around as EventDefHash!!!
*/ function $806c23c1e016259b$export$3a6d5c9ae78a2c08(input, context) {
    return $806c23c1e016259b$var$parseEvents($806c23c1e016259b$var$refineInputs(input), null, context);
}
function $806c23c1e016259b$var$refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === 'object' && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $806c23c1e016259b$var$DEF_DEFAULTS), rawDef));
    return rawDefs;
}
function $806c23c1e016259b$export$cbfbec548517f2b6(selection, pev, context) {
    context.emitter.trigger('select', Object.assign(Object.assign({}, $806c23c1e016259b$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $806c23c1e016259b$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $806c23c1e016259b$var$buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $806c23c1e016259b$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $806c23c1e016259b$export$bde1ed0f60b38f2f(allDay, marker, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let end = marker;
    if (allDay) {
        end = $806c23c1e016259b$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $806c23c1e016259b$export$dabba94403d45c8e(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = $806c23c1e016259b$var$compileEventUis(eventStore.defs, eventConfigBase);
    let dest = $806c23c1e016259b$export$7f8ddf7c7c20b3cd();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = $806c23c1e016259b$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $806c23c1e016259b$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $806c23c1e016259b$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $806c23c1e016259b$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv: dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $806c23c1e016259b$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $806c23c1e016259b$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $806c23c1e016259b$export$9e5f44173e64f162(copy.range.start),
        end: $806c23c1e016259b$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $806c23c1e016259b$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context);
    return copy;
}
class $806c23c1e016259b$var$EventSourceImpl {
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    remove() {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
}
class $806c23c1e016259b$export$71511d61b312f219 {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in $806c23c1e016259b$var$EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
        else if (name === 'id') {
            val = $806c23c1e016259b$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in $806c23c1e016259b$var$EVENT_NON_DATE_REFINERS) {
            val = $806c23c1e016259b$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in $806c23c1e016259b$var$EVENT_UI_REFINERS) {
            let ui = $806c23c1e016259b$var$EVENT_UI_REFINERS[name](val);
            if (name === 'color') ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === 'editable') ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = $806c23c1e016259b$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = $806c23c1e016259b$export$28f7fcd39efa255(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = $806c23c1e016259b$var$computeAlignedDayRange(instanceRange);
            let startDelta = $806c23c1e016259b$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = $806c23c1e016259b$export$28f7fcd39efa255(instanceRange.end, end, dateEnv, options.granularity);
                if ($806c23c1e016259b$var$durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = $806c23c1e016259b$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = $806c23c1e016259b$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = $806c23c1e016259b$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay: allDay
        };
        let { maintainDuration: maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv: dateEnv } = this._context;
        let instance = this._instance;
        let formatter = $806c23c1e016259b$export$d141bba7fdc215a3(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore: eventStore } = context.getCurrentData();
            let relevantEvents = $806c23c1e016259b$export$667d3bf0c5f83305(eventStore, instance.instanceId);
            let eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: []
                }
            };
            relevantEvents = $806c23c1e016259b$export$dabba94403d45c8e(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new $806c23c1e016259b$export$71511d61b312f219(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents
            });
            context.emitter.trigger('eventChange', {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: $806c23c1e016259b$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore: eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = $806c23c1e016259b$var$eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId: sourceId } = this._def;
        if (sourceId) return new $806c23c1e016259b$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return '';
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return '';
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || 'auto';
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui: ui } = def;
        let { startStr: startStr, endStr: endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== 'auto') res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
}
function $806c23c1e016259b$var$eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $806c23c1e016259b$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    let { defs: defs, instances: instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $806c23c1e016259b$export$71511d61b312f219(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $806c23c1e016259b$export$4c3d22f3d993c33f(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = $806c23c1e016259b$var$compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? $806c23c1e016259b$export$92108d983e8ee699(origRange, nextDayThreshold) : origRange;
        let slicedRange = $806c23c1e016259b$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== 'none') (ui.display === 'background' ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = $806c23c1e016259b$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = $806c23c1e016259b$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $806c23c1e016259b$export$45aabb5431c2d04f(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function $806c23c1e016259b$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $806c23c1e016259b$export$8743009a87fcb00f(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $806c23c1e016259b$var$compileEventUis(eventDefs, eventUiBases) {
    return $806c23c1e016259b$export$407448d2b89b1813(eventDefs, (eventDef)=>$806c23c1e016259b$var$compileEventUi(eventDef, eventUiBases));
}
function $806c23c1e016259b$var$compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases['']) uis.push(eventUiBases['']);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $806c23c1e016259b$export$1ee57be6f6687d2c(uis);
}
function $806c23c1e016259b$export$a91cd623adc48128(segs, eventOrderSpecs) {
    let objs = segs.map($806c23c1e016259b$var$buildSegCompareObj);
    objs.sort((obj0, obj1)=>$806c23c1e016259b$export$306ddfe3a8403e2(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function $806c23c1e016259b$var$buildSegCompareObj(seg) {
    let { eventRange: eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $806c23c1e016259b$var$computeSegDraggable(seg, context) {
    let { pluginHooks: pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def: def, ui: ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function $806c23c1e016259b$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $806c23c1e016259b$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $806c23c1e016259b$export$2538633961795d6b(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv: dateEnv, options: options } = context;
    let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = $806c23c1e016259b$export$9e5f44173e64f162(wholeEventStart).valueOf() === $806c23c1e016259b$export$9e5f44173e64f162(segStart).valueOf();
    let isEndDay = $806c23c1e016259b$export$9e5f44173e64f162($806c23c1e016259b$export$51b138e5a065c2bb(wholeEventEnd, -1)).valueOf() === $806c23c1e016259b$export$9e5f44173e64f162($806c23c1e016259b$export$51b138e5a065c2bb(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return '';
}
function $806c23c1e016259b$export$993a080e5cb62d74(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $806c23c1e016259b$export$2329c99376c9d0a4(todayRange, segRange.start)
    };
}
function $806c23c1e016259b$var$getEventClassNames(props) {
    let classNames = [
        'fc-event'
    ];
    if (props.isMirror) classNames.push('fc-event-mirror');
    if (props.isDraggable) classNames.push('fc-event-draggable');
    if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
    if (props.isDragging) classNames.push('fc-event-dragging');
    if (props.isResizing) classNames.push('fc-event-resizing');
    if (props.isSelected) classNames.push('fc-event-selected');
    if (props.isStart) classNames.push('fc-event-start');
    if (props.isEnd) classNames.push('fc-event-end');
    if (props.isPast) classNames.push('fc-event-past');
    if (props.isToday) classNames.push('fc-event-today');
    if (props.isFuture) classNames.push('fc-event-future');
    return classNames;
}
function $806c23c1e016259b$export$4d522598b426bb73(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function $806c23c1e016259b$export$6dabbe08653f866f(seg, context) {
    let { def: def, instance: instance } = seg.eventRange;
    let { url: url } = def;
    if (url) return {
        href: url
    };
    let { emitter: emitter, options: options } = context;
    let { eventInteractive: eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $806c23c1e016259b$var$createAriaKeyboardAttrs((ev)=>{
        emitter.trigger('eventClick', {
            el: ev.target,
            event: new $806c23c1e016259b$export$71511d61b312f219(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const $806c23c1e016259b$var$STANDARD_PROPS = {
    start: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    end: $806c23c1e016259b$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $806c23c1e016259b$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = $806c23c1e016259b$var$parseOpenDateSpan(raw, dateEnv);
    let { range: range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $806c23c1e016259b$var$parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra: extra } = $806c23c1e016259b$export$ee7c8ad385a60b7b(raw, $806c23c1e016259b$var$STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay: allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $806c23c1e016259b$export$7f557e5eb95176c2(span0, span1) {
    return $806c23c1e016259b$export$7a0bdf7d4a91ea88(span0.range, span1.range) && span0.allDay === span1.allDay && $806c23c1e016259b$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $806c23c1e016259b$var$isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== 'range' && propName !== 'allDay') {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function $806c23c1e016259b$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $806c23c1e016259b$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $806c23c1e016259b$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $806c23c1e016259b$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $806c23c1e016259b$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $806c23c1e016259b$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = $806c23c1e016259b$export$3b513254972cfc9c({
        editable: false
    }, context);
    let def = $806c23c1e016259b$export$f38c853ae54ed474(res.refined, res.extra, '', dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $806c23c1e016259b$var$compileEventUi(def, eventUiBases),
        instance: $806c23c1e016259b$export$995eb9fca571757(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $806c23c1e016259b$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
}
class $806c23c1e016259b$export$f787f51d84a910ad extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function $806c23c1e016259b$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method: method
    };
    if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new $806c23c1e016259b$export$f787f51d84a910ad('Failure parsing JSON', fetchRes);
        });
        else throw new $806c23c1e016259b$export$f787f51d84a910ad('Request failed', fetchRes);
    });
}
let $806c23c1e016259b$var$canVGrowWithinCell;
function $806c23c1e016259b$export$738ab4df8bf92ae9() {
    if ($806c23c1e016259b$var$canVGrowWithinCell == null) $806c23c1e016259b$var$canVGrowWithinCell = $806c23c1e016259b$var$computeCanVGrowWithinCell();
    return $806c23c1e016259b$var$canVGrowWithinCell;
}
function $806c23c1e016259b$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') return true;
    let el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    let div = el.querySelector('div');
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
class $806c23c1e016259b$export$a9c996f45e5784d0 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            $806c23c1e016259b$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: true
                });
            });
        };
        this.handleAfterPrint = ()=>{
            $806c23c1e016259b$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: false
                });
            });
        };
    }
    render() {
        let { props: props } = this;
        let { options: options } = props;
        let { forPrint: forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        let height = !isHeightAuto && options.height != null ? options.height : '';
        let classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            `fc-direction-${options.direction}`,
            props.theme.getClass('root')
        ];
        if (!$806c23c1e016259b$export$738ab4df8bf92ae9()) classNames.push('fc-liquid-hack');
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter: emitter } = this.props;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter: emitter } = this.props;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    }
}
class $806c23c1e016259b$export$78acf4525d8a74c4 {
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    destroy() {}
}
function $806c23c1e016259b$export$efca4cbe5dd06740(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $806c23c1e016259b$export$381353cf1dd55255(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const $806c23c1e016259b$export$a8550f7dbe79f93a = {};
class $806c23c1e016259b$export$2e2af4578d910ddf extends (0, $c329b3b3780c47a8$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.handleRefresh = ()=>{
            let timing = this.computeTiming();
            if (timing.state.nowDate.valueOf() !== this.state.nowDate.valueOf()) this.setState(timing.state);
            this.clearTimeout();
            this.setTimeout(timing.waitMs);
        };
        this.handleVisibilityChange = ()=>{
            if (!document.hidden) this.handleRefresh();
        };
        this.state = this.computeTiming().state;
    }
    render() {
        let { props: props, state: state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
        this.context.nowManager.addResetListener(this.handleRefresh);
        // fired tab becomes visible after being hidden
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
        this.context.nowManager.removeResetListener(this.handleRefresh);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    computeTiming() {
        let { props: props, context: context } = this;
        let unroundedNow = context.nowManager.getDateMarker();
        let currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
        let nextUnitStart = context.dateEnv.add(currentUnitStart, $806c23c1e016259b$export$4368d992c4eafac0(1, props.unit));
        let waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            state: {
                nowDate: currentUnitStart,
                todayRange: $806c23c1e016259b$var$buildDayRange(currentUnitStart)
            },
            waitMs: waitMs
        };
    }
    setTimeout(waitMs = this.computeTiming().waitMs) {
        // NOTE: timeout could take longer than expected if tab sleeps,
        // which is why we listen to 'visibilitychange'
        this.timeoutId = setTimeout(()=>{
            // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
            // This is why use use same waitMs from computeTiming, so we don't skip an interval while
            // .setState() is executing
            const timing = this.computeTiming();
            this.setState(timing.state, ()=>{
                this.setTimeout(timing.waitMs);
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
$806c23c1e016259b$export$2e2af4578d910ddf.contextType = $806c23c1e016259b$export$e7c866399fa523f5;
function $806c23c1e016259b$var$buildDayRange(date) {
    let start = $806c23c1e016259b$export$9e5f44173e64f162(date);
    let end = $806c23c1e016259b$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
class $806c23c1e016259b$export$a93c5207d687da10 {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger('_resize', true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager: currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType
                    });
                    this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv: dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: 'CHANGE_VIEW_TYPE',
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: 'PREV'
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: 'NEXT'
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.nowManager.getDateMarker()
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = $806c23c1e016259b$export$4368d992c4eafac0(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), $806c23c1e016259b$export$d141bba7fdc215a3(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $806c23c1e016259b$export$d141bba7fdc215a3(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = $806c23c1e016259b$var$parseDateSpan(selectionInput, state.dateEnv, $806c23c1e016259b$export$4368d992c4eafac0({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: 'SELECT_DATES',
                selection: selection
            });
            $806c23c1e016259b$export$cbfbec548517f2b6(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: 'UNSELECT_DATES'
            });
            $806c23c1e016259b$var$triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof $806c23c1e016259b$export$71511d61b312f219) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: $806c23c1e016259b$export$317a3d46287192d8({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof $806c23c1e016259b$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) [eventSource] = $806c23c1e016259b$export$90a7f3efeed30595(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = $806c23c1e016259b$var$parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new $806c23c1e016259b$export$71511d61b312f219(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: $806c23c1e016259b$export$317a3d46287192d8(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter: emitter } = this.getCurrentData();
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: $806c23c1e016259b$var$eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs: defs, instances: instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new $806c23c1e016259b$export$71511d61b312f219(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new $806c23c1e016259b$export$71511d61b312f219(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return $806c23c1e016259b$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENTS'
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new $806c23c1e016259b$var$EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new $806c23c1e016259b$var$EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof $806c23c1e016259b$var$EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = $806c23c1e016259b$export$ffb5f4729a158638(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    eventSource
                ]
            });
            return new $806c23c1e016259b$var$EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENT_SOURCES'
        });
    }
    refetchEvents() {
        this.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = $806c23c1e016259b$export$4368d992c4eafac0(timeInput);
        if (time) this.trigger('_scrollRequest', {
            time: time
        });
    }
}
function $806c23c1e016259b$export$24baa2b76016ce0e(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $806c23c1e016259b$export$890c4ad488842ce7(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $806c23c1e016259b$export$a33b77bbdbb8366c(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $806c23c1e016259b$export$158acd800e1ef08b(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $806c23c1e016259b$export$cf2f7c5792f80b46(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $806c23c1e016259b$export$53a70dd1ebbae346(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
const $806c23c1e016259b$var$EMPTY_EVENT_STORE = $806c23c1e016259b$export$7f8ddf7c7c20b3cd(); // for purecomponents. TODO: keep elsewhere
class $806c23c1e016259b$export$9d0e2d13d04f7070 {
    constructor(){
        this.getKeysForEventDefs = $806c23c1e016259b$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $806c23c1e016259b$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $806c23c1e016259b$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $806c23c1e016259b$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $806c23c1e016259b$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $806c23c1e016259b$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = $806c23c1e016259b$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $806c23c1e016259b$export$df995fae86a55f06($806c23c1e016259b$var$buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || $806c23c1e016259b$var$EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return $806c23c1e016259b$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs: defs, instances: instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = $806c23c1e016259b$export$7f8ddf7c7c20b3cd();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || $806c23c1e016259b$var$EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || $806c23c1e016259b$var$EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
}
function $806c23c1e016259b$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        '': $806c23c1e016259b$export$1ee57be6f6687d2c(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $806c23c1e016259b$export$e171bab687b50e0(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !$806c23c1e016259b$export$2329c99376c9d0a4(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !$806c23c1e016259b$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $806c23c1e016259b$export$2329c99376c9d0a4(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $806c23c1e016259b$export$1a8f5705751d8277(meta, theme) {
    let classNames = [
        'fc-day',
        `fc-day-${$806c23c1e016259b$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-day-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-day-past');
        if (meta.isFuture) classNames.push('fc-day-future');
        if (meta.isOther) classNames.push('fc-day-other');
    }
    return classNames;
}
function $806c23c1e016259b$export$527e9aa3390079e9(meta, theme) {
    let classNames = [
        'fc-slot',
        `fc-slot-${$806c23c1e016259b$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-slot-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-slot-past');
        if (meta.isFuture) classNames.push('fc-slot-future');
    }
    return classNames;
}
const $806c23c1e016259b$var$DAY_FORMAT = $806c23c1e016259b$export$d141bba7fdc215a3({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
const $806c23c1e016259b$var$WEEK_FORMAT = $806c23c1e016259b$export$d141bba7fdc215a3({
    week: 'long'
});
function $806c23c1e016259b$export$a17c37559e1db147(context, dateMarker, viewType = 'day', isTabbable = true) {
    const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === 'week' ? $806c23c1e016259b$var$WEEK_FORMAT : $806c23c1e016259b$var$DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === 'string') viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $806c23c1e016259b$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            'data-navlink': ''
        }, isTabbable ? $806c23c1e016259b$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        'aria-label': dateStr
    };
}
let $806c23c1e016259b$var$_isRtlScrollbarOnLeft = null;
function $806c23c1e016259b$export$c7ca7e4bc4f8a16e() {
    if ($806c23c1e016259b$var$_isRtlScrollbarOnLeft === null) $806c23c1e016259b$var$_isRtlScrollbarOnLeft = $806c23c1e016259b$var$computeIsRtlScrollbarOnLeft();
    return $806c23c1e016259b$var$_isRtlScrollbarOnLeft;
}
function $806c23c1e016259b$var$computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement('div');
    $806c23c1e016259b$export$faec65b429be379(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $806c23c1e016259b$export$9f4f30ee63539e24(outerEl);
    return res;
}
let $806c23c1e016259b$var$_scrollbarWidths;
function $806c23c1e016259b$export$a1edd97dd51cd48d() {
    if (!$806c23c1e016259b$var$_scrollbarWidths) $806c23c1e016259b$var$_scrollbarWidths = $806c23c1e016259b$var$computeScrollbarWidths();
    return $806c23c1e016259b$var$_scrollbarWidths;
}
function $806c23c1e016259b$var$computeScrollbarWidths() {
    let el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    let res = $806c23c1e016259b$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $806c23c1e016259b$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $806c23c1e016259b$export$2ec5befb9e6c97d4(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = $806c23c1e016259b$var$computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($806c23c1e016259b$export$c7ca7e4bc4f8a16e() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $806c23c1e016259b$export$d29e374196577086(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $806c23c1e016259b$export$39c1cc7c062529d4(el);
    let edges = $806c23c1e016259b$export$2ec5befb9e6c97d4(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $806c23c1e016259b$export$39c1cc7c062529d4(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $806c23c1e016259b$var$computeClippedClientRect(el) {
    let clippingParents = $806c23c1e016259b$export$53c86fa97d611818(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = $806c23c1e016259b$export$890c4ad488842ce7(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function $806c23c1e016259b$export$53c86fa97d611818(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class $806c23c1e016259b$export$ad4aebacdcaf47f8 {
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts: lefts, rights: rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops: tops, bottoms: bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return $806c23c1e016259b$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $806c23c1e016259b$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $806c23c1e016259b$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $806c23c1e016259b$var$similarNumArrays(this.rights || [], otherCache.rights || []);
    }
}
function $806c23c1e016259b$var$similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class $806c23c1e016259b$export$4ae495d48253603d {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class $806c23c1e016259b$export$7060da4b5db56fb9 extends $806c23c1e016259b$export$4ae495d48253603d {
    constructor(el){
        super();
        this.el = el;
    }
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
}
class $806c23c1e016259b$export$c5d1328b37d47994 extends $806c23c1e016259b$export$4ae495d48253603d {
    getScrollTop() {
        return window.scrollY;
    }
    getScrollLeft() {
        return window.scrollX;
    }
    setScrollTop(n) {
        window.scroll(window.scrollX, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.scrollY);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class $806c23c1e016259b$export$d22783b3c2400a3a extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.uid = $806c23c1e016259b$export$39b482c5e57630a8();
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !$806c23c1e016259b$export$dc98b0b04f4c7758(el, '.fc-event-mirror');
    }
    isValidDateDownEl(el) {
        return !$806c23c1e016259b$export$dc98b0b04f4c7758(el, '.fc-event:not(.fc-bg-event)') && !$806c23c1e016259b$export$dc98b0b04f4c7758(el, '.fc-more-link') && // a "more.." link
        !$806c23c1e016259b$export$dc98b0b04f4c7758(el, 'a[data-navlink]') && // a clickable nav link
        !$806c23c1e016259b$export$dc98b0b04f4c7758(el, '.fc-popover'); // hack
    }
}
class $806c23c1e016259b$export$45d219bdcd8ac53c {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class $806c23c1e016259b$export$766bf7dcfb630b6c {
    constructor(getEntryThickness = (entry)=>{
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return entry.thickness || 1;
    }){
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
        else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            const hiddenEntry = Object.assign(Object.assign({}, entry), {
                span: $806c23c1e016259b$export$b0165a7e514844(entry.span, insertion.touchingEntry.span)
            });
            hiddenEntries.push(hiddenEntry);
            this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        } else hiddenEntries.push(entry);
    }
    /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ splitEntry(entry, barrier, hiddenEntries) {
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, hiddenEntries);
        if (entrySpan.end > barrierSpan.end) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, hiddenEntries);
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            $806c23c1e016259b$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
            $806c23c1e016259b$var$insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        $806c23c1e016259b$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[$806c23c1e016259b$export$674f8f4247a5112e(entry)] = insertion.stackCnt;
    }
    /*
    does not care about limits
    */ findInsertion(newEntry) {
        let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            const trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = $806c23c1e016259b$export$eb84e45a33f6ba7c(trackingEntries, newEntry.span.start, $806c23c1e016259b$export$2e63b696b2c9441b); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[$806c23c1e016259b$export$674f8f4247a5112e(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $806c23c1e016259b$export$eb84e45a33f6ba7c(entriesByLevel[destLevel], newEntry.span.end, $806c23c1e016259b$export$2e63b696b2c9441b)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                thickness: this.getEntryThickness(entry),
                levelCoord: levelCoord
            }));
        }
        return rects;
    }
}
function $806c23c1e016259b$export$2e63b696b2c9441b(entry) {
    return entry.span.end;
}
function $806c23c1e016259b$export$674f8f4247a5112e(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function $806c23c1e016259b$export$d76842aa27385215(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if ($806c23c1e016259b$export$b0165a7e514844(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: $806c23c1e016259b$var$joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function $806c23c1e016259b$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $806c23c1e016259b$export$b0165a7e514844(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $806c23c1e016259b$export$eb84e45a33f6ba7c(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class $806c23c1e016259b$export$b2bcef12bcefba04 {
    constructor(el, selector){
        this.emitter = new $806c23c1e016259b$export$d66501df72047452();
    }
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const $806c23c1e016259b$export$aff10ba49ece4b91 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const $806c23c1e016259b$var$DRAG_META_REFINERS = {
    startTime: $806c23c1e016259b$export$4368d992c4eafac0,
    duration: $806c23c1e016259b$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $806c23c1e016259b$export$60bb826a6acf3081(raw) {
    let { refined: refined, extra: extra } = $806c23c1e016259b$export$ee7c8ad385a60b7b(raw, $806c23c1e016259b$var$DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $806c23c1e016259b$export$1abb261478089fe6(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $806c23c1e016259b$export$d141bba7fdc215a3({
        weekday: 'short'
    }); // "Sat"
    if (dayCnt > 1) return $806c23c1e016259b$export$d141bba7fdc215a3({
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
    }); // "Sat 11/12"
    return $806c23c1e016259b$export$d141bba7fdc215a3({
        weekday: 'long'
    }); // "Saturday"
}
const $806c23c1e016259b$var$CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function $806c23c1e016259b$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
class $806c23c1e016259b$export$ebc5e65867841cbe extends $806c23c1e016259b$export$ef35774e6d314e91 {
    render() {
        let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
        let { props: props } = this;
        let { date: date, dateProfile: dateProfile } = props;
        let dayMeta = $806c23c1e016259b$export$e171bab687b50e0(date, props.todayRange, null, dateProfile);
        let classNames = [
            $806c23c1e016259b$var$CLASS_NAME
        ].concat($806c23c1e016259b$export$1a8f5705751d8277(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $806c23c1e016259b$export$a17c37559e1db147(this.context, date) : {};
        let publicDate = dateEnv.toDate(date);
        // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
        // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
        if (dateEnv.namedTimeZoneImpl) publicDate = $806c23c1e016259b$export$51b138e5a065c2bb(publicDate, 3600000); // add an hour
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: publicDate,
            view: viewApi
        }, props.extraRenderProps), {
            text: text
        }), dayMeta);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan,
                'data-date': !dayMeta.isDisabled ? $806c23c1e016259b$export$56350196709588fc(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $806c23c1e016259b$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ]
            })));
    }
}
const $806c23c1e016259b$var$WEEKDAY_FORMAT = $806c23c1e016259b$export$d141bba7fdc215a3({
    weekday: 'long'
});
class $806c23c1e016259b$export$1ddf2d01943a3512 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
        let date = $806c23c1e016259b$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text: text
        });
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: [
                $806c23c1e016259b$var$CLASS_NAME,
                ...$806c23c1e016259b$export$1a8f5705751d8277(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $806c23c1e016259b$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ],
                elAttrs: {
                    'aria-label': dateEnv.format(date, $806c23c1e016259b$var$WEEKDAY_FORMAT)
                }
            })));
    }
}
class $806c23c1e016259b$export$27d1aff6bea49709 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = $806c23c1e016259b$export$df995fae86a55f06($806c23c1e016259b$var$createDayHeaderFormatter);
    }
    render() {
        let { context: context } = this;
        let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$2e2af4578d910ddf, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("tr", {
                role: "row"
            }, renderIntro && renderIntro('day'), dates.map((date)=>datesRepDistinctDays ? (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$ebc5e65867841cbe, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$1ddf2d01943a3512, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
}
function $806c23c1e016259b$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $806c23c1e016259b$export$1abb261478089fe6(datesRepDistinctDays, dateCnt);
}
class $806c23c1e016259b$export$ebb8f7cd71856fb9 {
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end: end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $806c23c1e016259b$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex($806c23c1e016259b$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices: indices } = this;
        let dayOffset = Math.floor($806c23c1e016259b$export$b4d5ecaefe2b27f3(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
}
class $806c23c1e016259b$export$1314441b8d04e1d5 {
    constructor(daySeries, breakOnWeeks){
        let { dates: dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt: colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
}
class $806c23c1e016259b$export$e0c3a065614c6254 {
    constructor(){
        this.sliceBusinessHours = $806c23c1e016259b$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $806c23c1e016259b$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $806c23c1e016259b$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $806c23c1e016259b$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $806c23c1e016259b$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases: eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: $806c23c1e016259b$export$51b138e5a065c2bb(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore($806c23c1e016259b$var$expandRecurring(businessHours, $806c23c1e016259b$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = $806c23c1e016259b$export$4c3d22f3d993c33f(eventStore, eventUiBases, $806c23c1e016259b$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = $806c23c1e016259b$export$4c3d22f3d993c33f(interaction.mutatedEvents, eventUiBases, $806c23c1e016259b$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = $806c23c1e016259b$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = $806c23c1e016259b$export$ae1af26003f05816(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = $806c23c1e016259b$var$fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
            start: dateRange.start,
            end: $806c23c1e016259b$export$625550452a3fa3ec(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $806c23c1e016259b$var$computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $806c23c1e016259b$export$51b138e5a065c2bb(range.start, dateProfile.slotMinTime.milliseconds),
        end: $806c23c1e016259b$export$51b138e5a065c2bb(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$export$6d1e945284085e64(interaction, dateProfile, context) {
    let { instances: instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!$806c23c1e016259b$export$f074adc9fbd50943(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $806c23c1e016259b$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $806c23c1e016259b$export$545a72cc0d3f00b0(dateSelection, dateProfile, context) {
    if (!$806c23c1e016259b$export$f074adc9fbd50943(dateProfile.validRange, dateSelection.range)) return false;
    return $806c23c1e016259b$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $806c23c1e016259b$var$isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: '',
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: '',
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $806c23c1e016259b$export$6b179bb11f7fd3a0)(props, context);
}
function $806c23c1e016259b$export$6b179bb11f7fd3a0(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !$806c23c1e016259b$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$806c23c1e016259b$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = $806c23c1e016259b$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        '': currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $806c23c1e016259b$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = $806c23c1e016259b$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = $806c23c1e016259b$var$compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$806c23c1e016259b$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap: eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($806c23c1e016259b$export$c18d01048907ea92(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $806c23c1e016259b$export$71511d61b312f219(context, otherDefs[otherInstance.defId], otherInstance), new $806c23c1e016259b$export$71511d61b312f219(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new $806c23c1e016259b$export$71511d61b312f219(context, origDef, origInstance);
            else eventApi = new $806c23c1e016259b$export$71511d61b312f219(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow($806c23c1e016259b$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig: selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$806c23c1e016259b$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap: selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($806c23c1e016259b$export$c18d01048907ea92(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $806c23c1e016259b$export$71511d61b312f219(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow($806c23c1e016259b$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $806c23c1e016259b$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!$806c23c1e016259b$var$anyRangesContainRange($806c23c1e016259b$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function $806c23c1e016259b$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === 'businessHours') return $806c23c1e016259b$var$eventStoreToRanges($806c23c1e016259b$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === 'string') return $806c23c1e016259b$var$eventStoreToRanges($806c23c1e016259b$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === 'object' && constraint) return $806c23c1e016259b$var$eventStoreToRanges($806c23c1e016259b$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $806c23c1e016259b$var$eventStoreToRanges(eventStore) {
    let { instances: instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $806c23c1e016259b$var$anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if ($806c23c1e016259b$export$f074adc9fbd50943(outerRange, innerRange)) return true;
    }
    return false;
}
const $806c23c1e016259b$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class $806c23c1e016259b$export$54c4fabc2291e9c0 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            $806c23c1e016259b$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        let { props: props } = this;
        let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            'fc-scroller'
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
            else className.push('fc-scroller-liquid');
        }
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            ref: this.handleEl,
            className: className.join(' '),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || '',
                right: isAbsolute && -(props.overcomeRight || 0) || '',
                bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                maxHeight: props.maxHeight || ''
            }
        }, props.children);
    }
    needsXScrolling() {
        if ($806c23c1e016259b$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if ($806c23c1e016259b$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if ($806c23c1e016259b$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if ($806c23c1e016259b$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class $806c23c1e016259b$export$807f1ba34db587c7 {
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths: depths, currentMap: currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return $806c23c1e016259b$export$a05254e7c3aeba6e(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return $806c23c1e016259b$export$90a7f3efeed30595(this.currentMap);
    }
}
function $806c23c1e016259b$export$7fe88b5920ffddd2(chunkEls) {
    let shrinkCells = $806c23c1e016259b$export$23ebac1979863676(chunkEls, '.fc-scrollgrid-shrink');
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $806c23c1e016259b$var$computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $806c23c1e016259b$export$60e660859c376841(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $806c23c1e016259b$export$df838d0240c938cf(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $806c23c1e016259b$export$60e660859c376841(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $806c23c1e016259b$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows: expandRows } = arg;
    let content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('table', {
        role: 'presentation',
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
        ].join(' '),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ''
        }
    }, arg.tableColGroupNode, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(isHeader ? 'thead' : 'tbody', {
        role: 'presentation'
    }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $806c23c1e016259b$export$f5339a28e56d1baf(cols0, cols1) {
    return $806c23c1e016259b$export$23f2a1d2818174ef(cols0, cols1, $806c23c1e016259b$export$a9c23c6ac3fc3eca);
}
function $806c23c1e016259b$export$add49c223b9ce4ea(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("col", {
            style: {
                width: colProps.width === 'shrink' ? $806c23c1e016259b$export$df7c425476ed4f2(shrinkWidth) : colProps.width || '',
                minWidth: colProps.minWidth || ''
            }
        }));
    }
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('colgroup', {}, ...colNodes);
}
function $806c23c1e016259b$export$df7c425476ed4f2(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $806c23c1e016259b$export$c69d65aa55814164(cols) {
    for (let col of cols){
        if (col.width === 'shrink') return true;
    }
    return false;
}
function $806c23c1e016259b$export$65ab0ebced932b79(liquid, context) {
    let classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table')
    ];
    if (liquid) classNames.push('fc-scrollgrid-liquid');
    return classNames;
}
function $806c23c1e016259b$export$101619b11a34a0bd(sectionConfig, wholeTableVGrow) {
    let classNames = [
        'fc-scrollgrid-section',
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
    if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
    return classNames;
}
function $806c23c1e016259b$export$1ec7a8278ebd1290(arg) {
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $806c23c1e016259b$export$89e9012e902952b6(options) {
    let { stickyHeaderDates: stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyHeaderDates;
}
function $806c23c1e016259b$export$4ad369a19af21c23(options) {
    let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyFooterScrollbar;
}
class $806c23c1e016259b$export$c667925124dac624 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.processCols = $806c23c1e016259b$export$df995fae86a55f06((a)=>a, $806c23c1e016259b$export$f5339a28e56d1baf); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = $806c23c1e016259b$export$df995fae86a55f06($806c23c1e016259b$export$add49c223b9ce4ea);
        this.scrollerRefs = new $806c23c1e016259b$export$807f1ba34db587c7();
        this.scrollerElRefs = new $806c23c1e016259b$export$807f1ba34db587c7(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = $806c23c1e016259b$export$65ab0ebced932b79(props.liquid, context);
        if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !$806c23c1e016259b$export$738ab4df8bf92ae9();
        const roleAttrs = {
            role: 'rowgroup'
        };
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('table', {
            role: 'grid',
            className: classNames.join(' '),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('thead', roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('tbody', roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('tfoot', roleAttrs, ...footSectionNodes), isBuggy && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('tbody', roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ('outerContent' in sectionConfig) return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: $806c23c1e016259b$export$101619b11a34a0bd(sectionConfig, this.props.liquid).join(' ')
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
        let { props: props } = this;
        let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
        let needsYScrolling = $806c23c1e016259b$export$df838d0240c938cf(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = $806c23c1e016259b$export$60e660859c376841(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
        let sectionKey = sectionConfig.key;
        let content = $806c23c1e016259b$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(isHeader ? 'th' : 'td', {
            ref: chunkConfig.elRef,
            role: 'presentation'
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: `fc-scroller-harness${isLiquid ? ' fc-scroller-harness-liquid' : ''}`
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$54c4fabc2291e9c0, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = $806c23c1e016259b$var$getSectionByKey(this.props.sections, key);
        if (section) $806c23c1e016259b$export$71cec2538cb2c617(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return $806c23c1e016259b$export$c69d65aa55814164(this.props.cols) ? $806c23c1e016259b$export$7fe88b5920ffddd2(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = $806c23c1e016259b$export$a1edd97dd51cd48d();
        let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    }
}
$806c23c1e016259b$export$c667925124dac624.addStateEquality({
    scrollerClientWidths: $806c23c1e016259b$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $806c23c1e016259b$export$a9c23c6ac3fc3eca
});
function $806c23c1e016259b$var$getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class $806c23c1e016259b$export$c1df809846363ebe extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            if (el) $806c23c1e016259b$var$setElSeg(el, this.props.seg);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { seg: seg } = props;
        const { eventRange: eventRange } = seg;
        const { ui: ui } = eventRange;
        const renderProps = {
            event: new $806c23c1e016259b$export$71511d61b312f219(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && $806c23c1e016259b$var$computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && $806c23c1e016259b$var$computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && $806c23c1e016259b$var$computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, Object.assign({}, props /* contains children */ , {
            elRef: this.handleEl,
            elClasses: [
                ...$806c23c1e016259b$var$getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }));
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) $806c23c1e016259b$var$setElSeg(this.el, this.props.seg);
    }
}
// should not be a purecomponent
class $806c23c1e016259b$export$6735ce526161c7bd extends $806c23c1e016259b$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let { ui: ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = $806c23c1e016259b$export$2538633961795d6b(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$c1df809846363ebe, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: $806c23c1e016259b$export$6dabbe08653f866f(seg, context),
            defaultGenerator: $806c23c1e016259b$var$renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-event-main'
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
function $806c23c1e016259b$var$renderInnerContent$1(innerProps) {
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title-container"
    }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, "\u00A0"))));
}
const $806c23c1e016259b$export$6e4b1d19c6e2e012 = (props)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { options: options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elTag: props.elTag || 'div',
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }));
    });
const $806c23c1e016259b$var$DAY_NUM_FORMAT = $806c23c1e016259b$export$d141bba7fdc215a3({
    day: 'numeric'
});
class $806c23c1e016259b$export$c5d7c1ac98841e53 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.refineRenderProps = $806c23c1e016259b$export$ebd11618f299a286($806c23c1e016259b$var$refineRenderProps);
    }
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elClasses: [
                ...$806c23c1e016259b$export$1a8f5705751d8277(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                'data-date': $806c23c1e016259b$export$56350196709588fc(props.date)
            }),
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }));
    }
}
function $806c23c1e016259b$export$d92db8a7dc823bb0(options) {
    return Boolean(options.dayCellContent || $806c23c1e016259b$var$hasCustomRenderingHandler('dayCellContent', options));
}
function $806c23c1e016259b$var$refineRenderProps(raw) {
    let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
    let dayMeta = $806c23c1e016259b$export$e171bab687b50e0(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $806c23c1e016259b$var$DAY_NUM_FORMAT) : '';
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
class $806c23c1e016259b$export$b02498c06ddfef28 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { seg: seg } = props;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$c1df809846363ebe, {
            elTag: "div",
            elClasses: [
                'fc-bg-event'
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: $806c23c1e016259b$var$renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function $806c23c1e016259b$var$renderInnerContent(props) {
    let { title: title } = props.event;
    return title && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $806c23c1e016259b$export$b975d55abac2bbe3(fillType) {
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: `fc-${fillType}`
    });
}
const $806c23c1e016259b$export$1343a74baacb0543 = (props)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { dateEnv: dateEnv, options: options } = context;
        let { date: date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , Object.assign({}, props /* includes children */ , {
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $806c23c1e016259b$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }));
    });
function $806c23c1e016259b$var$renderInner(innerProps) {
    return innerProps.text;
}
const $806c23c1e016259b$var$PADDING_FROM_VIEWPORT = 10;
class $806c23c1e016259b$var$Popover extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            titleId: $806c23c1e016259b$export$6559d589eb85fbb6()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $806c23c1e016259b$export$71cec2538cb2c617(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = $806c23c1e016259b$export$2ed0fc6709e59212(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === 'Escape') this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose: onClose } = this.props;
            if (onClose) onClose();
        };
    }
    render() {
        let { theme: theme, options: options } = this.context;
        let { props: props, state: state } = this;
        let classNames = [
            'fc-popover',
            theme.getClass('popover')
        ].concat(props.extraClassNames || []);
        return (0, $aac9273d3c8f822f$export$d39a5bbd09211389)((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(' '),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: 'fc-popover-header ' + theme.getClass('popoverHeader')
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("span", {
            className: 'fc-popover-close ' + theme.getIconClass('close'),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: 'fc-popover-body ' + theme.getClass('popoverContent')
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentMouseDown);
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl: isRtl } = this.context;
        let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
        let { rootEl: rootEl } = this;
        let alignmentRect = $806c23c1e016259b$var$computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? $806c23c1e016259b$export$dc98b0b04f4c7758(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, $806c23c1e016259b$var$PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $806c23c1e016259b$var$PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, $806c23c1e016259b$var$PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            $806c23c1e016259b$export$faec65b429be379(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
}
class $806c23c1e016259b$var$MorePopover extends $806c23c1e016259b$export$d22783b3c2400a3a {
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { options: options, dateEnv: dateEnv } = this.context;
        let { props: props } = this;
        let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$c5d7c1ac98841e53, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$var$Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    'fc-more-popover'
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, $806c23c1e016259b$export$d92db8a7dc823bb0(options) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-more-popover-misc'
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl: rootEl, props: props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
}
class $806c23c1e016259b$export$87b6ab1c2cb8b955 extends $806c23c1e016259b$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: $806c23c1e016259b$export$6559d589eb85fbb6()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) $806c23c1e016259b$export$71cec2538cb2c617(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props: props, context: context } = this;
            let { moreLinkClick: moreLinkClick } = context.options;
            let date = $806c23c1e016259b$var$computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def: def, instance: instance, range: range } = seg.eventRange;
                return {
                    event: new $806c23c1e016259b$export$71511d61b312f219(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === 'popover') this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
            let { moreLinkText: moreLinkText } = options;
            let { moreCnt: moreCnt } = props;
            let range = $806c23c1e016259b$var$computeRange(props);
            let text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = $806c23c1e016259b$export$342063e11d6c3cad(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text: text,
                view: viewApi
            };
            return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, Boolean(props.moreCnt) && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$export$e7094788287c5e9b, {
                elTag: props.elTag || 'a',
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    'fc-more-link'
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $806c23c1e016259b$var$createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    'aria-expanded': state.isPopoverOpen,
                    'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || $806c23c1e016259b$var$renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($806c23c1e016259b$var$MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = $806c23c1e016259b$export$dc98b0b04f4c7758(this.linkEl, '.fc-view-harness');
    }
}
function $806c23c1e016259b$var$renderMoreLinkInner(props) {
    return props.text;
}
function $806c23c1e016259b$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $806c23c1e016259b$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    let { hiddenSegs: hiddenSegs } = props;
    return {
        start: $806c23c1e016259b$export$cd571ca6d1702b73(hiddenSegs),
        end: $806c23c1e016259b$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $806c23c1e016259b$export$cd571ca6d1702b73(segs) {
    return segs.reduce($806c23c1e016259b$var$pickEarliestStart).eventRange.range.start;
}
function $806c23c1e016259b$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $806c23c1e016259b$var$computeLatestSegEnd(segs) {
    return segs.reduce($806c23c1e016259b$var$pickLatestEnd).eventRange.range.end;
}
function $806c23c1e016259b$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class $806c23c1e016259b$var$Store {
    constructor(){
        this.handlers = [];
    }
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class $806c23c1e016259b$export$1776704b6532a19a extends $806c23c1e016259b$var$Store {
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
    // for consistent order
    handle(customRendering) {
        const { map: map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
}




const $b12be9f4f0b8bc94$export$794e7bef9c0b12d9 = [];
const $b12be9f4f0b8bc94$var$MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list'
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display'
};
const $b12be9f4f0b8bc94$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $b12be9f4f0b8bc94$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today (buttonText, unit) {
            return unit === 'day' ? 'Today' : `This ${buttonText}`;
        }
    },
    viewHint: '$0 view',
    navLinkHint: 'Go to $0',
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? '' : 's'}`;
    }
});
function $b12be9f4f0b8bc94$var$organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    let allRawLocales = $b12be9f4f0b8bc94$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: $b12be9f4f0b8bc94$var$RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $b12be9f4f0b8bc94$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) return $b12be9f4f0b8bc94$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $b12be9f4f0b8bc94$var$queryLocale(inputSingular, available);
}
function $b12be9f4f0b8bc94$var$queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = $b12be9f4f0b8bc94$var$queryRawLocale(codes, available) || $b12be9f4f0b8bc94$var$RAW_EN_LOCALE;
    return $b12be9f4f0b8bc94$var$parseLocale(codeArg, codes, raw);
}
function $b12be9f4f0b8bc94$var$queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split('-');
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $b12be9f4f0b8bc94$var$parseLocale(codeArg, codes, raw) {
    let merged = (0, $806c23c1e016259b$export$953cecd6e717a553)([
        $b12be9f4f0b8bc94$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        'buttonText'
    ]);
    delete merged.code; // don't want this part of the options
    let { week: week } = merged;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $b12be9f4f0b8bc94$export$ae829ec7b2625219(input) {
    return {
        id: (0, $806c23c1e016259b$export$39b482c5e57630a8)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $b12be9f4f0b8bc94$var$buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = $b12be9f4f0b8bc94$var$combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $b12be9f4f0b8bc94$var$buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, $806c23c1e016259b$export$23f2a1d2818174ef)(overrideDefs, currentOverrideDefs) || !(0, $806c23c1e016259b$export$23f2a1d2818174ef)(globalDefs, currentGlobalDefs)) currentHooks = $b12be9f4f0b8bc94$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $b12be9f4f0b8bc94$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $b12be9f4f0b8bc94$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $b12be9f4f0b8bc94$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class $b12be9f4f0b8bc94$var$StandardTheme extends (0, $806c23c1e016259b$export$971d5caa766a69d7) {
}
$b12be9f4f0b8bc94$var$StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active'
};
$b12be9f4f0b8bc94$var$StandardTheme.prototype.baseIconClass = 'fc-icon';
$b12be9f4f0b8bc94$var$StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right'
};
$b12be9f4f0b8bc94$var$StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left'
};
$b12be9f4f0b8bc94$var$StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
$b12be9f4f0b8bc94$var$StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
$b12be9f4f0b8bc94$var$StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
function $b12be9f4f0b8bc94$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)$b12be9f4f0b8bc94$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$b12be9f4f0b8bc94$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $b12be9f4f0b8bc94$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = $b12be9f4f0b8bc94$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $b12be9f4f0b8bc94$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp('component');
    let superType = queryProp('superType');
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
        superDef = $b12be9f4f0b8bc94$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $b12be9f4f0b8bc94$var$parseViewConfigs(inputs) {
    return (0, $806c23c1e016259b$export$407448d2b89b1813)(inputs, $b12be9f4f0b8bc94$var$parseViewConfig);
}
function $b12be9f4f0b8bc94$var$parseViewConfig(input) {
    let rawOptions = typeof input === 'function' ? {
        component: input
    } : input;
    let { component: component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $b12be9f4f0b8bc94$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $806c23c1e016259b$export$ef35774e6d314e91))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $b12be9f4f0b8bc94$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $b12be9f4f0b8bc94$var$createViewHookComponent(options) {
    return (viewProps)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$e7c866399fa523f5).Consumer, null, (context)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$e7094788287c5e9b), {
                elTag: "div",
                elClasses: (0, $806c23c1e016259b$export$8b22cf2602fb60ce)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function $b12be9f4f0b8bc94$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = $b12be9f4f0b8bc94$var$parseViewConfigs(defaultInputs);
    let overrideConfigs = $b12be9f4f0b8bc94$var$parseViewConfigs(optionOverrides.views);
    let viewDefs = $b12be9f4f0b8bc94$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $806c23c1e016259b$export$407448d2b89b1813)(viewDefs, (viewDef)=>$b12be9f4f0b8bc94$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function $b12be9f4f0b8bc94$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = '';
    let singleUnit = '';
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = $b12be9f4f0b8bc94$var$createDurationCached(durationInput);
        if (duration) {
            let denom = (0, $806c23c1e016259b$export$db3b6bfb95261072)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $806c23c1e016259b$export$f1e1789686576879)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $806c23c1e016259b$export$f1e1789686576879))
    };
}
// hack to get memoization working
let $b12be9f4f0b8bc94$var$durationInputMap = {};
function $b12be9f4f0b8bc94$var$createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = $b12be9f4f0b8bc94$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $806c23c1e016259b$export$4368d992c4eafac0)(durationInput);
        $b12be9f4f0b8bc94$var$durationInputMap[json] = res;
    }
    return res;
}
function $b12be9f4f0b8bc94$var$reduceViewType(viewType, action) {
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}
function $b12be9f4f0b8bc94$var$reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function $b12be9f4f0b8bc94$var$getInitialDate(options, dateEnv, nowManager) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function $b12be9f4f0b8bc94$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case 'SET_OPTION':
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $b12be9f4f0b8bc94$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $b12be9f4f0b8bc94$var$initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return $b12be9f4f0b8bc94$var$addSources({}, $b12be9f4f0b8bc94$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $b12be9f4f0b8bc94$var$reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case 'ADD_EVENT_SOURCES':
            return $b12be9f4f0b8bc94$var$addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return $b12be9f4f0b8bc94$var$removeSource(eventSources, action.sourceId);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $b12be9f4f0b8bc94$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return $b12be9f4f0b8bc94$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $806c23c1e016259b$export$2d1720544b23b823)(action.sourceIds) : $b12be9f4f0b8bc94$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return $b12be9f4f0b8bc94$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function $b12be9f4f0b8bc94$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $b12be9f4f0b8bc94$var$fetchSourcesByIds(eventSources, $b12be9f4f0b8bc94$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $b12be9f4f0b8bc94$var$computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $b12be9f4f0b8bc94$var$addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = $b12be9f4f0b8bc94$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $b12be9f4f0b8bc94$var$removeSource(eventSourceHash, sourceId) {
    return (0, $806c23c1e016259b$export$dda1d9f60106f0e9)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function $b12be9f4f0b8bc94$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $b12be9f4f0b8bc94$var$fetchSourcesByIds(sourceHash, (0, $806c23c1e016259b$export$dda1d9f60106f0e9)(sourceHash, (eventSource)=>$b12be9f4f0b8bc94$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function $b12be9f4f0b8bc94$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$b12be9f4f0b8bc94$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $b12be9f4f0b8bc94$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $b12be9f4f0b8bc94$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $b12be9f4f0b8bc94$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options: options, calendarApi: calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, $806c23c1e016259b$export$39b482c5e57630a8)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, (res)=>{
        let { rawEvents: rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $b12be9f4f0b8bc94$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $b12be9f4f0b8bc94$var$excludeStaticSources(eventSources, context) {
    return (0, $806c23c1e016259b$export$dda1d9f60106f0e9)(eventSources, (eventSource)=>$b12be9f4f0b8bc94$var$doesSourceNeedRange(eventSource, context));
}
function $b12be9f4f0b8bc94$var$parseInitialSources(rawOptions, context) {
    let refiners = (0, $806c23c1e016259b$export$35e795649ee09318)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, $806c23c1e016259b$export$ffb5f4729a158638)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function $b12be9f4f0b8bc94$var$doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $b12be9f4f0b8bc94$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}
function $b12be9f4f0b8bc94$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $b12be9f4f0b8bc94$var$reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $b12be9f4f0b8bc94$var$reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $b12be9f4f0b8bc94$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? $b12be9f4f0b8bc94$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? $b12be9f4f0b8bc94$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $b12be9f4f0b8bc94$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = $b12be9f4f0b8bc94$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $b12be9f4f0b8bc94$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === 'rtl';
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(',').map((buttonName)=>{
            if (buttonName === 'title') {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $806c23c1e016259b$export$342063e11d6c3cad)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                    let prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                    buttonHint = (0, $806c23c1e016259b$export$342063e11d6c3cad)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || 'year',
                        'year'
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, $806c23c1e016259b$export$342063e11d6c3cad)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        }));
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class $b12be9f4f0b8bc94$var$ViewImpl {
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
}
let $b12be9f4f0b8bc94$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const $b12be9f4f0b8bc94$var$arrayEventSourcePlugin = $b12be9f4f0b8bc94$export$ae829ec7b2625219({
    name: 'array-event-source',
    eventSourceDefs: [
        $b12be9f4f0b8bc94$var$eventSourceDef$2
    ]
});
let $b12be9f4f0b8bc94$var$eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === 'function') return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv: dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, $806c23c1e016259b$export$3b14a55fb2447963)(func.bind(null, (0, $806c23c1e016259b$export$882b5998b3b9117c)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents: rawEvents
            }), errorCallback);
    }
};
const $b12be9f4f0b8bc94$var$funcEventSourcePlugin = $b12be9f4f0b8bc94$export$ae829ec7b2625219({
    name: 'func-event-source',
    eventSourceDefs: [
        $b12be9f4f0b8bc94$var$eventSourceDef$1
    ]
});
const $b12be9f4f0b8bc94$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let $b12be9f4f0b8bc94$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) return {
            url: refined.url,
            format: 'json',
            method: (refined.method || 'GET').toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta: meta } = arg.eventSource;
        const requestParams = $b12be9f4f0b8bc94$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $806c23c1e016259b$export$43caf9889c228507)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
const $b12be9f4f0b8bc94$var$jsonFeedEventSourcePlugin = $b12be9f4f0b8bc94$export$ae829ec7b2625219({
    name: 'json-event-source',
    eventSourceRefiners: $b12be9f4f0b8bc94$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $b12be9f4f0b8bc94$var$eventSourceDef
    ]
});
function $b12be9f4f0b8bc94$var$buildRequestParams(meta, range, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const $b12be9f4f0b8bc94$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    startTime: (0, $806c23c1e016259b$export$4368d992c4eafac0),
    endTime: (0, $806c23c1e016259b$export$4368d992c4eafac0),
    duration: (0, $806c23c1e016259b$export$4368d992c4eafac0),
    startRecur: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    endRecur: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5)
};
let $b12be9f4f0b8bc94$var$recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv: dateEnv
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $806c23c1e016259b$export$2408f22a0fab9ae5)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, $806c23c1e016259b$export$ae1af26003f05816)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $b12be9f4f0b8bc94$var$expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
const $b12be9f4f0b8bc94$var$simpleRecurringEventsPlugin = $b12be9f4f0b8bc94$export$ae829ec7b2625219({
    name: 'simple-recurring-event',
    recurringTypes: [
        $b12be9f4f0b8bc94$var$recurring
    ],
    eventRefiners: $b12be9f4f0b8bc94$var$SIMPLE_RECURRING_REFINERS
});
function $b12be9f4f0b8bc94$var$expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    let dowHash = daysOfWeek ? (0, $806c23c1e016259b$export$2d1720544b23b823)(daysOfWeek) : null;
    let dayMarker = (0, $806c23c1e016259b$export$9e5f44173e64f162)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, $806c23c1e016259b$export$625550452a3fa3ec)(dayMarker, 1);
    }
    return instanceStarts;
}
const $b12be9f4f0b8bc94$var$changeHandlerPlugin = $b12be9f4f0b8bc94$export$ae829ec7b2625219({
    name: 'change-handler',
    optionChangeHandlers: {
        events (events, context) {
            $b12be9f4f0b8bc94$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $b12be9f4f0b8bc94$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $b12be9f4f0b8bc94$var$handleEventSources(inputs, context) {
    let unfoundSources = (0, $806c23c1e016259b$export$90a7f3efeed30595)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: 'RESET_RAW_EVENTS',
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: 'REMOVE_EVENT_SOURCE',
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function $b12be9f4f0b8bc94$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, $806c23c1e016259b$export$882b5998b3b9117c)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $b12be9f4f0b8bc94$var$handleEventStore(eventStore, context) {
    let { emitter: emitter } = context;
    if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, $806c23c1e016259b$export$efccba1c4a2ef57b)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const $b12be9f4f0b8bc94$export$905153d94e0757fa = [
    $b12be9f4f0b8bc94$var$arrayEventSourcePlugin,
    $b12be9f4f0b8bc94$var$funcEventSourcePlugin,
    $b12be9f4f0b8bc94$var$jsonFeedEventSourcePlugin,
    $b12be9f4f0b8bc94$var$simpleRecurringEventsPlugin,
    $b12be9f4f0b8bc94$var$changeHandlerPlugin,
    $b12be9f4f0b8bc94$export$ae829ec7b2625219({
        name: 'misc',
        isLoadingFuncs: [
            (state)=>$b12be9f4f0b8bc94$var$computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: $b12be9f4f0b8bc94$var$handleDateProfile,
            eventStore: $b12be9f4f0b8bc94$var$handleEventStore
        }
    })
];
class $b12be9f4f0b8bc94$var$TaskRunner {
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $806c23c1e016259b$export$96f57966bedc81b4)(this.drain.bind(this));
    }
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue: queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function $b12be9f4f0b8bc94$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $806c23c1e016259b$export$d141bba7fdc215a3)(viewOptions.titleFormat || $b12be9f4f0b8bc94$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $b12be9f4f0b8bc94$var$buildTitleFormat(dateProfile) {
    let { currentRangeUnit: currentRangeUnit } = dateProfile;
    if (currentRangeUnit === 'year') return {
        year: 'numeric'
    };
    if (currentRangeUnit === 'month') return {
        year: 'numeric',
        month: 'long'
    }; // like "September 2014"
    let days = (0, $806c23c1e016259b$export$4a5767248b18ef41)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    // one day. longer, like "September 9 2014"
    return {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ class $b12be9f4f0b8bc94$var$CalendarNowManager {
    constructor(){
        this.resetListeners = new Set();
    }
    handleInput(dateEnv, nowInput) {
        const oldDateEnv = this.dateEnv;
        if (dateEnv !== oldDateEnv) {
            if (typeof nowInput === 'function') this.nowFn = nowInput;
            else if (!oldDateEnv) {
                this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                this.nowAnchorQueried = Date.now();
            }
            this.dateEnv = dateEnv;
            // not first time? fire reset handlers
            if (oldDateEnv) for (const resetListener of this.resetListeners.values())resetListener();
        }
    }
    getDateMarker() {
        return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
    }
    addResetListener(handler) {
        this.resetListeners.add(handler);
    }
    removeResetListener(handler) {
        this.resetListeners.delete(handler);
    }
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class $b12be9f4f0b8bc94$var$CalendarDataManager {
    constructor(props){
        this.computeCurrentViewData = (0, $806c23c1e016259b$export$df995fae86a55f06)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$organizeRawLocales);
        this.buildLocale = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildLocale);
        this.buildPluginHooks = $b12be9f4f0b8bc94$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildDateEnv$1);
        this.buildTheme = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildTheme);
        this.parseToolbars = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$parseToolbars);
        this.buildViewSpecs = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $806c23c1e016259b$export$ebd11618f299a286)($b12be9f4f0b8bc94$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildViewApi);
        this.buildViewUiProps = (0, $806c23c1e016259b$export$ebd11618f299a286)($b12be9f4f0b8bc94$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildEventUiBySource, (0, $806c23c1e016259b$export$a9c23c6ac3fc3eca));
        this.buildEventUiBases = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $806c23c1e016259b$export$ebd11618f299a286)($b12be9f4f0b8bc94$var$parseContextBusinessHours);
        this.buildTitle = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildTitle);
        this.nowManager = new $b12be9f4f0b8bc94$var$CalendarNowManager();
        this.emitter = new (0, $806c23c1e016259b$export$d66501df72047452)();
        this.actionRunner = new $b12be9f4f0b8bc94$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new $b12be9f4f0b8bc94$var$CalendarNowManager();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        let currentDate = $b12be9f4f0b8bc94$var$getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $806c23c1e016259b$export$2329c99376c9d0a4)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = $b12be9f4f0b8bc94$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
            renderableEventStore: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if ($b12be9f4f0b8bc94$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    resetOptions(optionOverrides, changedOptionNames) {
        let { props: props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: 'NOTHING'
        });
    }
    _handleAction(action) {
        let { props: props, state: state, emitter: emitter } = this;
        let dynamicOptionOverrides = $b12be9f4f0b8bc94$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = $b12be9f4f0b8bc94$var$reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate: currentDate, dateProfile: dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = $b12be9f4f0b8bc94$var$reduceCurrentDate(currentDate, action);
        dateProfile = $b12be9f4f0b8bc94$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
        action.type === 'NEXT' || // "
        !(0, $806c23c1e016259b$export$2329c99376c9d0a4)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = $b12be9f4f0b8bc94$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, $806c23c1e016259b$export$9bb611d729802a56)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = $b12be9f4f0b8bc94$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: $b12be9f4f0b8bc94$var$reduceDateSelection(state.dateSelection, action),
            eventSelection: $b12be9f4f0b8bc94$var$reduceSelectedEvent(state.eventSelection, action),
            eventDrag: $b12be9f4f0b8bc94$var$reduceEventDrag(state.eventDrag, action),
            eventResize: $b12be9f4f0b8bc94$var$reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = $b12be9f4f0b8bc94$var$computeIsLoading(state, calendarContext);
        let isLoading = $b12be9f4f0b8bc94$var$computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger('loading', true);
        else if (wasLoading && !isLoading) emitter.trigger('loading', false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props: props, state: state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            nowManager: this.nowManager,
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = $b12be9f4f0b8bc94$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, $806c23c1e016259b$export$b4171a6734a65d42)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, $806c23c1e016259b$export$b4171a6734a65d42)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        $b12be9f4f0b8bc94$var$warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales: locales, locale: locale } = (0, $806c23c1e016259b$export$3466f893ebf79586)([
            (0, $806c23c1e016259b$export$f1e1789686576879),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $b12be9f4f0b8bc94$export$905153d94e0757fa);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $806c23c1e016259b$export$61196ced6d74a310)), (0, $806c23c1e016259b$export$3a1a48c8f6ef640e)), (0, $806c23c1e016259b$export$a07804094c3ecf2d)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, $806c23c1e016259b$export$3466f893ebf79586)([
            (0, $806c23c1e016259b$export$f1e1789686576879),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $806c23c1e016259b$export$c4ce752e73470fba)[optionName] && optionName in currentRaw && (0, $806c23c1e016259b$export$c4ce752e73470fba)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        $b12be9f4f0b8bc94$var$warnUnknownOptions(extra);
        this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            nowManager: this.nowManager,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, $806c23c1e016259b$export$3466f893ebf79586)([
            (0, $806c23c1e016259b$export$f1e1789686576879),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $806c23c1e016259b$export$61196ced6d74a310)), (0, $806c23c1e016259b$export$3a1a48c8f6ef640e)), (0, $806c23c1e016259b$export$a07804094c3ecf2d)), (0, $806c23c1e016259b$export$56c0d5a1e737357d)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $806c23c1e016259b$export$c4ce752e73470fba)[optionName] && (0, $806c23c1e016259b$export$c4ce752e73470fba)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $806c23c1e016259b$export$c4ce752e73470fba)[optionName] && (0, $806c23c1e016259b$export$c4ce752e73470fba)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    }
}
function $b12be9f4f0b8bc94$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = $b12be9f4f0b8bc94$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $806c23c1e016259b$export$3722cfe417b6ed86)({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $b12be9f4f0b8bc94$var$buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $b12be9f4f0b8bc94$var$StandardTheme;
    return new ThemeClass(options);
}
function $b12be9f4f0b8bc94$var$buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $806c23c1e016259b$export$db202ddc8be9136);
    return new DateProfileGeneratorClass(props);
}
function $b12be9f4f0b8bc94$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $b12be9f4f0b8bc94$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $b12be9f4f0b8bc94$var$buildEventUiBySource(eventSources) {
    return (0, $806c23c1e016259b$export$407448d2b89b1813)(eventSources, (eventSource)=>eventSource.ui);
}
function $b12be9f4f0b8bc94$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        '': eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $b12be9f4f0b8bc94$var$buildViewUiProps(calendarContext) {
    let { options: options } = calendarContext;
    return {
        eventUiSingleBase: (0, $806c23c1e016259b$export$25ce5a424b770e84)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $806c23c1e016259b$export$25ce5a424b770e84)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $b12be9f4f0b8bc94$var$computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function $b12be9f4f0b8bc94$var$parseContextBusinessHours(calendarContext) {
    return (0, $806c23c1e016259b$export$3a6d5c9ae78a2c08)(calendarContext.options.businessHours, calendarContext);
}
function $b12be9f4f0b8bc94$var$warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ''));
}
class $b12be9f4f0b8bc94$var$ToolbarSection extends (0, $806c23c1e016259b$export$ef35774e6d314e91) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('div', {
            className: 'fc-toolbar-chunk'
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props: props } = this;
        let { theme: theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass('button')
                ];
                if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                children.push((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("button", {
                    type: "button",
                    title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(' '),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("span", {
                    className: buttonIcon,
                    role: "img"
                }) : '')));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
            return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)('div', {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class $b12be9f4f0b8bc94$var$Toolbar extends (0, $806c23c1e016259b$export$ef35774e6d314e91) {
    render() {
        let { model: model, extraClassName: extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : ''
        ];
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: classNames.join(' ')
        }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props: props } = this;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($b12be9f4f0b8bc94$var$ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class $b12be9f4f0b8bc94$var$ViewHarness extends (0, $806c23c1e016259b$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, $806c23c1e016259b$export$71cec2538cb2c617)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
    render() {
        let { props: props, state: state } = this;
        let { aspectRatio: aspectRatio } = props;
        let classNames = [
            'fc-view-harness',
            aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' // harness controls the height
             : 'fc-view-harness-passive'
        ];
        let height = '';
        let paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || '';
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(' '),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class $b12be9f4f0b8bc94$var$EventClicking extends (0, $806c23c1e016259b$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, $806c23c1e016259b$export$8743009a87fcb00f)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, $806c23c1e016259b$export$dc98b0b04f4c7758)(ev.target, '.fc-event-forced-url');
                let url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new (0, $806c23c1e016259b$export$71511d61b312f219)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, $806c23c1e016259b$export$3d8c2f653ac9d0b9)(settings.el, 'click', '.fc-event', this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class $b12be9f4f0b8bc94$var$EventHovering extends (0, $806c23c1e016259b$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, $806c23c1e016259b$export$8743009a87fcb00f)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        this.removeHoverListeners = (0, $806c23c1e016259b$export$34aec0b863436764)(settings.el, '.fc-event', this.handleSegEnter, this.handleSegLeave);
    }
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component: component } = this;
        let { context: context } = component;
        let seg = (0, $806c23c1e016259b$export$8743009a87fcb00f)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, $806c23c1e016259b$export$71511d61b312f219)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
}
class $b12be9f4f0b8bc94$var$CalendarContent extends (0, $806c23c1e016259b$export$3c2fa207a37baaea) {
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, $806c23c1e016259b$export$df995fae86a55f06)((0, $806c23c1e016259b$export$ce26c07117d59d6a));
        this.buildViewPropTransformers = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildViewPropTransformers);
        this.buildToolbarProps = (0, $806c23c1e016259b$export$df995fae86a55f06)($b12be9f4f0b8bc94$var$buildToolbarProps);
        this.headerRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.footerRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, $806c23c1e016259b$export$6559d589eb85fbb6)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, $806c23c1e016259b$export$efca4cbe5dd06740)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                $b12be9f4f0b8bc94$var$EventClicking,
                $b12be9f4f0b8bc94$var$EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, $806c23c1e016259b$export$a8550f7dbe79f93a)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, $806c23c1e016259b$export$a8550f7dbe79f93a)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, $806c23c1e016259b$export$96f57966bedc81b4)(()=>{
            this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger('windowResize', {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options: options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props: props } = this;
        let { toolbarConfig: toolbarConfig, options: options } = props;
        let viewVGrow = false;
        let viewHeight = '';
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = '';
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$e7c866399fa523f5).Provider, {
            value: viewContext
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$2e2af4578d910ddf), {
            unit: "day"
        }, (nowDate)=>{
            let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
            return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, toolbarConfig.header && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($b12be9f4f0b8bc94$var$Toolbar, Object.assign({
                ref: this.headerRef,
                extraClassName: "fc-header-toolbar",
                model: toolbarConfig.header,
                titleId: viewLabelId
            }, toolbarProps)), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($b12be9f4f0b8bc94$var$ViewHarness, {
                liquid: viewVGrow,
                height: viewHeight,
                aspectRatio: viewAspectRatio,
                labeledById: viewLabelId
            }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($b12be9f4f0b8bc94$var$Toolbar, Object.assign({
                ref: this.footerRef,
                extraClassName: "fc-footer-toolbar",
                model: toolbarConfig.footer,
                titleId: ""
            }, toolbarProps)));
        }));
    }
    componentDidMount() {
        let { props: props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener('resize', this.handleWindowResize);
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props: props } = this;
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger('_unmount');
    }
    buildAppendContent() {
        let { props: props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks: pluginHooks } = props;
        let { viewSpec: viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(ViewComponent, Object.assign({}, viewProps));
    }
}
function $b12be9f4f0b8bc94$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $806c23c1e016259b$export$2329c99376c9d0a4)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $b12be9f4f0b8bc94$var$buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class $b12be9f4f0b8bc94$export$e1aef45b828286de extends (0, $806c23c1e016259b$export$a93c5207d687da10) {
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData: currentData } = this;
                (0, $806c23c1e016259b$export$c3950d9923825c02)(()=>{
                    (0, $c329b3b3780c47a8$export$b3890eb0ae9dca99)((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$a9c996f45e5784d0), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$7910e0436ed8d1de).Provider, {
                            value: this.customContentRenderId
                        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($b12be9f4f0b8bc94$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, $c329b3b3780c47a8$export$b3890eb0ae9dca99)(null, this.el);
                this.setClassNames([]);
                this.setHeight('');
            }
        };
        (0, $806c23c1e016259b$export$555508cbc6add439)(el);
        this.el = el;
        this.renderRunner = new (0, $806c23c1e016259b$export$96f57966bedc81b4)(this.handleRenderRequest);
        new $b12be9f4f0b8bc94$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, $806c23c1e016259b$export$c3950d9923825c02)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    }
    pauseRendering() {
        this.renderRunner.pause('pauseRendering');
    }
    resumeRendering() {
        this.renderRunner.resume('pauseRendering', true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, $806c23c1e016259b$export$23f2a1d2818174ef)(classNames, this.currentClassNames)) {
            let { classList: classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, $806c23c1e016259b$export$2219238a014317b0)(this.el, 'height', height);
    }
}
function $b12be9f4f0b8bc94$export$3ae94a2503e890a1(dateInput, options = {}) {
    let dateEnv = $b12be9f4f0b8bc94$var$buildDateEnv(options);
    let formatter = (0, $806c23c1e016259b$export$d141bba7fdc215a3)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return '';
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $b12be9f4f0b8bc94$export$9b1080e2eec9158(startInput, endInput, options) {
    let dateEnv = $b12be9f4f0b8bc94$var$buildDateEnv(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    let formatter = (0, $806c23c1e016259b$export$d141bba7fdc215a3)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return '';
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $806c23c1e016259b$export$f1e1789686576879).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $b12be9f4f0b8bc94$var$buildDateEnv(settings) {
    let locale = $b12be9f4f0b8bc94$var$buildLocale(settings.locale || 'en', $b12be9f4f0b8bc94$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $806c23c1e016259b$export$3722cfe417b6ed86)(Object.assign(Object.assign({
        timeZone: (0, $806c23c1e016259b$export$f1e1789686576879).timeZone,
        calendarSystem: 'gregory'
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $b12be9f4f0b8bc94$export$3b384895d0cca0f2(props, allDay) {
    return (0, $806c23c1e016259b$export$4c3d22f3d993c33f)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const $b12be9f4f0b8bc94$export$83d89fbfd8236492 = '6.1.17';





/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class $f9357e1d4d6e2cc8$export$b3c27e869d856b7 extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.headerElRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
    }
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props: props, context: context } = this;
        let sections = [];
        let stickyHeaderDates = (0, $806c23c1e016259b$export$89e9012e902952b6)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$a3c9165b94390bcd), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$c667925124dac624), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { props: props, context: context } = this;
        let stickyHeaderDates = !props.forPrint && (0, $806c23c1e016259b$export$89e9012e902952b6)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $806c23c1e016259b$export$4ad369a19af21c23)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: 'main',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [
                {
                    key: 'main',
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: 'footer',
            key: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'main',
                    content: (0, $806c23c1e016259b$export$1ec7a8278ebd1290)
                }
            ]
        });
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$a3c9165b94390bcd), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
}
function $f9357e1d4d6e2cc8$var$splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function $f9357e1d4d6e2cc8$var$splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function $f9357e1d4d6e2cc8$var$splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const $f9357e1d4d6e2cc8$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $806c23c1e016259b$export$d141bba7fdc215a3)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow'
});
function $f9357e1d4d6e2cc8$var$hasListItemDisplay(seg) {
    let { display: display } = seg.eventRange.ui;
    return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class $f9357e1d4d6e2cc8$var$TableBlockEvent extends (0, $806c23c1e016259b$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$6735ce526161c7bd), Object.assign({}, props, {
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-block-event',
                'fc-h-event'
            ],
            defaultTimeFormat: $f9357e1d4d6e2cc8$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class $f9357e1d4d6e2cc8$var$TableListItemEvent extends (0, $806c23c1e016259b$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let timeFormat = options.eventTimeFormat || $f9357e1d4d6e2cc8$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, $806c23c1e016259b$export$2538633961795d6b)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$c1df809846363ebe), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-dot-event'
            ],
            elAttrs: (0, $806c23c1e016259b$export$6dabbe08653f866f)(props.seg, context),
            defaultGenerator: $f9357e1d4d6e2cc8$var$renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function $f9357e1d4d6e2cc8$var$renderInnerContent(renderProps) {
    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, "\u00A0")));
}
class $f9357e1d4d6e2cc8$var$TableCellMoreLink extends (0, $806c23c1e016259b$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.compileSegs = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$compileSegs);
    }
    render() {
        let { props: props } = this;
        let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$87b6ab1c2cb8b955), {
            elClasses: [
                'fc-daygrid-more-link'
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                        }
                    }, $f9357e1d4d6e2cc8$var$hasListItemDisplay(seg) ? (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $806c23c1e016259b$export$993a080e5cb62d74)(seg, props.todayRange))) : (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $806c23c1e016259b$export$993a080e5cb62d74)(seg, props.todayRange))));
                }));
            }
        });
    }
}
function $f9357e1d4d6e2cc8$var$compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
const $f9357e1d4d6e2cc8$var$DEFAULT_WEEK_NUM_FORMAT = (0, $806c23c1e016259b$export$d141bba7fdc215a3)({
    week: 'narrow'
});
class $f9357e1d4d6e2cc8$var$TableCell extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.state = {
            dayNumberId: (0, $806c23c1e016259b$export$6559d589eb85fbb6)()
        };
        this.handleRootEl = (el)=>{
            (0, $806c23c1e016259b$export$71cec2538cb2c617)(this.rootElRef, el);
            (0, $806c23c1e016259b$export$71cec2538cb2c617)(this.props.elRef, el);
        };
    }
    render() {
        let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
        let { options: options, dateEnv: dateEnv } = context;
        let { date: date, dateProfile: dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && $f9357e1d4d6e2cc8$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$c5d7c1ac98841e53), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                'fc-daygrid-day',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                'aria-labelledby': state.dayNumberId
            } : {}), {
                role: 'gridcell'
            }),
            defaultGenerator: $f9357e1d4d6e2cc8$var$renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$1343a74baacb0543), {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-week-number'
                ],
                elAttrs: (0, $806c23c1e016259b$export$a17c37559e1db147)(context, date, 'week'),
                date: date,
                defaultFormat: $f9357e1d4d6e2cc8$var$DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, $806c23c1e016259b$export$d92db8a7dc823bb0)(options) || props.forceDayTop) ? (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top"
            }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-day-number',
                    isMonthStart && 'fc-daygrid-month-start'
                ],
                elAttrs: Object.assign(Object.assign({}, (0, $806c23c1e016259b$export$a17c37559e1db147)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: 'hidden'
                }
            }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("a", {
                className: "fc-daygrid-day-number"
            }, "\u00A0")) : undefined, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
}
function $f9357e1d4d6e2cc8$var$renderTopInner(props) {
    return props.dayNumberText || (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, "\u00A0");
}
function $f9357e1d4d6e2cc8$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, $806c23c1e016259b$export$51b138e5a065c2bb)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function $f9357e1d4d6e2cc8$var$generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ':' + seg.firstCol;
}
function $f9357e1d4d6e2cc8$var$generateSegUid(seg) {
    return $f9357e1d4d6e2cc8$var$generateSegKey(seg) + ':' + seg.lastCol;
}
function $f9357e1d4d6e2cc8$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    let hierarchy = new $f9357e1d4d6e2cc8$var$DayGridSegHierarchy((segEntry)=>{
        // TODO: more DRY with generateSegUid
        let segUid = segs[segEntry.index].eventRange.instance.instanceId + ':' + segEntry.span.start + ':' + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let segUid = $f9357e1d4d6e2cc8$var$generateSegUid(seg);
        let eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $f9357e1d4d6e2cc8$var$placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: $f9357e1d4d6e2cc8$var$resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: $f9357e1d4d6e2cc8$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: $f9357e1d4d6e2cc8$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function $f9357e1d4d6e2cc8$var$placeRects(allRects, segs, cells) {
    let rectsByEachCol = $f9357e1d4d6e2cc8$var$groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: $f9357e1d4d6e2cc8$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: $f9357e1d4d6e2cc8$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: $f9357e1d4d6e2cc8$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function $f9357e1d4d6e2cc8$var$groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function $f9357e1d4d6e2cc8$var$resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, $806c23c1e016259b$export$ae1af26003f05816)(origRange, {
        start: cells[spanStart].date,
        end: (0, $806c23c1e016259b$export$625550452a3fa3ec)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class $f9357e1d4d6e2cc8$var$DayGridSegHierarchy extends (0, $806c23c1e016259b$export$766bf7dcfb630b6c) {
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel: entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, $806c23c1e016259b$export$674f8f4247a5112e)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
        const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
        // the entry that the new insertion is touching must be hidden
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, $806c23c1e016259b$export$674f8f4247a5112e)(touchingEntry);
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    // split up the touchingEntry, reinsert it
                    const hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, $806c23c1e016259b$export$b0165a7e514844)(touchingEntry.span, entry.span)
                    });
                    // reinsert the area that turned into a "more" link (so no other entries try to
                    // occupy the space) but mark it forced-hidden
                    const hiddenEntryId = (0, $806c23c1e016259b$export$674f8f4247a5112e)(hiddenEntry);
                    forceHidden[hiddenEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(touchingEntry, entry, hiddenEntries);
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        // will try to reslice...
        super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
}
class $f9357e1d4d6e2cc8$var$TableRow extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, $806c23c1e016259b$export$807f1ba34db587c7)(); // the <td>
        this.frameElRefs = new (0, $806c23c1e016259b$export$807f1ba34db587c7)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, $806c23c1e016259b$export$807f1ba34db587c7)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, $806c23c1e016259b$export$807f1ba34db587c7)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let { options: options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = $f9357e1d4d6e2cc8$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = $f9357e1d4d6e2cc8$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = $f9357e1d4d6e2cc8$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = $f9357e1d4d6e2cc8$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $f9357e1d4d6e2cc8$var$computeFgSegPlacement((0, $806c23c1e016259b$export$a91cd623adc48128)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, $f9357e1d4d6e2cc8$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, normalFgNodes), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, mirrorFgNodes)),
                bgContent: (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, this.renderFillSegs(highlightSegsByCol[col], 'highlight'), this.renderFillSegs(businessHoursByCol[col], 'non-business'), this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, $806c23c1e016259b$export$a9c23c6ac3fc3eca)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props: props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props: props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context: context } = this;
        let { eventSelection: eventSelection } = this.props;
        let { framePositions: framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg: seg } = placement;
            let { instanceId: instanceId } = seg.eventRange.instance;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = '';
            let right = '';
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                key: $f9357e1d4d6e2cc8$var$generateSegKey(seg),
                ref: isMirror ? null : this.segHarnessRefs.createRef($f9357e1d4d6e2cc8$var$generateSegUid(seg)),
                style: {
                    visibility: isVisible ? '' : 'hidden',
                    marginTop: isAbsolute ? '' : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : '',
                    left: left,
                    right: right
                }
            }, $f9357e1d4d6e2cc8$var$hasListItemDisplay(seg) ? (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $806c23c1e016259b$export$993a080e5cb62d74)(seg, todayRange))) : (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $806c23c1e016259b$export$993a080e5cb62d74)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl: isRtl } = this.context;
        let { todayRange: todayRange } = this.props;
        let { framePositions: framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
                key: (0, $806c23c1e016259b$export$4d522598b426bb73)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === 'bg-event' ? (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$b02498c06ddfef28), Object.assign({
                seg: seg
            }, (0, $806c23c1e016259b$export$993a080e5cb62d74)(seg, todayRange))) : (0, $806c23c1e016259b$export$b975d55abac2bbe3)(fillType)));
        }
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props: props, state: state, frameElRefs: frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, $806c23c1e016259b$export$ad4aebacdcaf47f8)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, $806c23c1e016259b$export$ad4aebacdcaf47f8)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldSegHeights = this.state.segHeights;
            const newSegHeights = this.querySegHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    querySegHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let segHeights = {};
        // get the max height amongst instance segs
        for(let segUid in segElMap){
            let height = Math.round(segElMap[segUid].getBoundingClientRect().height);
            segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
        }
        return segHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
}
$f9357e1d4d6e2cc8$var$TableRow.addStateEquality({
    segHeights: (0, $806c23c1e016259b$export$a9c23c6ac3fc3eca)
});
function $f9357e1d4d6e2cc8$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = $f9357e1d4d6e2cc8$var$buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function $f9357e1d4d6e2cc8$var$buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class $f9357e1d4d6e2cc8$export$d955b1c53830e05a extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$splitSegsByRow);
        this.splitBgEventSegs = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$splitSegsByRow);
        this.splitFgEventSegs = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$splitSegsByRow);
        this.splitDateSelectionSegs = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$splitSegsByRow);
        this.splitEventDrag = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$splitInteractionByRow);
        this.splitEventResize = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$var$splitInteractionByRow);
        this.rowRefs = new (0, $806c23c1e016259b$export$807f1ba34db587c7)();
    }
    render() {
        let { props: props, context: context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$2e2af4578d910ddf), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $c329b3b3780c47a8$export$ffb0004e005737fa), null, props.cells.map((cells, row)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$var$TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row].filter($f9357e1d4d6e2cc8$var$isSegAllDay),
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        this.registerInteractiveComponent();
    }
    componentDidUpdate() {
        // for if started with zero cells
        this.registerInteractiveComponent();
    }
    registerInteractiveComponent() {
        if (!this.rootEl) {
            // HACK: need a daygrid wrapper parent to do positioning
            // NOTE: a daygrid resource view w/o resources can have zero cells
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            const rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
            if (rootEl) {
                this.rootEl = rootEl;
                this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    isHitComboAllowed: this.props.isHitComboAllowed
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, $806c23c1e016259b$export$ad4aebacdcaf47f8)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, $806c23c1e016259b$export$ad4aebacdcaf47f8)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions: colPositions, rowPositions: rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, $806c23c1e016259b$export$625550452a3fa3ec)(start, 1);
        return {
            start: start,
            end: end
        };
    }
}
function $f9357e1d4d6e2cc8$var$isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class $f9357e1d4d6e2cc8$export$54ec01a60f47d33d extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.elRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.needsScrollReset = false;
    }
    render() {
        let { props: props } = this;
        let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural'
        ];
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            ref: this.elRef,
            className: classNames.join(' '),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ''
            }
        }, props.colGroupNode, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("tbody", {
            role: "presentation"
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$export$d955b1c53830e05a, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = $f9357e1d4d6e2cc8$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest('.fc-daygrid-body');
                const scrollEl = originEl.closest('.fc-scroller');
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
}
function $f9357e1d4d6e2cc8$var$getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, $806c23c1e016259b$export$5dbe06c6d8c68cfb)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, $806c23c1e016259b$export$56350196709588fc)(dateProfile.currentDate)}"]`);
    return el;
}
class $f9357e1d4d6e2cc8$export$eb38be9553e58392 extends (0, $806c23c1e016259b$export$e0c3a065614c6254) {
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
}
class $f9357e1d4d6e2cc8$export$cd402b7558adf371 extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.slicer = new $f9357e1d4d6e2cc8$export$eb38be9553e58392();
        this.tableRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$export$54ec01a60f47d33d, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
}
class $f9357e1d4d6e2cc8$export$39eed66de95896e5 extends $f9357e1d4d6e2cc8$export$b3c27e869d856b7 {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $806c23c1e016259b$export$df995fae86a55f06)($f9357e1d4d6e2cc8$export$61e79f95d746b006);
        this.headerRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.tableRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
    // can't override any lifecycle methods from parent
    }
    render() {
        let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$27d1aff6bea49709), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($f9357e1d4d6e2cc8$export$cd402b7558adf371, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
}
function $f9357e1d4d6e2cc8$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $806c23c1e016259b$export$ebb8f7cd71856fb9)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $806c23c1e016259b$export$1314441b8d04e1d5)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
class $f9357e1d4d6e2cc8$export$9fcce6e2d16ec31d extends (0, $806c23c1e016259b$export$db202ddc8be9136) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props: props } = this;
        return $f9357e1d4d6e2cc8$export$a2ad67969be9f247({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function $f9357e1d4d6e2cc8$export$a2ad67969be9f247(props) {
    let { dateEnv: dateEnv, currentRange: currentRange } = props;
    let { start: start, end: end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $806c23c1e016259b$export$151db275011178c4)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $806c23c1e016259b$export$625550452a3fa3ec)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, $806c23c1e016259b$export$136fd86de524d3c2)(lastMonthRenderStart, end));
        end = (0, $806c23c1e016259b$export$151db275011178c4)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var $f9357e1d4d6e2cc8$var$css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
(0, $806c23c1e016259b$export$e9316ff9106cdb75)($f9357e1d4d6e2cc8$var$css_248z);




var $ec63da3e729bdd2a$export$2e2bcd8739ae039 = (0, $b12be9f4f0b8bc94$export$ae829ec7b2625219)({
    name: '@fullcalendar/daygrid',
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: (0, $f9357e1d4d6e2cc8$export$39eed66de95896e5),
            dateProfileGeneratorClass: (0, $f9357e1d4d6e2cc8$export$9fcce6e2d16ec31d)
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: 'dayGrid',
            duration: {
                years: 1
            }
        }
    }
});




(0, $806c23c1e016259b$export$aff10ba49ece4b91).touchMouseIgnoreWait = 500;
let $3092bb0ca7036a39$var$ignoreMouseDepth = 0;
let $3092bb0ca7036a39$var$listenerCnt = 0;
let $3092bb0ca7036a39$var$isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ class $3092bb0ca7036a39$var$PointerDragging {
    constructor(containerEl){
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ''; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = '';
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = (ev)=>{
            if (!this.shouldIgnoreMouse() && $3092bb0ca7036a39$var$isPrimaryMouseButton(ev) && this.tryStart(ev)) {
                let pev = this.createEventFromMouse(ev, true);
                this.emitter.trigger('pointerdown', pev);
                this.initScrollWatch(pev);
                if (!this.shouldIgnoreMove) document.addEventListener('mousemove', this.handleMouseMove);
                document.addEventListener('mouseup', this.handleMouseUp);
            }
        };
        this.handleMouseMove = (ev)=>{
            let pev = this.createEventFromMouse(ev);
            this.recordCoords(pev);
            this.emitter.trigger('pointermove', pev);
        };
        this.handleMouseUp = (ev)=>{
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
            this.emitter.trigger('pointerup', this.createEventFromMouse(ev));
            this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = (ev)=>{
            if (this.tryStart(ev)) {
                this.isTouchDragging = true;
                let pev = this.createEventFromTouch(ev, true);
                this.emitter.trigger('pointerdown', pev);
                this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                let targetEl = ev.target;
                if (!this.shouldIgnoreMove) targetEl.addEventListener('touchmove', this.handleTouchMove);
                targetEl.addEventListener('touchend', this.handleTouchEnd);
                targetEl.addEventListener('touchcancel', this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener('scroll', this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = (ev)=>{
            let pev = this.createEventFromTouch(ev);
            this.recordCoords(pev);
            this.emitter.trigger('pointermove', pev);
        };
        this.handleTouchEnd = (ev)=>{
            if (this.isDragging) {
                let targetEl = ev.target;
                targetEl.removeEventListener('touchmove', this.handleTouchMove);
                targetEl.removeEventListener('touchend', this.handleTouchEnd);
                targetEl.removeEventListener('touchcancel', this.handleTouchEnd);
                window.removeEventListener('scroll', this.handleTouchScroll, true); // useCaptured=true
                this.emitter.trigger('pointerup', this.createEventFromTouch(ev));
                this.cleanup(); // call last so that pointerup has access to props
                this.isTouchDragging = false;
                $3092bb0ca7036a39$var$startIgnoringMouse();
            }
        };
        this.handleTouchScroll = ()=>{
            this.wasTouchScroll = true;
        };
        this.handleScroll = (ev)=>{
            if (!this.shouldIgnoreMove) {
                let pageX = window.scrollX - this.prevScrollX + this.prevPageX;
                let pageY = window.scrollY - this.prevScrollY + this.prevPageY;
                this.emitter.trigger('pointermove', {
                    origEvent: ev,
                    isTouch: this.isTouchDragging,
                    subjectEl: this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - this.origPageX,
                    deltaY: pageY - this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, $806c23c1e016259b$export$d66501df72047452)();
        containerEl.addEventListener('mousedown', this.handleMouseDown);
        containerEl.addEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        $3092bb0ca7036a39$var$listenerCreated();
    }
    destroy() {
        this.containerEl.removeEventListener('mousedown', this.handleMouseDown);
        this.containerEl.removeEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        $3092bb0ca7036a39$var$listenerDestroyed();
    }
    tryStart(ev) {
        let subjectEl = this.querySubjectEl(ev);
        let downEl = ev.target;
        if (subjectEl && (!this.handleSelector || (0, $806c23c1e016259b$export$dc98b0b04f4c7758)(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    }
    cleanup() {
        $3092bb0ca7036a39$var$isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    }
    querySubjectEl(ev) {
        if (this.selector) return (0, $806c23c1e016259b$export$dc98b0b04f4c7758)(ev.target, this.selector);
        return this.containerEl;
    }
    shouldIgnoreMouse() {
        return $3092bb0ca7036a39$var$ignoreMouseDepth || this.isTouchDragging;
    }
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    cancelTouchScroll() {
        if (this.isDragging) $3092bb0ca7036a39$var$isWindowTouchMoveCancelled = true;
    }
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    initScrollWatch(ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener('scroll', this.handleScroll, true); // useCapture=true
        }
    }
    recordCoords(ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.scrollX;
            this.prevScrollY = window.scrollY;
        }
    }
    destroyScrollWatch() {
        if (this.shouldWatchScroll) window.removeEventListener('scroll', this.handleScroll, true); // useCaptured=true
    }
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    createEventFromMouse(ev, isFirst) {
        let deltaX = 0;
        let deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        } else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    }
    createEventFromTouch(ev, isFirst) {
        let touches = ev.touches;
        let pageX;
        let pageY;
        let deltaX = 0;
        let deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        } else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        } else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    }
}
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function $3092bb0ca7036a39$var$isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function $3092bb0ca7036a39$var$startIgnoringMouse() {
    $3092bb0ca7036a39$var$ignoreMouseDepth += 1;
    setTimeout(()=>{
        $3092bb0ca7036a39$var$ignoreMouseDepth -= 1;
    }, (0, $806c23c1e016259b$export$aff10ba49ece4b91).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function $3092bb0ca7036a39$var$listenerCreated() {
    $3092bb0ca7036a39$var$listenerCnt += 1;
    if ($3092bb0ca7036a39$var$listenerCnt === 1) window.addEventListener('touchmove', $3092bb0ca7036a39$var$onWindowTouchMove, {
        passive: false
    });
}
function $3092bb0ca7036a39$var$listenerDestroyed() {
    $3092bb0ca7036a39$var$listenerCnt -= 1;
    if (!$3092bb0ca7036a39$var$listenerCnt) window.removeEventListener('touchmove', $3092bb0ca7036a39$var$onWindowTouchMove, {
        passive: false
    });
}
function $3092bb0ca7036a39$var$onWindowTouchMove(ev) {
    if ($3092bb0ca7036a39$var$isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ class $3092bb0ca7036a39$var$ElementMirror {
    constructor(){
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    start(sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.scrollX;
        this.origScreenY = pageY - window.scrollY;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    }
    handleMove(pageX, pageY) {
        this.deltaX = pageX - window.scrollX - this.origScreenX;
        this.deltaY = pageY - window.scrollY - this.origScreenY;
        this.updateElPosition();
    }
    // can be called before start
    setIsVisible(bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) this.mirrorEl.style.display = '';
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        } else if (this.isVisible) {
            if (this.mirrorEl) this.mirrorEl.style.display = 'none';
            this.isVisible = bool;
        }
    }
    // always async
    stop(needsRevertAnimation, callback) {
        let done = ()=>{
            this.cleanup();
            callback();
        };
        if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
        (this.deltaX || this.deltaY // if same coords, transition won't work
        )) this.doRevertAnimation(done, this.revertDuration);
        else setTimeout(done, 0);
    }
    doRevertAnimation(callback, revertDuration) {
        let mirrorEl = this.mirrorEl;
        let finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition = 'top ' + revertDuration + 'ms,' + 'left ' + revertDuration + 'ms';
        (0, $806c23c1e016259b$export$faec65b429be379)(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top
        });
        (0, $806c23c1e016259b$export$8c78c7c36408ea29)(mirrorEl, ()=>{
            mirrorEl.style.transition = '';
            callback();
        });
    }
    cleanup() {
        if (this.mirrorEl) {
            (0, $806c23c1e016259b$export$9f4f30ee63539e24)(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    }
    updateElPosition() {
        if (this.sourceEl && this.isVisible) (0, $806c23c1e016259b$export$faec65b429be379)(this.getMirrorEl(), {
            left: this.sourceElRect.left + this.deltaX,
            top: this.sourceElRect.top + this.deltaY
        });
    }
    getMirrorEl() {
        let sourceElRect = this.sourceElRect;
        let mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.style.userSelect = 'none';
            mirrorEl.style.webkitUserSelect = 'none';
            mirrorEl.style.pointerEvents = 'none';
            mirrorEl.classList.add('fc-event-dragging');
            (0, $806c23c1e016259b$export$faec65b429be379)(mirrorEl, {
                position: 'fixed',
                zIndex: this.zIndex,
                visibility: '',
                boxSizing: 'border-box',
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: 'auto',
                bottom: 'auto',
                margin: 0
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    }
}
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ class $3092bb0ca7036a39$var$ScrollGeomCache extends (0, $806c23c1e016259b$export$4ae495d48253603d) {
    constructor(scrollController, doesListening){
        super();
        this.handleScroll = ()=>{
            this.scrollTop = this.scrollController.getScrollTop();
            this.scrollLeft = this.scrollController.getScrollLeft();
            this.handleScrollChange();
        };
        this.scrollController = scrollController;
        this.doesListening = doesListening;
        this.scrollTop = this.origScrollTop = scrollController.getScrollTop();
        this.scrollLeft = this.origScrollLeft = scrollController.getScrollLeft();
        this.scrollWidth = scrollController.getScrollWidth();
        this.scrollHeight = scrollController.getScrollHeight();
        this.clientWidth = scrollController.getClientWidth();
        this.clientHeight = scrollController.getClientHeight();
        this.clientRect = this.computeClientRect(); // do last in case it needs cached values
        if (this.doesListening) this.getEventTarget().addEventListener('scroll', this.handleScroll);
    }
    destroy() {
        if (this.doesListening) this.getEventTarget().removeEventListener('scroll', this.handleScroll);
    }
    getScrollTop() {
        return this.scrollTop;
    }
    getScrollLeft() {
        return this.scrollLeft;
    }
    setScrollTop(top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    }
    setScrollLeft(top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    }
    getClientWidth() {
        return this.clientWidth;
    }
    getClientHeight() {
        return this.clientHeight;
    }
    getScrollWidth() {
        return this.scrollWidth;
    }
    getScrollHeight() {
        return this.scrollHeight;
    }
    handleScrollChange() {}
}
class $3092bb0ca7036a39$var$ElementScrollGeomCache extends $3092bb0ca7036a39$var$ScrollGeomCache {
    constructor(el, doesListening){
        super(new (0, $806c23c1e016259b$export$7060da4b5db56fb9)(el), doesListening);
    }
    getEventTarget() {
        return this.scrollController.el;
    }
    computeClientRect() {
        return (0, $806c23c1e016259b$export$d29e374196577086)(this.scrollController.el);
    }
}
class $3092bb0ca7036a39$var$WindowScrollGeomCache extends $3092bb0ca7036a39$var$ScrollGeomCache {
    constructor(doesListening){
        super(new (0, $806c23c1e016259b$export$c5d1328b37d47994)(), doesListening);
    }
    getEventTarget() {
        return window;
    }
    computeClientRect() {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight
        };
    }
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    handleScrollChange() {
        this.clientRect = this.computeClientRect();
    }
}
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
const $3092bb0ca7036a39$var$getTime = typeof performance === 'function' ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ class $3092bb0ca7036a39$var$AutoScroller {
    constructor(){
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            '.fc-scroller'
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = ()=>{
            if (this.isAnimating) {
                let edge = this.computeBestEdge(this.pointerScreenX + window.scrollX, this.pointerScreenY + window.scrollY);
                if (edge) {
                    let now = $3092bb0ca7036a39$var$getTime();
                    this.handleSide(edge, (now - this.msSinceRequest) / 1000);
                    this.requestAnimation(now);
                } else this.isAnimating = false; // will stop animation
            }
        };
    }
    start(pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    }
    handleMove(pageX, pageY) {
        if (this.isEnabled) {
            let pointerScreenX = pageX - window.scrollX;
            let pointerScreenY = pageY - window.scrollY;
            let yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            let xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) this.everMovedUp = true;
            else if (yDelta > 0) this.everMovedDown = true;
            if (xDelta < 0) this.everMovedLeft = true;
            else if (xDelta > 0) this.everMovedRight = true;
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation($3092bb0ca7036a39$var$getTime());
            }
        }
    }
    stop() {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for (let scrollCache of this.scrollCaches)scrollCache.destroy();
            this.scrollCaches = null;
        }
    }
    requestAnimation(now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    }
    handleSide(edge, seconds) {
        let { scrollCache: scrollCache } = edge;
        let { edgeThreshold: edgeThreshold } = this;
        let invDistance = edgeThreshold - edge.distance;
        let velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
        this.maxVelocity * seconds;
        let sign = 1;
        switch(edge.name){
            case 'left':
                sign = -1;
            // falls through
            case 'right':
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case 'top':
                sign = -1;
            // falls through
            case 'bottom':
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    }
    // left/top are relative to document topleft
    computeBestEdge(left, top) {
        let { edgeThreshold: edgeThreshold } = this;
        let bestSide = null;
        let scrollCaches = this.scrollCaches || [];
        for (let scrollCache of scrollCaches){
            let rect = scrollCache.clientRect;
            let leftDist = left - rect.left;
            let rightDist = rect.right - left;
            let topDist = top - rect.top;
            let bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'top',
                    distance: topDist
                };
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'bottom',
                    distance: bottomDist
                };
                /*
                TODO: fix broken RTL scrolling. canScrollLeft always returning false
                https://github.com/fullcalendar/fullcalendar/issues/4837
                */ if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'left',
                    distance: leftDist
                };
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'right',
                    distance: rightDist
                };
            }
        }
        return bestSide;
    }
    buildCaches(scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map((el)=>{
            if (el === window) return new $3092bb0ca7036a39$var$WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            return new $3092bb0ca7036a39$var$ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    }
    queryScrollEls(scrollStartEl) {
        let els = [];
        for (let query of this.scrollQuery)if (typeof query === 'object') els.push(query);
        else /*
                TODO: in the future, always have auto-scroll happen on element where current Hit came from
                Ticket: https://github.com/fullcalendar/fullcalendar/issues/4593
                */ els.push(...Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query)));
        return els;
    }
}
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ class $3092bb0ca7036a39$var$FeaturefulElementDragging extends (0, $806c23c1e016259b$export$b2bcef12bcefba04) {
    constructor(containerEl, selector){
        super(containerEl);
        this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        this.delay = null;
        this.minDistance = 0;
        this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        this.mirrorNeedsRevert = false;
        this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        this.isDelayEnded = false;
        this.isDistanceSurpassed = false;
        this.delayTimeoutId = null;
        this.onPointerDown = (ev)=>{
            if (!this.isDragging) {
                this.isInteracting = true;
                this.isDelayEnded = false;
                this.isDistanceSurpassed = false;
                (0, $806c23c1e016259b$export$2f6ca3d3b1f80bf5)(document.body);
                (0, $806c23c1e016259b$export$d24c54395ce0c509)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                this.emitter.trigger('pointerdown', ev);
                if (this.isInteracting && // not destroyed via pointerdown handler
                !this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    this.mirror.setIsVisible(false); // reset. caller must set-visible
                    this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    this.startDelay(ev);
                    if (!this.minDistance) this.handleDistanceSurpassed(ev);
                }
            }
        };
        this.onPointerMove = (ev)=>{
            if (this.isInteracting) {
                this.emitter.trigger('pointermove', ev);
                if (!this.isDistanceSurpassed) {
                    let minDistance = this.minDistance;
                    let distanceSq; // current distance from the origin, squared
                    let { deltaX: deltaX, deltaY: deltaY } = ev;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) this.handleDistanceSurpassed(ev);
                }
                if (this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== 'scroll') {
                        this.mirror.handleMove(ev.pageX, ev.pageY);
                        this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    this.emitter.trigger('dragmove', ev);
                }
            }
        };
        this.onPointerUp = (ev)=>{
            if (this.isInteracting) {
                this.isInteracting = false;
                (0, $806c23c1e016259b$export$8a5498727ef6be21)(document.body);
                (0, $806c23c1e016259b$export$6554612db691658e)(document.body);
                this.emitter.trigger('pointerup', ev); // can potentially set mirrorNeedsRevert
                if (this.isDragging) {
                    this.autoScroller.stop();
                    this.tryStopDrag(ev); // which will stop the mirror
                }
                if (this.delayTimeoutId) {
                    clearTimeout(this.delayTimeoutId);
                    this.delayTimeoutId = null;
                }
            }
        };
        let pointer = this.pointer = new $3092bb0ca7036a39$var$PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', this.onPointerDown);
        pointer.emitter.on('pointermove', this.onPointerMove);
        pointer.emitter.on('pointerup', this.onPointerUp);
        if (selector) pointer.selector = selector;
        this.mirror = new $3092bb0ca7036a39$var$ElementMirror();
        this.autoScroller = new $3092bb0ca7036a39$var$AutoScroller();
    }
    destroy() {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    }
    startDelay(ev) {
        if (typeof this.delay === 'number') this.delayTimeoutId = setTimeout(()=>{
            this.delayTimeoutId = null;
            this.handleDelayEnd(ev);
        }, this.delay); // not assignable to number!
        else this.handleDelayEnd(ev);
    }
    handleDelayEnd(ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    }
    handleDistanceSurpassed(ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    }
    tryStartDrag(ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger('dragstart', ev);
                if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
            }
        }
    }
    tryStopDrag(ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    }
    stopDrag(ev) {
        this.isDragging = false;
        this.emitter.trigger('dragend', ev);
    }
    // fill in the implementations...
    setIgnoreMove(bool) {
        this.pointer.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        this.mirror.setIsVisible(bool);
    }
    setMirrorNeedsRevert(bool) {
        this.mirrorNeedsRevert = bool;
    }
    setAutoScrollEnabled(bool) {
        this.autoScroller.isEnabled = bool;
    }
}
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ class $3092bb0ca7036a39$var$OffsetTracker {
    constructor(el){
        this.el = el;
        this.origRect = (0, $806c23c1e016259b$export$39c1cc7c062529d4)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, $806c23c1e016259b$export$53c86fa97d611818)(el).map((scrollEl)=>new $3092bb0ca7036a39$var$ElementScrollGeomCache(scrollEl, true));
    }
    destroy() {
        for (let scrollCache of this.scrollCaches)scrollCache.destroy();
    }
    computeLeft() {
        let left = this.origRect.left;
        for (let scrollCache of this.scrollCaches)left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        return left;
    }
    computeTop() {
        let top = this.origRect.top;
        for (let scrollCache of this.scrollCaches)top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        return top;
    }
    isWithinClipping(pageX, pageY) {
        let point = {
            left: pageX,
            top: pageY
        };
        for (let scrollCache of this.scrollCaches){
            if (!$3092bb0ca7036a39$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, $806c23c1e016259b$export$24baa2b76016ce0e)(point, scrollCache.clientRect)) return false;
        }
        return true;
    }
}
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function $3092bb0ca7036a39$var$isIgnoredClipping(node) {
    let tagName = node.tagName;
    return tagName === 'HTML' || tagName === 'BODY';
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ class $3092bb0ca7036a39$var$HitDragging {
    constructor(dragging, droppableStore){
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.disablePointCheck = false;
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = (ev)=>{
            let { dragging: dragging } = this;
            this.initialHit = null;
            this.movingHit = null;
            this.finalHit = null;
            this.prepareHits();
            this.processFirstCoord(ev);
            if (this.initialHit || !this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                this.emitter.trigger('pointerdown', ev);
            } else dragging.setIgnoreMove(true);
        };
        this.handleDragStart = (ev)=>{
            this.emitter.trigger('dragstart', ev);
            this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = (ev)=>{
            this.emitter.trigger('dragmove', ev);
            this.handleMove(ev);
        };
        this.handlePointerUp = (ev)=>{
            this.releaseHits();
            this.emitter.trigger('pointerup', ev);
        };
        this.handleDragEnd = (ev)=>{
            if (this.movingHit) this.emitter.trigger('hitupdate', null, true, ev);
            this.finalHit = this.movingHit;
            this.movingHit = null;
            this.emitter.trigger('dragend', ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        dragging.emitter.on('dragmove', this.handleDragMove);
        dragging.emitter.on('pointerup', this.handlePointerUp);
        dragging.emitter.on('dragend', this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, $806c23c1e016259b$export$d66501df72047452)();
    }
    // sets initialHit
    // sets coordAdjust
    processFirstCoord(ev) {
        let origPoint = {
            left: ev.pageX,
            top: ev.pageY
        };
        let adjustedPoint = origPoint;
        let subjectEl = ev.subjectEl;
        let subjectRect;
        if (subjectEl instanceof HTMLElement) {
            subjectRect = (0, $806c23c1e016259b$export$39c1cc7c062529d4)(subjectEl);
            adjustedPoint = (0, $806c23c1e016259b$export$158acd800e1ef08b)(adjustedPoint, subjectRect);
        }
        let initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                let slicedSubjectRect = (0, $806c23c1e016259b$export$890c4ad488842ce7)(subjectRect, initialHit.rect);
                if (slicedSubjectRect) adjustedPoint = (0, $806c23c1e016259b$export$cf2f7c5792f80b46)(slicedSubjectRect);
            }
            this.coordAdjust = (0, $806c23c1e016259b$export$53a70dd1ebbae346)(adjustedPoint, origPoint);
        } else this.coordAdjust = {
            left: 0,
            top: 0
        };
    }
    handleMove(ev, forceHandle) {
        let hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !$3092bb0ca7036a39$var$isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger('hitupdate', hit, false, ev);
        }
    }
    prepareHits() {
        this.offsetTrackers = (0, $806c23c1e016259b$export$407448d2b89b1813)(this.droppableStore, (interactionSettings)=>{
            interactionSettings.component.prepareHits();
            return new $3092bb0ca7036a39$var$OffsetTracker(interactionSettings.el);
        });
    }
    releaseHits() {
        let { offsetTrackers: offsetTrackers } = this;
        for(let id in offsetTrackers)offsetTrackers[id].destroy();
        this.offsetTrackers = {};
    }
    queryHitForOffset(offsetLeft, offsetTop) {
        let { droppableStore: droppableStore, offsetTrackers: offsetTrackers } = this;
        let bestHit = null;
        for(let id in droppableStore){
            let component = droppableStore[id].component;
            let offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
            offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                let originLeft = offsetTracker.computeLeft();
                let originTop = offsetTracker.computeTop();
                let positionLeft = offsetLeft - originLeft;
                let positionTop = offsetTop - originTop;
                let { origRect: origRect } = offsetTracker;
                let width = origRect.right - origRect.left;
                let height = origRect.bottom - origRect.top;
                if (// must be within the element's bounds
                positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                    let hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                    (0, $806c23c1e016259b$export$f074adc9fbd50943)(hit.dateProfile.activeRange, hit.dateSpan.range) && // Ensure the component we are querying for the hit is accessibly my the pointer
                    // Prevents obscured calendars (ex: under a modal dialog) from accepting hit
                    // https://github.com/fullcalendar/fullcalendar/issues/5026
                    (this.disablePointCheck || offsetTracker.el.contains(offsetTracker.el.getRootNode().elementFromPoint(// add-back origins to get coordinate relative to top-left of window viewport
                    positionLeft + originLeft - window.scrollX, positionTop + originTop - window.scrollY))) && (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    }
}
function $3092bb0ca7036a39$var$isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, $806c23c1e016259b$export$7f557e5eb95176c2)(hit0.dateSpan, hit1.dateSpan);
}
function $3092bb0ca7036a39$var$buildDatePointApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.datePointTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $3092bb0ca7036a39$var$buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function $3092bb0ca7036a39$var$buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ class $3092bb0ca7036a39$var$DateClicking extends (0, $806c23c1e016259b$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        this.handlePointerDown = (pev)=>{
            let { dragging: dragging } = this;
            let downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        this.handleDragEnd = (ev)=>{
            let { component: component } = this;
            let { pointer: pointer } = this.dragging;
            if (!pointer.wasTouchScroll) {
                let { initialHit: initialHit, finalHit: finalHit } = this.hitDragging;
                if (initialHit && finalHit && $3092bb0ca7036a39$var$isHitsEqual(initialHit, finalHit)) {
                    let { context: context } = component;
                    let arg = Object.assign(Object.assign({}, $3092bb0ca7036a39$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger('dateClick', arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        this.dragging = new $3092bb0ca7036a39$var$FeaturefulElementDragging(settings.el);
        this.dragging.autoScroller.isEnabled = false;
        let hitDragging = this.hitDragging = new $3092bb0ca7036a39$var$HitDragging(this.dragging, (0, $806c23c1e016259b$export$381353cf1dd55255)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
}
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ class $3092bb0ca7036a39$var$DateSelecting extends (0, $806c23c1e016259b$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        this.dragSelection = null;
        this.handlePointerDown = (ev)=>{
            let { component: component, dragging: dragging } = this;
            let { options: options } = component.context;
            let canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? $3092bb0ca7036a39$var$getComponentTouchDelay$1(component) : null;
        };
        this.handleDragStart = (ev)=>{
            this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            let { context: context } = this.component;
            let dragSelection = null;
            let isInvalid = false;
            if (hit) {
                let initialHit = this.hitDragging.initialHit;
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = $3092bb0ca7036a39$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, $806c23c1e016259b$export$545a72cc0d3f00b0)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: 'SELECT_DATES',
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: 'UNSELECT_DATES'
            });
            if (!isInvalid) (0, $806c23c1e016259b$export$1fbe638ecf81657e)();
            else (0, $806c23c1e016259b$export$d66dc83d8cfc8dd)();
            if (!isFinal) this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        this.handlePointerUp = (pev)=>{
            if (this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, $806c23c1e016259b$export$cbfbec548517f2b6)(this.dragSelection, pev, this.component.context);
                this.dragSelection = null;
            }
        };
        let { component: component } = settings;
        let { options: options } = component.context;
        let dragging = this.dragging = new $3092bb0ca7036a39$var$FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new $3092bb0ca7036a39$var$HitDragging(this.dragging, (0, $806c23c1e016259b$export$381353cf1dd55255)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', this.handlePointerUp);
    }
    destroy() {
        this.dragging.destroy();
    }
}
function $3092bb0ca7036a39$var$getComponentTouchDelay$1(component) {
    let { options: options } = component.context;
    let delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function $3092bb0ca7036a39$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, $806c23c1e016259b$export$493d36ec626b6698));
    let props = {};
    for (let transformer of dateSelectionTransformers){
        let res = transformer(hit0, hit1);
        if (res === false) return null;
        if (res) Object.assign(props, res);
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
class $3092bb0ca7036a39$var$EventDragging extends (0, $806c23c1e016259b$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        // internal state
        this.subjectEl = null;
        this.subjectSeg = null; // the seg being selected/dragged
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null; // the events being dragged
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let origTarget = ev.origEvent.target;
            let { component: component, dragging: dragging } = this;
            let { mirror: mirror } = dragging;
            let { options: options } = component.context;
            let initialContext = component.context;
            this.subjectEl = ev.subjectEl;
            let subjectSeg = this.subjectSeg = (0, $806c23c1e016259b$export$8743009a87fcb00f)(ev.subjectEl);
            let eventRange = this.eventRange = subjectSeg.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            this.relevantEvents = (0, $806c23c1e016259b$export$667d3bf0c5f83305)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? $3092bb0ca7036a39$var$getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, $806c23c1e016259b$export$dc98b0b04f4c7758)(origTarget, '.fc');
            mirror.revertDuration = options.dragRevertDuration;
            let isValid = component.isValidSegDownEl(origTarget) && !(0, $806c23c1e016259b$export$dc98b0b04f4c7758)(origTarget, '.fc-event-resizer'); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            this.isDragging = isValid && ev.subjectEl.classList.contains('fc-event-draggable');
        };
        this.handleDragStart = (ev)=>{
            let initialContext = this.component.context;
            let eventRange = this.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== this.component.props.eventSelection) initialContext.dispatch({
                    type: 'SELECT_EVENT',
                    eventInstanceId: eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: 'UNSELECT_EVENT'
            });
            if (this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger('eventDragStart', {
                    el: this.subjectEl,
                    event: new (0, $806c23c1e016259b$export$71511d61b312f219)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            if (!this.isDragging) return;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let initialContext = this.component.context;
            // states based on new hit
            let receivingContext = null;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                let receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = $3092bb0ca7036a39$var$computeEventMutation(initialHit, hit, this.eventRange.instance.range.start, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, $806c23c1e016259b$export$dabba94403d45c8e)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, $806c23c1e016259b$export$6d1e945284085e64)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)();
                        }
                    }
                } else receivingContext = null;
            }
            this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, $806c23c1e016259b$export$1fbe638ecf81657e)();
            else (0, $806c23c1e016259b$export$d66dc83d8cfc8dd)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                $3092bb0ca7036a39$var$isHitsEqual(initialHit, hit)) mutation = null;
                this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                this.dragging.setMirrorIsVisible(!hit || !this.subjectEl.getRootNode().querySelector('.fc-event-mirror'));
                // assign states based on new hit
                this.receivingContext = receivingContext;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handlePointerUp = ()=>{
            if (!this.isDragging) this.cleanup(); // because handleDragEnd won't fire
        };
        this.handleDragEnd = (ev)=>{
            if (this.isDragging) {
                let initialContext = this.component.context;
                let initialView = initialContext.viewApi;
                let { receivingContext: receivingContext, validMutation: validMutation } = this;
                let eventDef = this.eventRange.def;
                let eventInstance = this.eventRange.instance;
                let eventApi = new (0, $806c23c1e016259b$export$71511d61b312f219)(initialContext, eventDef, eventInstance);
                let relevantEvents = this.relevantEvents;
                let mutatedRelevantEvents = this.mutatedRelevantEvents;
                let { finalHit: finalHit } = this.hitDragging;
                this.clearDrag(); // must happen after revert animation
                initialContext.emitter.trigger('eventDragStop', {
                    el: this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext === initialContext) {
                        let updatedEventApi = new (0, $806c23c1e016259b$export$71511d61b312f219)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                        initialContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents
                        });
                        let eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, $806c23c1e016259b$export$efccba1c4a2ef57b)(mutatedRelevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        let transformed = {};
                        for (let transformer of initialContext.getCurrentData().pluginHooks.eventDropTransformers)Object.assign(transformed, transformer(validMutation, initialContext));
                        initialContext.emitter.trigger('eventDrop', Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext.emitter.trigger('eventChange', eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext) {
                        let eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, $806c23c1e016259b$export$efccba1c4a2ef57b)(relevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        initialContext.emitter.trigger('eventLeave', Object.assign(Object.assign({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext.dispatch({
                            type: 'REMOVE_EVENTS',
                            eventStore: relevantEvents
                        });
                        initialContext.emitter.trigger('eventRemove', eventRemoveArg);
                        let addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                        let addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                        let addedEventApi = new (0, $806c23c1e016259b$export$71511d61b312f219)(receivingContext, addedEventDef, addedEventInstance);
                        receivingContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents
                        });
                        let eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, $806c23c1e016259b$export$efccba1c4a2ef57b)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                            revert () {
                                receivingContext.dispatch({
                                    type: 'REMOVE_EVENTS',
                                    eventStore: mutatedRelevantEvents
                                });
                            }
                        };
                        receivingContext.emitter.trigger('eventAdd', eventAddArg);
                        if (ev.isTouch) receivingContext.dispatch({
                            type: 'SELECT_EVENT',
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, $3092bb0ca7036a39$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext.emitter.trigger('eventReceive', Object.assign(Object.assign({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext.emitter.trigger('_noEventDrop');
            }
            this.cleanup();
        };
        let { component: component } = this;
        let { options: options } = component.context;
        let dragging = this.dragging = new $3092bb0ca7036a39$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = $3092bb0ca7036a39$var$EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new $3092bb0ca7036a39$var$HitDragging(this.dragging, (0, $806c23c1e016259b$export$a8550f7dbe79f93a));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', this.handlePointerUp);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
    // render a drag state on the next receivingCalendar
    displayDrag(nextContext, state) {
        let initialContext = this.component.context;
        let prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) prevContext.dispatch({
                type: 'SET_EVENT_DRAG',
                state: {
                    affectedEvents: state.affectedEvents,
                    mutatedEvents: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
                    isEvent: true
                }
            });
            else prevContext.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
        }
        if (nextContext) nextContext.dispatch({
            type: 'SET_EVENT_DRAG',
            state: state
        });
    }
    clearDrag() {
        let initialCalendar = this.component.context;
        let { receivingContext: receivingContext } = this;
        if (receivingContext) receivingContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) initialCalendar.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
    }
    cleanup() {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    }
}
// TODO: test this in IE11
// QUESTION: why do we need it on the resizable???
$3092bb0ca7036a39$var$EventDragging.SELECTOR = '.fc-event-draggable, .fc-event-resizable';
function $3092bb0ca7036a39$var$computeEventMutation(hit0, hit1, eventInstanceStart, massagers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let date0 = dateSpan0.range.start;
    let date1 = dateSpan1.range.start;
    let standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, $806c23c1e016259b$export$9e5f44173e64f162)(eventInstanceStart);
        else // Moving from allDate->timed
        // Doesn't matter where on the event the drag began, mutate the event's start-date to date1
        date0 = eventInstanceStart;
    }
    let delta = (0, $806c23c1e016259b$export$28f7fcd39efa255)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    let mutation = {
        datesDelta: delta,
        standardProps: standardProps
    };
    for (let massager of massagers)massager(mutation, hit0, hit1);
    return mutation;
}
function $3092bb0ca7036a39$var$getComponentTouchDelay(component) {
    let { options: options } = component.context;
    let delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
class $3092bb0ca7036a39$var$EventResizing extends (0, $806c23c1e016259b$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        // internal state
        this.draggingSegEl = null;
        this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        this.eventRange = null;
        this.relevantEvents = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let { component: component } = this;
            let segEl = this.querySegEl(ev);
            let seg = (0, $806c23c1e016259b$export$8743009a87fcb00f)(segEl);
            let eventRange = this.eventRange = seg.eventRange;
            this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            this.dragging.setIgnoreMove(!this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        this.handleDragStart = (ev)=>{
            let { context: context } = this.component;
            let eventRange = this.eventRange;
            this.relevantEvents = (0, $806c23c1e016259b$export$667d3bf0c5f83305)(context.getCurrentData().eventStore, this.eventRange.instance.instanceId);
            let segEl = this.querySegEl(ev);
            this.draggingSegEl = segEl;
            this.draggingSeg = (0, $806c23c1e016259b$export$8743009a87fcb00f)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger('eventResizeStart', {
                el: segEl,
                event: new (0, $806c23c1e016259b$export$71511d61b312f219)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { context: context } = this.component;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let eventInstance = this.eventRange.instance;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
                isEvent: true
            };
            if (hit) {
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = $3092bb0ca7036a39$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains('fc-event-resizer-start'), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, $806c23c1e016259b$export$dabba94403d45c8e)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, $806c23c1e016259b$export$6d1e945284085e64)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: 'SET_EVENT_RESIZE',
                state: interaction
            });
            else context.dispatch({
                type: 'UNSET_EVENT_RESIZE'
            });
            if (!isInvalid) (0, $806c23c1e016259b$export$1fbe638ecf81657e)();
            else (0, $806c23c1e016259b$export$d66dc83d8cfc8dd)();
            if (!isFinal) {
                if (mutation && $3092bb0ca7036a39$var$isHitsEqual(initialHit, hit)) mutation = null;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handleDragEnd = (ev)=>{
            let { context: context } = this.component;
            let eventDef = this.eventRange.def;
            let eventInstance = this.eventRange.instance;
            let eventApi = new (0, $806c23c1e016259b$export$71511d61b312f219)(context, eventDef, eventInstance);
            let relevantEvents = this.relevantEvents;
            let mutatedRelevantEvents = this.mutatedRelevantEvents;
            context.emitter.trigger('eventResizeStop', {
                el: this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (this.validMutation) {
                let updatedEventApi = new (0, $806c23c1e016259b$export$71511d61b312f219)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: mutatedRelevantEvents
                });
                let eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, $806c23c1e016259b$export$efccba1c4a2ef57b)(mutatedRelevantEvents, context, eventInstance),
                    revert () {
                        context.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger('eventResize', Object.assign(Object.assign({}, eventChangeArg), {
                    el: this.draggingSegEl,
                    startDelta: this.validMutation.startDelta || (0, $806c23c1e016259b$export$4368d992c4eafac0)(0),
                    endDelta: this.validMutation.endDelta || (0, $806c23c1e016259b$export$4368d992c4eafac0)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger('eventChange', eventChangeArg);
            } else context.emitter.trigger('_noEventResize');
            // reset all internal state
            this.draggingSeg = null;
            this.relevantEvents = null;
            this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        let { component: component } = settings;
        let dragging = this.dragging = new $3092bb0ca7036a39$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = '.fc-event-resizer';
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        let hitDragging = this.hitDragging = new $3092bb0ca7036a39$var$HitDragging(this.dragging, (0, $806c23c1e016259b$export$381353cf1dd55255)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
    querySegEl(ev) {
        return (0, $806c23c1e016259b$export$dc98b0b04f4c7758)(ev.subjectEl, '.fc-event');
    }
}
function $3092bb0ca7036a39$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
    let dateEnv = hit0.context.dateEnv;
    let date0 = hit0.dateSpan.range.start;
    let date1 = hit1.dateSpan.range.start;
    let delta = (0, $806c23c1e016259b$export$28f7fcd39efa255)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
class $3092bb0ca7036a39$var$UnselectAuto {
    constructor(context){
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = (selectInfo)=>{
            if (selectInfo.jsEvent) this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = (pev)=>{
            let unselectCancel = this.context.options.unselectCancel;
            let downEl = (0, $806c23c1e016259b$export$2ed0fc6709e59212)(pev.origEvent);
            this.matchesCancel = !!(0, $806c23c1e016259b$export$dc98b0b04f4c7758)(downEl, unselectCancel);
            this.matchesEvent = !!(0, $806c23c1e016259b$export$dc98b0b04f4c7758)(downEl, $3092bb0ca7036a39$var$EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = (pev)=>{
            let { context: context } = this;
            let { documentPointer: documentPointer } = this;
            let calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    let unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !this.matchesCancel)) context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !this.matchesEvent // interaction DIDN'T start on an event
                ) context.dispatch({
                    type: 'UNSELECT_EVENT'
                });
            }
            this.isRecentPointerDateSelect = false;
        };
        let documentPointer = this.documentPointer = new $3092bb0ca7036a39$var$PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on('pointerdown', this.onDocumentPointerDown);
        documentPointer.emitter.on('pointerup', this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on('select', this.onSelect);
    }
    destroy() {
        this.context.emitter.off('select', this.onSelect);
        this.documentPointer.destroy();
    }
}
const $3092bb0ca7036a39$var$OPTION_REFINERS = {
    fixedMirrorParent: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5)
};
const $3092bb0ca7036a39$var$LISTENER_REFINERS = {
    dateClick: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventDragStart: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventDragStop: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventDrop: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventResizeStart: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventResizeStop: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventResize: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    drop: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventReceive: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5),
    eventLeave: (0, $806c23c1e016259b$export$7ccc53e8f1e7dfc5)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ class $3092bb0ca7036a39$var$ExternalElementDragging {
    constructor(dragging, suppliedDragMeta){
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = (ev)=>{
            this.dragMeta = this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { dragging: dragging } = this.hitDragging;
            let receivingContext = null;
            let droppableEvent = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
                mutatedEvents: (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)(),
                isEvent: this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = $3092bb0ca7036a39$var$computeEventForDateSpan(hit.dateSpan, this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, $806c23c1e016259b$export$317a3d46287192d8)(droppableEvent);
                    isInvalid = !(0, $806c23c1e016259b$export$6d1e945284085e64)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, $806c23c1e016259b$export$7f8ddf7c7c20b3cd)();
                        droppableEvent = null;
                    }
                }
            }
            this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector('.fc-event-mirror'));
            if (!isInvalid) (0, $806c23c1e016259b$export$1fbe638ecf81657e)();
            else (0, $806c23c1e016259b$export$d66dc83d8cfc8dd)();
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                this.receivingContext = receivingContext;
                this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = (pev)=>{
            let { receivingContext: receivingContext, droppableEvent: droppableEvent } = this;
            this.clearDrag();
            if (receivingContext && droppableEvent) {
                let finalHit = this.hitDragging.finalHit;
                let finalView = finalHit.context.viewApi;
                let dragMeta = this.dragMeta;
                receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, $3092bb0ca7036a39$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    let addingEvents = (0, $806c23c1e016259b$export$317a3d46287192d8)(droppableEvent);
                    receivingContext.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: addingEvents
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: 'SELECT_EVENT',
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger('eventReceive', {
                        event: new (0, $806c23c1e016259b$export$71511d61b312f219)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert () {
                            receivingContext.dispatch({
                                type: 'REMOVE_EVENTS',
                                eventStore: addingEvents
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            this.receivingContext = null;
            this.droppableEvent = null;
        };
        let hitDragging = this.hitDragging = new $3092bb0ca7036a39$var$HitDragging(dragging, (0, $806c23c1e016259b$export$a8550f7dbe79f93a));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    buildDragMeta(subjectEl) {
        if (typeof this.suppliedDragMeta === 'object') return (0, $806c23c1e016259b$export$60bb826a6acf3081)(this.suppliedDragMeta);
        if (typeof this.suppliedDragMeta === 'function') return (0, $806c23c1e016259b$export$60bb826a6acf3081)(this.suppliedDragMeta(subjectEl));
        return $3092bb0ca7036a39$var$getDragMetaFromEl(subjectEl);
    }
    displayDrag(nextContext, state) {
        let prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) prevContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
        if (nextContext) nextContext.dispatch({
            type: 'SET_EVENT_DRAG',
            state: state
        });
    }
    clearDrag() {
        if (this.receivingContext) this.receivingContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
    }
    canDropElOnCalendar(el, receivingContext) {
        let dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === 'function') return dropAccept.call(receivingContext.calendarApi, el);
        if (typeof dropAccept === 'string' && dropAccept) return Boolean((0, $806c23c1e016259b$export$c03999cb2f36933f)(el, dropAccept));
        return true;
    }
}
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function $3092bb0ca7036a39$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
    let defProps = Object.assign({}, dragMeta.leftoverProps);
    for (let transform of context.pluginHooks.externalDefTransforms)Object.assign(defProps, transform(dateSpan, dragMeta));
    let { refined: refined, extra: extra } = (0, $806c23c1e016259b$export$3b513254972cfc9c)(defProps, context);
    let def = (0, $806c23c1e016259b$export$f38c853ae54ed474)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    let start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    let end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, $806c23c1e016259b$export$bde1ed0f60b38f2f)(dateSpan.allDay, start, context);
    let instance = (0, $806c23c1e016259b$export$995eb9fca571757)(def.defId, {
        start: start,
        end: end
    });
    return {
        def: def,
        instance: instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function $3092bb0ca7036a39$var$getDragMetaFromEl(el) {
    let str = $3092bb0ca7036a39$var$getEmbeddedElData(el, 'event');
    let obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, $806c23c1e016259b$export$60bb826a6acf3081)(obj);
}
(0, $806c23c1e016259b$export$aff10ba49ece4b91).dataAttrPrefix = '';
function $3092bb0ca7036a39$var$getEmbeddedElData(el, name) {
    let prefix = (0, $806c23c1e016259b$export$aff10ba49ece4b91).dataAttrPrefix;
    let prefixedName = (prefix ? prefix + '-' : '') + name;
    return el.getAttribute('data-' + prefixedName) || '';
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ class $3092bb0ca7036a39$export$f2a139e5d18b9882 {
    constructor(el, settings = {}){
        this.handlePointerDown = (ev)=>{
            let { dragging: dragging } = this;
            let { minDistance: minDistance, longPressDelay: longPressDelay } = this.settings;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, $806c23c1e016259b$export$f1e1789686576879).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, $806c23c1e016259b$export$f1e1789686576879).longPressDelay : 0;
        };
        this.handleDragStart = (ev)=>{
            if (ev.isTouch && this.dragging.delay && ev.subjectEl.classList.contains('fc-event')) this.dragging.mirror.getMirrorEl().classList.add('fc-event-selected');
        };
        this.settings = settings;
        let dragging = this.dragging = new $3092bb0ca7036a39$var$FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        new $3092bb0ca7036a39$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    destroy() {
        this.dragging.destroy();
    }
}
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ class $3092bb0ca7036a39$var$InferredElementDragging extends (0, $806c23c1e016259b$export$b2bcef12bcefba04) {
    constructor(containerEl){
        super(containerEl);
        this.shouldIgnoreMove = false;
        this.mirrorSelector = '';
        this.currentMirrorEl = null;
        this.handlePointerDown = (ev)=>{
            this.emitter.trigger('pointerdown', ev);
            if (!this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            this.emitter.trigger('dragstart', ev);
        };
        this.handlePointerMove = (ev)=>{
            if (!this.shouldIgnoreMove) this.emitter.trigger('dragmove', ev);
        };
        this.handlePointerUp = (ev)=>{
            this.emitter.trigger('pointerup', ev);
            if (!this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            this.emitter.trigger('dragend', ev);
        };
        let pointer = this.pointer = new $3092bb0ca7036a39$var$PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', this.handlePointerDown);
        pointer.emitter.on('pointermove', this.handlePointerMove);
        pointer.emitter.on('pointerup', this.handlePointerUp);
    }
    destroy() {
        this.pointer.destroy();
    }
    setIgnoreMove(bool) {
        this.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        if (bool) // restore a previously hidden element.
        // use the reference in case the selector class has already been removed.
        {
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = '';
                this.currentMirrorEl = null;
            }
        } else {
            let mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = 'hidden';
            }
        }
    }
}
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ class $3092bb0ca7036a39$export$51e5e9a9728fcd8f {
    constructor(containerOrSettings, settings){
        let containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        let dragging = this.dragging = new $3092bb0ca7036a39$var$InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === 'string') dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = '[data-event]';
        if (typeof settings.mirrorSelector === 'string') dragging.mirrorSelector = settings.mirrorSelector;
        let externalDragging = new $3092bb0ca7036a39$var$ExternalElementDragging(dragging, settings.eventData);
        // The hit-detection system requires that the dnd-mirror-element be pointer-events:none,
        // but this can't be guaranteed for third-party draggables, so disable
        externalDragging.hitDragging.disablePointCheck = true;
    }
    destroy() {
        this.dragging.destroy();
    }
}
var $3092bb0ca7036a39$export$2e2bcd8739ae039 = (0, $b12be9f4f0b8bc94$export$ae829ec7b2625219)({
    name: '@fullcalendar/interaction',
    componentInteractions: [
        $3092bb0ca7036a39$var$DateClicking,
        $3092bb0ca7036a39$var$DateSelecting,
        $3092bb0ca7036a39$var$EventDragging,
        $3092bb0ca7036a39$var$EventResizing
    ],
    calendarInteractions: [
        $3092bb0ca7036a39$var$UnselectAuto
    ],
    elementDraggingImpl: $3092bb0ca7036a39$var$FeaturefulElementDragging,
    optionRefiners: $3092bb0ca7036a39$var$OPTION_REFINERS,
    listenerRefiners: $3092bb0ca7036a39$var$LISTENER_REFINERS
});






class $d47a4fbcf0a90846$var$SingleMonth extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $806c23c1e016259b$export$df995fae86a55f06)((0, $f9357e1d4d6e2cc8$export$61e79f95d746b006));
        this.slicer = new (0, $f9357e1d4d6e2cc8$export$eb38be9553e58392)();
        this.state = {
            labelId: (0, $806c23c1e016259b$export$6559d589eb85fbb6)()
        };
    }
    render() {
        const { props: props, state: state, context: context } = this;
        const { dateProfile: dateProfile, forPrint: forPrint } = props;
        const { options: options } = context;
        const dayTableModel = this.buildDayTableModel(dateProfile, context.dateProfileGenerator);
        const slicedProps = this.slicer.sliceProps(props, dateProfile, options.nextDayThreshold, context, dayTableModel);
        // ensure single-month has aspect ratio
        const tableHeight = props.tableWidth != null ? props.tableWidth / options.aspectRatio : null;
        const rowCnt = dayTableModel.cells.length;
        const rowHeight = tableHeight != null ? tableHeight / rowCnt : null;
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            ref: props.elRef,
            "data-date": props.isoDateStr,
            className: "fc-multimonth-month",
            style: {
                width: props.width
            },
            role: "grid",
            "aria-labelledby": state.labelId
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: "fc-multimonth-header",
            style: {
                marginBottom: rowHeight
            },
            role: "presentation"
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: "fc-multimonth-title",
            id: state.labelId
        }, context.dateEnv.format(props.dateProfile.currentRange.start, props.titleFormat)), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("table", {
            className: [
                'fc-multimonth-header-table',
                context.theme.getClass('table')
            ].join(' '),
            role: "presentation"
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("thead", {
            role: "rowgroup"
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$27d1aff6bea49709), {
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: false
        })))), (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("div", {
            className: [
                'fc-multimonth-daygrid',
                'fc-daygrid',
                'fc-daygrid-body',
                !forPrint && 'fc-daygrid-body-balanced',
                forPrint && 'fc-daygrid-body-unbalanced',
                forPrint && 'fc-daygrid-body-natural'
            ].join(' '),
            style: {
                marginTop: -rowHeight
            }
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("table", {
            className: [
                'fc-multimonth-daygrid-table',
                context.theme.getClass('table')
            ].join(' '),
            style: {
                height: forPrint ? '' : tableHeight
            },
            role: "presentation"
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)("tbody", {
            role: "rowgroup"
        }, (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $f9357e1d4d6e2cc8$export$d955b1c53830e05a), Object.assign({}, slicedProps, {
            dateProfile: dateProfile,
            cells: dayTableModel.cells,
            eventSelection: props.eventSelection,
            dayMaxEvents: !forPrint,
            dayMaxEventRows: !forPrint,
            showWeekNumbers: options.weekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: forPrint
        }))))));
    }
}
class $d47a4fbcf0a90846$var$MultiMonthView extends (0, $806c23c1e016259b$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.splitDateProfileByMonth = (0, $806c23c1e016259b$export$df995fae86a55f06)($d47a4fbcf0a90846$var$splitDateProfileByMonth);
        this.buildMonthFormat = (0, $806c23c1e016259b$export$df995fae86a55f06)($d47a4fbcf0a90846$var$buildMonthFormat);
        this.scrollElRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.firstMonthElRef = (0, $c329b3b3780c47a8$export$7d1e3a5e95ceca43)();
        this.needsScrollReset = false;
        this.handleSizing = (isForced)=>{
            if (isForced) this.updateSize();
        };
    }
    render() {
        const { context: context, props: props, state: state } = this;
        const { options: options } = context;
        const { clientWidth: clientWidth, clientHeight: clientHeight } = state;
        const monthHPadding = state.monthHPadding || 0;
        const colCount = Math.min(clientWidth != null ? Math.floor(clientWidth / (options.multiMonthMinWidth + monthHPadding)) : 1, options.multiMonthMaxColumns) || 1;
        const monthWidthPct = 100 / colCount + '%';
        const monthTableWidth = clientWidth == null ? null : clientWidth / colCount - monthHPadding;
        const isLegitSingleCol = clientWidth != null && colCount === 1;
        const monthDateProfiles = this.splitDateProfileByMonth(context.dateProfileGenerator, props.dateProfile, context.dateEnv, isLegitSingleCol ? false : options.fixedWeekCount, options.showNonCurrentDates);
        const monthTitleFormat = this.buildMonthFormat(options.multiMonthTitleFormat, monthDateProfiles);
        const rootClassNames = [
            'fc-multimonth',
            isLegitSingleCol ? 'fc-multimonth-singlecol' : 'fc-multimonth-multicol',
            monthTableWidth != null && monthTableWidth < 400 ? 'fc-multimonth-compact' : '',
            props.isHeightAuto ? '' : 'fc-scroller'
        ];
        return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)((0, $806c23c1e016259b$export$a3c9165b94390bcd), {
            elRef: this.scrollElRef,
            elClasses: rootClassNames,
            viewSpec: context.viewSpec
        }, monthDateProfiles.map((monthDateProfile, i)=>{
            const monthStr = (0, $806c23c1e016259b$export$5dbe06c6d8c68cfb)(monthDateProfile.currentRange.start);
            return (0, $c329b3b3780c47a8$export$c8a8987d4410bf2d)($d47a4fbcf0a90846$var$SingleMonth, Object.assign({}, props, {
                key: monthStr,
                isoDateStr: monthStr,
                elRef: i === 0 ? this.firstMonthElRef : undefined,
                titleFormat: monthTitleFormat,
                dateProfile: monthDateProfile,
                width: monthWidthPct,
                tableWidth: monthTableWidth,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            }));
        }));
    }
    componentDidMount() {
        this.updateSize();
        this.context.addResizeHandler(this.handleSizing);
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (!(0, $806c23c1e016259b$export$a9c23c6ac3fc3eca)(prevProps, this.props)) this.handleSizing(false);
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    updateSize() {
        const scrollEl = this.scrollElRef.current;
        const firstMonthEl = this.firstMonthElRef.current;
        if (scrollEl) this.setState({
            clientWidth: scrollEl.clientWidth,
            clientHeight: scrollEl.clientHeight
        });
        if (firstMonthEl && scrollEl) {
            if (this.state.monthHPadding == null) this.setState({
                monthHPadding: scrollEl.clientWidth - // go within padding
                firstMonthEl.firstChild.offsetWidth
            });
        }
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.state.monthHPadding != null // indicates sizing already happened
        ) {
            const { currentDate: currentDate } = this.props.dateProfile;
            const scrollEl = this.scrollElRef.current;
            const monthEl = scrollEl.querySelector(`[data-date="${(0, $806c23c1e016259b$export$5dbe06c6d8c68cfb)(currentDate)}"]`);
            scrollEl.scrollTop = monthEl.getBoundingClientRect().top - this.firstMonthElRef.current.getBoundingClientRect().top;
            this.needsScrollReset = false;
        }
    }
    // workaround for when queued setState render (w/ clientWidth) gets cancelled because
    // subsequent update and shouldComponentUpdate says not to render :(
    shouldComponentUpdate() {
        return true;
    }
}
// date profile
// -------------------------------------------------------------------------------------------------
const $d47a4fbcf0a90846$var$oneMonthDuration = (0, $806c23c1e016259b$export$4368d992c4eafac0)(1, 'month');
function $d47a4fbcf0a90846$var$splitDateProfileByMonth(dateProfileGenerator, dateProfile, dateEnv, fixedWeekCount, showNonCurrentDates) {
    const { start: start, end: end } = dateProfile.currentRange;
    let monthStart = start;
    const monthDateProfiles = [];
    while(monthStart.valueOf() < end.valueOf()){
        const monthEnd = dateEnv.add(monthStart, $d47a4fbcf0a90846$var$oneMonthDuration);
        const currentRange = {
            // yuck
            start: dateProfileGenerator.skipHiddenDays(monthStart),
            end: dateProfileGenerator.skipHiddenDays(monthEnd, -1, true)
        };
        let renderRange = (0, $f9357e1d4d6e2cc8$export$a2ad67969be9f247)({
            currentRange: currentRange,
            snapToWeek: true,
            fixedWeekCount: fixedWeekCount,
            dateEnv: dateEnv
        });
        renderRange = {
            // yuck
            start: dateProfileGenerator.skipHiddenDays(renderRange.start),
            end: dateProfileGenerator.skipHiddenDays(renderRange.end, -1, true)
        };
        const activeRange = dateProfile.activeRange ? (0, $806c23c1e016259b$export$ae1af26003f05816)(dateProfile.activeRange, showNonCurrentDates ? renderRange : currentRange) : null;
        monthDateProfiles.push({
            currentDate: dateProfile.currentDate,
            isValid: dateProfile.isValid,
            validRange: dateProfile.validRange,
            renderRange: renderRange,
            activeRange: activeRange,
            currentRange: currentRange,
            currentRangeUnit: 'month',
            isRangeAllDay: true,
            dateIncrement: dateProfile.dateIncrement,
            slotMinTime: dateProfile.slotMaxTime,
            slotMaxTime: dateProfile.slotMinTime
        });
        monthStart = monthEnd;
    }
    return monthDateProfiles;
}
// date formatting
// -------------------------------------------------------------------------------------------------
const $d47a4fbcf0a90846$var$YEAR_MONTH_FORMATTER = (0, $806c23c1e016259b$export$d141bba7fdc215a3)({
    year: 'numeric',
    month: 'long'
});
const $d47a4fbcf0a90846$var$YEAR_FORMATTER = (0, $806c23c1e016259b$export$d141bba7fdc215a3)({
    month: 'long'
});
function $d47a4fbcf0a90846$var$buildMonthFormat(formatOverride, monthDateProfiles) {
    return formatOverride || (monthDateProfiles[0].currentRange.start.getUTCFullYear() !== monthDateProfiles[monthDateProfiles.length - 1].currentRange.start.getUTCFullYear() ? $d47a4fbcf0a90846$var$YEAR_MONTH_FORMATTER : $d47a4fbcf0a90846$var$YEAR_FORMATTER);
}
const $d47a4fbcf0a90846$var$OPTION_REFINERS = {
    multiMonthTitleFormat: (0, $806c23c1e016259b$export$d141bba7fdc215a3),
    multiMonthMaxColumns: Number,
    multiMonthMinWidth: Number
};
var $d47a4fbcf0a90846$var$css_248z = ".fc .fc-multimonth{border:1px solid var(--fc-border-color);display:flex;flex-wrap:wrap;overflow-x:hidden;overflow-y:auto}.fc .fc-multimonth-title{font-size:1.2em;font-weight:700;padding:1em 0;text-align:center}.fc .fc-multimonth-daygrid{background:var(--fc-page-bg-color)}.fc .fc-multimonth-daygrid-table,.fc .fc-multimonth-header-table{table-layout:fixed;width:100%}.fc .fc-multimonth-daygrid-table{border-top-style:hidden!important}.fc .fc-multimonth-singlecol .fc-multimonth{position:relative}.fc .fc-multimonth-singlecol .fc-multimonth-header{background:var(--fc-page-bg-color);position:relative;top:0;z-index:2}.fc .fc-multimonth-singlecol .fc-multimonth-daygrid{position:relative;z-index:1}.fc .fc-multimonth-singlecol .fc-multimonth-daygrid-table,.fc .fc-multimonth-singlecol .fc-multimonth-header-table{border-left-style:hidden;border-right-style:hidden}.fc .fc-multimonth-singlecol .fc-multimonth-month:last-child .fc-multimonth-daygrid-table{border-bottom-style:hidden}.fc .fc-multimonth-multicol{line-height:1}.fc .fc-multimonth-multicol .fc-multimonth-month{padding:0 1.2em 1.2em}.fc .fc-multimonth-multicol .fc-daygrid-more-link{border:1px solid var(--fc-event-border-color);display:block;float:none;padding:1px}.fc .fc-multimonth-compact{line-height:1}.fc .fc-multimonth-compact .fc-multimonth-daygrid-table,.fc .fc-multimonth-compact .fc-multimonth-header-table{font-size:.9em}.fc-media-screen .fc-multimonth-singlecol .fc-multimonth-header{position:sticky}.fc-media-print .fc-multimonth{overflow:visible}";
(0, $806c23c1e016259b$export$e9316ff9106cdb75)($d47a4fbcf0a90846$var$css_248z);
var $d47a4fbcf0a90846$export$2e2bcd8739ae039 = (0, $b12be9f4f0b8bc94$export$ae829ec7b2625219)({
    name: '@fullcalendar/multimonth',
    initialView: 'multiMonthYear',
    optionRefiners: $d47a4fbcf0a90846$var$OPTION_REFINERS,
    views: {
        multiMonth: {
            component: $d47a4fbcf0a90846$var$MultiMonthView,
            dateProfileGeneratorClass: (0, $f9357e1d4d6e2cc8$export$9fcce6e2d16ec31d),
            multiMonthMinWidth: 350,
            multiMonthMaxColumns: 3
        },
        multiMonthYear: {
            type: 'multiMonth',
            duration: {
                years: 1
            },
            fixedWeekCount: true,
            showNonCurrentDates: false
        }
    }
});




// Helper to get the correct color based on status and initiator
const $f46203b51dd01070$var$getBookingColor = (booking)=>{
    if (booking.status === (0, $51a1d58e4b12a103$export$d971c9d602083500).PENDING) {
        const initiatedBy = booking.initiated_by || 'host';
        return initiatedBy === 'wwoofer' ? (0, $51a1d58e4b12a103$export$8dac938d775a885c).WWOOFER_INITIATED : (0, $51a1d58e4b12a103$export$8dac938d775a885c).HOST_INITIATED;
    }
    return (0, $51a1d58e4b12a103$export$764fad7f3e305206)[booking.status] || '#888';
};
const $f46203b51dd01070$export$3ee915f8151bd4f1 = (bookings, onEventClick, calendarView = (0, $51a1d58e4b12a103$export$9be60a615e817341).MONTH, unavailableDates = [], onSelectDates = null, onUnavailableEventClick = null)=>{
    const calendarRef = (0, $1G08a.useRef)(null);
    const calendarInstanceRef = (0, $1G08a.useRef)(null);
    const onEventClickRef = (0, $1G08a.useRef)(onEventClick);
    const onSelectDatesRef = (0, $1G08a.useRef)(onSelectDates);
    const onUnavailableEventClickRef = (0, $1G08a.useRef)(onUnavailableEventClick);
    const savedStateRef = (0, $1G08a.useRef)({
        view: calendarView,
        date: null
    });
    // Update the event click handler ref when it changes
    (0, $1G08a.useEffect)(()=>{
        onEventClickRef.current = onEventClick;
    }, [
        onEventClick
    ]);
    (0, $1G08a.useEffect)(()=>{
        onSelectDatesRef.current = onSelectDates;
    }, [
        onSelectDates
    ]);
    (0, $1G08a.useEffect)(()=>{
        onUnavailableEventClickRef.current = onUnavailableEventClick;
    }, [
        onUnavailableEventClick
    ]);
    (0, $1G08a.useEffect)(()=>{
        if (!calendarRef.current) return;
        // Only create a calendar if one doesn't exist
        if (!calendarInstanceRef.current) {
            // Prepare initial events from bookings
            const events = bookings.map((booking)=>({
                    id: booking.id,
                    title: `Visit with ${booking.current_user_role === 'host' ? booking.wwoofer_name : booking.host_name}`,
                    start: booking.start_date,
                    end: (0, $a3a32424dd0a2710$export$c16e5eea4d80b673)(booking.end_date),
                    backgroundColor: $f46203b51dd01070$var$getBookingColor(booking),
                    borderColor: $f46203b51dd01070$var$getBookingColor(booking),
                    extendedProps: {
                        booking: booking
                    }
                }));
            // Prepare background events for unavailable dates
            const unavailableEvents = unavailableDates.map((ud)=>({
                    id: `unavailable-${ud.id}`,
                    start: ud.start_date,
                    end: (0, $a3a32424dd0a2710$export$c16e5eea4d80b673)(ud.end_date),
                    display: 'background',
                    backgroundColor: '#ff000033',
                    classNames: [
                        'unavailable-date'
                    ],
                    extendedProps: {
                        unavailableId: ud.id,
                        isUnavailable: true
                    }
                }));
            // Create new calendar instance
            const calendar = new (0, $b12be9f4f0b8bc94$export$e1aef45b828286de)(calendarRef.current, {
                plugins: [
                    (0, $ec63da3e729bdd2a$export$2e2bcd8739ae039),
                    (0, $3092bb0ca7036a39$export$2e2bcd8739ae039),
                    (0, $d47a4fbcf0a90846$export$2e2bcd8739ae039)
                ],
                initialView: savedStateRef.current.view || calendarView,
                initialDate: savedStateRef.current.date || undefined,
                events: [
                    ...events,
                    ...unavailableEvents
                ],
                selectable: !!onSelectDates,
                selectMirror: true,
                unselectAuto: true,
                select: function(info) {
                    if (onSelectDatesRef.current) {
                        // end is exclusive in FullCalendar — convert back to inclusive
                        const endDate = new Date(info.endStr);
                        endDate.setDate(endDate.getDate() - 1);
                        const inclusiveEnd = endDate.toISOString().slice(0, 10);
                        onSelectDatesRef.current(info.startStr, inclusiveEnd);
                        calendar.unselect();
                    }
                },
                eventClick: function(info) {
                    if (info.event.extendedProps.isUnavailable) {
                        if (onUnavailableEventClickRef.current) onUnavailableEventClickRef.current(info.event.extendedProps.unavailableId);
                        return;
                    }
                    if (onEventClickRef.current) // Pass booking ID instead of booking object to ensure fresh data is used
                    onEventClickRef.current(info.event.extendedProps.booking.id);
                },
                height: calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).YEAR ? 800 : calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).MULTI_MONTH_STACK ? 900 : 650,
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: ''
                },
                eventDisplay: 'block',
                dayMaxEvents: calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).YEAR ? 2 : calendarView === (0, $51a1d58e4b12a103$export$9be60a615e817341).MULTI_MONTH_STACK ? 1 : 3,
                views: {
                    multiMonthYear: {
                        type: 'multiMonth',
                        duration: {
                            years: 1
                        },
                        multiMonthMaxColumns: 3,
                        multiMonthMinWidth: 250
                    },
                    multiMonthStack: {
                        type: 'multiMonth',
                        duration: {
                            months: 6
                        },
                        multiMonthMaxColumns: 1,
                        multiMonthMinWidth: 350
                    }
                },
                datesSet: function(info) {
                    // Save the current view state whenever the user navigates or the view changes
                    savedStateRef.current = {
                        view: info.view.type,
                        date: info.view.currentStart
                    };
                }
            });
            calendar.render();
            calendarInstanceRef.current = calendar;
        }
        // Cleanup function
        return ()=>{
            if (calendarInstanceRef.current) {
                // Save state before destroying
                savedStateRef.current = {
                    view: calendarInstanceRef.current.view.type,
                    date: calendarInstanceRef.current.getDate()
                };
                calendarInstanceRef.current.destroy();
                calendarInstanceRef.current = null;
            }
        };
    }, [
        calendarView
    ]); // Only recreate when calendarView changes
    // Separate effect to handle booking updates
    (0, $1G08a.useEffect)(()=>{
        if (calendarInstanceRef.current) {
            // Save current view state before updating events
            savedStateRef.current = {
                view: calendarInstanceRef.current.view.type,
                date: calendarInstanceRef.current.getDate()
            };
            // Prepare events from bookings
            const events = bookings.map((booking)=>({
                    id: booking.id,
                    title: `Visit with ${booking.current_user_role === 'host' ? booking.wwoofer_name : booking.host_name}`,
                    start: booking.start_date,
                    end: (0, $a3a32424dd0a2710$export$c16e5eea4d80b673)(booking.end_date),
                    backgroundColor: $f46203b51dd01070$var$getBookingColor(booking),
                    borderColor: $f46203b51dd01070$var$getBookingColor(booking),
                    extendedProps: {
                        booking: booking
                    }
                }));
            // Get current events to compare
            const currentEvents = calendarInstanceRef.current.getEvents();
            // Remove booking events that no longer exist
            currentEvents.forEach((event)=>{
                if (!event.extendedProps.isUnavailable && !events.find((newEvent)=>newEvent.id == event.id)) event.remove();
            });
            // Add or update booking events
            events.forEach((newEvent)=>{
                const existingEvent = currentEvents.find((event)=>event.id == newEvent.id);
                if (existingEvent) // Update existing event properties if they've changed
                {
                    if (existingEvent.title !== newEvent.title || existingEvent.startStr !== newEvent.start || existingEvent.endStr !== newEvent.end || existingEvent.backgroundColor !== newEvent.backgroundColor) {
                        existingEvent.setProp('title', newEvent.title);
                        existingEvent.setStart(newEvent.start);
                        existingEvent.setEnd(newEvent.end);
                        existingEvent.setProp('backgroundColor', newEvent.backgroundColor);
                        existingEvent.setProp('borderColor', newEvent.borderColor);
                        existingEvent.setExtendedProp('booking', newEvent.extendedProps.booking);
                    }
                } else // Add new event
                calendarInstanceRef.current.addEvent(newEvent);
            });
        }
    }, [
        bookings
    ]); // Update events when bookings change
    // Sync unavailable background events when unavailableDates changes
    (0, $1G08a.useEffect)(()=>{
        if (!calendarInstanceRef.current) return;
        const currentEvents = calendarInstanceRef.current.getEvents();
        // Remove stale unavailability background events
        currentEvents.forEach((event)=>{
            if (event.extendedProps.isUnavailable) event.remove();
        });
        // Add current unavailable date ranges as background events
        unavailableDates.forEach((ud)=>{
            calendarInstanceRef.current.addEvent({
                id: `unavailable-${ud.id}`,
                start: ud.start_date,
                end: (0, $a3a32424dd0a2710$export$c16e5eea4d80b673)(ud.end_date),
                display: 'background',
                backgroundColor: '#ff000033',
                classNames: [
                    'unavailable-date'
                ],
                extendedProps: {
                    unavailableId: ud.id,
                    isUnavailable: true
                }
            });
        });
    }, [
        unavailableDates
    ]);
    // Handle calendar view changes from props
    (0, $1G08a.useEffect)(()=>{
        if (calendarInstanceRef.current && calendarView !== savedStateRef.current.view) {
            // Save current date before changing view
            const currentDate = calendarInstanceRef.current.getDate();
            calendarInstanceRef.current.changeView(calendarView, currentDate);
            savedStateRef.current = {
                view: calendarView,
                date: currentDate
            };
        }
    }, [
        calendarView
    ]);
    // Cleanup on unmount
    (0, $1G08a.useEffect)(()=>{
        return ()=>{
            if (calendarInstanceRef.current) calendarInstanceRef.current.destroy();
        };
    }, []);
    return calendarRef;
};



var $1G08a = parcelRequire("1G08a");

const $b7390877365b5efc$export$b69a94c2c9e70ac6 = (userId)=>{
    const [unavailableDates, setUnavailableDates] = (0, $1G08a.useState)([]);
    const [isLoading, setIsLoading] = (0, $1G08a.useState)(false);
    const [error, setError] = (0, $1G08a.useState)(null);
    const fetchUnavailableDates = (0, $1G08a.useCallback)(async ()=>{
        if (!userId) return;
        setIsLoading(true);
        setError(null);
        try {
            const data = await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).get(`unavailable-dates/user/${userId}`);
            setUnavailableDates(Array.isArray(data) ? data : []);
        } catch (err) {
            setError(err.message || 'Failed to load unavailable dates.');
        } finally{
            setIsLoading(false);
        }
    }, [
        userId
    ]);
    (0, $1G08a.useEffect)(()=>{
        fetchUnavailableDates();
    }, [
        fetchUnavailableDates
    ]);
    const addUnavailableRange = (0, $1G08a.useCallback)(async (startDate, endDate)=>{
        setError(null);
        try {
            await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).post('unavailable-dates', {
                start_date: startDate,
                end_date: endDate
            });
            await fetchUnavailableDates();
        } catch (err) {
            setError(err.message || 'Failed to save unavailable date range.');
            throw err;
        }
    }, [
        fetchUnavailableDates
    ]);
    const removeUnavailableRange = (0, $1G08a.useCallback)(async (id)=>{
        setError(null);
        try {
            await (0, $9683d1ac1e2167a9$export$2e2bcd8739ae039).delete(`unavailable-dates/${id}`);
            await fetchUnavailableDates();
        } catch (err) {
            setError(err.message || 'Failed to remove unavailable date range.');
            throw err;
        }
    }, [
        fetchUnavailableDates
    ]);
    return {
        unavailableDates: unavailableDates,
        isLoading: isLoading,
        error: error,
        addUnavailableRange: addUnavailableRange,
        removeUnavailableRange: removeUnavailableRange,
        refetch: fetchUnavailableDates
    };
};



parcelRequire("1G08a");

const $6121083b65ac3abb$var$CalendarModal = ({ booking: booking, onClose: onClose, actionLoading: actionLoading, onEditDates: onEditDates, onCancel: onCancel, onAccept: onAccept, currentUserId: currentUserId })=>{
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "calendar-modal",
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $1bb93376bab2327d$export$2e2bcd8739ae039), {
            booking: booking,
            actionLoading: actionLoading,
            onEditDates: onEditDates,
            onCancel: onCancel,
            onAccept: onAccept,
            currentUserId: currentUserId,
            showCloseButton: true,
            onClose: onClose
        })
    });
};
var $6121083b65ac3abb$export$2e2bcd8739ae039 = $6121083b65ac3abb$var$CalendarModal;



const $e251db4eb7c983c3$var$unavailableDatesEnabled = window.wwoofBooking?.unavailableDatesEnabled || false;
const $e251db4eb7c983c3$var$wwooferInitiatedEnabled = window.wwoofBooking?.settings?.wwooferInitiatedEnabled || false;
const $e251db4eb7c983c3$var$CalendarView = ({ bookings: bookings, calendarModal: calendarModal, setCalendarModal: setCalendarModal, calendarView: calendarView, actionLoading: actionLoading, onEditDates: onEditDates, onCancel: onCancel, onAccept: onAccept, currentUserId: currentUserId })=>{
    const [pendingAdd, setPendingAdd] = (0, (/*@__PURE__*/$parcel$interopDefault($1G08a))).useState(null); // { startDate, endDate }
    const [pendingRemove, setPendingRemove] = (0, (/*@__PURE__*/$parcel$interopDefault($1G08a))).useState(null); // unavailableId
    const [unavailableError, setUnavailableError] = (0, (/*@__PURE__*/$parcel$interopDefault($1G08a))).useState(null);
    const { unavailableDates: unavailableDates, addUnavailableRange: addUnavailableRange, removeUnavailableRange: removeUnavailableRange } = (0, $b7390877365b5efc$export$b69a94c2c9e70ac6)($e251db4eb7c983c3$var$unavailableDatesEnabled ? currentUserId : null);
    const handleSelectDates = $e251db4eb7c983c3$var$unavailableDatesEnabled ? (startDate, endDate)=>{
        setUnavailableError(null);
        setPendingAdd({
            startDate: startDate,
            endDate: endDate
        });
    } : null;
    const handleUnavailableEventClick = $e251db4eb7c983c3$var$unavailableDatesEnabled ? (unavailableId)=>{
        setUnavailableError(null);
        setPendingRemove(unavailableId);
    } : null;
    const calendarRef = (0, $f46203b51dd01070$export$3ee915f8151bd4f1)(bookings, (bookingId)=>{
        const booking = bookings.find((b)=>b.id == bookingId);
        if (booking) setCalendarModal({
            booking: booking
        });
    }, calendarView, unavailableDates, handleSelectDates, handleUnavailableEventClick);
    // Close modal if the booking no longer exists after data refresh
    (0, (/*@__PURE__*/$parcel$interopDefault($1G08a))).useEffect(()=>{
        if (calendarModal && !bookings.find((b)=>b.id == calendarModal.booking.id)) setCalendarModal(null);
    }, [
        bookings,
        calendarModal
    ]);
    // Update modal booking data when bookings array changes
    (0, (/*@__PURE__*/$parcel$interopDefault($1G08a))).useEffect(()=>{
        if (calendarModal) {
            const updatedBooking = bookings.find((b)=>b.id == calendarModal.booking.id);
            if (updatedBooking) {
                // Compare booking objects by status and other key properties to avoid unnecessary updates
                const hasStatusChanged = updatedBooking.status !== calendarModal.booking.status;
                const hasStartDateChanged = updatedBooking.start_date !== calendarModal.booking.start_date;
                const hasEndDateChanged = updatedBooking.end_date !== calendarModal.booking.end_date;
                if (hasStatusChanged || hasStartDateChanged || hasEndDateChanged) setCalendarModal({
                    booking: updatedBooking
                });
            }
        }
    }, [
        bookings,
        calendarModal
    ]);
    const confirmAddUnavailable = async ()=>{
        if (!pendingAdd) return;
        try {
            await addUnavailableRange(pendingAdd.startDate, pendingAdd.endDate);
        } catch (err) {
            setUnavailableError(err.message || 'Failed to mark dates as unavailable.');
        }
        setPendingAdd(null);
    };
    const confirmRemoveUnavailable = async ()=>{
        if (!pendingRemove) return;
        try {
            await removeUnavailableRange(pendingRemove);
        } catch (err) {
            setUnavailableError(err.message || 'Failed to remove unavailability.');
        }
        setPendingRemove(null);
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "calendar-view",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                ref: calendarRef
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $4968431f639f2516$export$2e2bcd8739ae039), {
                unavailableDatesEnabled: $e251db4eb7c983c3$var$unavailableDatesEnabled,
                wwooferInitiatedEnabled: $e251db4eb7c983c3$var$wwooferInitiatedEnabled
            }),
            unavailableError && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                className: "unavailable-error",
                style: {
                    color: '#d63638',
                    marginTop: '8px'
                },
                children: unavailableError
            }),
            pendingAdd && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "unavailable-confirm-modal",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "unavailable-confirm-modal__overlay",
                        onClick: ()=>setPendingAdd(null)
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "unavailable-confirm-modal__box",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h3", {
                                children: "Mark as Unavailable?"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("p", {
                                children: [
                                    "Mark ",
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("strong", {
                                        children: pendingAdd.startDate
                                    }),
                                    " to ",
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("strong", {
                                        children: pendingAdd.endDate
                                    }),
                                    " as unavailable?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "unavailable-confirm-modal__actions",
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                        className: "button button-primary",
                                        onClick: confirmAddUnavailable,
                                        children: "Confirm"
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                        className: "button",
                                        onClick: ()=>setPendingAdd(null),
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            pendingRemove && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                className: "unavailable-confirm-modal",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                        className: "unavailable-confirm-modal__overlay",
                        onClick: ()=>setPendingRemove(null)
                    }),
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                        className: "unavailable-confirm-modal__box",
                        children: [
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h3", {
                                children: "Remove Unavailability?"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                                children: "Mark these dates as available again?"
                            }),
                            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                                className: "unavailable-confirm-modal__actions",
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                        className: "button button-primary",
                                        onClick: confirmRemoveUnavailable,
                                        children: "Yes, Remove"
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                                        className: "button",
                                        onClick: ()=>setPendingRemove(null),
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            calendarModal && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $6121083b65ac3abb$export$2e2bcd8739ae039), {
                booking: calendarModal.booking,
                onClose: ()=>setCalendarModal(null),
                actionLoading: actionLoading,
                onEditDates: onEditDates,
                onCancel: onCancel,
                onAccept: onAccept,
                currentUserId: currentUserId
            })
        ]
    });
};
var $e251db4eb7c983c3$export$2e2bcd8739ae039 = $e251db4eb7c983c3$var$CalendarView;





parcelRequire("1G08a");
const $62ce7d9aa6b87dbf$var$WhatsNewNotification = ({ changes: changes, isVisible: isVisible, onClose: onClose, lastVisit: lastVisit })=>{
    if (!isVisible || !changes) return null;
    const getCurrentUserId = ()=>window.wwoofBooking?.currentUserId;
    const getOtherPartyName = (booking)=>{
        const currentUserId = getCurrentUserId();
        return booking.host_id === currentUserId ? booking.wwoofer_name : booking.host_name;
    };
    const formatDateRange = (start, end)=>{
        return `${new Date(start).toLocaleDateString()} - ${new Date(end).toLocaleDateString()}`;
    };
    const formatTimeAgo = (dateString)=>{
        // Parse as UTC to avoid timezone issues
        // The dateString is in format 'YYYY-MM-DD HH:MM:SS' and is UTC
        const date = new Date(dateString + ' UTC');
        const now = new Date();
        const diffInMinutes = Math.floor((now - date) / 60000);
        if (diffInMinutes < 1) return 'just now';
        if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
    };
    const renderNewBookings = (bookings)=>{
        if (!bookings || bookings.length === 0) return null;
        return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "whats-new-section",
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("h4", {
                    children: [
                        "\uD83C\uDF89 New Booking Request",
                        bookings.length > 1 ? 's' : '',
                        " (",
                        bookings.length,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("ul", {
                    children: [
                        bookings.slice(0, 3).map((booking)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("strong", {
                                        children: getOtherPartyName(booking)
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("small", {
                                        children: formatDateRange(booking.start_date, booking.end_date)
                                    })
                                ]
                            }, booking.id)),
                        bookings.length > 3 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("em", {
                                children: [
                                    "...and ",
                                    bookings.length - 3,
                                    " more"
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    const renderStatusChanges = (statusChanges)=>{
        if (!statusChanges || statusChanges.length === 0) return null;
        return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "whats-new-section",
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("h4", {
                    children: [
                        "\uD83D\uDCCB Status Update",
                        statusChanges.length > 1 ? 's' : '',
                        " (",
                        statusChanges.length,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("ul", {
                    children: [
                        statusChanges.slice(0, 3).map((booking)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("strong", {
                                        children: getOtherPartyName(booking)
                                    }),
                                    " -",
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("span", {
                                        className: `status-${booking.status}`,
                                        children: [
                                            " ",
                                            booking.status_label
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("small", {
                                        children: formatDateRange(booking.start_date, booking.end_date)
                                    })
                                ]
                            }, booking.id)),
                        statusChanges.length > 3 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("em", {
                                children: [
                                    "...and ",
                                    statusChanges.length - 3,
                                    " more"
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    const renderDateChanges = (dateChanges)=>{
        if (!dateChanges || dateChanges.length === 0) return null;
        return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "whats-new-section",
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("h4", {
                    children: [
                        "\uD83D\uDCC5 Date Change",
                        dateChanges.length > 1 ? 's' : '',
                        " (",
                        dateChanges.length,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("ul", {
                    children: [
                        dateChanges.slice(0, 2).map((change, index)=>/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("strong", {
                                        children: getOtherPartyName(change)
                                    }),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("small", {
                                        children: [
                                            "Updated to: ",
                                            formatDateRange(change.start_date, change.end_date)
                                        ]
                                    })
                                ]
                            }, index)),
                        dateChanges.length > 2 && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("em", {
                                children: [
                                    "...and ",
                                    dateChanges.length - 2,
                                    " more"
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    const hasAnyChanges = Object.values(changes).some((changeArray)=>Array.isArray(changeArray) && changeArray.length > 0);
    if (!hasAnyChanges) return null;
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "whats-new-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "whats-new-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "whats-new-header",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h3", {
                            children: "\u2728 What's New Since Your Last Visit"
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            className: "whats-new-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "whats-new-content",
                    children: [
                        lastVisit && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("p", {
                            className: "last-visit-info",
                            children: [
                                "Last visited: ",
                                formatTimeAgo(lastVisit)
                            ]
                        }),
                        renderNewBookings(changes.new_bookings),
                        renderStatusChanges(changes.status_changes),
                        renderDateChanges(changes.date_changes)
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "whats-new-footer",
                    children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                        className: "whats-new-button",
                        onClick: onClose,
                        children: "Got it!"
                    })
                })
            ]
        })
    });
};
var $62ce7d9aa6b87dbf$export$2e2bcd8739ae039 = $62ce7d9aa6b87dbf$var$WhatsNewNotification;




var $1G08a = parcelRequire("1G08a");




parcelRequire("1G08a");

const $63e2057318291b7b$var$Modal = ({ isOpen: isOpen, onClose: onClose, title: title, children: children, showCloseButton: showCloseButton = false })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "modal-content",
            onClick: (e)=>e.stopPropagation(),
            children: [
                title && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("button", {
                            className: "modal-close-button",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "modal-body",
                    children: children
                }),
                showCloseButton && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                    className: "modal-footer",
                    children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        children: "Close"
                    })
                })
            ]
        })
    });
};
var $63e2057318291b7b$export$2e2bcd8739ae039 = $63e2057318291b7b$var$Modal;


const $349b19b3bff8ba88$var$DatePickerModal = ({ isOpen: isOpen, onClose: onClose, onSave: onSave, booking: booking, loading: loading, error: error })=>{
    const [startDate, setStartDate] = (0, $1G08a.useState)('');
    const [endDate, setEndDate] = (0, $1G08a.useState)('');
    const [errors, setErrors] = (0, $1G08a.useState)({});
    // Initialize dates when modal opens
    (0, $1G08a.useEffect)(()=>{
        if (isOpen && booking) {
            setStartDate((0, $a3a32424dd0a2710$export$2fbf685d4c7ca6e6)(booking.start_date));
            setEndDate((0, $a3a32424dd0a2710$export$2fbf685d4c7ca6e6)(booking.end_date));
            setErrors({});
        }
    }, [
        isOpen,
        booking
    ]);
    const validateForm = ()=>{
        const newErrors = {};
        const minDateString = (0, $a3a32424dd0a2710$export$a26bb6a012e2ca6f)(0); // Allow editing from today
        // Check if this is an in-progress booking being edited by a host with allowHostEditInprogress enabled
        const isInProgressEdit = booking?.status === (0, $51a1d58e4b12a103$export$d971c9d602083500).IN_PROGRESS && window.wwoofBooking?.settings?.allowHostEditInprogress;
        if (!startDate) newErrors.startDate = 'Start date is required';
        else if (!isInProgressEdit) {
            // Only validate start date is not in the past for non-in-progress bookings
            const startDateBackend = (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate);
            if (startDateBackend < minDateString) newErrors.startDate = 'Start date cannot be in the past';
        }
        if (!endDate) newErrors.endDate = 'End date is required';
        else if (endDate === startDate) newErrors.endDate = 'End date must be after start date';
        else {
            const startDateBackend = (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate);
            const endDateBackend = (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(endDate);
            if (endDateBackend <= startDateBackend) newErrors.endDate = 'End date must be after start date';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSave = ()=>{
        if (!validateForm()) return;
        const startDateBackend = (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(startDate);
        const endDateBackend = (0, $a3a32424dd0a2710$export$d156a7a13ef27ff9)(endDate);
        onSave({
            start_date: startDateBackend,
            end_date: endDateBackend
        });
    };
    const handleClose = ()=>{
        setStartDate('');
        setEndDate('');
        setErrors({});
        onClose();
    };
    // Convert date input (YYYY-MM-DD) to DD-MM-YYYY for display
    const handleDateInputChange = (value, setterFunction)=>{
        if (value) {
            const parts = value.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts;
                setterFunction(`${day}-${month}-${year}`);
            }
        } else setterFunction('');
    };
    // Convert DD-MM-YYYY to YYYY-MM-DD for input value
    const getInputValue = (ddmmyyyy)=>{
        if (!ddmmyyyy) return '';
        const parts = ddmmyyyy.split('-');
        if (parts.length === 3) {
            const [day, month, year] = parts;
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        return '';
    };
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $63e2057318291b7b$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: handleClose,
        title: "Edit Booking Dates",
        children: /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
            className: "date-picker-form",
            children: [
                error && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "error-banner",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("strong", {
                            children: "Error:"
                        }),
                        " ",
                        error
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                            htmlFor: "start-date",
                            children: [
                                "Start Date:",
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                    id: "start-date",
                                    type: "date",
                                    value: getInputValue(startDate),
                                    onChange: (e)=>handleDateInputChange(e.target.value, setStartDate),
                                    className: errors.startDate ? 'error' : ''
                                })
                            ]
                        }),
                        errors.startDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                            className: "error-message",
                            children: errors.startDate
                        }),
                        startDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                            className: "date-preview",
                            children: [
                                "Display: ",
                                startDate
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("label", {
                            htmlFor: "end-date",
                            children: [
                                "End Date:",
                                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("input", {
                                    id: "end-date",
                                    type: "date",
                                    value: getInputValue(endDate),
                                    onChange: (e)=>handleDateInputChange(e.target.value, setEndDate),
                                    className: errors.endDate ? 'error' : ''
                                })
                            ]
                        }),
                        errors.endDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                            className: "error-message",
                            children: errors.endDate
                        }),
                        endDate && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                            className: "date-preview",
                            children: [
                                "Display: ",
                                endDate
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                            variant: "cancel",
                            onClick: handleClose,
                            disabled: loading,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $766f882fc71a230f$export$2e2bcd8739ae039), {
                            variant: "edit",
                            onClick: handleSave,
                            disabled: loading,
                            children: loading ? 'Saving...' : 'Save Changes'
                        })
                    ]
                })
            ]
        })
    });
};
var $349b19b3bff8ba88$export$2e2bcd8739ae039 = $349b19b3bff8ba88$var$DatePickerModal;


// Helper functions for localStorage
const $abf79a2047030f96$var$getStoredStatusFilters = ()=>{
    try {
        const stored = localStorage.getItem('wwoof-booking-status-filters');
        if (stored) {
            const parsed = JSON.parse(stored);
            // Validate that the stored values are valid statuses
            const validStatuses = Object.values((0, $51a1d58e4b12a103$export$d971c9d602083500));
            const filteredStatuses = parsed.filter((status)=>validStatuses.includes(status));
            return filteredStatuses.length > 0 ? filteredStatuses : Object.values((0, $51a1d58e4b12a103$export$d971c9d602083500));
        }
    } catch (error) {
        console.warn('Failed to load status filters from localStorage:', error);
    }
    return Object.values((0, $51a1d58e4b12a103$export$d971c9d602083500));
};
const $abf79a2047030f96$var$storeStatusFilters = (statuses)=>{
    try {
        localStorage.setItem('wwoof-booking-status-filters', JSON.stringify(statuses));
    } catch (error) {
        console.warn('Failed to save status filters to localStorage:', error);
    }
};
// Helper functions for view mode persistence
const $abf79a2047030f96$var$getStoredViewMode = (fallbackView = (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).LIST)=>{
    try {
        const stored = localStorage.getItem('wwoof-booking-view-mode');
        if (stored && Object.values((0, $51a1d58e4b12a103$export$f4c4d822ceaa9764)).includes(stored)) return stored;
    } catch (error) {
        console.warn('Failed to load view mode from localStorage:', error);
    }
    return fallbackView;
};
const $abf79a2047030f96$var$storeViewMode = (viewMode)=>{
    try {
        localStorage.setItem('wwoof-booking-view-mode', viewMode);
    } catch (error) {
        console.warn('Failed to save view mode to localStorage:', error);
    }
};
// Helper functions for sort preference persistence
const $abf79a2047030f96$var$getStoredSort = ()=>{
    try {
        const stored = localStorage.getItem('wwoof-booking-sort-by');
        if (stored && Object.values((0, $51a1d58e4b12a103$export$a10e4eda63f1399b)).includes(stored)) return stored;
    } catch (error) {
        console.warn('Failed to load sort preference from localStorage:', error);
    }
    return (0, $51a1d58e4b12a103$export$a10e4eda63f1399b).CREATED_DESC;
};
const $abf79a2047030f96$var$storeSort = (sortBy)=>{
    try {
        localStorage.setItem('wwoof-booking-sort-by', sortBy);
    } catch (error) {
        console.warn('Failed to save sort preference to localStorage:', error);
    }
};
const $abf79a2047030f96$var$BookingDashboard = ({ userId: userId, view: initialView = (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).LIST })=>{
    // Determine the initial view mode - use stored preference if available, 
    // otherwise fall back to initialView, but ignore 'both' value from PHP
    const getInitialView = ()=>{
        const storedView = $abf79a2047030f96$var$getStoredViewMode();
        if (storedView && Object.values((0, $51a1d58e4b12a103$export$f4c4d822ceaa9764)).includes(storedView)) return storedView;
        // If initialView is 'both' or not a valid view mode, default to LIST
        if (initialView === 'both' || !Object.values((0, $51a1d58e4b12a103$export$f4c4d822ceaa9764)).includes(initialView)) return (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).LIST;
        return initialView;
    };
    const [view, setView] = (0, $1G08a.useState)(getInitialView);
    const [calendarView, setCalendarView] = (0, $1G08a.useState)((0, $51a1d58e4b12a103$export$9be60a615e817341).MONTH);
    const [calendarModal, setCalendarModal] = (0, $1G08a.useState)(null);
    const [selectedStatuses, setSelectedStatuses] = (0, $1G08a.useState)($abf79a2047030f96$var$getStoredStatusFilters);
    const [sortBy, setSortBy] = (0, $1G08a.useState)($abf79a2047030f96$var$getStoredSort);
    const { bookings: bookings, loading: loading, refreshing: refreshing, error: error, refreshBookings: refreshBookings, currentUserId: currentUserId } = (0, $1d7540ca182d067a$export$b40d734c8db78b02)(userId);
    // Dashboard changes tracking
    const { changes: changes, loading: changesLoading, showNotification: showWhatsNew, dismissNotification: dismissWhatsNew } = (0, $c0dbc813b76ae576$export$39a407f50f857acd)(userId);
    // Save status filter preferences whenever they change
    (0, $1G08a.useEffect)(()=>{
        $abf79a2047030f96$var$storeStatusFilters(selectedStatuses);
    }, [
        selectedStatuses
    ]);
    // Save view mode preference whenever it changes
    (0, $1G08a.useEffect)(()=>{
        $abf79a2047030f96$var$storeViewMode(view);
    }, [
        view
    ]);
    // Save sort preference whenever it changes
    (0, $1G08a.useEffect)(()=>{
        $abf79a2047030f96$var$storeSort(sortBy);
    }, [
        sortBy
    ]);
    // Handler to update status filters and save to localStorage
    const handleStatusChange = (newStatuses)=>{
        setSelectedStatuses(newStatuses);
    };
    // Handler to update view mode and save to localStorage
    const handleViewChange = (newView)=>{
        setView(newView);
    };
    // Handler to update sort preference
    const handleSortChange = (newSort)=>{
        setSortBy(newSort);
    };
    const { actionLoading: actionLoading, error: actionError, acceptBooking: acceptBooking, cancelBooking: cancelBooking, editBookingDates: editBookingDates, setError: setActionError, showAcceptPopup: showAcceptPopup, setShowAcceptPopup: setShowAcceptPopup, showAgreementPopup: showAgreementPopup, setShowAgreementPopup: setShowAgreementPopup, handleAcceptAgreement: handleAcceptAgreement, handleAgreementClose: handleAgreementClose, pendingBooking: pendingBooking, showDatePicker: showDatePicker, bookingToEdit: bookingToEdit, handleDatePickerSave: handleDatePickerSave, handleDatePickerClose: handleDatePickerClose, showErrorPopup: showErrorPopup, setShowErrorPopup: setShowErrorPopup, errorPopupMessage: errorPopupMessage } = (0, $2dcc4f06e0257310$export$b05f746f92c8d0a9)(refreshBookings);
    // Filter bookings based on selected status only
    const filterBookings = (bookings)=>{
        return bookings.filter((booking)=>selectedStatuses.includes(booking.status));
    };
    // Sort bookings based on selected sort option
    const sortBookings = (bookings)=>{
        const sorted = [
            ...bookings
        ];
        switch(sortBy){
            case (0, $51a1d58e4b12a103$export$a10e4eda63f1399b).DATE_ASC:
                return sorted.sort((a, b)=>a.start_date.localeCompare(b.start_date));
            case (0, $51a1d58e4b12a103$export$a10e4eda63f1399b).DATE_DESC:
                return sorted.sort((a, b)=>b.start_date.localeCompare(a.start_date));
            case (0, $51a1d58e4b12a103$export$a10e4eda63f1399b).CREATED_ASC:
                return sorted.sort((a, b)=>a.created_at.localeCompare(b.created_at));
            case (0, $51a1d58e4b12a103$export$a10e4eda63f1399b).CREATED_DESC:
                return sorted.sort((a, b)=>b.created_at.localeCompare(a.created_at));
            default:
                return sorted.sort((a, b)=>a.start_date.localeCompare(b.start_date));
        }
    };
    const sortedBookings = sortBookings(filterBookings(bookings));
    if (loading || changesLoading) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $21eb0e5ed4d9941c$export$2e2bcd8739ae039), {
        message: "Loading bookings..."
    });
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "wwoof-booking-dashboard",
        children: [
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $62ce7d9aa6b87dbf$export$2e2bcd8739ae039), {
                changes: changes?.changes,
                isVisible: showWhatsNew,
                onClose: dismissWhatsNew,
                lastVisit: changes?.last_visit
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $80b78a6727727a2b$export$2e2bcd8739ae039), {
                view: view,
                setView: handleViewChange,
                calendarView: calendarView,
                setCalendarView: setCalendarView,
                selectedStatuses: selectedStatuses,
                onStatusChange: handleStatusChange,
                sortBy: sortBy,
                onSortChange: handleSortChange
            }),
            error && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                className: "error-message",
                children: error
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: errorPopupMessage,
                isVisible: showErrorPopup,
                onClose: ()=>setShowErrorPopup(false)
            }),
            view === (0, $51a1d58e4b12a103$export$f4c4d822ceaa9764).LIST ? /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $e8272dd4e4d207a7$export$2e2bcd8739ae039), {
                bookings: sortedBookings,
                loading: refreshing,
                actionLoading: actionLoading,
                onEditDates: editBookingDates,
                onCancel: cancelBooking,
                onAccept: acceptBooking,
                currentUserId: currentUserId
            }) : /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $e251db4eb7c983c3$export$2e2bcd8739ae039), {
                bookings: sortedBookings,
                calendarModal: calendarModal,
                setCalendarModal: setCalendarModal,
                calendarView: calendarView,
                actionLoading: actionLoading,
                onEditDates: editBookingDates,
                onCancel: cancelBooking,
                onAccept: acceptBooking,
                currentUserId: currentUserId,
                refreshing: refreshing
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: pendingBooking?.initiated_by === 'wwoofer' ? window.wwoofBooking?.popupTexts?.hostAccepted || "Before accepting this WWOOFer's visit request, please confirm that you understand and agree to the following:" : window.wwoofBooking?.popupTexts?.wwoofrerAccepted || "Before accepting this visit request, please confirm that you understand and agree to the following:",
                isVisible: showAgreementPopup,
                onClose: handleAgreementClose,
                requireAgreement: true,
                agreementText: "I agree to the WWOOF Ireland Declaration.",
                onAccept: handleAcceptAgreement
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $29e8c66b7747c055$export$2e2bcd8739ae039), {
                message: window.wwoofBooking?.popupTexts?.wwoofrerAccepted || 'You have accepted this visit request!',
                isVisible: showAcceptPopup,
                onClose: ()=>setShowAcceptPopup(false)
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $349b19b3bff8ba88$export$2e2bcd8739ae039), {
                isOpen: showDatePicker,
                onClose: handleDatePickerClose,
                onSave: handleDatePickerSave,
                booking: bookingToEdit,
                loading: actionLoading,
                error: actionError
            })
        ]
    });
};
var $abf79a2047030f96$export$2e2bcd8739ae039 = $abf79a2047030f96$var$BookingDashboard;




var $1G08a = parcelRequire("1G08a");




const $e1064718a1456d03$var$UserAvailabilityCalendar = ({ userId: userId, bookingDates: bookingDates = [] })=>{
    const calendarRef = (0, $1G08a.useRef)(null);
    const calendarInstanceRef = (0, $1G08a.useRef)(null);
    const { unavailableDates: unavailableDates, isLoading: isLoading, error: error } = (0, $b7390877365b5efc$export$b69a94c2c9e70ac6)(userId);
    // Build/rebuild the calendar when unavailableDates loads
    (0, $1G08a.useEffect)(()=>{
        if (!calendarRef.current || isLoading) return;
        if (calendarInstanceRef.current) {
            calendarInstanceRef.current.destroy();
            calendarInstanceRef.current = null;
        }
        const unavailableEvents = unavailableDates.map((ud)=>({
                id: `unavailable-${ud.id}`,
                start: ud.start_date,
                end: (0, $a3a32424dd0a2710$export$c16e5eea4d80b673)(ud.end_date),
                display: 'background',
                backgroundColor: '#ff000033',
                classNames: [
                    'unavailable-date'
                ]
            }));
        const bookingEvents = bookingDates.map((bd, i)=>({
                id: `booking-${i}`,
                start: bd.start_date,
                end: (0, $a3a32424dd0a2710$export$c16e5eea4d80b673)(bd.end_date),
                display: 'background',
                backgroundColor: '#ff000033',
                classNames: [
                    'unavailable-date',
                    'unavailable-date--booking'
                ]
            }));
        const calendar = new (0, $b12be9f4f0b8bc94$export$e1aef45b828286de)(calendarRef.current, {
            plugins: [
                (0, $ec63da3e729bdd2a$export$2e2bcd8739ae039)
            ],
            initialView: 'dayGridMonth',
            events: [
                ...unavailableEvents,
                ...bookingEvents
            ],
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: ''
            },
            height: 500,
            editable: false,
            selectable: false,
            eventClick: function() {
            // read-only — no interaction
            }
        });
        calendar.render();
        calendarInstanceRef.current = calendar;
        return ()=>{
            if (calendarInstanceRef.current) {
                calendarInstanceRef.current.destroy();
                calendarInstanceRef.current = null;
            }
        };
    }, [
        unavailableDates,
        bookingDates,
        isLoading
    ]);
    if (error) return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
        className: "unavailability-calendar-error",
        children: error
    });
    return /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("div", {
        className: "user-availability-calendar",
        children: [
            isLoading && /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("p", {
                className: "unavailability-calendar-loading",
                children: "Loading availability\u2026"
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("div", {
                ref: calendarRef
            }),
            /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsxs)("p", {
                className: "unavailability-calendar-legend",
                children: [
                    /*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)("span", {
                        className: "unavailability-calendar-legend__swatch"
                    }),
                    "Unavailable dates"
                ]
            })
        ]
    });
};
var $e1064718a1456d03$export$2e2bcd8739ae039 = $e1064718a1456d03$var$UserAvailabilityCalendar;


// Wait for React to be available (keeping compatibility with WordPress setup)
function $6276e384dc8cac6b$var$waitForReact(callback) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($1G08a))) !== 'undefined' && typeof (0, $96335ac8adae3409$export$882461b6382ed46c) !== 'undefined') callback();
    else setTimeout(()=>$6276e384dc8cac6b$var$waitForReact(callback), 100);
}
$6276e384dc8cac6b$var$waitForReact(function() {
    // Initialize components when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize Visit Request Form (Host-initiated)
        const visitRequestForm = document.getElementById('wwoof-visit-request-form');
        if (visitRequestForm) {
            const wwooferId = parseInt(visitRequestForm.dataset.wwooferId);
            const hostId = parseInt(visitRequestForm.dataset.hostId);
            const threadId = parseInt(visitRequestForm.dataset.threadId);
            const root = (0, $96335ac8adae3409$export$882461b6382ed46c)(visitRequestForm);
            root.render(/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $d14f23ecf9d8993e$export$2e2bcd8739ae039), {
                wwooferId: wwooferId,
                hostId: hostId,
                threadId: threadId
            }));
        }
        // Initialize WWOOFer Visit Request Form (WWOOFer-initiated)
        const wwooferVisitRequestForm = document.getElementById('wwoof-wwoofer-visit-request-form');
        if (wwooferVisitRequestForm) {
            const hostId = parseInt(wwooferVisitRequestForm.dataset.hostId);
            const wwooferId = parseInt(wwooferVisitRequestForm.dataset.wwooferId);
            const threadId = parseInt(wwooferVisitRequestForm.dataset.threadId);
            const root = (0, $96335ac8adae3409$export$882461b6382ed46c)(wwooferVisitRequestForm);
            root.render(/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $15903fdd71bea06b$export$2e2bcd8739ae039), {
                hostId: hostId,
                wwooferId: wwooferId,
                threadId: threadId
            }));
        }
        // Initialize Booking Dashboard
        const bookingDashboard = document.getElementById('wwoof-booking-dashboard');
        if (bookingDashboard) {
            const userId = parseInt(bookingDashboard.dataset.userId);
            const view = bookingDashboard.dataset.view;
            const root = (0, $96335ac8adae3409$export$882461b6382ed46c)(bookingDashboard);
            root.render(/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $abf79a2047030f96$export$2e2bcd8739ae039), {
                userId: userId,
                view: view
            }));
        }
        // Initialize User Availability Calendar (read-only profile shortcode)
        const availabilityCalendar = document.getElementById('wwoof-user-availability-calendar');
        if (availabilityCalendar) {
            const userId = parseInt(availabilityCalendar.dataset.userId);
            let bookingDates = [];
            if (availabilityCalendar.dataset.bookingDates) try {
                bookingDates = JSON.parse(availabilityCalendar.dataset.bookingDates);
            } catch (e) {
                bookingDates = [];
            }
            const root = (0, $96335ac8adae3409$export$882461b6382ed46c)(availabilityCalendar);
            root.render(/*#__PURE__*/ (0, $ee14841e48c228d7$exports.jsx)((0, $e1064718a1456d03$export$2e2bcd8739ae039), {
                userId: userId,
                bookingDates: bookingDates
            }));
        }
    });
});

})();
//# sourceMappingURL=main.js.map
